webpackJsonp([44],{

/***/ "+F3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+P0O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Increase',
  props: ['type'],
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['vcListNoSettleEnabled']), (0, _vuex.mapState)({
    coinListWithPrice: function coinListWithPrice(state) {
      return state.vc.coinListWithPrice;
    }
  }), {
    vcListWithType: function vcListWithType() {
      var _this = this;

      return this.vcListNoSettleEnabled.filter(function (item) {
        return item.type === _this.type;
      });
    },
    coinList: function coinList() {
      var _this2 = this;

      if (!this.coinListWithPrice.length) return [];
      return this.vcListWithType.map(function (settleItem) {
        return _this2.coinListWithPrice.find(function (coinWithPriceItem) {
          return settleItem.id === coinWithPriceItem.a;
        });
      }).filter(function (item) {
        return !!item;
      }).slice(0, 5);
    }
  }),
  methods: {
    clickVcItem: function clickVcItem(currency) {
      var _this3 = this;

      this.$store.dispatch('setVcId', currency.a).then(function () {
        _this3.$router.push('/trade');
      }).catch(function (err) {
        _this3.$message.error(err.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "+ZKe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Increase',
  props: ['type'],
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['vcListNoSettleEnabled']), (0, _vuex.mapState)({
    coinListWithPrice: function coinListWithPrice(state) {
      return state.vc.coinListWithPrice;
    }
  }), {
    vcListWithType: function vcListWithType() {
      var _this = this;

      return this.vcListNoSettleEnabled.filter(function (item) {
        return item.type === _this.type;
      });
    },
    coinList: function coinList() {
      var _this2 = this;

      if (!this.coinListWithPrice.length) return [];
      return this.vcListWithType.map(function (settleItem) {
        return _this2.coinListWithPrice.find(function (coinWithPriceItem) {
          return settleItem.id === coinWithPriceItem.a;
        });
      }).filter(function (item) {
        return !!item;
      }).slice(0, 5);
    }
  }),
  methods: {
    clickVcItem: function clickVcItem(currency) {
      var _this3 = this;

      this.$store.dispatch('setVcId', currency.a).then(function () {
        _this3.$router.push('/trade');
      }).catch(function (err) {
        _this3.$message.error(err.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "+dCX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Poster',
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['tradeConfig', 'vcId'])),
  methods: {}
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "+jdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{class:("confirm-" + _vm.position),attrs:{"dialog-class":'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":("vux-popup-animate-" + _vm.position),"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"dialog-content"},[_c('div',{staticClass:"dialog-title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),_vm._t("default",function(){return [_c('div',{staticClass:"content-tips",domProps:{"innerHTML":_vm._s(_vm.content)}})]}),_vm._v(" "),_c('div',{staticClass:"action-btn"},[_c('flexbox',{attrs:{"gutter":10}},[_c('flexbox-item',[_c('c-button',{staticClass:"cancel-button",on:{"click":_vm._onCancel}},[_vm._v("\n              "+_vm._s(_vm.$t('button.cancel'))+"\n              "),(_vm.interval.enabled && _vm.interval.mode === 'cancel')?[_vm._v("\n                ("+_vm._s(_vm._f("formatMsToS")(_vm.interval.intervalTime))+")\n              ")]:_vm._e()],2)],1),_vm._v(" "),_c('flexbox-item',[_c('c-button',{staticClass:"confirm-button",nativeOn:{"click":function($event){return _vm._onConfirm($event)}}},[_vm._v(_vm._s(_vm.confirmText || _vm.$t('button.confirm')))])],1)],1)],1)],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+ji0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap custom-tab",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+kMp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
};

/***/ }),

/***/ "/Ma6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"increase-container"},[(_vm.coinList.length)?_c('ul',{staticClass:"increase-t-body"},_vm._l((_vm.coinList),function(currency){return _c('li',{key:currency.id,on:{"click":function($event){return _vm.clickVcItem(currency)}}},[_c('div',{staticClass:"currency-type"},[_c('span',{staticClass:"type txt-color"},[_vm._v(_vm._s(currency.c))])]),_vm._v(" "),_c('div',{staticClass:"price txt-color"},[_c('span',[_vm._v(_vm._s(_vm._f("getFullNum")(currency.g)))])]),_vm._v(" "),_c('div',{staticClass:"increase",class:currency.k >= 0 ? 'green-bg' : 'red-bg'},[_c('span',[_vm._v(_vm._s(currency.k >= 0 ? "+" : '')+_vm._s(currency['changePerStr'] || '0%'))])])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/PDB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__ = __webpack_require__("v42V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__ = __webpack_require__("urgZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8cc4f9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__ = __webpack_require__("+jdt");
function injectStyle (ssrContext) {
  __webpack_require__("5IjK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8cc4f9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("cvA0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("92Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_31c83ce0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("KVNH");
function injectStyle (ssrContext) {
  __webpack_require__("ekbS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_31c83ce0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0B0L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'SlideItem',
  props: {
    item: {
      type: Object,
      default: function _default() {
        /* istanbul ignore next */
        return {};
      }
    }
  }
};

/***/ }),

/***/ "0Rqi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return (0, _objectAssign2.default)({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "0pea":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
};

/***/ }),

/***/ "1Fm+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue__ = __webpack_require__("oUHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue__ = __webpack_require__("1MMv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0092da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Increase_vue__ = __webpack_require__("aMHp");
function injectStyle (ssrContext) {
  __webpack_require__("YyuS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f0092da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Increase_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0092da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Increase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1KuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue__ = __webpack_require__("35uk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue__ = __webpack_require__("j969");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79cd691a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ThemeSwitch_vue__ = __webpack_require__("A+Om");
function injectStyle (ssrContext) {
  __webpack_require__("vtIf")
  __webpack_require__("xkKr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79cd691a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitch_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79cd691a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_ThemeSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1MMv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Increase',
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['vcListNoSettleEnabled']), (0, _vuex.mapState)({
    coinListWithPrice: function coinListWithPrice(state) {
      return state.vc.coinListWithPrice;
    }
  }), {
    increaseCoinList: function increaseCoinList() {
      var _this = this;

      if (!this.coinListWithPrice.length) return [];
      return this.vcListNoSettleEnabled.map(function (settleItem) {
        return _this.coinListWithPrice.find(function (coinWithPriceItem) {
          return settleItem.id === coinWithPriceItem.a;
        });
      }).filter(function (item) {
        return !!item;
      }).sort(function (pre, next) {
        return next.k - pre.k;
      });
    }
  }),
  methods: {
    clickVcItem: function clickVcItem(currency) {
      var _this2 = this;

      this.$store.dispatch('setVcId', currency.a).then(function () {
        _this2.$router.push('/trade');
      }).catch(function (err) {
        _this2.$message.error(err.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "1Mrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue__ = __webpack_require__("2mkt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue__ = __webpack_require__("ST6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db174910_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Ranking_vue__ = __webpack_require__("wVfc");
function injectStyle (ssrContext) {
  __webpack_require__("IL/Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db174910"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db174910_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Ranking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1OU/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1qIR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "24fE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _swiper = __webpack_require__("NjrX");

var _swiper2 = _interopRequireDefault(_swiper);

var _router = __webpack_require__("0FxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      (0, _router.go)(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse((0, _stringify2.default)(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new _swiper2.default({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
};

/***/ }),

/***/ "26Nj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return (0, _objectAssign2.default)({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "2A0z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cleanStyle = __webpack_require__("wmxo");

var _cleanStyle2 = _interopRequireDefault(_cleanStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'group',
  methods: {
    cleanStyle: _cleanStyle2.default
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "2BuD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue__ = __webpack_require__("+P0O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue__ = __webpack_require__("+ZKe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c71cf24a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Coins_vue__ = __webpack_require__("/Ma6");
function injectStyle (ssrContext) {
  __webpack_require__("1OU/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c71cf24a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Coins_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c71cf24a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Coins_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2GrC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("piuB");

exports.default = {
  name: 'TabItem',
  mixins: [_multiItems.childMixin],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
};

/***/ }),

/***/ "2mkt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _Tab = __webpack_require__("HsJn");

var _Slide = __webpack_require__("vJdA");

var _Slide2 = _interopRequireDefault(_Slide);

var _SlideItem = __webpack_require__("L4cg");

var _SlideItem2 = _interopRequireDefault(_SlideItem);

var _Increase = __webpack_require__("1Fm+");

var _Increase2 = _interopRequireDefault(_Increase);

var _Clinch = __webpack_require__("mgPS");

var _Clinch2 = _interopRequireDefault(_Clinch);

var _Coins = __webpack_require__("2BuD");

var _Coins2 = _interopRequireDefault(_Coins);

var _dict = __webpack_require__("Mqi+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Ranking',
  components: { Tab: _Tab.Tab, TabItem: _Tab.TabItem, Slide: _Slide2.default, SlideItem: _SlideItem2.default, Increase: _Increase2.default, Clinch: _Clinch2.default, Coins: _Coins2.default },
  data: function data() {
    return {
      tabs: [{ label: 'home.ranking.increase.title', component: 'Increase', key: 0, value: 0 }, { label: 'home.ranking.clinch.title', component: 'Clinch', key: 1, value: 1 }],
      currentTab: '1',
      currentTabIndex: 0,
      slideOptions: {
        listenScroll: true,
        probeType: 3,
        directionLockThreshold: 0,
        eventPassthrough: 'vertical'
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['dict', 'locale']), {
    vcTypeOptions: function vcTypeOptions() {
      var excludeKeys = "1,2,3,4";
      return (0, _dict.generateDictArrListByKey)(this.dict, 'VcTypeEnum', excludeKeys).map(function (item) {
        return (0, _extends3.default)({}, item, { component: 'Coins' });
      });
    }
  }),
  watch: {
    locale: function locale() {
      this.$nextTick(function () {
        // this.$refs['slide'].refresh()
      });
    }
  },
  methods: {
    clickTabItem: function clickTabItem(tabItem) {
      this.currentTab = tabItem.value;
      this.currentTabIndex = this.vcTypeOptions.findIndex(function (item) {
        return item.value === tabItem.value;
      });
    },
    slideOnChange: function slideOnChange(current) {
      this.currentTab = this.vcTypeOptions[current].value;
    }
  }
};

/***/ }),

/***/ "2ol5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vcTimingTradeRequest = exports.vcTimingTradeConfig = undefined;

var _request = __webpack_require__("vLgD");

var _request2 = _interopRequireDefault(_request);

var _prefix = __webpack_require__("jnOm");

var _prefix2 = _interopRequireDefault(_prefix);

var _auth = __webpack_require__("Pfph");

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***
 * 获取极速交易配置
 * @param data
 * @returns {AxiosPromise}
 */
var vcTimingTradeConfig = exports.vcTimingTradeConfig = function vcTimingTradeConfig(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/vc-timing-trade-config/list',
    method: 'post',
    data: data
  });
};

/***
 * 极速交易 下单
 * @param data
 * @returns {AxiosPromise}
 */
var vcTimingTradeRequest = exports.vcTimingTradeRequest = function vcTimingTradeRequest(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/vc-timing-trade/request',
    method: 'post',
    data: data
  });
};

/***/ }),

/***/ "2pWa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _ThemeSwitch = __webpack_require__("1KuB");

var _ThemeSwitch2 = _interopRequireDefault(_ThemeSwitch);

var _i18n = __webpack_require__("mWYR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'HomeHeader',
  components: { ThemeSwitch: _ThemeSwitch2.default },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    locale: function locale(state) {
      return state.i18n.locale;
    }
  }), {
    currentLocaleIcon: function currentLocaleIcon() {
      return (_i18n.i18nLocales[this.locale] || { icon: '' }).icon;
    },
    localeName: function localeName() {
      return _i18n.i18nLocales[this.locale].localeName;
    }
  }),
  methods: {
    clickCustomService: function clickCustomService() {
      this.$store.dispatch('showCustomerService');
      // this.$store.dispatch('disConnectSocket')
      // console.log(this.$store.state.app)
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "2sLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("vjYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("TCOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_283ca23f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("+F3j");
function injectStyle (ssrContext) {
  __webpack_require__("tw8n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_283ca23f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2uFj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /***
   * 新注册用户的默认密码
   * @type {string}
   */
  defaultLoginPassword: 'a123456',
  /***
   * 货币单位
   */
  symbol: "",
  /***
   * 平台名称
   */
  platform: "FXMT",

  /***
   * 默认交易模式: 0 = 极速, 1 = 期货
   */
  defaultTradeType: 0,

  /***
   * 新增银行卡是否显示branchCode(支行代码)
   */
  branchCodeEnabled: false
};

/***/ }),

/***/ "35uk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ThemeSwitch',
  methods: {
    switchTheme: function switchTheme() {
      this.$store.dispatch('switchThemeMode');
    }
  }
};

/***/ }),

/***/ "373V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3C/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3ECv":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAABCCAIAAADbi2+YAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM1MiwgMjAyMC8wMS8zMC0xNTo1MDozOCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTIwNjVBMDcyMkU5MTFFRDlBMzg4NzgyNEMzOEZBREEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTIwNjVBMDgyMkU5MTFFRDlBMzg4NzgyNEMzOEZBREEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFMjA2NUEwNTIyRTkxMUVEOUEzODg3ODI0QzM4RkFEQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFMjA2NUEwNjIyRTkxMUVEOUEzODg3ODI0QzM4RkFEQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtbxEAMAAAWLSURBVHja7JpZaF1VFIb/vc+5SW6TJmmmOsS2WLUiRXCAOkC1UESpfdEWxYdiEXECcaAIglQcEPPimwOoYKwKKmi1LyIq1PRJEF+KVQtt4pTG2iGNTXrP2Xu51roJaG5ybixc8JzsxaWEm30D58u/1v+vnRratBWhzqpsQBDYFY9dDJwCTpB8EdgtqAzggAT4g3CpwfUR/qTAbmHlgVb9d4SwLcJWi59I8JFiLUo1ppcY0w0W98eCjHV3HNgWIyEME06jMP3bGN11GHxD2Otxk0WqGhyIsTnChPbyYuzZCAJiZAHaaQamCK+lGCUst+gyeMXhyUQ+Xl6c7M4osrsj9AHjmSdZXJPAjhixwauJoBzneacCTIoz8v4LuyOEKyweK2FjhDGqg6DX4ADh0QTPphhIRXp9+v4EYUolTPpaFF5RjR1rFNg6g34jCJrnP8y9uduhBFxt8ZHHUqDNoNtgS4S3HQ6RfOtcIyep8Lrjhu0xYpo8yFZYrDA4SXXals+zafAXXRBS7LaHPO6IcLvFWoPnS1huxD0K2LOkz199cVLjJr3SYK3FURIRXWLwl77/zzMZmmWXOB/YEMnH74ywq0lEN5LvfSOe20+5H49pW1WfnHS1us6iRSmwBm+0+MAJ0OaZpks0mrTpgVnFlDuBJ2JcE2HUwxqxjh2JxEDWb5pXdmaOOyiOIL3qpyWDCsmjVgmy1lqUUTWFcO7lto2MbguEJQbvOuz3QrB2zYh1ArJst0fCkWffFx7PJGgx07+hgujOq+54xvdaOBJYVtmxTCZVlXygAlxl5dNeX2UV5y43TbZWyHzmIDDqRH2MeMjjNouVFr9QftnNpTurDdtqcF8sT8hR7ug8g8mrAHlyfUd4McEw+8P8g4+5X2Bws8WbDj8T2iFekeekYua+N471CuQEcFeEh2KZYrVznf2hA2g3+NDhZScXTasyWRh9HdHfSvtM7+c5J8/jczy/u/UJ33I44PF4jH6L0/+m0qom8FIqptFncOECpj4faNK84ouwXdiseySeU5cZfOnxqZdmnFWsuB9JRMde2Yn64KpRhudAv96sTCHvV1L1sjEPqYstNlqRWLWWzGxUpwirjaTcqcxwVxU3Z2Be0XiMcjZmkznspd9b8n2tUi+b8tOut7jcislGuirwHOw0mCTBsdKIHb/jJJdkjPxjkFz9QCRneCxyNlzXJJJ7OpGoWC6k7ox21kVGRhu/zjP4zOHeBG+kAuscI0nlWitrRnbDctBJNU7zRsHhkSfjaovBFMcp11dSmezYCpdxJNZ0x9F3IMVTqRjl6w6PJCJAbjruWT4wTnXuVDjErK9g0IlUOQ9/7bHbY1m+/cLW2f/5sVlZP3hsr+A99VPOaPz8+/idBHscuqxcLp2Z/8cnGqo7dFCy8xwkPJdgg5UW/j3fl1CZ866sPbszkfVrmMQfzcx05yjHy+wLKYYIh0kCzaxFYmLmLz7Mhzt0lIT494Q9KfaRiJdRLs237kzW/6mo3gKM6a7aUeOJVuXGK0ePme2YFbURbuSvNBveEuHhRDiyAJsNuiGK42W5C/m9CKinu2pL9ZnpdFYbAKv3l7XfPUny/s4SPvHYwqIDfiNZTvrVjiuY1mmK4s67sy6ekkyNZ+KDsfDl/WSwhFsjiYQehSnbKDXzvPuVps26rPORdecMKLDLLraCzXpV97mTATcGbErEpjvVRgK7rGpWR2YXvqeC9524BEuPs7RHkXTXmL8XsL6+Jdnb1lh87CQedqJIk66RumMDbVPHKOu8G/Iiw6ho7Br8dyqvF3Y9hbKIButucVRgF9gFdoFdYBcqsAvsArvALlRgF9gFdoFdYBcqsAvsArvALlRgF9gFdoFdYBcqsAvsArvALlRgF9j9P+pvAQYAK9zS4KCnKV8AAAAASUVORK5CYII="

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__ = __webpack_require__("ykmb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__ = __webpack_require__("4rCc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_30e3872a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_item_vue__ = __webpack_require__("A29d");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_30e3872a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3kuK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3mzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("Xbrq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("MuS8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bcd3e44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("9qnA");
function injectStyle (ssrContext) {
  __webpack_require__("wNAT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bcd3e44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bcd3e44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "43sz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/***
 * 设备id
 * @type {string | string}
 */
var deviceId = exports.deviceId = (window || {
  navigator: {
    userAgent: ''
  }
}).navigator.userAgent;

/***
 * 设备类型
 * @type {string}
 */
var deviceType = exports.deviceType = '2';

/***/ }),

/***/ "4VBY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4rCc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

exports.default = {
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
};

/***/ }),

/***/ "4xPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue__ = __webpack_require__("WNks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue__ = __webpack_require__("u9hx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b8fd96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Locales_vue__ = __webpack_require__("kK/z");
function injectStyle (ssrContext) {
  __webpack_require__("WgBt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94b8fd96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Locales_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b8fd96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Locales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "52YF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue__ = __webpack_require__("wjhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue__ = __webpack_require__("c0or");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd3aa75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_QuickMenus_vue__ = __webpack_require__("f6mN");
function injectStyle (ssrContext) {
  __webpack_require__("szdm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3dd3aa75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_QuickMenus_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd3aa75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_QuickMenus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5IjK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5m/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{staticClass:"carousel",attrs:{"loop":"","auto":"","index":_vm.carousel.currentIndex,"show-dots":false,"height":"7.8125rem"}},_vm._l((_vm.carousel.items),function(img,imgIndex){return _c('swiper-item',{key:imgIndex,staticClass:"carousel-item"},[_c('a',{staticClass:"swiper-link",attrs:{"href":img['targetUrl'],"target":"_blank"}},[_c('img',{staticClass:"carousel-img",attrs:{"src":img['imgUrl'],"alt":("carousel-" + (imgIndex + 1))}})])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5vzO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAABCCAMAAABjNwj9AAAC/VBMVEXbAA376g7bAA39+Q7rdQ7bAA3bAA376g7++Q7rdQ7ZAA3/7w3bAAn87Q3+7Q3/8w3/7wn/8Qf35Q+hHxSdVgv/7gTVxyTw3gzt1AqmXwr/9ATbOkOwQRakFBafPBSnMhLUrxCpTQ336QysTwzo3Quijwu8Ygu+aAqxdAfEx8a+vsI4ZKXa013dQUqGiDqkSTnBxC+HjC/HwSXs3xusERmpFxepJBb46BSTJRSYLBOfFRLMhg+7Wg7v5guPXgv04gmldAisXgatlwPHy9+4rrW8p6yzpqqtoJ2rjpe9cJG1sYDNynkvaXitd3GvTDPaIi3f0iatoiLFuCCwNxyYVRimBhikDBHbtRCwZxCvXBDYlw/z3A7qzg26Vgz66Avr2guibQu3TQnlvweYXwb/+wWynwK5pgHP5+zHzOrI0dC8vM69tcm7tr/JrrvGl61Oc6a7g5+3mZ69wZvSZJawgYu4tYqzoH6mjHx0h3itZnO/qmRGRmCocF+hmlhMKVjcS1SmslDj3ky7hkzcMTunnTqjMzpnMTTbKjRgVTDn3CyffSq6tCmdXiigFiXOyiS/tyLVzyGlIh3XxhrQxBqulxq1IRq4rBnQqRW7XhWcHxXBtxSjLRRtahHarBCcbxDIkQ/FWA+eRQ/78Q6TgQ6BIA6vfg3q3wyeZgzh0QuiVgt+NguILwujfwp6dwqUcgm1RgmoRAeIawV2agDCxtPAvbq+rrfMc5x+jpi8uZSVnZGmcoiinoc+WoPAcoFYdIC0qHbiZ280OW/HwW10d2yzdmNCcGLRwmGLmV/XzlfByFaep1KvbFKcSlFgJU/WQUqgWkWAHkJXWUBzKUBXXTuphjm4vDe4uzfs4TTLwDSkKDS0qTKpqTKZmzCrezCXOyyePym5iifm4yPcFyOMOiKvTx2qKB3e1RyVSxpxghiaIhZzbxPlxA/Gow/BnQ/Siw6+dA68Vw6iUQyWbgu/dAqvewilZAibYwiBXghwRQhxUgemdgZvSQbCegO9rADRkQDxR9ljAAAABnRSTlPt7fLt7dz92IIiAAADY0lEQVRYw+zNQQ0AMAzEsKhaK238AY9FPj0TMI2jqXEUjINMmTJl2jc9B5zr+GJhYOagD2BmYGSnD2AkwiZePgwh2tjEKx7PiyZEE5v4uPknz+LmRvYWLWziNjc3Fpt0x1BssrG5OTdYiDY28YoF9Qeq2E4LtLUN7A4SAwnRxiZusWkS4VOiFty9siBqynSJWUbc7LSyCSCjhKkmIcKhIstDZUNMp0b008gmPnY+44SZE0U+yomIyC1Mni0s8gwoRAOb+OO5ebnj1zwXsZu3/Ns8O5EQhxXc7Py2/FS3KW6+3dJoPg6OVNUXiz8lL16rqmovxSf0Zt1be17q2sTLvubndwn28KTpdquWLLmn39N143qnkNK6HxvFqWwTu9Bfp9Rl4sKhJpamJlbumZpbdmvlBAilOaWJ81HZJoGg2hYlcTOT1b9Xmcq6F7p67vVwCRC9VdsSR+14EtXJKOIWNxPetHGtZZj7Vs/iAhetACnvjFKq2wRQik52WUyMmWzHnMsvw9zcCrbluWqJSVRlewlSN/R4haJmBMvICMuadry6ODPMV9PFszhX8/56GZkn1tG81LSJW8JKv7Ds9XxZi0175qw+W3fGI29XruaDpCrX81Zz+akaevzWR9I93isJW1lcsGjz8WkryXTL0Xr4zze9XF2Jl8rxdKKkd8ayZLmFjsJ1PkcPWvr5+bVOetdbuT+Fm8opAiDrpzdPC6n8Upb8suFxdfWl9eqxf+QV+JtaJ6pHU9dPvMpNm4v4VByUJTUUHS0tEm3UY23kFaS8nctnx3BT1SbupGPOO9ghNkV+lbOxMYz4ALbJK5zapZGUTlYpr0oC2CZJOTW1CDU1oE2HsrwEqZ1zBdJUneyVHBRBodejryYTG/xZXkIgVdVJiMp+EgCoT89Q7za/wsqVGhsca3yDE9UTzaw5jICC3VQuYQVPaedr77PnX7G0q2ZnxeHtlfqRcxcJHgcKVghQuX6aYHDVwEiInZvbuFGnoeFkY+cifpDgNYM+qseToKAg2PV8oqKiAqKifHBBSmyiD2CkX6+Gfj01uvU+h2nfHTDsEqM2jdpEY4CwiQcIaQYQNvHw8LTrPgKSCBka2aTb7F9/oF5a2h9hFY1sktaVbtdtlj5He5t4wIC2oUe/WSH6zXQBAFrHfL80gsKEAAAAAElFTkSuQmCC"

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("7uin");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("DxUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_2a6d97f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("zzui");
function injectStyle (ssrContext) {
  __webpack_require__("DV/k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_2a6d97f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "67RI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends4 = __webpack_require__("Dd8w");

var _extends5 = _interopRequireDefault(_extends4);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _stroage = __webpack_require__("DsOT");

var _nameSpace = __webpack_require__("Eeb1");

var _nameSpace2 = __webpack_require__("Ypiv");

var _cache = __webpack_require__("TuU3");

var _vcTimingTradeConfig = __webpack_require__("2ol5");

var _vc = __webpack_require__("CJgj");

var _utils = __webpack_require__("oAV5");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    vcId: (0, _stroage.getStorage)(_nameSpace.__VC_ID__, !0) || '',
    tradeConfig: (0, _cache.initStateInCacheHas)(_nameSpace.__TRADE_CONFIG__),
    vcList: (0, _cache.initStateInCacheHas)(_nameSpace.__VC_LIST__),
    coinListWithPrice: (0, _stroage.getStorage)(_nameSpace.__COIN_LIST_WITH_PRICE__) || []
  },
  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_COIN_LIST_WITH_PRICE, function (state, coinListWithPrice) {
    state.coinListWithPrice = coinListWithPrice;
    (0, _stroage.setStorage)(_nameSpace.__COIN_LIST_WITH_PRICE__, coinListWithPrice);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_VC_LIST, function (state, vcList) {
    state.vcList = vcList;
    (0, _stroage.setStorage)(_nameSpace.__VC_LIST__, vcList);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_VC_ID, function (state, vcId) {
    state.vcId = vcId;
    (0, _stroage.setStorage)(_nameSpace.__VC_ID__, vcId);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_TRADE_CONFIG, function (state, tradeConfig) {
    state.tradeConfig = tradeConfig;
    (0, _stroage.setStorage)(_nameSpace.__TRADE_CONFIG__, tradeConfig);
  }), _mutations),
  actions: {
    /***
     * 获取带价格行情的币种列表
     * @param commit
     * @returns {Promise<unknown>}
     */
    getCoinListWithPrice: function getCoinListWithPrice(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        (0, _vc.vcMarketList)({}).then(function (res) {
          if (res.success) {
            commit(_nameSpace2.SET_COIN_LIST_WITH_PRICE, res.data.map(function (coinItem) {
              return (0, _extends5.default)({}, coinItem, {
                changePerStr: (0, _utils.formatNumberToPercent)(coinItem.l)
              });
            }));
          }
          return resolve();
        }).catch(reject);
      });
    },
    setVcId: function setVcId(_ref2, vcId) {
      var commit = _ref2.commit,
          getters = _ref2.getters,
          dispatch = _ref2.dispatch;

      return new _promise2.default(function (resolve, reject) {
        if (!vcId) return reject('No Such vcId');
        commit(_nameSpace2.SET_VC_ID, vcId);
        return resolve();
        /* if (!getters.tradeConfig.length) {
          dispatch('getTradeConfig').then(tradeConfig => {
            if (tradeConfig.find(vcConfig => vcConfig.vcId === vcId)) {
              commit(SET_VC_ID, vcId)
              return resolve(vcId)
            } else {
              return reject(new Error('该币种暂时无法交易'))
            }
          })
        } else {
          if (getters.tradeConfig.find(vcConfig => vcConfig.vcId === vcId)) {
            commit(SET_VC_ID, vcId)
            return resolve(vcId)
          } else {
            return reject(new Error('该币种暂时无法交易'))
          }
        } */
      });
    },
    getTradeConfig: function getTradeConfig(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state,
          getters = _ref3.getters,
          dispatch = _ref3.dispatch;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          noCache = _ref4.noCache;

      return new _promise2.default(function (resolve, reject) {
        if (!noCache && (0, _cache.checkCacheVersionIsRight)(state.tradeConfig)) {
          return resolve(getters.tradeConfig);
        } else {
          (0, _vcTimingTradeConfig.vcTimingTradeConfig)({}).then(function (res) {
            if (res.success) {
              var tradeConfig = res.data;

              commit(_nameSpace2.SET_TRADE_CONFIG, (0, _extends5.default)({}, state.tradeConfig, (0, _defineProperty3.default)({}, 'value_' + getters.locale, {
                data: tradeConfig,
                finishUpdateTime: (0, _cache.findTargetUpdateTimeByKey)(_nameSpace.__TRADE_CONFIG__)
              })));
              if (!getters.vcId) {
                dispatch('setVcId', tradeConfig[0]['vcId']);
              }
              return resolve(tradeConfig);
            } else {
              return reject(new Error(res.message));
            }
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    },
    getVcList: function getVcList(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state,
          getters = _ref5.getters,
          dispatch = _ref5.dispatch;

      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          noCache = _ref6.noCache;

      return new _promise2.default(function (resolve, reject) {
        if (!noCache && (0, _cache.checkCacheVersionIsRight)(state.vcList)) {
          return resolve(getters.vcList);
        } else {
          (0, _vc.vcList)({}).then(function (res) {
            if (res.success) {
              var _vcList = res.data;

              commit(_nameSpace2.SET_VC_LIST, (0, _extends5.default)({}, state.vcList, (0, _defineProperty3.default)({}, 'value_' + getters.locale, {
                data: _vcList,
                finishUpdateTime: (0, _cache.findTargetUpdateTimeByKey)(_nameSpace.__VC_LIST__)
              })));
              setTimeout(function () {
                return resolve(_vcList);
              }, 0);
            } else {
              return reject(new Error(res.message));
            }
          }).catch(function (err) {
            console.log(err);
            reject(err);
          });
        }
      });
    }
  }
};

/***/ }),

/***/ "6Q4U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _popup = __webpack_require__("+v63");

var _popup2 = _interopRequireDefault(_popup);

var _dom = __webpack_require__("te2A");

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new _popup2.default({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && (0, _keys2.default)(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && _dom2.default.removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && _dom2.default.addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
};

/***/ }),

/***/ "75l9":
/***/ (function(module, exports) {

module.exports = {"_args":[["axios@0.21.4","/opt/work/workspace/fxmt-pc-page"]],"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_spec":"0.21.4","_where":"/opt/work/workspace/fxmt-pc-page","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),

/***/ "7uin":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'confirm',
  components: {
    XDialog: _xDialog2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "92Bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preventBodyScroll = __webpack_require__("JkZY");

var _preventBodyScroll2 = _interopRequireDefault(_preventBodyScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_preventBodyScroll2.default],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "9qnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.headerVisible)?_c('div',{staticClass:"fix-header content-bg",style:({ zIndex: _vm.zIndex })},[(_vm.leftVisible)?_c('div',{staticClass:"header-arrow",on:{"click":function($event){return _vm.$emit('backClick')}}},[_c('i',{staticClass:"iconfont icon-arrow-left back txt-color"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header-content"},[_vm._t("title",function(){return [_c('h3',{staticClass:"title txt-color"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]})],2),_vm._v(" "),_c('div',{staticClass:"header-right txt-color"},[_vm._t("right",function(){return [(_vm.showFilter)?_c('div',{staticClass:"filter txt-color",on:{"click":function($event){return _vm.$emit('clickFilter')}}},[_vm._v("\n        筛选\n      ")]):_vm._e()]})],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A+Om":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"theme-switch second-content-bg",on:{"click":_vm.switchTheme}},[_c('span',{staticClass:"switch-check third-content-bg"},[_c('span',{staticClass:"switch-icon"},[_c('svg',{staticClass:"switch-appearance-sun",attrs:{"xmlns":"http://www.w3.org/2000/svg","focusable":"false","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12,18c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S15.3,18,12,18zM12,8c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C16,9.8,14.2,8,12,8z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12,4c-0.6,0-1-0.4-1-1V1c0-0.6,0.4-1,1-1s1,0.4,1,1v2C13,3.6,12.6,4,12,4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12,24c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2C13,23.6,12.6,24,12,24z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.6,6.6c-0.3,0-0.5-0.1-0.7-0.3L3.5,4.9c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l1.4,1.4c0.4,0.4,0.4,1,0,1.4C6.2,6.5,5.9,6.6,5.6,6.6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M19.8,20.8c-0.3,0-0.5-0.1-0.7-0.3l-1.4-1.4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l1.4,1.4c0.4,0.4,0.4,1,0,1.4C20.3,20.7,20,20.8,19.8,20.8z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h2c0.6,0,1,0.4,1,1S3.6,13,3,13z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M23,13h-2c-0.6,0-1-0.4-1-1s0.4-1,1-1h2c0.6,0,1,0.4,1,1S23.6,13,23,13z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4.2,20.8c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l1.4-1.4c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-1.4,1.4C4.7,20.7,4.5,20.8,4.2,20.8z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18.4,6.6c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l1.4-1.4c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-1.4,1.4C18.9,6.5,18.6,6.6,18.4,6.6z"}})]),_vm._v(" "),_c('svg',{staticClass:"switch-appearance-moon",attrs:{"xmlns":"http://www.w3.org/2000/svg","focusable":"false","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12.1,22c-0.3,0-0.6,0-0.9,0c-5.5-0.5-9.5-5.4-9-10.9c0.4-4.8,4.2-8.6,9-9c0.4,0,0.8,0.2,1,0.5c0.2,0.3,0.2,0.8-0.1,1.1c-2,2.7-1.4,6.4,1.3,8.4c2.1,1.6,5,1.6,7.1,0c0.3-0.2,0.7-0.3,1.1-0.1c0.3,0.2,0.5,0.6,0.5,1c-0.2,2.7-1.5,5.1-3.6,6.8C16.6,21.2,14.4,22,12.1,22zM9.3,4.4c-2.9,1-5,3.6-5.2,6.8c-0.4,4.4,2.8,8.3,7.2,8.7c2.1,0.2,4.2-0.4,5.8-1.8c1.1-0.9,1.9-2.1,2.4-3.4c-2.5,0.9-5.3,0.5-7.5-1.1C9.2,11.4,8.1,7.7,9.3,4.4z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A29d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ABCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("26Nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0Rqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_26523019_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("WAoa");
function injectStyle (ssrContext) {
  __webpack_require__("HNSI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_26523019_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AqkY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-button",class:_vm.type,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('button.confirm')))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AwbH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("uCgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z5JB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_73f1dc7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Vr/s");
function injectStyle (ssrContext) {
  __webpack_require__("Z/xP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_73f1dc7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "C5nv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue__ = __webpack_require__("D+3M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue__ = __webpack_require__("iPEl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a54771_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Cell_vue__ = __webpack_require__("TEkW");
function injectStyle (ssrContext) {
  __webpack_require__("oOSo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41a54771"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a54771_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Cell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CBEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue__ = __webpack_require__("lixA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue__ = __webpack_require__("e25r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_120f08fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_CButton_vue__ = __webpack_require__("AqkY");
function injectStyle (ssrContext) {
  __webpack_require__("JOEE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-120f08fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CButton_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_120f08fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_CButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CJgj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vcMarketDetailKline = exports.vcMarketDetail = exports.vcList = exports.vcMarketList = exports.vcMarketKline = undefined;

var _request = __webpack_require__("vLgD");

var _request2 = _interopRequireDefault(_request);

var _prefix = __webpack_require__("jnOm");

var _prefix2 = _interopRequireDefault(_prefix);

var _auth = __webpack_require__("Pfph");

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***
 * 获取货币K线图
 * @param data
 * @returns {AxiosPromise}
 */
var vcMarketKline = exports.vcMarketKline = function vcMarketKline(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/vc/market/kline',
    method: 'post',
    data: data
  });
};

/***
 * 获取行情列表[带价格数据]
 * @param data
 * @returns {AxiosPromise}
 */
var vcMarketList = exports.vcMarketList = function vcMarketList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/vc/market/list',
    method: 'post',
    data: data
  });
};

/***
 * 获取币种列表[不带行情数据 只做静态展示]
 * @param data
 * @returns {AxiosPromise}
 */
var vcList = exports.vcList = function vcList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/vc/list',
    method: 'post',
    data: data
  });
};

/***
 * 获取货币最新行情
 * @param data
 * @returns {AxiosPromise}
 */
var vcMarketDetail = exports.vcMarketDetail = function vcMarketDetail(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/vc/market/detail',
    method: 'post',
    data: data
  });
};

/***
 * 获取货币最新行情
 * @param data
 * @returns {AxiosPromise}
 */
var vcMarketDetailKline = exports.vcMarketDetailKline = function vcMarketDetailKline(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/vc/market/detail-kline',
    method: 'post',
    data: data
  });
};

/***/ }),

/***/ "CMqz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

var _datetimepicker = __webpack_require__("zV4+");

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _group = __webpack_require__("rHil");

var _group2 = _interopRequireDefault(_group);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _uuid = __webpack_require__("KRg4");

var _uuid2 = _interopRequireDefault(_uuid);

var _format2 = __webpack_require__("ODCk");

var _format3 = _interopRequireDefault(_format2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'datetime',
  mixins: [_uuid2.default],
  components: {
    Group: _group2.default,
    InlineDesc: _inlineDesc2.default,
    Icon: _icon2.default
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = (0, _keys2.default)(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new _datetimepicker2.default(_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = (0, _format3.default)(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
};

/***/ }),

/***/ "D+3M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Cell',
  props: {
    title: {
      required: true,
      type: String
    },
    value: {
      required: false,
      type: [String, Number]
    },
    isLink: {
      required: false,
      type: Boolean,
      default: false
    }
  }
};

/***/ }),

/***/ "DS/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"right","width":"100%"},model:{value:(_vm.currentVisibleVModel),callback:function ($$v) {_vm.currentVisibleVModel=$$v},expression:"currentVisibleVModel"}},[_c('div',{staticClass:"customer-service base-bg"},[(_vm.customer.show)?[_c('iframe',{attrs:{"src":_vm.PORTAL_systemConfig['customerUrl'],"frameborder":"0","width":"100%","height":"100%"}})]:_vm._e(),_vm._v(" "),(_vm.closeVisible)?_c('span',{staticClass:"close",on:{"click":function($event){_vm.currentVisibleVModel = false}}},[_c('i',{staticClass:"iconfont icon-close"})]):_vm._e()],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DV/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DsOT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearStorageItem = exports.getStorage = exports.setStorage = undefined;

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***
 * 存储缓存内容
 * @param key
 * @param val
 */
function setStorage(key, val) {
  if (key === undefined || val === undefined) return;
  window.localStorage.setItem(key, (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' ? (0, _stringify2.default)(val) : val);
}

/***
 * 获取指定缓存内容
 * @param key
 * @param noParse
 * @returns {string}
 */
function getStorage(key) {
  var noParse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (key === undefined) return '';
  var val = void 0;
  try {
    if (noParse) {
      val = window.localStorage.getItem(key);
    } else {
      val = JSON.parse(window.localStorage.getItem(key));
    }
  } catch (e) {
    val = window.localStorage.getItem(key);
  }
  return val;
}

/***
 * 删除指定缓存内容
 * @param key
 * @returns {string}
 */
function clearStorageItem(key) {
  window.localStorage.removeItem(key);
}

exports.setStorage = setStorage;
exports.getStorage = getStorage;
exports.clearStorageItem = clearStorageItem;

/***/ }),

/***/ "DxUy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'confirm',
  components: {
    XDialog: _xDialog2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "EN2Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: 'Masuk',
    usernameLabel: 'Nama Pengguna',
    usernamePlaceholder: 'Masukkan 2-10 kombinasi digit nama Anda',
    loginPasswordLabel: 'kata sandi masuk',
    loginPasswordPlaceholder: 'Masukkan kata sandi Anda',
    googleCodeLabel: 'kode verifikasi Google',
    googleCodePlaceholder: 'Masukkan kode verifikasi Google 6 digit',
    hasNoAccount: 'Belum ada akun,',
    goRegister: 'Pergi untuk mendaftar',
    onlineCustom: 'Layanan pelanggan online',
    loginArgument: 'Melanjutkan login berarti setuju',
    userArgument: '《Perjanjian Pengguna》',
    registerNotEnabled: 'Fungsi pendaftaran tidak terbuka, harap hubungi administrator',
    usernameRequired: 'Masukkan nama pengguna yang benar',
    loginPasswordRequired: 'Masukkan kata sandi login yang benar',
    googleCodeRequired: 'Masukkan kode verifikasi Google yang benar',
    loginButton: 'Masuk'
  },
  register: {
    title: 'Daftar',
    usernameLabel: 'Nama Pengguna',
    usernamePlaceholder: 'Masukkan 2-10 kombinasi digit nama Anda',
    loginPasswordLabel: 'Kata sandi masuk',
    loginPasswordPlaceholder: 'Masukkan kata sandi Anda',
    loginPasswordPreLabel: 'Konfirmasi kata sandi masuk',
    loginPasswordPrePlaceholder: 'Masukkan ulang kata sandi Anda',
    fudPasswordLabel: 'Kata sandi dana',
    fudPasswordPlaceholder: 'Masukkan kata sandi dana',
    inviteCodeLabel: 'Kode Undangan',
    inviteCodePlaceholder: 'Masukkan kode undangan 6 digit',
    registerNeed: 'Lanjutkan daftar berarti setuju',
    registerArgument: '《Perjanjian Pendaftaran》',
    usernameRequired: 'Masukkan nama pengguna yang benar',
    loginPasswordRequired: 'Masukkan kata sandi login yang benar',
    loginPasswordPreRequired: 'Masukkan kata sandi login konfirmasi yang benar',
    fundPasswordRequired: 'Masukkan kata sandi dana yang benar',
    inviteCodeRequired: 'Masukkan kode undangan yang benar',
    diffLoginPasswordError: 'Kedua kata sandi masuk tidak konsisten',
    registerSuccess: 'Pendaftaran berhasil',
    registerButton: 'Daftar',
    emailLabel: 'Email',
    emailPlaceholder: 'Masukkan alamat email Anda',
    emailCodeLabel: 'Kode verifikasi',
    emailCodePlaceholder: 'Masukkan kode verifikasi email Anda',
    second: 'kedua',
    getEmailCodeButton: 'Dapatkan kode',
    emailRequired: 'Masukkan alamat email yang benar dan coba lagi',
    emailCodeRequired: 'Masukkan kode verifikasi email yang benar dan coba lagi'
  },
  home: {
    hotCoin: {
      title: 'Penawaran Panas',
      more: 'Lebih'
    },
    poster: {
      title: 'Setoran cepat',
      enter: 'Masuk sekarang>',
      subTitle: 'Mendukung BTC, USDT, ETH, dll.'
    },
    quickMenus: {
      futuresTrading: 'Perdagangan Berjangka',
      helpCenter: 'Pusat Bantuan'
    },
    ranking: {
      increase: {
        title: 'Daftar naik'
      },
      clinch: {
        title: 'Daftar Omzet'
      }
    }
  },
  tabBar: {
    home: 'Beranda',
    price: 'Market',
    trade: 'Trade',
    fund: 'Aset',
    user: 'Profil'
  },
  currency: {
    favorite: 'Opsional',
    allCurrency: 'titik',
    dayVol: 'jumlah 24 jam',
    addFavor: '+ Tambahkan Bantuan'
  },
  trade: {
    bills: 'Tagihan',
    todayOpen: 'Buka',
    star: 'Opsional',
    vol: 'Volume',
    low: 'terendah',
    high: 'tertinggi',
    timing: 'Kecepatan ekstrim',
    spot: 'Futures',
    buyMore: 'beli lebih banyak',
    buyEmpty: 'beli pendek',
    indicator: 'Indikator',
    indicatorSettings: 'Pengaturan Indikator',
    balance: 'saldo saya',
    fee: 'biaya layanan',
    ruleIdError: 'Silakan pilih waktu kedaluwarsa',
    deleteFavoriteSuccess: 'Berhasil menghapus mata uang favorit',
    addFavoriteSuccess: 'Menambahkan mata uang yang dipilih berhasil',
    buyIn: 'beli',
    sellOut: 'Jual',
    holding: 'memegang posisi',
    history: 'Sejarah',
    spotOrderConfirm: {
      title: 'Konfirmasi Beli',
      amountPlaceholder: 'Masukkan jumlah pembelian'
    },
    spotTradeOrder: {
      holding: {
        coin: 'mata uang',
        buyInAmountPrice: 'Harga total beli/harga satuan',
        buyInCount: 'Kuantitas',
        actions: 'operasi',
        sellOut: 'Jual',
        profit: 'untung dan rugi'
      }
    },
    orderConfirm: {
      title: 'Konfirmasi Pesanan',
      coinName: 'mata uang',
      direction: 'arah',
      price: 'harga saat ini',
      balance: 'Saldo({simbol})',
      fee: 'biaya layanan',
      buyMoreLabel: 'beli lebih banyak',
      buyEmptyLabel: 'beli pendek',
      buyQuantity: 'Miktar satın al',
      buyAmount: 'Jumlah Pembelian',
      submit: 'Konfirmasi pesanan'
    },
    garis: {
      buka: 'Buka:',
      tutup: 'tutup:',
      ubah: 'Atas dan bawah:'
    }
  },
  finance: {
    title: 'Keuangan'
  },
  allFinance: {
    title: 'Manajemen keuangan',
    all: 'semua'
  },
  financeOrders: {
    title: 'Perintah gadai',
    holdingLabel: 'memegang',
    historyLabel: 'Sejarah',
    holding: {
      amount: 'Jumlah janji',
      rateStr: 'jumlah pendapatan/hasil',
      vcCount: 'Jumlah koin yang dijaminkan',
      cycle: 'Siklus posisi',
      day: 'hari',
      calcStartDate: 'Mulai tanggal nilai',
      serviceAmount: 'Biaya Layanan',
      redeemOrder: 'Tukarkan'
    },
    history: {
      incomeAmount: 'jumlah pendapatan',
      rateStr: 'hasil',
      amount: 'Jumlah janji',
      vcCount: 'Jumlah koin yang dijaminkan',
      calcStartDate: 'Mulai tanggal nilai',
      calcEndDate: 'Tanggal Akhir',
      cycle: 'hari siklus',
      serviceAmount: 'Biaya Layanan',
      day: 'hari'
    }
  },
  financeOrderBills: {
    title: 'Tagihan pendapatan gadai',
    amount: 'jumlah',
    balance: 'Saldo'
  },
  financeItem: {
    rateStr: 'hasil',
    buyType: 'Tipe Beli',
    cycle: 'hari siklus',
    exchangeRate: 'Kurs (saldo pertukaran mata uang virtual)',
    day: 'hari',
    cycleType: 'tipe siklus',
    serviceRateStr: 'Tarif Layanan'
  },
  buyFinance: {
    title: 'Beli',
    rateStr: 'hasil',
    name: 'nama',
    buyType: 'Tipe Beli',
    cycle: 'hari siklus',
    cycleType: 'tipe siklus',
    exchangeRate: 'Kurs (saldo pertukaran mata uang virtual)',
    serviceRateStr: 'Tarif Layanan',
    remark: 'komentar',
    buyAmountLabel: 'Jumlah Beli ({coin})',
    descriptionTitle: 'Deskripsi Produk',
    descriptionPart1: '1. Produk ini adalah produk manajemen kekayaan tanpa jaminan pokok. Fluktuasi pasar dapat menyebabkan kerugian pokok. Silakan berinvestasi dengan hati-hati.',
    descriptionPart2: '2. Aturan penyelesaian pembayaran:',
    descriptionPart3: 'Jika harga penyelesaian < harga yang ditautkan, BTC akan diselesaikan setelah jatuh tempo; jumlah penyelesaian = jumlah investasi * (1+ hari * tingkat pengembalian tahunan / 365).',
    descriptionPart4: 'Jika harga penyelesaian ≥ harga terkait, USDT akan diselesaikan setelah jatuh tempo; jumlah penyelesaian = jumlah investasi * harga terkait * (1+ hari * tingkat pengembalian tahunan / 365).',
    descriptionPart5: '3. Tingkat pengembalian aktual tahunan berubah dengan pasar secara real time, silakan merujuk ke transaksi pembelian aktual.',
    descriptionPart6: '4. Jumlah investasi dikonversi sesuai dengan pasar secara real time, silakan lihat transaksi pembelian yang sebenarnya.',
    descriptionPart7: '5. Setelah produk dibeli, dapat dilihat di halaman penyimpanan mata uang saya, dan pengembalian dana akan secara otomatis dikeluarkan ke akun spot setelah tanggal kedaluwarsa.',
    buyButton: 'Beli [{coin}]'
  },

  fund: {
    description: 'aset',
    recharge: 'Isi ulang',
    withdraw: 'tarik koin',
    exchange: 'Transfer',
    empty: 'Dompet kosong, ayo'
  },
  userCenter: {
    lastLogin: 'Login terakhir',
    myTeam: 'Tim Saya',
    identity: 'otentikasi nama asli',
    zskAccount: 'ZSK akun',
    walletAddress: 'alamat dompet',
    bankCard: 'Rekening bank',
    userBills: 'Catatan Perubahan Akun',
    timingTradeOrder: 'Posisi sangat cepat',
    contactTradeOrder: 'Posisi kontrak',
    userReport: 'Laporan Pengguna',
    teamReport: 'laporan tim',
    share: 'Saya ingin berbagi',
    customer: 'Hubungi layanan pelanggan',
    helpCenter: 'Pusat Bantuan',
    platform: 'Pengenalan Platform',
    profit: 'Laba dan rugi hari ini',
    balance: 'Saldo saya',
    withdraw: 'Tarik koin',
    recharge: 'Isi ulang',
    creditStoreLabel: 'Point Kredit'
  },
  settings: {
    title: 'Pengaturan',
    fundPassword: 'kata sandi dana',
    googleValidator: 'Validator Google',
    editLoginPassword: 'Ubah kata sandi masuk',
    switchLocale: 'beralih bahasa'
  },
  editFundPassword: {
    title: 'Ubah Kata Sandi Dana',
    currentPasswordLabel: 'kata sandi saat ini',
    currentPasswordPlaceholder: 'Masukkan kata sandi dana saat ini',
    newPasswordLabel: 'Kata Sandi Baru',
    newPasswordPlaceholder: 'Masukkan kata sandi dana yang dimodifikasi',
    prePasswordLabel: 'Konfirmasi kata sandi',
    prePasswordPlaceholder: 'Hapus dan masukkan kembali kata sandi dana yang dimodifikasi',
    tips: 'Password dana adalah sertifikat penting untuk transaksi, harap atur dengan hati-hati dan ingat baik-baik',
    currentPasswordRequired: 'Masukkan kata sandi dana saat ini',
    newPasswordRequired: 'Masukkan sandi dana yang akan diubah',
    prePasswordRequired: 'Masukkan sandi dana untuk diubah lagi',
    prePasswordDiff: 'Dua input kata sandi tidak konsisten'
  },
  bindFundPassword: {
    title: 'Ikat kata sandi dana',
    fundPasswordLabel: 'kata sandi dana',
    fundPasswordPlaceholder: 'Masukkan kata sandi dana',
    fundPasswordPreLabel: 'Konfirmasi Kata Sandi',
    fundPasswordPrePlaceholder: 'Silakan masukkan kata sandi dana lagi',
    fundPasswordRequired: 'Masukkan kata sandi dana yang benar',
    fundPasswordPreRequired: 'Masukkan kata sandi konfirmasi yang benar',
    fundPasswordDiff: 'Kedua kata sandi tidak konsisten',
    bindSuccess: 'Kata sandi dana berhasil diikat',
    tips: 'Password dana adalah kredensial penting untuk transaksi, harap atur dengan hati-hati dan ingat baik-baik'
  },
  editLoginPassword: {
    title: 'Ubah kata sandi login',
    currentPasswordLabel: 'kata sandi saat ini',
    currentPasswordPlaceholder: 'Masukkan kata sandi login saat ini',
    newPasswordLabel: 'Kata Sandi Baru',
    newPasswordPlaceholder: 'Masukkan kata sandi login yang dimodifikasi',
    prePasswordLabel: 'Konfirmasi kata sandi',
    prePasswordPlaceholder: 'Hapus dan masukkan kembali kata sandi login yang dimodifikasi',
    tips: 'Kata sandi masuk adalah kredensial penting untuk autentikasi masuk, dll., harap atur dengan hati-hati dan ingat baik-baik',
    currentPasswordRequired: 'Masukkan kata sandi login saat ini',
    newPasswordRequired: 'Masukkan kata sandi login yang akan diubah',
    prePasswordRequired: 'Harap masukkan kembali kata sandi login yang akan diubah',
    prePasswordDiff: 'Dua input kata sandi tidak konsisten'
  },
  bindGoogleValidator: {
    title: 'Ikat Google Authenticator',
    qrCodeLabel: 'kode QR',
    keyLabel: 'Kunci',
    loginPasswordLabel: 'kata sandi masuk',
    loginPasswordPlaceholder: 'Masukkan kata sandi login Anda',
    googleCodeLabel: 'kode verifikasi Google',
    googleCodePlaceholder: 'Masukkan kode verifikasi Google 6 digit',
    tipsPart1: 'Cari Google Authenticator di app store',
    tipsPart2: 'Gunakan Google Authenticator untuk memindai kode QR di atas, atau masukkan kunci untuk pengikatan secara manual',
    tipsPart3: 'Masukkan 6 digit kode verifikasi Google di atas, klik Confirm to submit',
    loginPasswordRequired: 'Masukkan kata sandi login',
    googleCodeRequired: 'Masukkan kode verifikasi Google 6 digit'
  },
  walletAddress: {
    title: 'Alamat Dompet',
    add: '+ tambahkan alamat dompet',
    remark: 'komentar',
    addButton: 'Tambahkan alamat dompet',
    tips: 'Jika Anda ingin mengubah atau menghapus informasi alamat, harap hubungi layanan pelanggan'
  },
  addWalletAddress: {
    title: 'Tambahkan alamat dompet',
    vcChainNameIdLabel: 'tipe rantai',
    vcAccountLabel: 'alamat dompet',
    vcAccountPlaceholder: 'Masukkan alamat dompet',
    remarkLabel: 'Keterangan',
    remarkPlaceholder: 'Masukkan konten komentar',
    fundPasswordLabel: 'kata sandi dana',
    fundPasswordPlaceholder: 'Masukkan kata sandi dana Anda',
    tips: 'Alamat dompet yang ditambahkan tidak dapat diubah, harap verifikasi bahwa informasinya benar',
    vcIdRequired: 'Silakan pilih mata uang yang benar',
    vcChainNameIdRequired: 'Silakan pilih jenis rantai yang benar',
    vcAccountRequired: 'Masukkan alamat dompet yang benar',
    fundPwdRequired: 'Silakan masukkan kata sandi dana yang benar',
    addSuccess: 'Alamat dompet berhasil ditambahkan'
  },
  receiveWays: {
    title: 'Kartu Bank Saya',
    add: '+ Tambahkan kartu bank',
    tips: 'Jika Anda ingin mengubah atau menghapus informasi kartu bank, harap hubungi layanan pelanggan',
    addCardButton: 'Tambahkan kartu bank'
  },
  zskAccount: {
    title: 'Akun cepat',
    add: '+ Tambahkan akun cepat',
    tips: 'Untuk mengubah atau menghapus informasi akun, harap hubungi layanan pelanggan',
    addCardButton: 'Tambah akun'
  },
  addZskAccount: {
    title: 'Tambahkan akun cepat',
    withdrawNameLabel: 'Nama',
    withdrawNamePlaceholder: 'Silakan masukkan nama Anda',
    withdrawNameRequired: 'Nama tidak boleh kosong',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Masukkan ZSK',
    fundPasswordLabel: 'Kata sandi dana',
    fundPasswordPlaceholder: 'Masukkan kata sandi dana Anda',
    tips: 'Harap isi informasi akun yang ditambahkan dengan hati-hati, perusahaan tidak akan bertanggung jawab atas masalah penarikan yang gagal tiba karena informasi yang salah'
  },
  addBankCard: {
    title: 'Tambahkan kartu bank baru',
    withdrawNameLabel: 'Nama',
    withdrawNamePlaceholder: 'Silakan masukkan nama Anda',
    withdrawNameRequired: 'Nama tidak boleh kosong',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Masukkan ZSK',
    zskRequired: 'ZSK ID Dibutuhkan',
    cardNumLabel: 'Nomor kartu bank',
    cardNumPlaceholder: 'Masukkan nomor kartu bank',
    branchLabel: 'Alamat cabang',
    branchPlaceholder: 'Masukkan alamat cabang kartu bank',
    fundPasswordLabel: 'kata sandi dana',
    fundPasswordPlaceholder: 'Masukkan kata sandi dana',
    tips: 'Kartu bank adalah data penting untuk transaksi tarik tunai, harap isi dengan hati-hati, perusahaan tidak akan bertanggung jawab atas masalah seperti kegagalan menerima uang tunai karena pengisian informasi kartu yang salah. ',
    backIdRequired: 'Silakan pilih bank rekening',
    cardNumRequired: 'Masukkan nomor kartu bank yang benar',
    fundPwdRequired: 'Masukkan kata sandi dana yang benar',
    idCardPlaceholder: 'Masukkan nomor ID Anda',
    idCardLabel: 'nomor KTP',
    idCardDiperlukan: 'Masukkan nomor ID yang benar',
    cciPlaceholder: 'Masukkan CCI kartu bank',
    branchCodePlaceholder: 'Silakan masukkan kode cabang',
    branchCodeLabel: 'Kode cabang',
    katakanaPlaceholder: 'Silakan masukkan katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Catatan Perubahan Akun',
    vcName: 'Mata uang',
    amount: 'jumlah',
    balance: 'Saldo'
  },
  timingTradeOrder: {
    title: 'Perintah Trading Sangat Cepat',
    waiting: {
      title: 'Pesanan dalam proses',
      amount: 'jumlah',
      period: 'periode',
      receivePrice: 'Harga beli',
      settlement: 'penyelesaian sedang berlangsung'
    },
    history: {
      title: 'Historical Orders',
      buyInClose: 'Harga beli',
      saleOutClose: 'harga jual'
    }
  },
  userReport: {
    title: 'Laporan Pengguna',
    profit: 'Untung',
    timingTradeAmountFee: 'Biaya penanganan/pesanan perdagangan yang sangat cepat',
    timingTradePrizePoint: 'Bonus/rabat perdagangan yang sangat cepat',
    rechargeInfo: 'Biaya isi ulang/penanganan',
    withdrawInfo: 'Biaya penarikan/penanganan',
    exchangeInfo: 'Biaya penukaran/penanganan'
  },
  userReportDay: {
    title: 'Laporan Harian Pengguna',
    profit: 'Untung',
    timingTradeAmountFee: 'Biaya penanganan/pesanan perdagangan yang sangat cepat',
    timingTradePrizePoint: 'Bonus/rabat perdagangan yang sangat cepat',
    rechargeInfo: 'Biaya isi ulang/penanganan',
    withdrawInfo: 'Biaya penarikan/penanganan',
    exchangeInfo: 'Biaya penukaran/penanganan'
  },
  teamReport: {
    title: 'Laporan Tim',
    goToReportDay: 'Lihat laporan harian',
    timingTradeBetAmountServiceCharge: 'Pesanan perdagangan/biaya layanan yang sangat cepat',
    timingTradeBetPrizePoint: 'Bonus/Rabat Trading Cepat',
    timingTradeUserAndCount: 'Jumlah pedagang cepat/jumlah transaksi',
    rechargeAmountFee: 'Jumlah isi ulang/biaya layanan',
    rechargePersonCount: 'Isi ulang orang/jumlah transaksi',
    withdrawAmountFee: 'jumlah penarikan/biaya layanan',
    withdrawPersonCount: 'Jumlah orang yang menarik uang/transaksi',
    firstRechargeUserAndCount: 'Jumlah isi ulang pertama/jumlah orang',
    usernamePlaceholder: 'Masukkan nama pengguna tingkat rendah',
    previewAllTradeInfo: 'Lihat semua informasi perdagangan cepat',
    coin: 'mata uang',
    timingTradeBetAmount: 'Jumlah taruhan perdagangan yang sangat cepat',
    profit: 'Untung',
    action: 'operasi',
    previewReportDay: 'Lihat laporan harian'
  },
  teamTimingTradeInfo: {
    title: 'Perdagangan Kecepatan Tim',
    profit: 'Untung',
    subTitle: 'Informasi transaksi kecepatan tim',
    timingTradeAmountFee: 'Biaya pesanan/layanan perdagangan yang sangat cepat',
    timingTradePrizePoint: 'Bonus/rabat perdagangan yang sangat cepat',
    rechargeInfo: 'Isi Ulang/Biaya Layanan',
    withdrawInfo: 'Penarikan/Biaya Layanan',
    exchangeInfo: 'Biaya Pertukaran/Layanan'
  },
  teamReportDay: {
    title: 'Laporan Harian Tim',
    subTitle: 'Laporan Harian Tim [{username}]',
    timingTradeBetAmountFee: 'Biaya pesanan/layanan perdagangan yang sangat cepat',
    timingTradeBetPrizePoint: 'Bonus/Rabat Trading Cepat',
    rechargeAmountFee: 'Jumlah isi ulang/biaya layanan',
    rechargePersonCount: 'Isi ulang orang/jumlah transaksi',
    timingTradeUserAndCount: 'Jumlah pedagang cepat/jumlah transaksi',
    firstRechargePersonCount: 'Jumlah isi ulang pertama/jumlah transaksi',
    withdrawAmountFee: 'jumlah penarikan/biaya layanan',
    withdrawPersonCount: 'Jumlah orang yang menarik uang/transaksi',
    exchangeAmountFee: 'Jumlah Pertukaran/Biaya Layanan'
  },
  share: {
    title: 'Saya ingin berbagi',
    qrCodeLabel: 'kode QR',
    registerUrlLabel: 'Alamat pendaftaran',
    inviteCodeLabel: 'Kode Undangan',
    hasNoInviteCode: 'Akun saat ini tidak memiliki kode undangan,',
    generateInvitationCode: 'Coba buat dengan satu klik',
    tipsPart1: 'Pindai kode QR di atas untuk mengisi informasi pendaftaran untuk mendaftar',
    tipsPart2: 'Salin alamat pendaftaran dan isi informasi pendaftaran untuk mendaftar',
    tipsPart3: 'Buka antarmuka pendaftaran situs ini secara manual dan isi kode undangan untuk mendaftar',
    saveImageError: 'Gagal menyimpan gambar, coba tekan lama gambar dan simpan'
  },
  myTeam: {
    title: 'Tim Saya',
    usernamePlaceholder: 'Masukkan nama pengguna tingkat rendah',
    point: 'potongan harga (kecepatan/kontrak)',
    totalBalance: 'Saldo',
    lastLoginTime: 'Waktu Masuk Terakhir',
    noLoginTime: 'tidak ada'
  },
  userDetail: {
    username: 'nama pengguna',
    userType: 'Jenis Pengguna',
    title: 'Detail Pengguna',
    pointPercentTiming: 'Rabat transaksi yang sangat cepat',
    pointPercentContract: 'Rabat transaksi kontrak',
    registerWay: 'Metode pendaftaran',
    teamCounts: 'Nomor tim',
    teamOnline: 'tim daring',
    balance: 'Saldo',
    registerTime: 'Waktu pendaftaran',
    onlineStatus: 'status masuk'
  },
  addUser: {
    title: 'Tambah Pengguna',
    addUserDirect: {
      userTypeLabel: 'Jenis Pengguna',
      usernameLabel: 'Nama Pengguna',
      usernamePlaceholder: 'Masukkan nama pengguna akun',
      pointTimingLabel: 'Rabat transaksi yang sangat cepat',
      pointContractLabel: 'Rabat transaksi kontrak',
      tips: 'Kata sandi awal adalah: "{kata sandi}"; tolong ingatkan pengguna untuk mengubah kata sandi tepat waktu setelah membuka akun',
      userTypeRequired: 'Silakan pilih jenis akun',
      usernameRequired: 'Masukkan nama pengguna akun',
      pointTimingRequired: 'Silakan pilih rebate transaksi yang cepat',
      pointContractRequired: 'Silakan pilih rabat transaksi kontrak',
      copyTemplate: '\n         Nama pengguna: {nama pengguna};\n         Kata sandi masuk: {loginPassword};\n         URL Masuk: {loginAddress};\n         Rabat perdagangan cepat: {timingTradePoint};\n         Rabat perdagangan kontrak: {contactTradePoint};\n         '
    }
  },
  recharge: {
    title: 'Isi ulang',
    configIdLabel: 'Saluran deposit',
    chainNameLabel: 'nama rantai',
    amountLabel: 'Jumlah isi ulang',
    userCardNameLabel: 'Pembayar',
    userCardNamePlaceholder: 'Masukkan nama pembayar',
    fee: 'biaya layanan',
    acceptAmountTipsPart1: 'Isi ulang',
    acceptAmountTipsPart2: ', perlu membayar',
    tipsPart1: 'Karena antarmuka pembayaran online tidak stabil, saat ini hanya isi ulang transfer offline yang didukung! ',
    tipsPart2: 'Harap isi jumlah transfer yang sebenarnya dengan jujur, jika tidak maka dapat menyebabkan peninjauan sistem gagal dan memengaruhi kemajuan pengisian ulang. ',
    emptyPart1: 'Tidak ada saluran isi ulang yang tersedia, ',
    emptyPart2: 'Ketuk untuk mencoba lagi',
    amountRequired: 'Jumlah isi ulang tidak boleh kosong',
    maxPrecisionError: 'Jumlah isi ulang dapat memiliki hingga {amountMaxPrecision} tempat desimal',
    payUserNameError: 'Masukkan pembayar yang benar dan coba lagi',
    userMobileLabel: 'Nomor ponsel',
    userMobilePlaceholder: 'Masukkan nomor ponsel pengguna',
    needPayLabel: 'Perlu membayar',
    needPayPlaceholder: 'Klik untuk memasukkan [{simbol}] jumlah'
  },
  payDetail: {
    title: 'Transfer informasi',
    addressLabel: 'Alamat setoran',
    rechargeAmount: 'Jumlah Isi Ulang',
    bankNameLabel: 'Bank',
    branchLabel: 'Alamat cabang',
    cardName: 'Nama',
    cardNum: 'nomor kartu',
    uploadImgLabel: 'Kredensial Pembayaran',
    uploadImgPlaceholder: 'Klik untuk mengunggah gambar voucher pembayaran',
    uploadImgRequired: 'Silakan unggah gambar voucher pembayaran',
    vcTransferTipsPart1: '1. Salin alamat setoran atau pindai kode QR untuk menyetor',
    vcTransferTipsPart2: '2. Unggah gambar voucher pembayaran setelah deposit selesai',
    vcTransferTipsPart3: 'Untuk meningkatkan efisiensi setoran, pastikan untuk mengunggah gambar sertifikat yang jelas dan berdefinisi tinggi, jika gambar informasi yang relevan tidak jelas, ini dapat menyebabkan sistem gagal meninjau dan memengaruhi kemajuan setoran. ',
    bankCardTips: 'Untuk meningkatkan efisiensi penyetoran uang, harap pastikan bahwa nama pengirim dan pengirim sama; jika informasi yang relevan tidak cocok, dapat menyebabkan sistem gagal meninjau dan mempengaruhi kemajuan dari deposito. ',
    bankCardTransferSuccess: 'Saya telah berhasil mentransfer'
  },
  rechargeOrder: {
    title: 'Pesanan Deposit',
    payAmount: 'Jumlah isi ulang',
    receiveAmount: 'jumlah yang diterima'
  },
  identity: {
    title: 'Informasi nama asli',
    subTitle: 'Otentikasi nama asli mencakup otentikasi informasi, otentikasi identitas',
    name: 'Nama',
    idType: 'tipe dokumen',
    idNum: 'nomor ID',
    demand: 'membutuhkan',
    informationVer: 'Verifikasi Informasi',
    idAuthentication: 'Otentikasi',
    material: 'Bahan'
  },
  verified: {
    title: 'Otentikasi nama asli',
    idCardTypeLabel: 'Jenis Sertifikat',
    idCardFrontSideImgLabel: 'Kartu Depan SideImgLabel',
    idCardBackSideImgLabel: 'Bagian belakang foto ID',
    idCardHandSideImgLabel: 'foto ID genggam',
    nameLabel: 'Nama dokumen',
    namePlaceholder: 'Masukkan nama ID Anda',
    idCardNumLabel: 'nomor KTP',
    idCardNumPlaceholder: 'Masukkan nomor ID',
    fundPwdLabel: 'kata sandi dana',
    fundPwdPlaceholder: 'Masukkan kata sandi dana Anda',
    tips: 'Otentikasi informasi setelah dikirimkan, tidak dapat diubah, harap periksa dengan cermat dan isi dengan benar',
    idCardTypeRequired: 'Silakan pilih jenis kartu',
    idCardFrontSideImgRequired: 'Unggah foto depan KTP',
    idCardBackSideImgRequired: 'Mohon unggah foto bagian belakang KTP',
    idCardHandSideImgRequired: 'Harap unggah foto ID genggam',
    nameRequired: 'Masukkan nama dokumen',
    idCardNumRequired: 'Masukkan nomor ID',
    fundPwdRequired: 'Masukkan kata sandi dana Anda',
    submitSuccess: 'Permintaan otentikasi berhasil dikirim'
  },
  help: {
    title: 'Pusat Bantuan'
  },
  helpDetail: {
    title: 'Detail Bantuan'
  },
  myMessage: {
    title: 'Pesan Saya'
  },
  messageDetail: {
    title: 'Detail pesan'
  },
  withdraw: {
    title: 'Tarik koin',
    tips: 'Untuk memastikan keamanan dana dan efisiensi penarikan; harap hati-hati memeriksa apakah informasi yang diisi sudah benar, dan biaya penanganan yang dihasilkan selama proses penarikan akan dipotong dari saldo',
    receiveAmountTipsPart1: 'Tarik',
    receiveAmountTipsPart2: ', diharapkan tiba',
    fee: 'biaya layanan',
    myBalance: 'Saldo [{vcName}] saya:',
    configIdLabel: 'saluran penarikan',
    amountLabel: 'jumlah penarikan',
    fundLabel: 'kata sandi dana',
    fundPlaceholder: 'Masukkan kata sandi dana Anda',
    googleCodeLabel: 'kode verifikasi Google',
    googleCodePlaceholder: 'Masukkan kode verifikasi Google 6 digit',
    maxPrecisionError: 'Jumlah penarikan dapat memiliki hingga {amountMaxPrecision} tempat desimal',
    amountRequired: 'Masukkan atau pilih jumlah penarikan yang benar',
    bankCardError: 'Silakan pilih kartu bank yang benar',
    fundPwdError: 'Masukkan kata sandi dana yang benar',
    walletAddressError: 'Silakan pilih alamat dompet yang benar',
    success: 'Permintaan penarikan berhasil dikirim, harap tunggu pemrosesan',
    emptyPart1: 'Tidak ada saluran penarikan yang tersedia,',
    emptyPart2: 'Ketuk untuk mencoba lagi'
  },
  withdrawOrder: {
    title: 'Pesanan penarikan',
    requestAmount: 'Jumlah bill of lading',
    receiveAmount: 'jumlah yang diterima'
  },
  locales: {
    title: 'Ganti bahasa'
  },
  lines: {
    title: 'Pemilihan Jalur',
    switchLine: 'switch line'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Berhasil menghapus mata uang favorit',
    addFavoriteSuccess: 'Berhasil menambahkan mata uang favorit'
  },
  currencySelect: {
    currencyName: 'mata uang',
    currencyPlaceholder: 'Klik untuk memilih mata uang'
  },
  walletItem: {
    available: 'tersedia',
    convert: 'konversi (USDT)'
  },
  banks: {
    bankIdLabel: 'Bank',
    bankIdPlaceholder: 'Klik untuk memilih bank'
  },
  banksPop: {
    title: 'Pilih Bank',
    search: 'Masukkan kata kunci bank'
  },
  historyOrderDetail: {
    title: 'Rincian Pesanan',
    coin: 'Mata uang transaksi',
    amount: 'jumlah pesanan',
    buyInClose: 'Harga beli',
    sellOutClose: 'Harga Jual',
    isQuest: 'Ada pertanyaan tentang pesanan ini?',
    connectCustomer: 'Hubungi layanan pelanggan?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Klik untuk memilih rabat pengguna'
  },
  walletAddressSelect: {
    title: 'Pilih alamat dompet',
    label: 'alamat dompet',
    placeholder: 'Klik untuk memilih alamat dompet'
  },
  myCardSelect: {
    title: 'Pilih akun',
    label: 'rekening penerima',
    placeholder: 'Klik untuk memilih akun'
  },
  amountInput: {
    amountRange: 'minimum {minAmount}, maksimum {maxAmount}',
    amountMin: 'Minimum {minAmount}, tanpa batas atas',
    amountErrorEmpty: '{label} salah, harap periksa dan coba lagi',
    amountErrorOutRange: '{label} di luar jangkauan, harap periksa dan coba lagi'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Minimum {minAmount}, tanpa batas atas',
    placeholderHasMax: 'minimum {minAmount}, maksimum {maxAmount}',
    amountErrorEmpty: 'Jumlahnya salah, silakan coba lagi setelah verifikasi',
    amountErrorOutRange: 'Jumlahnya di luar jangkauan, harap verifikasi dan coba lagi'
  },
  common: {
    remark: 'komentar',
    saveImage: 'Simpan secara lokal',
    online: 'daring',
    offline: 'offline',
    profit: 'untung dan rugi',
    date: 'tanggal',
    period: 'periode',
    pointAmount: 'Jumlah rabat pengguna',
    point: 'Rabat pengguna',
    direction: 'arah',
    winLoss: 'Penghasilan',
    lose: 'kalah',
    add: 'Tambah baru',
    win: 'menang',
    edit: 'Ubah',
    notBind: 'tidak terikat',
    alreadyBind: 'sudah terikat',
    enabled: 'diaktifkan',
    notEnabled: 'tidak diaktifkan',
    queryRange: 'Rentang Kueri',
    copy: 'Salin',
    orderNum: 'nomor pesanan',
    null: 'tidak ada',
    noData: 'Tidak ada data',
    refreshSuccess: 'Berhasil menyegarkan',
    loadMoreData: 'Muat lebih banyak data',
    noMoreData: 'Tidak ada lagi data',
    lookMore: 'Lagi',
    more: 'Lagi'
  },
  date: {
    today: 'hari ini',
    yesterday: 'Kemarin',
    last7Days: 'hampir 7 hari',
    last14Days: 'hampir 14 hari',
    split: 'ke'
  },
  button: {
    save: 'Simpan',
    logout: 'keluar',
    confirm: 'OK',
    cancel: 'Batal',
    submit: 'Kirim',
    addNow: 'Tambahkan sekarang',
    reset: 'setel ulang',
    nextStep: 'Berikutnya',
    goCertification: 'Pergi ke sertifikasi'
  },
  confirm: {
    title: {
      logout: 'keluar',
      unBindFundPassword: 'kata sandi dana tidak terikat',
      addUserDirect: 'Tambah Pengguna',
      addUserInfo: 'Berhasil menambahkan pengguna',
      jumpToRechargePage: 'Konfirmasi Lompat',
      unAuthentication: 'autentikasi nama tidak nyata',
      noBindBankCard: 'Tidak ada kartu bank yang ditambahkan',
      noBindCoinAddress: 'Tidak ada alamat dompet yang ditambahkan',
      tradeConfirm: 'Konfirmasi transaksi',
      buyFinance: 'Konfirmasi pembelian',
      redeemOrder: 'Penukaran pesanan janji'
    },
    content: {
      logout: 'Apakah Anda yakin untuk keluar dari akun saat ini?',
      unBindFundPassword: 'Kata sandi dana yang tidak terikat telah terdeteksi, untuk memastikan keamanan akun, harap ikat kata sandi dana Anda terlebih dahulu',
      addUserDirect: 'Pengguna baru akan segera ditambahkan, harap verifikasi bahwa informasinya benar dan klik OK untuk melanjutkan, nama pengguna [ {username} ], tipe pengguna [ {userType} ], kata sandi login [ {password} ], dan selisih antara rabat perdagangan cepat saya [ {diffPointTiming} ], dan selisih rabat transaksi kontrak saya [ {diffPointContract} ]',
      addUserInfo: 'Username [ {username} ]; <br /> Login password [ {password} ];<br /> Login URL [ {loginAddress} ];<br /> Ekstrim rabat transaksi [ {pointPercentTiming} ];<br / > /> Rabat transaksi kontrak [{pointPercentContract}];',
      jumpToRechargePage: 'Tentang melompat ke antarmuka isi ulang tiga pihak, silakan klik konfirmasi untuk melanjutkan',
      unAuthentication: 'Terdeteksi bahwa akun belum menjalani autentikasi nama asli, untuk memastikan peredaran dana normal, harap lakukan autentikasi nama asli terlebih dahulu',
      noBindBankCard: 'Terdeteksi bahwa akun tidak terikat atau diaktifkan dengan kartu bank. Untuk memastikan sirkulasi dana normal, harap tambahkan kartu bank terlebih dahulu',
      noBindCoinAddress: 'Terdeteksi bahwa akun tidak terikat atau mengaktifkan akun mata uang virtual. Untuk memastikan sirkulasi dana normal, harap tambahkan alamat akun mata uang virtual terlebih dahulu',
      tradeConfirm: 'Pesanan akan segera dikirim, harap pastikan informasi pesanan sudah benar dan klik Konfirmasi Pesanan untuk mengirimkan',
      buyFinance: 'Akan membeli [{coin}], beli saham: {amount}, harap konfirmasikan bahwa pengoperasian sudah benar dan klik OK untuk melanjutkan',
      redeemOrder: 'Pesanan kontribusi ({orderNum}) akan ditukarkan, harap konfirmasikan bahwa pengoperasian sudah benar dan klik Konfirmasi untuk melanjutkan'
    }
  },
  message: {
    bindSuccess: 'Bind berhasil',
    successOperation: 'Operasi berhasil',
    logoutSuccess: 'Berhasil keluar',
    editSuccess: 'Berhasil dimodifikasi',
    addSuccess: 'Berhasil dimodifikasi',
    copySuccess: 'Penyalinan berhasil',
    copyFailed: 'Penyalinan gagal'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Hari',
      week_day_1: 'Satu',
      week_day_2: 'dua',
      week_day_3: 'tiga',
      week_day_4: 'empat',
      week_day_5: 'lima',
      week_day_6: 'Enam'
    },
    loading: {
      loading: 'memuat'
    }
  },
  helpItems: {
    title: {
      part1: 'Mengapa jumlah aset yang dikonversi berubah? ',
      part2: 'Lupa metode penanganan kata sandi dana untuk transaksi OTC',
      part3: 'Kemana aliran dana setelah pembelian transaksi OTC selesai? ',
      part4: 'Mengapa Anda ingin membatasi berapa kali Anda dapat mengubah nama panggilan Anda',
      part5: 'Apa arti transfer, mengapa perlu transfer',
      part6: 'Bagaimana cara menghitung ekuitas akun dari kontrak pengguna? ',
      part7: 'Berapa nilai stop loss dan take profit yang ditetapkan pada posisi pembukaan? Bagaimana cara mengaturnya? ',
      part8: 'Bagaimana cara mengurangi risiko kontrak? ',
      part9: 'Apa yang ditunjukkan oleh kuantitas dalam posisi terbuka kontrak? ',
      part10: 'Petunjuk likuidasi paksa',
      part11: 'Apa aturan perdagangan kontrak? ',
      part12: 'Berapa margin dalam perdagangan kontrak? ',
      part13: 'Apa itu limit order dan market order? ',
      part14: 'Apa yang diwakili oleh risiko transaksi kontrak',
      part15: 'Mengapa Anda memerlukan konversi mata uang? ',
      part16: 'Mengapa pihak lain tidak menerima transfer tepat waktu setelah transfer transaksi OTC? ',
      part17: 'Bagaimana cara membeli Tether (USDT) melalui OTC? '
    },
    content: {
      part1: 'Nilai mata uang digital yang saat ini dipegang dalam Renminbi saat diubah menjadi aset akan berubah karena fluktuasi harga aset digital. Jumlah aset digital Anda tidak berubah. ',
      part2: 'Jika Anda lupa kata sandi dana transaksi OTC, silakan buka "Pengaturan-Saya-Klik untuk mengatur kata sandi dana" atau hubungi layanan pelanggan untuk mengatur ulang',
      part3: 'Setelah pesanan beli OTC selesai, dana akan masuk ke akun mata uang resmi di aset. Jika Anda perlu menggunakan aset yang dibeli OTC untuk perdagangan kontrak atau perdagangan berjangka, silakan buka modul transfer dana untuk mentransfer. ',
      part4: 'Untuk alasan keamanan transaksi Anda, saat ini kami membatasi nama panggilan untuk diubah hanya sekali. ',
      part5: 'Untuk memastikan independensi dana antara berbagai akun Anda dan untuk memfasilitasi kontrol risiko Anda yang wajar, akun modul perdagangan utama dengan ini dibagi. Transfer mengacu pada proses saling konversi aset antara berbagai akun perdagangan. ',
      part6: '<p>Ekuitas akun kontrak, metode perhitungannya adalah sebagai berikut:</p> <p>Ekuitas akun kontrak = margin posisi + keuntungan dan kerugian mengambang posisi + jumlah tersedia akun saat ini</p>',
      part7: 'Take profit and stop loss adalah batas keuntungan dan batas kerugian yang Anda tetapkan. Ketika jumlah stop profit dan stop loss yang ditetapkan tercapai, sistem akan menutup posisi secara otomatis. Hal ini dapat digunakan untuk pengendalian risiko Anda saat membeli kontrak. Setengah dari jumlah take profit yang ditetapkan adalah: tingkatkan jumlah x jumlah x leverage berlipat, dan tetapkan stop loss. Kami sarankan Anda mengaturnya sesuai dengan situasi aset Anda yang sebenarnya untuk mengendalikan risiko secara wajar . ',
      part8: 'Anda dapat mentransfer aset yang tersedia dari akun yang tersisa ke akun kontrak dengan mentransfer dana, atau mengurangi risiko dengan mengurangi posisi. ',
      part9: 'Kuantitas dalam posisi terbuka menunjukkan jumlah mata uang yang ingin Anda beli. Misalnya: pada halaman pembuka pasangan perdagangan BTC/USDT, pilih untuk membeli long, masukkan harga sebagai 1000USDT, dan masukkan kuantitas sebagai 10BTC, yang artinya: Anda berharap untuk membeli 10 BTC dengan harga satuan 1000USDT. ',
      part10: '<p>Tingkat risiko adalah indikator untuk mengukur risiko aset Anda. Ketika tingkat risiko sama dengan 100%, posisi Anda dianggap likuidasi. Tingkat risiko=(margin posisi/ekuitas akun kontrak)*100 %, untuk mencegah pengguna melebihi posisi mereka, sistem menetapkan rasio penyesuaian tingkat risiko.Ketika tingkat risiko mencapai nilai risiko yang ditetapkan oleh sistem, sistem akan memaksa likuidasi. Misalnya: jika rasio penyesuaian yang ditetapkan oleh sistem adalah 10%, maka ketika tingkat risiko Anda lebih besar atau sama dengan 90%, semua posisi Anda akan ditutup paksa oleh sistem. </p> <p>Catatan: Jika sistem memaksa likuidasi yang disebabkan oleh risiko berlebihan, semua posisi Anda akan ditutup, jadi saya harap Anda dapat mengontrol risiko Anda secara wajar untuk menghindari kerugian yang tidak perlu< /p>',
      part11: '<p>Jenis perdagangan</p> <p>Jenis perdagangan dibagi menjadi dua arah: buka posisi long (beli) dan buka posisi short (jual):</p> <p>Beli long (Calling) artinya bahwa Anda percaya bahwa indeks saat ini akan naik, dan berharap untuk membeli sejumlah kontrak tertentu dengan harga yang Anda tetapkan atau harga pasar saat ini. </p> <p>Short selling (bearish) berarti Anda percaya bahwa indeks saat ini mungkin turun, dan berharap untuk menjual sejumlah kontrak tertentu dengan harga yang Anda tetapkan atau harga pasar saat ini. </p> <p>Cara melakukan pemesanan</p> <p>Pemesanan batas: Anda perlu menentukan harga dan jumlah pesanan</p> <p>Pesanan pasar: Anda hanya perlu mengatur jumlah order , harga adalah harga pasar saat ini</p> <p>Posisi</p> <p>Ketika order pembukaan yang Anda kirimkan selesai, itu disebut posisi</p> <p>Masalah pengiriman kontrak </p> <p>Kontrak platform adalah kontrak abadi tanpa waktu pengiriman yang ditentukan. Selama kondisi likuidasi sistem tidak terpenuhi atau Anda tidak menutup posisi secara manual, Anda dapat menahan posisi tersebut secara permanen. </p> <p>Sistem menutup posisi</p> <p>1: Sistem secara otomatis menutup posisi ketika nilai stop profit dan stop loss yang ditetapkan tercapai</p> <p>2: Risiko terlalu tinggi, sistem memaksa posisi ditutup </p>',
      part12: '<p>Dalam transaksi kontrak, pengguna dapat berpartisipasi dalam transaksi kontrak dengan membayar dana sebagai jaminan keuangan untuk pelaksanaan kontrak sesuai dengan harga dan kuantitas kontrak, sesuai dengan kelipatan leverage yang sesuai, dan dana ini adalah margin kontrak. Pengguna akan menempati margin saat membuka posisi, dan semakin banyak margin untuk membuka posisi yang ditempati, semakin tinggi risiko akun. </p> <p>Margin = (harga pembukaan * kuantitas) / rasio leverage</p>',
      part13: 'Batas pesanan mengacu pada harga yang Anda harapkan untuk mempercayakan platform untuk melakukan transaksi, dan pesanan pasar mengacu pada mempercayakan platform secara langsung untuk melakukan transaksi dengan harga saat ini. Dalam aturan pembukaan posisi, market order diprioritaskan di atas limit order. Jika Anda memilih limit order, harap buka posisi secara wajar sesuai dengan harga pasar mata uang saat ini untuk menghindari kerugian yang disebabkan oleh harga pembukaan yang tidak wajar. ',
      part14: 'Tingkat risiko adalah indikator risiko di akun kontrak Anda, dan tingkat risiko sama dengan 100% dianggap likuidasi. Kami menyarankan Anda, ketika risiko Anda melebihi 50%, Anda perlu membuka posisi dengan hati-hati untuk menghindari kerugian akibat likuidasi. Anda dapat mengurangi risiko Anda dengan mengisi kembali dana aset kontrak yang tersedia, atau mengurangi posisi. ',
      part15: 'Fungsi bursa adalah untuk memungkinkan kelancaran sirkulasi dana dalam berbagai mata uang di aset Anda, dan QCC yang diperoleh di akun berjangka dapat secara bebas dikonversi menjadi USDT untuk diperdagangkan. USDT di akun lain juga dapat dengan bebas dikonversi menjadi QCC untuk transaksi. ',
      part16: 'Pertama-tama, harap pastikan metode pembayaran yang Anda isi saat mentransfer uang sama persis dengan yang ditampilkan di halaman detail pesanan. Kemudian harap konfirmasi apakah metode pembayaran Anda instan atau tertunda. Terakhir, harap hubungi bank dan lembaga pembayaran Anda untuk pemeliharaan sistem atau alasan lainnya. ',
      part17: '<p>Metode 1: Pilih pesanan yang ingin Anda beli melalui daftar jual beli OTC untuk membeli atau menjual. </p> <p>Metode 2: Klik tombol terbitkan untuk menerbitkan pesanan beli atau jual sesuai kebutuhan Anda untuk transaksi cepat. Sistem akan dengan cepat mencocokkan Anda dengan pembeli dan penjual. </p> <p>Catatan: Jika pesanan pembelian tidak dibayar setelah 15 menit, sistem akan membatalkan pesanan secara otomatis, harap bayar tepat waktu. Jika pesanan dibatalkan lebih dari 3 kali pada hari yang sama, transaksi tidak dapat dilakukan lagi pada hari yang sama, dan otoritas perdagangan akan dipulihkan pada hari berikutnya. </p>'
    }
  }
};

/***/ }),

/***/ "Ee28":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slide",staticClass:"slide"},[_c('div',{ref:"slideGroup",staticClass:"slide-group"},[_vm._t("default",function(){return _vm._l((_vm.data),function(item,index){return _c('slide-item',{key:index,attrs:{"item":item},nativeOn:{"click":function($event){return _vm.clickItem(item, index)}}})})})],2),_vm._v(" "),(_vm.showDots)?_c('div',{staticClass:"slide-dots"},[_vm._t("dots",function(){return _vm._l((_vm.dots),function(item,index){return _c('span',{key:index,class:{active: _vm.currentPageIndex === index}})})},{"current":_vm.currentPageIndex,"dots":_vm.dots})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eeb1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/***
 * token
 * @type {string}
 * @private
 */
var __TOKEN__ = exports.__TOKEN__ = '__TOKEN__';

/***
 * 主题模式
 * @type {string}
 * @private
 */
var __THEME_MODE__ = exports.__THEME_MODE__ = '__THEME_MODE__';

/***
 * 用户信息
 * @type {string}
 * @private
 */
var __USER_INFO__ = exports.__USER_INFO__ = '__USER_INFO__';

/***
 * 缓存信息
 * @type {string}
 * @private
 */
var __CACHE_INFO__ = exports.__CACHE_INFO__ = '__CACHE_INFO__';

/***
 * 系统配置
 * @type {string}
 * @private
 */
var __SYSTEM_CONFIG__ = exports.__SYSTEM_CONFIG__ = '__SYSTEM_CONFIG__';

/***
 * 字典信息
 * @type {string}
 * @private
 */
var __DICT__ = exports.__DICT__ = '__DICT__';

/***
 * 系统公告
 * @type {string}
 * @private
 */
var __SYSTEM_NOTICE__ = exports.__SYSTEM_NOTICE__ = '__SYSTEM_NOTICE__';

/***
 * 银行列表
 * @type {string}
 * @private
 */
var __BANK__ = exports.__BANK__ = '__BANK__';

/***
 * 是否隐藏余额
 * @type {string}
 * @private
 */
var __HIDE_BALANCE__ = exports.__HIDE_BALANCE__ = '__HIDE_BALANCE__';

/***
 * 静态币种[]
 * @type {string}
 * @private
 */
var __VC_LIST__ = exports.__VC_LIST__ = '__VC_LIST__';

/***
 * 自选币种列表
 * @type {string}
 * @private
 */
var __FAVORITE_CURRENCY__ = exports.__FAVORITE_CURRENCY__ = '__FAVORITE_CURRENCY__';

/***
 * 交易配置列表
 * @type {string}
 * @private
 */
var __TRADE_CONFIG__ = exports.__TRADE_CONFIG__ = '__TRADE_CONFIG__';

/***
 * 最近查看行情的vcId
 * @type {string}
 * @private
 */
var __VC_ID__ = exports.__VC_ID__ = '__VC_ID__';

/***
 * 首页Banner图
 * @type {string}
 * @private
 */
var __BANNER__ = exports.__BANNER__ = '__BANNER__';

/***
 * 语言
 * @type {string}
 * @private
 */
var __LOCALE__ = exports.__LOCALE__ = '__LOCALE__';

/***
 * 支持的语言列表
 * @type {string}
 * @private
 */
var __LOCALE_LIST__ = exports.__LOCALE_LIST__ = '__LOCALE_LIST__';

/***
 * 带价格的币种列表
 * @type {string}
 * @private
 */
var __COIN_LIST_WITH_PRICE__ = exports.__COIN_LIST_WITH_PRICE__ = '__COIN_LIST_WITH_PRICE__';

/***/ }),

/***/ "FQHV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      isActive: false
    };
  },
  activated: function activated() {
    this.isActive = true;
  },
  deactivated: function deactivated() {
    this.isActive = false;
  }
};

/***/ }),

/***/ "GRCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue__ = __webpack_require__("jbSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue__ = __webpack_require__("2GrC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4419de98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_TabItem_vue__ = __webpack_require__("iEY0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_TabItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4419de98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_TabItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GTMH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dom = __webpack_require__("vNF5");

/***
 * RED_CLASS: 红色cls
 * GREEN_CLASS: 绿色cls
 * GRAY_CLASS: 灰色cls
 * @type {string}
 */
var RED_CLASS = 'red';
var GREEN_CLASS = 'green';
var GRAY_CLASS = 'gray';

/***
 * 根据不同值显示不同的数字颜色
 * @param el
 * @param binding
 */
function setColorAction(el, binding) {
  if (binding.value === false) return;
  (0, _dom.hasClass)(el, RED_CLASS) && (0, _dom.removeClass)(el, RED_CLASS);
  (0, _dom.hasClass)(el, GREEN_CLASS) && (0, _dom.removeClass)(el, GREEN_CLASS);
  (0, _dom.hasClass)(el, GRAY_CLASS) && (0, _dom.removeClass)(el, GRAY_CLASS);
  if (binding.value === undefined) {} else {
    +binding.value >= 0 && (0, _dom.addClass)(el, GREEN_CLASS);
    +binding.value < 0 && (0, _dom.addClass)(el, RED_CLASS);
  }
}

exports.default = {
  bind: setColorAction,
  update: setColorAction,
  unbind: function unbind(el) {
    (0, _dom.hasClass)(el, RED_CLASS) && (0, _dom.removeClass)(el, RED_CLASS);
    (0, _dom.hasClass)(el, GREEN_CLASS) && (0, _dom.removeClass)(el, GREEN_CLASS);
    (0, _dom.hasClass)(el, GRAY_CLASS) && (0, _dom.removeClass)(el, GRAY_CLASS);
  }
};

/***/ }),

/***/ "GYmr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "HAiq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: 'ログイン',
    usernameLabel: 'ユーザー名',
    usernamePlaceholder: '英語で始まる 2 ～ 10 個の英語の数字の組み合わせ',
    loginPasswordLabel: 'ログインパスワード',
    loginPasswordPlaceholder: 'ログインパスワードを入力してください',
    googleCodeLabel: 'Google 確認コード',
    googleCodePlaceholder: '6 桁の Google 確認コードを入力してください',
    hasNoAccount: 'まだアカウントがありません,',
    goRegister: '登録に移動',
    onlineCustom: 'オンラインカスタマーサービス',
    loginArgument: 'ログインを続けることは同意することを意味します',
    userArgument: '《利用規約》',
    registerNotEnabled: '登録機能が開いていません。管理者に問い合わせてください',
    usernameRequired: '正しいユーザー名を入力してください',
    loginPasswordRequired: '正しいログイン パスワードを入力してください',
    googleCodeRequired: '正しい Google 確認コードを入力してください',
    loginButton: 'ログイン'
  },
  register: {
    title: '登録',
    usernameLabel: 'ユーザー名',
    usernamePlaceholder: '登録されているユーザー名を入力してください',
    loginPasswordLabel: 'ログインパスワード',
    loginPasswordPlaceholder: '登録ユーザーのログインパスワードを入力してください',
    loginPasswordPreLabel: 'ログインパスワードの確認',
    loginPasswordPrePlaceholder: 'ログインパスワードをもう一度入力してください',
    fudPasswordLabel: 'ファンドパスワード',
    fudPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    inviteCodeLabel: '招待コード',
    inviteCodePlaceholder: '6 桁の招待コードを入力してください',
    registerNeed: '登録を続けることは同意することを意味します',
    registerArgument: '《登録契約書》',
    usernameRequired: '正しいユーザー名を入力してください',
    loginPasswordRequired: '正しいログイン パスワードを入力してください',
    loginPasswordPreRequired: '正しい確認ログイン パスワードを入力してください',
    FundPasswordRequired: '正しいファンドのパスワードを入力してください',
    InvitationCodeRequired: '正しい招待コードを入力してください',
    diffLoginPasswordError: '2 つのログイン パスワードが一致しません',
    registerSuccess: '登録成功',
    registerButton: '登録',
    emailLabel: 'メール',
    emailPlaceholder: 'メールアドレスを入力してください',
    emailCodeLabel: '確認コード',
    emailCodePlaceholder: 'メール確認コードを入力してください',
    second: '2 番目',
    getEmailCodeButton: 'コードを取得',
    emailRequired: '正しい電子メール アドレスを入力して、もう一度お試しください',
    emailCodeRequired: '正しい電子メール確認コードを入力して、もう一度お試しください'
  },
  home: {
    hotCoin: {
      title: '人気のセール',
      more: 'もっと'
    },
    poster: {
      title: 'クイック デポジット',
      enter: '今すぐ入力>',
      subTitle: 'BTC、USDT、ETH などをサポート'
    },
    quickMenus: {
      futuresTrading: '先物取引',
      helpCenter: 'ヘルプセンター'
    },
    ranking: {
      increase: {
        title: 'ライジングリスト'
      },
      clinch: {
        title: '売上高リスト'
      }
    }
  },
  tabBar: {
    home: 'ホーム',
    price: '引用',
    trade: '貿易',
    fund: '資産',
    user: '私の'
  },
  currency: {
    favorite: 'オプション',
    allCurrency: 'スポット',
    dayVol: '24H の量',
    addFavor: '+ 好意を追加'
  },
  trade: {
    bills: '注文',
    todayOpen: '開く',
    star: 'オプション',
    vol: 'ボリューム',
    low: '最低',
    high: '最高',
    timing: '超高速',
    spot: '先物',
    buyMore: 'さらに購入する',
    buyEmpty: '空売りを買う',
    indicator: 'インジケーター',
    indicatorSettings: 'インジケーター設定',
    balance: '私の残高',
    fee: 'サービス料',
    ruleIdError: '有効期限を選択してください',
    deleteFavoriteSuccess: 'お気に入りの通貨を正常に削除しました',
    addFavoriteSuccess: '選択した通貨の追加に成功しました',
    buyIn: '購入',
    sellOut: '売ります',
    holding: '位置を保持する',
    history: '歴史',
    spotOrderConfirm: {
      title: '購入の確認',
      amountPlaceholder: '購入数量を入力してください'
    },
    spotTradeOrder: {
      holding: {
        coin: '通貨',
        buyInAmountPrice: '購入合計価格/単価',
        buyInCount: '数量',
        actions: '操作',
        sellOut: '売ります',
        profit: '損益'
      }
    },
    orderConfirm: {
      title: '注文確認',
      coinName: '通貨',
      direction: '方向',
      price: '現在の価格',
      balance: '残高',
      fee: 'サービス料',
      buyMoreLabel: 'さらに購入',
      buyEmptyLabel: 'ショート購入',
      buyQuantity: '購入数量',
      buyAmount: '購買金額',
      submit: '注文を確認する'
    },
    kline: {
      open: '開く:',
      close: '閉じる:',
      change: '上下:'
    }
  },
  finance: {
    title: 'ファイナンス'
  },
  allFinance: {
    title: '財務管理',
    all: 'すべて'
  },
  financeOrders: {
    title: '誓約命令',
    holdingLabel: '保有',
    historyLabel: '歴史',
    holding: {
      amount: '誓約額',
      rateStr: '収入金額/利回り',
      vcCount: '約束されたコインの数',
      cycle: '位置サイクル',
      day: '日',
      calcStartDate: '開始値の日付',
      serviceAmount: 'サービス料',
      redeemOrder: '引き換える'
    },
    history: {
      incomeAmount: '収入額',
      rateStr: '収量',
      amount: '誓約額',
      vcCount: '約束されたコインの数',
      calcStartDate: '開始値の日付',
      calcEndDate: '終了日',
      cycle: 'サイクル日数',
      serviceAmount: 'サービス料',
      day: '日'
    }
  },
  financeOrderBills: {
    title: '誓約収入請求書',
    amount: '金額',
    balance: 'バランス'
  },
  financeItem: {
    rateStr: '収量',
    buyType: '購入タイプ',
    cycle: 'サイクル日数',
    exchangeRate: '為替レート（仮想通貨為替残高）',
    day: '日',
    cycleType: 'サイクルタイプ',
    serviceRateStr: 'サービス料金'
  },
  buyFinance: {
    title: '購入',
    rateStr: '収量',
    name: '名前',
    buyType: '購入タイプ',
    cycle: 'サイクル日数',
    cycleType: 'サイクルタイプ',
    exchangeRate: '為替レート（仮想通貨為替残高）',
    serviceRateStr: 'サービス料金',
    remark: 'コメント',
    buyAmountLabel: '購入額 ({coin})',
    descriptionTitle: '製品説明',
    descriptionPart1: '1. 本商品は元本保証のない資産運用商品です。相場の変動により元本が損失する可能性があります。投資は慎重に行ってください。',
    descriptionPart2: '2. 支払い決済ルール:',
    descriptionPart3: '決済価格 < リンク価格の場合、BTC は満期後に決済されます。決済額 = 投資額 * (1+ 日 * 年率収益率 / 365)。',
    descriptionPart4: '決済価格 ≥ 固定価格の場合、USDT は満期後に決済されます。決済額 = 投資額 * 固定価格 * (1+ 日 * 年率収益率 / 365)。',
    descriptionPart5: '3. 実際の年率収益率は市場に応じてリアルタイムに変化します。実際の購入取引を参照してください。',
    descriptionPart6: '4. 投資額は市場に応じてリアルタイムに換算されます。実際の購入取引を参照してください。',
    descriptionPart7: '5. 製品購入後、通貨保有ページで確認でき、有効期限が過ぎるとスポット口座に自動的に返金されます。',
    buyButton: '[{coin}] を購入'
  },
  fund: {
    description: '資産',
    recharge: 'リチャージ',
    withdraw: 'コインを引き出す',
    exchange: '転送',
    empty: '財布は空です、行きましょう'
  },
  userCenter: {
    lastLogin: '最終ログイン',
    myTeam: '私のチーム',
    identity: '実名認証',
    walletAddress: 'ウォレットアドレス',
    zskAccount: 'FPS アカウント',
    bankCard: '銀行口座',
    userBills: 'アカウント変更記録',
    timingTradeOrder: '非常に速いポジション',
    spotTradeOrder: '先物ポジション',
    contactTradeOrder: '約定ポジション',
    userReport: 'ユーザーレポート',
    teamReport: 'チームレポート',
    share: '共有したい',
    customer: 'カスタマーサービスに連絡してください',
    helpCenter: 'ヘルプセンター',
    platform: 'プラットフォームの紹介',
    profit: '今日の損益',
    balance: '私の残高',
    withdraw: 'コインを引き出す',
    recharge: 'リチャージ',
    creditStoreLabel: 'クレジット ポイント'
  },
  settings: {
    title: '設定',
    fundPassword: 'ファンドのパスワード',
    googleValidator: 'Google バリデータ',
    editLoginPassword: 'ログインパスワードを変更',
    switchLocale: '言語を切り替える'
  },
  editFundPassword: {
    title: 'ファンドのパスワードを変更',
    currentPasswordLabel: '現在のパスワード',
    currentPasswordPlaceholder: '現在のファンドのパスワードを入力してください',
    newPasswordLabel: '新しいパスワード',
    newPasswordPlaceholder: '変更したファンドのパスワードを入力してください',
    prePasswordLabel: 'パスワードの確認',
    prePasswordPlaceholder: '変更したファンドのパスワードをクリアして再入力',
    tips: 'ファンドのパスワードは取引のための重要な証明書です。慎重に設定し、覚えておいてください。',
    currentPasswordRequired: '現在のファンドのパスワードを入力してください',
    newPasswordRequired: '変更するファンドのパスワードを入力してください',
    prePasswordRequired: '変更するファンドのパスワードを再度入力してください',
    prePasswordDiff: '2 つのパスワード入力が矛盾しています'
  },
  bindFundPassword: {
    title: 'バインドファンドのパスワード',
    fundPasswordLabel: 'ファンドパスワード',
    fundPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    fundPasswordPreLabel: 'パスワードを確認',
    fundPasswordPrePlaceholder: 'ファンドのパスワードをもう一度入力してください',
    fundPasswordRequired: '正しいファンドのパスワードを入力してください',
    fundPasswordPreRequired: '正しい確認パスワードを入力してください',
    fundPasswordDiff: '2 つのパスワードは矛盾しています',
    bindSuccess: 'ファンドのパスワードは正常にバインドされました',
    tips: 'ファンドのパスワードは取引のための重要な認証情報です。慎重に設定し、覚えておいてください。'
  },
  editLoginPassword: {
    title: 'ログインパスワードの変更',
    currentPasswordLabel: '現在のパスワード',
    currentPasswordPlaceholder: '現在のログインパスワードを入力してください',
    newPasswordLabel: '新しいパスワード',
    newPasswordPlaceholder: '変更したログインパスワードを入力してください',
    prePasswordLabel: 'パスワードの確認',
    prePasswordPlaceholder: '変更したログインパスワードをクリアして再入力',
    tips: 'ログインパスワードはログイン認証などに使用する重要な情報です。慎重に設定し、覚えておいてください。',
    currentPasswordRequired: '現在のログインパスワードを入力してください',
    newPasswordRequired: '変更するログインパスワードを入力してください',
    prePasswordRequired: '変更するログインパスワードを再入力してください',
    prePasswordDiff: '2 つのパスワード入力が矛盾しています'
  },
  bindGoogleValidator: {
    title: 'Google Authenticator のバインド',
    qrCodeLabel: 'QR コード',
    keyLabel: 'キー',
    loginPasswordLabel: 'ログインパスワード',
    loginPasswordPlaceholder: 'ログインパスワードを入力してください',
    googleCodeLabel: 'Google 確認コード',
    googleCodePlaceholder: '6 桁の Google 確認コードを入力してください',
    tipsPart11: 'アプリ ストアで Google Authenticator を検索する',
    tipsPart12: 'Google Authenticator を使用して上記の QR コードをスキャンするか、バインドするキーを手動で入力します',
    tipsPart13: '上記の 6 桁の Google 確認コードを入力し、[確認] をクリックして送信してください',
    loginPasswordRequired: 'ログインパスワードを入力してください',
    googleCodeRequired: '6 桁の Google 確認コードを入力してください'
  },
  walletAddress: {
    title: 'ウォレットアドレス',
    add: '+ ウォレットアドレスを追加',
    remark: 'コメント',
    addButton: 'ウォレットアドレスを追加',
    tips: '住所情報を変更または削除したい場合は、カスタマーサービスまでご連絡ください。'
  },
  addWalletAddress: {
    title: 'ウォレットアドレスを追加',
    vcChainNameIdLabel: 'チェーン タイプ',
    vcAccountLabel: 'ウォレットアドレス',
    vcAccountPlaceholder: 'ウォレットアドレスを入力してください',
    remarkLabel: '備考',
    remarkPlaceholder: '備考の内容を入力してください',
    fundPasswordLabel: 'ファンドパスワード',
    fundPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    tips: '追加されたウォレット アドレスは変更できません。情報が正しいことを確認してください。',
    vcIdRequired: '正しい通貨を選択してください',
    vcChainNameIdRequired: '正しいチェーン タイプを選択してください',
    vcAccountRequired: '正しいウォレットアドレスを入力してください',
    fundPwdRequired: '正しいファンドのパスワードを入力してください',
    addSuccess: 'ウォレットアドレスが正常に追加されました'
  },
  receiveWays: {
    title: 'マイバンクカード',
    add: '+ 銀行カードを追加',
    tips: '銀行カード情報を変更または削除したい場合は、カスタマー サービスにお問い合わせください。',
    addCardButton: '銀行カードを追加'
  },
  zskAccount: {
    title: 'FPS アカウント',
    add: '+ FPS アカウントを追加',
    tips: 'アカウント情報を変更または削除するには、カスタマー サービスにお問い合わせください。',
    addCardButton: 'アカウントを追加'
  },
  addZskAccount: {
    title: 'FPS アカウントを追加',
    withdrawNameLabel: '名前',
    withdrawNamePlaceholder: '名前を入力してください',
    withdrawNameRequired: '名前を空にすることはできません',
    zskLabel: 'ZSK',
    zskPlaceholder: 'FPS IDを入力してください',
    fundPasswordLabel: 'ファンドパスワード',
    fundPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    tips: '追加されたアカウントの情報は慎重に入力してください。情報が間違っていたために出金が届かない問題については、当社は責任を負いません。'
  },
  addBankCard: {
    title: '新しい銀行カードを追加する',
    cardNumLabel: '銀行カード番号',
    withdrawNameLabel: '名前',
    withdrawNamePlaceholder: '名前を入力してください',
    withdrawNameRequired: '名前を空にすることはできません',
    zskLabel: 'ZSK',
    zskPlaceholder: 'FPS IDを入力してください',
    zskRequired: '正しい FPS ID を入力してください',
    cardNumPlaceholder: '銀行カード番号を入力してください',
    branchLabel: '支店アドレス',
    branchPlaceholder: '銀行カード支店の住所を入力してください',
    fundPasswordLabel: 'ファンドパスワード',
    fundPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    tips: '銀行カードは取引現金引き出しのための重要なデータです。慎重に入力してください。カード情報の誤った入力による現金の受け取り失敗などの問題については、当社は責任を負いません。',
    backIdRequired: '口座銀行を選択してください',
    cardNumRequired: '正しい銀行カード番号を入力してください',
    fundPwdRequired: '正しいファンドのパスワードを入力してください',
    idCardPlaceholder: 'ID 番号を入力してください',
    idCardLabel: 'ID カード番号',
    idCardRequired: '正しい ID 番号を入力してください',
    cciPlaceholder: '銀行カード CCI を入力してください',
    branchCodePlaceholder: '支店番号ドを入力してください',
    branchCodeLabel: '支店番号',
    katakanaPlaceholder: 'カタカナで入力してください',
    katakanaLabel: 'カタカナ'
  },
  userBills: {
    title: 'アカウント変更記録',
    vcName: '通貨',
    amount: '金額 ({シンボル})',
    balance: 'バランス({シンボル})'
  },
  timingTradeOrder: {
    title: '非常に速い取引注文',
    waiting: {
      title: '注文中',
      amount: '金額',
      period: '期間',
      receivePrice: '購入価格',
      settlement: '決済中'
    },
    history: {
      title: '歴史的命令',
      buyInClose: '購入価格',
      saleOutClose: 'セール価格'
    }
  },
  spotTradeOrder: {
    title: '先物取引注文',
    waiting: {
      title: '注文中',
      buyInAmount: '合計購入価格',
      buyInPrice: '購入単価',
      buyInCount: '購入数量',
      buyInTime: '時間を買う'
    },
    history: {
      title: '歴史的命令',
      buyInAmount: '合計購入価格',
      buyInPrice: '購入単価',
      buyInCount: '購入数量',
      sellOutAmount: '合計販売価格',
      sellOutPrice: '販売単価',
      sellOutTime: '販売時間'
    }
  },
  userReport: {
    title: 'ユーザーレポート',
    profit: '利益',
    timingTradeAmountFee: '非常に速い取引注文/手数料',
    timingTradePrizePoint: '非常に速い取引ボーナス/リベート',
    rechargeInfo: 'リチャージ/手数料',
    withdrawInfo: '出金・手数料',
    exchangeInfo: '交換・手数料'
  },
  userReportDay: {
    title: 'ユーザー日報',
    profit: '利益',
    timingTradeAmountFee: '非常に速い取引注文/手数料',
    timingTradePrizePoint: '非常に速い取引ボーナス/リベート',
    rechargeInfo: 'リチャージ/手数料',
    withdrawInfo: '出金・手数料',
    exchangeInfo: '交換・手数料'
  },
  teamReport: {
    title: 'チームレポート',
    goToReportDay: '日次レポートを表示',
    timingTradeBetAmountServiceCharge: '非常に速い取引注文/サービス料',
    timingTradeBetPrizePoint: '高速取引ボーナス/リベート',
    timingTradeUserAndCount: 'スピードトレーダーの数/取引数',
    rechargeAmountFee: 'リチャージ金額/サービス料',
    rechargePersonCount: 'リチャージ担当者/トランザクション数',
    withdrawAmountFee: '出金額/サービス料',
    withdrawPersonCount: 'お金/取引を引き出した人の数',
    firstRechargeUserAndCount: '初回リチャージ金額/人数',
    usernamePlaceholder: '下位レベルのユーザー名を入力してください',
    previewAllTradeInfo: 'すべてのスピードトレード情報を表示',
    coin: '通貨',
    timingTradeBetAmount: '非常に速い取引の賭け金',
    profit: '利益',
    action: '操作',
    previewReportDay: '日次レポートを表示'
  },
  teamTimingTradeInfo: {
    title: 'チームスピードトレーディング',
    profit: '利益',
    subTitle: 'チームスピードトランザクション情報',
    timingTradeAmountFee: '非常に速い取引注文/サービス手数料',
    timingTradePrizePoint: '非常に速い取引ボーナス/リベート',
    rechargeInfo: 'リチャージ/サービス料金',
    withdrawInfo: '出金/サービス料',
    exchangeInfo: '交換/サービス手数料'
  },
  teamReportDay: {
    title: 'チーム日報',
    subTitle: 'チーム [{username}] の日報',
    timingTradeBetAmountFee: '非常に速い取引注文/サービス手数料',
    timingTradeBetPrizePoint: '高速取引ボーナス/リベート',
    rechargeAmountFee: 'リチャージ金額/サービス料',
    rechargePersonCount: 'リチャージ担当者/トランザクション数',
    timingTradeUserAndCount: 'スピードトレーダーの数/取引数',
    firstRechargePersonCount: '最初のリチャージ金額/トランザクション数',
    withdrawAmountFee: '出金額/サービス料',
    withdrawPersonCount: 'お金/取引を引き出した人の数',
    exchangeAmountFee: '両替金額/サービス手数料'
  },
  share: {
    title: 'シェアしたい',
    qrCodeLabel: 'QR コード',
    registerUrlLabel: '登録アドレス',
    inviteCodeLabel: '招待コード',
    hasNoInviteCode: '現在のアカウントには招待コードがありません、',
    generateInvitationCode: 'ワンクリックで生成してみます',
    tipsPart1: '上記のQRコードを読み取って登録情報を入力して登録してください',
    tipsPart2: '登録アドレスをコピーし、登録情報を記入して登録します',
    tipsPart3: 'このサイトの登録インターフェイスを手動で開き、招待コードを入力して登録します',
    saveImageError: '画像の保存に失敗しました。画像を長押しして保存してください。'
  },
  myTeam: {
    title: '私のチーム',
    usernamePlaceholder: '下位レベルのユーザー名を入力してください',
    point: 'リベート (速度/契約)',
    totalBalance: '残高',
    lastLoginTime: '最終ログイン時刻',
    noLoginTime: 'なし'
  },
  userDetail: {
    username: 'ユーザー名',
    userType: 'ユーザータイプ',
    title: 'ユーザーの詳細',
    pointPercentTiming: '非常に高速なトランザクション リベート',
    pointPercentContract: '契約トランザクション リベート',
    registerWay: '登録メソッド',
    teamCounts: 'チーム番号',
    teamOnline: 'チームオンライン',
    balance: 'バランス',
    registerTime: '登録時刻',
    onlineStatus: 'ログインステータス'
  },
  addUser: {
    title: 'ユーザーの追加',
    addUserDirect: {
      userTypeLabel: 'ユーザータイプ',
      usernameLabel: 'ユーザー名',
      usernamePlaceholder: 'アカウントのユーザー名を入力してください',
      pointTimingLabel: '非常に高速なトランザクション リベート',
      pointContractLabel: '契約トランザクション リベート',
      tips: '初期パスワードは「{password}」です。アカウント開設後、時間内にパスワードを変更するようユーザーに通知してください',
      userTypeRequired: 'アカウントの種類を選択してください',
      usernameRequired: 'アカウントのユーザー名を入力してください',
      pointTimingRequired: '高速トランザクション リベートを選択してください',
      pointContractRequired: '契約取引リベートを選択してください',
      copyTemplate: '\n         \u30E6\u30FC\u30B6\u30FC\u540D: {\u30E6\u30FC\u30B6\u30FC\u540D};\n         \u30ED\u30B0\u30A4\u30F3\u30D1\u30B9\u30EF\u30FC\u30C9: {loginPassword};\n         \u30ED\u30B0\u30A4\u30F3 URL: {loginAddress};\n         \u9AD8\u901F\u53D6\u5F15\u30EA\u30D9\u30FC\u30C8: {timingTradePoint};\n         \u5951\u7D04\u53D6\u5F15\u30EA\u30D9\u30FC\u30C8: {contactTradePoint};\n         '
    }
  },
  recharge: {
    title: 'リチャージ',
    configIdLabel: '入金チャネル',
    chainNameLabel: 'チェーン名',
    amountLabel: 'リチャージ額',
    userCardNameLabel: '支払者',
    userCardNamePlaceholder: '支払者の名前を入力してください',
    fee: 'サービス料',
    receiveAmountTipsPart1: 'リチャージ',
    receiveAmountTipsPart2: '、支払う必要があります',
    tipsPart1: 'オンライン決済インターフェースが不安定なため、現在はオフライン送金リチャージのみがサポートされています。',
    tipsPart2: '実際の送金額を正直に入力してください。そうしないと、システムの審査が失敗し、リチャージの進行状況に影響を与える可能性があります。',
    emptyPart1: '利用可能なリチャージ チャネルがありません、',
    emptyPart2: 'タップして再試行',
    amountRequired: 'リチャージ額を空にすることはできません',
    maxPrecisionError: 'リチャージ金額の小数点以下の桁数は {amountMaxPrecision} 桁までです',
    payUserNameError: '正しい支払者を入力して、もう一度お試しください',
    userMobileLabel: '携帯電話番号',
    userMobilePlaceholder: 'ユーザーの携帯電話番号を入力してください',
    needPayLabel: '支払う必要があります',
    needPayPlaceholder: 'クリックして 金額を入力'
  },
  payDetail: {
    title: '乗り換えのご案内',
    addressLabel: '入金アドレス',
    rechargeAmount: 'リチャージ金額',
    bankNameLabel: '銀行',
    branchLabel: '支店アドレス',
    cardName: '名前',
    cardNum: 'カード番号',
    uploadImgLabel: '支払い資格情報',
    uploadImgPlaceholder: 'クリックして支払い伝票画像をアップロード',
    uploadImgRequired: '支払い伝票の写真をアップロードしてください',
    vcTransferTipsPart1: '1. 入金アドレスをコピーするか、QR コードをスキャンして入金',
    vcTransferTipsPart2: '2. 入金完了後に支払い伝票の画像をアップロード',
    vcTransferTipsPart3: '入金の効率を向上させるため、鮮明で高解像度の証明書の写真を必ずアップロードしてください。関連情報の写真が鮮明でない場合、システムの審査に失敗し、入金の進行に影響を与える可能性があります。 ',
    bankCardTips: '入金の効率を向上させるため、送金者と送金者の名前が同じであることを確認してください。関連する情報が一致しない場合、システムが審査に失敗し、進行に影響を与える可能性があります」預金の。',
    bankCardTransferSuccess: '転送に成功しました'
  },
  rechargeOrder: {
    title: '入金注文',
    payAmount: 'リチャージ額',
    receiveAmount: '受取金額'
  },
  identity: {
    title: '実名情報',
    subTitle: '実名認証には情報認証、身元認証も含まれる',
    name: '名前',
    idType: 'ドキュメントタイプ',
    idNum: 'ID番号',
    demand: '要求する',
    informationVer: '情報の検証',
    idAuthentication: '認証',
    material: '材料'
  },
  verified: {
    title: '実名認証',
    idCardTypeLabel: '証明書の種類',
    idCardFrontSideImgLabel: 'カード表面 SideImgLabel',
    idCardBackSideImgLabel: '証明写真の裏面',
    idCardHandSideImgLabel: '手持ちの証明写真',
    nameLabel: 'ドキュメント名',
    namePlaceholder: 'ID名を入力してください',
    idCardNumLabel: 'ID カード番号',
    idCardNumPlaceholder: 'ID番号を入力してください',
    fundPwdLabel: 'ファンドのパスワード',
    fundPwdPlaceholder: 'ファンドのパスワードを入力してください',
    tips: '情報認証は一度送信すると変更できません。よく確認して正しく入力してください。',
    idCardTypeRequired: 'カードの種類を選択してください',
    idCardFrontSideImgRequired: 'ID カードの正面写真をアップロードしてください',
    idCardBackSideImgRequired: 'ID カードの裏面の写真をアップロードしてください',
    idCardHandSideImgRequired: '手持ちの証明写真をアップロードしてください',
    nameRequired: 'ドキュメントの名前を入力してください',
    idCardNumRequired: 'ID 番号を入力してください',
    fundPwdRequired: 'ファンドのパスワードを入力してください',
    submitSuccess: '認証リクエストは正常に送信されました'
  },
  help: {
    title: 'ヘルプセンター'
  },
  helpDetail: {
    title: 'ヘルプの詳細'
  },
  myMessage: {
    title: '私のプライベートメッセージ'
  },
  messageDetail: {
    title: 'プライベートメッセージの詳細'
  },
  withdraw: {
    title: 'コインを引き出す',
    tips: '資金の安全性と出金の効率性を確保するため、入力された情報が正しいことを慎重に確認してください。出金プロセス中に発生する手数料は残高から差し引かれます。',
    receiveAmountTipsPart1: '出金',
    receiveAmountTipsPart2: '、到着予定',
    fee: 'サービス料',
    myBalance: '[{vcName}] の残高:',
    configIdLabel: '出金チャネル',
    amountLabel: '出金額',
    fundLabel: 'ファンドのパスワード',
    fundPlaceholder: 'ファンドのパスワードを入力してください',
    googleCodeLabel: 'Google 確認コード',
    googleCodePlaceholder: '6 桁の Google 確認コードを入力してください',
    maxPrecisionError: '出金金額の小数点以下の桁数は {amountMaxPrecision} までです',
    amountRequired: '正しい出金額を入力または選択してください',
    bankCardError: '正しい銀行カードを選択してください',
    fundPwdError: '正しいファンドのパスワードを入力してください',
    walletAddressError: '正しいウォレットアドレスを選択してください',
    success: '出金リクエストは正常に送信されました。処理をお待ちください',
    emptyPart1: '利用可能な出金チャネルがありません、',
    emptyPart2: 'タップして再試行してください'
  },
  withdrawOrder: {
    title: '撤回命令',
    requestAmount: '船荷証券の金額',
    receiveAmount: '受取金額'
  },
  locales: {
    title: '言語を切り替える'
  },
  lines: {
    title: 'ライン選択',
    switchLine: 'スイッチライン'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'お気に入りの通貨を正常に削除しました',
    addFavoriteSuccess: 'お気に入りの通貨を正常に追加しました'
  },
  currencySelect: {
    currencyName: '通貨',
    currencyPlaceholder: 'クリックして通貨を選択'
  },
  walletItem: {
    available: '利用可能',
    convert: '変換 (USDT)'
  },
  banks: {
    bankIdLabel: '銀行',
    bankIdPlaceholder: 'クリックして銀行を選択します'
  },
  banksPop: {
    title: '銀行を選択',
    search: '銀行のキーワードを入力してください'
  },
  historyOrderDetail: {
    title: '注文の詳細',
    coin: '取引通貨',
    amount: '注文金額',
    buyInClose: '購入価格',
    sellOutClose: '売り価格',
    isQuest: 'この注文について質問はありますか?',
    connectCustomer: 'カスタマー サービスに連絡しますか?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'クリックしてユーザー リベートを選択'
  },
  walletAddressSelect: {
    title: 'ウォレットアドレスを選択',
    label: 'ウォレットアドレス',
    placeholder: 'クリックしてウォレットアドレスを選択'
  },
  myCardSelect: {
    title: 'アカウントを選択',
    label: '受取口座',
    placeholder: 'クリックしてアカウントを選択'
  },
  amountInput: {
    amountRange: '最小値 {minAmount}、最大値 {maxAmount}',
    amountMin: '最小値 {minAmount}、上限なし',
    amountErrorEmpty: '{label} が間違っています。確認してもう一度お試しください',
    amountErrorOutRange: '{label} は範囲外です。確認して再試行してください。'
  },
  amountFormItem: {
    placeholderOnlyMin: '最小値 {minAmount}、上限なし',
    placeholderHasMax: '最小値 {minAmount}、最大値 {maxAmount}',
    amountErrorEmpty: '金額が間違っています。確認後にもう一度お試しください',
    amountErrorOutRange: '金額が範囲外です。確認して再試行してください。'
  },
  common: {
    remark: 'コメント',
    saveImage: 'ローカルに保存',
    online: 'オンライン',
    offline: 'オフライン',
    profit: '損益',
    date: '日付',
    period: '期間',
    pointAmount: 'ユーザー リベート金額',
    point: 'ユーザー リベート',
    direction: '方向',
    winLoss: '収入',
    lose: '負ける',
    add: '新規追加',
    win: '勝つ',
    edit: '変更',
    notBind: 'バインドされていない',
    alreadyBind: 'すでにバインドされています',
    enabled: '有効',
    notEnabled: '有効ではありません',
    queryRange: 'クエリ範囲',
    copy: 'コピー',
    orderNum: '注文番号',
    null: 'なし',
    noData: 'まだデータがありません',
    refreshSuccess: 'リフレッシュに成功しました',
    loadMoreData: 'さらにデータをロードする',
    noMoreData: 'これ以上データはありません',
    lookMore: 'もっと見る',
    more: 'もっと見る'
  },
  date: {
    today: '今日',
    yesterday: '昨日',
    last7Days: 'ほぼ 7 日間',
    last14Days: 'ほぼ 14 日間',
    split: 'へ'
  },
  button: {
    save: '保存',
    logout: 'ログアウト',
    confirm: 'OK',
    cancel: 'キャンセル',
    submit: '送信',
    addNow: '今すぐ追加',
    reset: 'リセット',
    nextStep: '次へ',
    goCertification: '認定に移動'
  },
  confirm: {
    title: {
      logout: 'ログアウト',
      unBindFundPassword: 'バインドされていないファンドのパスワード',
      addUserDirect: 'ユーザーを追加',
      addUserInfo: 'ユーザーの追加に成功しました',
      jumpToRechargePage: 'ジャンプを確認',
      unAuthentication: '非実名認証',
      noBindBankCard: '銀行カードは追加されていません',
      noBindCoinAddress: 'ウォレットアドレスは追加されていません',
      tradeConfirm: '取引を確認します',
      sellOutSpotOrder: '売りポジション',
      buyFinance: '購入を確認します',
      redeemOrder: '誓約注文の償還'
    },
    content: {
      logout: '現在のアカウントからログアウトしてもよろしいですか?',
      unBindFundPassword: 'バインドされていないファンドのパスワードが検出されました。アカ​​ウントのセキュリティを確保するために、最初にファンドのパスワードをバインドしてください',
      addUserDirect: '新しいユーザーがまもなく追加されます。情報が正しいことを確認し、[OK] をクリックして続行してください。ユーザー名 [ {username} ]、ユーザー タイプ [ {userType} ]、ログイン パスワード [ {password} ]、および私のスピード取引リベートの差 [ {diffPointTiming} ] と私の契約取引リベートの差 [ {diffPointContract} ]',
      addUserInfo: 'ユーザー名 [ {username} ]; <br /> ログイン パスワード [ {password} ];<br /> ログイン URL [ {loginAddress} ];<br /> エクストリーム トランザクション リベート [ {pointPercentTiming} ];<br / > /> 契約トランザクション リベート [{pointPercentContract}];',
      jumpToRechargePage: 'サードパーティのリチャージ インターフェイスにジャンプしようとしています。続行するには確認をクリックしてください',
      unAuthentication: 'アカウントが実名認証を受けていないことが検出されました。資金の正常な流通を確保するために、最初に実名認証を実行してください',
      noBindBankCard: 'アカウントが銀行カードにバインドされていないか、有効になっていないことが検出されました。資金を正常に流通させるために、最初に銀行カードを追加してください。',
      noBindCoinAddress: 'アカウントにバインドまたは有効化された仮想通貨アカウントがないことが検出されました。資金の正常な循環を確保するために、最初に仮想通貨アカウントのアドレスを追加してください',
      tradeConfirm: '注文が送信されようとしています。注文情報が正しいことを確認してから、[注文を確認] をクリックして送信してください。',
      sellOutSpotOrder: 'ポジション注文が売られようとしています。操作が正しいことを確認し、[OK]をクリックして続行してください。',
      buyFinance: '[{coin}] を購入しようとしています。シェア: {amount} を購入します。操作が正しいことを確認し、[OK] をクリックして続行してください。',
      redeemOrder: '誓約注文 ({orderNum}) が償還されようとしています。操作が正しいことを確認し、「確認」をクリックして続行してください。'
    }
  },
  message: {
    bindSuccess: 'バインド成功',
    successOperation: '操作は成功しました',
    logoutSuccess: '正常に終了',
    editSuccess: '正常に変更されました',
    addSuccess: '正常に追加されました',
    copySuccess: 'コピー成功',
    copyFailed: 'コピーに失敗しました'
  },
  vux: {
    'inline-calendar': {
      week_day_0: '日',
      week_day_1: '1',
      week_day_2: '2',
      week_day_3: '3',
      week_day_4: '4',
      week_day_5: '5',
      week_day_6: '6'
    },
    loading: {
      loading: '読み込み中'
    }
  },
  helpItems: {
    title: {
      part1: '資産換算額はなぜ変わるの？',
      part2: '店頭取引におけるファンドパスワードを忘れた場合の対処方法',
      part3: '店頭取引購入完了後の資金はどこへ流れるのか?',
      part4: 'ニックネームの変更回数を制限したいのはなぜですか',
      part5: '異動の意味、なぜ異動する必要があるのか​​',
      part6: 'ユーザー契約のアカウント資本はどのように計算するのですか?',
      part7: 'オープンポジションに設定されたストップロスとテイクプロフィットの値はいくらですか?」 どのように設定すればよいでしょうか? ',
      part8: '契約リスクを軽減するにはどうすればよいですか?',
      part9: '約定オープンポジションの数量は何を示していますか?',
      part10: '強制清算に関する指示',
      part11: '約定取引ルールとは何ですか？',
      part12: '約定取引における証拠金とは何ですか？',
      part13: '指値注文と成行注文とは何ですか?',
      part14: '契約取引のリスクとは何を意味するのか',
      part15: 'なぜ通貨換算が必要なのですか?',
      part16: '店頭取引の送金後、相手方はなぜ送金の受け取りが間に合わなかったのですか?',
      part17: '店頭でテザー(USDT)を購入するにはどうすればいいですか?'
    },
    content: {
      part1: '現在人民元で保有されているデジタル通貨を資産に変換したときの価値は、デジタル資産の価格変動により変化します。」 デジタル資産の数は変わりません。',
      part2: 'OTC 取引ファンドのパスワードを忘れた場合は、[マイ設定] をクリックしてファンドのパスワードを設定する」に移動するか、カスタマー サービスに連絡してリセットしてください。',
      part3: 'OTC 買い注文が完了すると、資金は資産の法定通貨口座に入力されます。 OTC購入資産を契約取引または先物取引に使用する必要がある場合は、資金移動モジュールに移動して転送してください。 ',
      part4: 'トランザクションのセキュリティ上の理由から、現在、ニックネームの変更は 1 回のみに制限されています。 ',
      part5: 'お客様のさまざまな口座間で資金の独立性を確保し、合理的なリスク管理を容易にするために、主要な取引モジュールの口座はここに分割されます。」 移転とは、さまざまな取引口座間で資産を相互に変換するプロセスを指します。',
      part6: '<p>契約口座資本、計算方法は次のとおりです:</p> <p>契約口座資本 = ポジション証拠金 + ポジション変動損益 + 当座利用可能額</p>',
      part7: 'テイクプロフィットとストップロスは、あなたが設定した利益制限と損失制限です。設定されたストッププロフィットとストップロスの金額に達すると、システムは自動的にポジションを決済します。」 契約購入時のリスクコントロールにご利用いただけます。設定されたテイクプロフィット額の半分は増加額×数量×レバレッジ倍数、ストップロスを設定します。リスクを合理的にコントロールするために、実際の資産状況に応じて設定することをお勧めします。',
      part8: '資金移動により残りの口座の利用可能資産を契約口座に移したり、ポジションを減らすことでリスクを軽減することができます。',
      part9: 'オープンポジションの数量は、購入予定の通貨の数量を示します。 たとえば、BTC/USDT 取引ペアの最初のページで、買いを選択し、価格を 1000USDT として入力し、数量を 10BTC として入力します。これは、単価 1000USDT で 10 BTC を購入することを期待していることを意味します。 ',
      part10: '<p>リスク度は、資産のリスクを測定する指標です。リスク度が 100% に等しい場合、ポジションは清算されたとみなされます。リスク度 = (ポジション証拠金 / 契約口座資本)*100ユーザーがポジションを超過することを防ぐために、システムはリスク度の調整率を設定し、リスク度がシステムが設定したリスク値に達すると、システムは強制的に清算します。 例: システムによって設定された調整率が 10% の場合、リスク度が 90% 以上になると、すべてのポジションがシステムによって強制的に決済されます。 </p> <p>注: 過剰なリスクによってシステムが強制決済を行った場合、すべてのポジションがクローズされるため、不必要な損失を避けるためにリスクを合理的に制御できることを願っています。</p>',
      part11: '<p>取引タイプ</p> <p>取引タイプは、オープン ロング ポジション (買い) とオープン ショート ポジション (売り) の 2 つの方向に分かれています。</p> <p>買いロング (コール) とは、現在の指数が上昇する可能性があると信じており、設定した価格または現在の市場価格で特定の契約を一定量購入したいと考えている場合。 </p> <p>空売り (弱気) とは、現在の指数が下落する可能性があると信じ、設定した価格または現在の市場価格で一定数の特定の契約を売却することを希望することを意味します。 </p> <p>注文方法</p> <p>指値注文: 注文の価格と数量を指定する必要があります</p> <p>成行注文: 数量を設定するだけです注文の価格は現在の市場価格です。</p> <p>ポジション</p> <p>送信した開始注文が完了すると、それはポジションと呼ばれます。</p> <p>契約の配信の問題</p> <p>プラットフォーム契約は、納期が定められていない永久契約です。 システム清算条件が満たされない限り、またはポジションを手動で決済しない限り、ポジションを永久に保持できます。 </p> <p>システムはポジションをクローズします</p> <p>1: ストッププロフィットとストップロスの設定値に達すると、システムは自動的にポジションをクローズします</p> <p>2: リスク高すぎると、システムはポジションを強制的にクローズします。</p>',
      part12: '<p>契約取引では、ユーザーは契約価格と数量、および対応するレバレッジ倍数に応じて、契約履行の金銭的保証として資金を支払うことで契約の取引に参加することができます。このような資金が契約証拠金です。 ユーザーはポジションをオープンするときに証拠金を占有し、ポジションを開くための証拠金が占有されるほど、口座のリスクが高くなります。 </p> <p>証拠金 = (始値 * 数量) / レバレッジ比率</p>',
      part13: '指値注文とは、プラットフォームに取引を委託することを期待する価格を指し、成行注文とは、プラットフォームに直接委託して、現在の価格で取引を行うことを指します。」 ポジションをオープンする際のルールでは、成行注文が指値注文よりも優先されます。 指値注文を選択する場合は、不当な始値による損失を避けるために、現在の通貨の市場価格に応じて合理的にポジションをオープンしてください。',
      part14: 'リスク レベルは契約アカウントのリスク指標であり、リスク レベルが 100% に等しい場合は清算とみなされます。 リスクが 50% を超える場合は、清算による損失を避けるために慎重にポジションをオープンする必要があることをお勧めします。 契約資産の利用可能な資金を補充するか、ポジションを減らすことでリスクを軽減できます。 ',
      part15: '取引所の機能は、資産内のさまざまな通貨での資金のスムーズな循環を可能にすることであり、先物口座で取得した QCC は取引のために自由に USDT に変換できます。」 他のアカウントのUSDTも、取引のために自由にQCCに変換できます。',
      part16: 'まず、お振込の際にご入力いただくお支払い方法が、注文詳細ページに表示されているお支払い方法と全く同じであることをご確認ください。 次に、お支払い方法が即時か遅延かを確認してください。 最後に、システムメンテナンスなどの理由により、ご利用の銀行および決済機関にご連絡ください。',
      part17: '<p>方法 1: 店頭売買リストから買いたい注文を選択し、売買します。 </p> <p>方法 2: 公開ボタンをクリックして、迅速な取引のニーズに応じて買い注文または売り注文を公開します。 システムはすぐに買い手と売り手をマッチングします。 </p> <p>注: 注文書が 15 分経過しても支払われない場合、システムにより注文が自動的にキャンセルされます。期限内にお支払いください。 同日に3回以上注文がキャンセルされた場合、その日のうちに再度取引を行うことはできず、翌日に取引権限が回復されます。 </p>'
    }
  }
};

/***/ }),

/***/ "HD9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("6Q4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Tqs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_696d4120_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("stEx");
function injectStyle (ssrContext) {
  __webpack_require__("MLsm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_696d4120_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HJi0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("piuB");

exports.default = {
  name: 'Tab',
  mixins: [_multiItems.parentMixin],
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent';
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;

      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
};

/***/ }),

/***/ "HMfG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: '로그인',
    usernameLabel: '사용자 이름',
    usernamePlaceholder: '영어로 시작하는 2-10개의 영어 숫자 조합',
    loginPasswordLabel: '로그인 비밀번호',
    loginPasswordPlaceholder: '로그인 비밀번호를 입력하세요',
    googleCodeLabel: 'Google 인증 코드',
    googleCodePlaceholder: 'Google 인증 코드 6자리를 입력하세요',
    hasNoAccount: '아직 계정이 없습니다.',
    goRegister: '등록으로 이동',
    onlineCustom: '온라인 고객 서비스',
    loginArgument: '계속 로그인하면 동의한 것으로 간주됩니다.',
    userArgument: '"사용자 계약"',
    RegisterNotEnabled: '등록 기능이 열려 있지 않습니다. 관리자에게 문의하세요.',
    usernameRequired: '올바른 사용자 이름을 입력하세요',
    loginPasswordRequired: '올바른 로그인 비밀번호를 입력하세요',
    googleCodeRequired: '올바른 Google 인증 코드를 입력하세요',
    loginButton: '로그인'
  },
  register: {
    title: '등록',
    usernameLabel: '사용자 이름',
    usernamePlaceholder: '등록된 사용자 이름을 입력하세요',
    loginPasswordLabel: '로그인 비밀번호',
    loginPasswordPlaceholder: '등록된 사용자의 로그인 비밀번호를 입력하세요',
    loginPasswordPreLabel: '로그인 비밀번호 확인',
    loginPasswordPrePlaceholder: '로그인 비밀번호를 다시 입력하세요',
    fudPasswordLabel: '펀드 비밀번호',
    fudPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    inviteCodeLabel: '초대 코드',
    inviteCodePlaceholder: '초대코드 6자리를 입력하세요',
    registerNeed: '계속 등록하는 것은 동의를 나타냅니다.',
    registerArgument: '"등록 계약"',
    usernameRequired: '올바른 사용자 이름을 입력하세요',
    loginPasswordRequired: '올바른 로그인 비밀번호를 입력하세요',
    loginPasswordPreRequired: '올바른 확인 로그인 비밀번호를 입력하세요',
    fundPasswordRequired: '올바른 펀드 비밀번호를 입력하세요',
    inviteCodeRequired: '올바른 초대 코드를 입력하세요',
    diffLoginPasswordError: '입력한 두 개의 로그인 비밀번호가 일치하지 않습니다.',
    registerSuccess: '등록 성공',
    registerButton: '등록',
    emailLabel: '이메일',
    emailPlaceholder: '이메일 주소를 입력하세요',
    emailCodeLabel: '인증 코드',
    emailCodePlaceholder: '이메일 확인 코드를 입력하세요',
    second: '두 번째',
    getEmailCodeButton: '인증 코드 받기',
    emailRequired: '올바른 이메일 주소를 입력하고 다시 시도하세요',
    emailCodeRequired: '올바른 이메일 확인 코드를 입력하고 다시 시도하십시오'
  },
  home: {
    hotCoin: {
      title: '핫 딜',
      more: '더'
    },
    poster: {
      title: '빠른 입금',
      enter: '지금 입력하세요>',
      subTitle: 'BTC, USDT, ETH 등 지원'
    },
    quickMenus: {
      futuresTrading: '선물 거래',
      helpCenter: '도움말 센터'
    },
    ranking: {
      increase: {
        title: '성장 목록'
      },
      clinch: {
        title: '거래량 목록'
      }
    }
  },
  tabBar: {
    home: '집',
    price: '견적',
    trade: '무역',
    fund: '자산',
    user: '내'
  },
  currency: {
    favorite: '당신의 선택',
    allCurrency: '현물',
    dayVol: '24시간 금액',
    addFavor: '+ 다음에 추가'
  },
  trade: {
    bills: '주문',
    todayOpen: '열기',
    star: '당신의 선택',
    vol: '거래량',
    low: '가장 낮음',
    high: '가장 높음',
    timing: '매우 빠르다',
    spot: '선물',
    buyMore: '추가 구매',
    buyEmpty: '단기 구매',
    indicator: '표시기',
    indicatorSettings: '표시기 설정',
    balance: '내 잔액',
    fee: '서비스 수수료',
    ruleIdError: '만료 시간을 선택하세요',
    deleteFavoriteSuccess: 'FavoriteSuccess 삭제',
    addFavoriteSuccess: '선택한 통화를 성공적으로 추가했습니다.',
    buyIn: '구매',
    sellOut: '판매',
    holding: '위치',
    history: '역사',
    spotOrderConfirm: {
      title: '구매 확인',
      amountPlaceholder: '구매 수량을 입력하세요'
    },
    spotTradeOrder: {
      holding: {
        coin: '통화',
        buyInAmountPrice: '총 구매 가격/단가',
        buyInCount: '수량',
        actions: '작업',
        sellOut: '판매',
        profit: '이익과 손실'
      }
    },
    orderConfirm: {
      title: '주문 확인',
      coinName: '통화',
      direction: '방향',
      price: '현재 가격',
      balance: '균형',
      fee: '서비스 수수료',
      buyMoreLabel: '추가 구매',
      buyEmptyLabel: '짧게 구매하세요',
      buyQuantity: '구매 수량',
      buyAmount: '구매 금액',
      submit: '주문 확인'
    },
    kline: {
      open: '열다:',
      close: '닫기:',
      change: '위 또는 아래:'
    }
  },
  finance: {
    title: '금융'
  },
  allFinance: {
    title: '재무관리',
    all: '모두'
  },
  financeOrders: {
    title: '서약 명령',
    holdingLabel: '보유',
    historyLabel: '역사',
    holding: {
      amount: '약정 금액',
      rateStr: '소득 금액/수익률',
      vcCount: '담보 코인 수량',
      cycle: '위치주기',
      day: '일',
      calcStartDate: '값 날짜',
      serviceAmount: '서비스 수수료',
      redeemOrder: '상환'
    },
    history: {
      incomeAmount: '소득 금액',
      rateStr: '수율',
      amount: '약정 금액',
      vcCount: '담보 코인 수량',
      calcStartDate: '값 날짜',
      calcEndDate: '이자 종료 날짜',
      cycle: '주기일',
      serviceAmount: '서비스 수수료',
      day: '일'
    }
  },
  financeOrderBills: {
    title: '공약소득 청구서',
    amount: '금액',
    balance: '균형'
  },
  financeItem: {
    rateStr: '수율',
    buyType: '구매 유형',
    cycle: '주기일',
    exchangeRate: '환율(가상화폐 교환 잔액)',
    day: '일',
    cycleType: '주기 유형',
    serviceRateStr: '서비스 요금'
  },
  buyFinance: {
    title: '구매',
    rateStr: '수율',
    name: '이름',
    buyType: '구매 유형',
    cycle: '주기일',
    cycleType: '주기 유형',
    exchangeRate: '환율(가상화폐 교환 잔액)',
    serviceRateStr: '서비스 요금',
    remark: '비고',
    buyAmountLabel: '구매 금액 ({coin})',
    descriptionTitle: '제품 설명',
    descriptionPart1: '1. 본 상품은 무원금 보장 금융상품입니다. 시세 변동에 따라 원금 손실이 발생할 수 있으니 신중하게 투자하시기 바랍니다.',
    descriptionPart2: '2. 지불 정산 규칙:',
    descriptionPart3: '정산가격 < 연동가격인 경우, BTC는 만기 이후 정산되며, 정산금액 = 투자금액* (1 + 일수 * 연환산수익률 / 365).',
    descriptionPart4: '결제 가격 ≥ 연결 가격인 경우 USDT는 만료 후 정산됩니다. 결제 수량 = 투자 금액 * 연결 가격 * (1 + 일수 * 연간 수익률 / 365).',
    descriptionPart5: '3. 실제 연간 수익률은 시장 상황에 따라 실시간으로 변경됩니다. 실제 구매 거래를 참고하세요.',
    descriptionPart6: '4. 투자금액은 시세에 따라 실시간으로 환산되므로 실제 구매거래를 참고하시기 바랍니다.',
    descriptionPart7: '5. 상품 구매 후 내 화폐 보유 페이지에서 확인하실 수 있습니다. 만료 후 자동으로 현물 계좌로 환불됩니다.',
    buyButton: '[{코인}] 구매'
  },
  fund: {
    description: '자산',
    recharge: '재충전',
    withdraw: '통화 철회',
    exchange: '이전',
    empty: '지갑이 비어 있습니다. 가세요'
  },
  userCenter: {
    lastLogin: '마지막 로그인',
    myTeam: '내 팀',
    identity: '실명인증',
    walletAddress: '지갑 주소',
    zskAccount: 'FPS 계정',
    bankCard: '은행 계좌',
    userBills: '계정 변경 기록',
    timingTradeOrder: '매우 빠른 포지션',
    spotTradeOrder: '선물 포지션',
    contactTradeOrder: '계약 위치',
    userReport: '사용자 보고서',
    teamReport: '팀 보고서',
    share: '공유하고 싶습니다',
    customer: '고객 서비스에 문의하세요',
    helpCenter: '도움말 센터',
    platform: '플랫폼 소개',
    profit: '오늘의 손익',
    balance: '내 잔액',
    withdraw: '통화 철회',
    recharge: '재충전',
    creditStoreLabel: '신용 포인트'
  },
  settings: {
    title: '설정',
    fundPassword: '펀드 비밀번호',
    googleValidator: 'Google 유효성 검사기',
    editLoginPassword: '로그인 비밀번호 변경',
    switchLocale: '언어 전환'
  },
  editFundPassword: {
    title: '펀드 비밀번호 변경',
    currentPasswordLabel: '현재 비밀번호',
    currentPasswordPlaceholder: '현재 펀드 비밀번호를 입력하세요',
    newPasswordLabel: '새 비밀번호',
    newPasswordPlaceholder: '수정된 펀드 비밀번호를 입력하세요',
    prePasswordLabel: '비밀번호 확인',
    prePasswordPlaceholder: '수정된 펀드 비밀번호를 다시 입력하세요',
    tips: '펀드 비밀번호는 거래에 있어 중요한 인증서이므로 잘 설정하시고 기억해두시기 바랍니다',
    currentPasswordRequired: '현재 펀드 비밀번호를 입력하세요',
    newPasswordRequired: '수정할 펀드 비밀번호를 입력하세요',
    prePasswordRequired: '다시 수정하려면 펀드 비밀번호를 입력하세요',
    prePasswordDiff: '두 개의 비밀번호 항목이 일치하지 않습니다'
  },
  bindFundPassword: {
    title: '바인딩 펀드 비밀번호',
    fundPasswordLabel: '펀드 비밀번호',
    fundPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    fundPasswordPreLabel: '비밀번호 확인',
    fundPasswordPrePlaceholder: '펀드 비밀번호를 다시 입력하세요',
    fundPasswordRequired: '올바른 펀드 비밀번호를 입력하세요',
    fundPasswordPreRequired: '올바른 확인 비밀번호를 입력하세요',
    fundPasswordDiff: '두 개의 비밀번호 항목이 일치하지 않습니다',
    binSuccess: '자금 비밀번호 바인딩 성공',
    tips: '펀드 비밀번호는 거래에 있어 중요한 인증서이므로 신중하게 설정하고 기억하시기 바랍니다'
  },
  editLoginPassword: {
    title: '로그인 비밀번호 변경',
    currentPasswordLabel: '현재 비밀번호',
    currentPasswordPlaceholder: '현재 로그인 비밀번호를 입력하세요',
    newPasswordLabel: '새 비밀번호',
    newPasswordPlaceholder: '수정된 로그인 비밀번호를 입력하세요',
    prePasswordLabel: '비밀번호 확인',
    prePasswordPlaceholder: '수정된 로그인 비밀번호를 다시 입력하세요',
    tips: '로그인 비밀번호는 로그인 인증 등에 있어 중요한 정보이므로 잘 설정하시고 기억해두시기 바랍니다',
    currentPasswordRequired: '현재 로그인 비밀번호를 입력하세요',
    newPasswordRequired: '수정할 로그인 비밀번호를 입력하세요',
    prePasswordRequired: '다시 수정하려면 로그인 비밀번호를 입력하세요',
    prePasswordDiff: '두 개의 비밀번호 입력이 일치하지 않습니다'
  },
  bindGoogleValidator: {
    title: 'Google OTP 바인딩',
    qrCodeLabel: 'QR 코드',
    keyLabel: '키',
    loginPasswordLabel: '로그인 비밀번호',
    loginPasswordPlaceholder: '로그인 비밀번호를 입력하세요',
    googleCodeLabel: 'Google 인증 코드',
    googleCodePlaceholder: 'Google 인증 코드 6자리를 입력하세요',
    tipsPart1: 'App Store에서 Google OTP 검색',
    tipsPart2: 'Google OTP를 사용하여 위의 QR 코드를 스캔하거나 수동으로 키를 입력하여 바인딩하세요',
    tipsPart3: '위의 6자리 Google 인증 코드를 입력하고 확인 및 제출을 클릭하세요',
    loginPasswordRequired: '로그인 비밀번호를 입력하세요',
    googleCodeRequired: '6자리 Google 인증 코드를 입력하세요.'
  },
  walletAddress: {
    title: '지갑 주소',
    add: '+ 지갑 주소 추가',
    remark: '비고',
    addButton: '지갑 주소 추가',
    tips: '주소 정보 수정, 삭제를 원하실 경우 고객센터로 연락주세요'
  },
  addWalletAddress: {
    title: '지갑 주소 추가',
    vcChainNameIdLabel: '체인 유형',
    vcAccountLabel: '지갑 주소',
    vcAccountPlaceholder: '지갑 주소를 입력하세요',
    remarkLabel: '비고',
    remarkPlaceholder: '비고 내용을 입력하세요',
    fundPasswordLabel: '펀드 비밀번호',
    fundPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    tips: '추가된 지갑 주소는 수정할 수 없습니다. 정보가 올바른지 확인하세요.',
    vcIdRequired: '올바른 통화를 선택하세요',
    vcChainNameIdRequired: '올바른 체인 유형을 선택하세요',
    vcAccountRequired: '올바른 지갑 주소를 입력하세요',
    fundPwdRequired: '올바른 펀드 비밀번호를 입력하세요',
    addSuccess: '지갑 주소가 성공적으로 추가되었습니다.'
  },
  receiveWays: {
    title: '내 은행 카드',
    add: '+ 은행 카드 추가',
    tips: '은행 카드 정보를 수정하거나 삭제하려면 고객 서비스에 문의하세요',
    addCardButton: '은행 카드 추가'
  },
  zskAccount: {
    title: 'FPS 계정',
    add: '+ FPS 계정 추가',
    tips: '계정정보 수정, 삭제를 원하시면 고객센터로 연락주세요',
    addCardButton: '계정 추가'
  },
  addZskAccount: {
    title: '새 FPS 계정',
    withdrawNameLabel: '이름',
    withdrawNamePlaceholder: '이름을 입력하세요',
    withdrawNameRequired: '이름은 비워둘 수 없습니다.',
    zskLabel: 'FPS',
    zskPlaceholder: 'FPS를 입력하세요',
    fundPasswordLabel: '펀드 비밀번호',
    fundPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    tips: '계좌 추가 정보 입력 시 주의하시기 바랍니다. 잘못된 정보 입력으로 인한 출금 실패에 대해 회사는 책임을 지지 않습니다.'
  },
  addBankCard: {
    title: '새 은행 카드 추가',
    cardNumLabel: '은행 카드 번호',
    withdrawNameLabel: '이름',
    withdrawNamePlaceholder: '이름을 입력하세요',
    withdrawNameRequired: '이름은 비워둘 수 없습니다.',
    zskLabel: 'FPS',
    zskPlaceholder: 'FPS를 입력하세요',
    zskRequired: '올바른 FPS를 입력하세요',
    cardNumPlaceholder: '은행 카드 번호를 입력하세요',
    branchLabel: '지점 주소',
    branchPlaceholder: '은행 카드 지점 주소를 입력하세요',
    fundPasswordLabel: '펀드 비밀번호',
    fundPasswordPlaceholder: '펀드 비밀번호를 입력하세요',
    tips: '은행카드\'는 거래 및 현금출금에 있어 중요한 정보이므로 꼭 기재해 주시기 바랍니다. 카드정보를 잘못 기재하여 출금이 되지 않는 등의 문제에 대해서는 회사에서는 책임을 지지 않습니다. ',
    backIdRequired: '계좌 개설 은행을 선택하세요',
    cardNumRequired: '올바른 은행 카드 번호를 입력하세요',
    fundPwdRequired: '올바른 펀드 비밀번호를 입력하세요',
    idCardPlaceholder: 'ID 번호를 입력하세요',
    idCardLabel: '신분증 번호',
    idCardRequired: '올바른 ID 번호를 입력하세요',
    cciPlaceholder: '은행 카드 CCI를 입력하세요',
    branchCodePlaceholder: '지점 번호를 입력하세요',
    branchCodeLabel: '지점 번호',
    katakanaPlaceholder: '가타카나를 입력하세요',
    katakanaLabel: '가타카나'
  },
  userBills: {
    title: '계정 변경 기록',
    vcName: '통화',
    amount: '금액',
    balance: '균형'
  },
  timingTradeOrder: {
    title: '매우 빠른 거래 주문',
    waiting: {
      title: '진행 중인 주문',
      amount: '금액',
      period: '기간',
      receivePrice: '구매 가격',
      settlement: '정착'
    },
    history: {
      title: '역사적 명령',
      buyInClose: '매수 가격',
      saleOutClose: '판매 가격'
    }
  },
  spotTradeOrder: {
    title: '선물 거래 주문',
    waiting: {
      title: '진행 중인 주문',
      buyInAmount: '총 구매 가격',
      buyInPrice: '구매 단가',
      buyInCount: '구매 수량',
      buyInTime: '구매 시간'
    },
    history: {
      title: '역사적 명령',
      buyInAmount: '총 구매 가격',
      buyInPrice: '구매 단가',
      buyInCount: '구매 수량',
      sellOutAmount: '총 판매가',
      sellOutPrice: '판매 단가',
      sellOutTime: '판매 시간'
    }
  },
  userReport: {
    title: '이용자 신고',
    profit: '이익',
    timingTradeAmountFee: '매우 빠른 거래 주문/처리 수수료',
    timingTradePrizePoint: '매우 빠른 거래 보너스/리베이트',
    rechargeInfo: '충전/취급 수수료',
    withdrawInfo: '인출/취급 수수료',
    exchangeInfo: '교환/취급 수수료'
  },
  userReportDay: {
    title: '사용자 일일 보고서',
    profit: '이익',
    timingTradeAmountFee: '매우 빠른 거래 주문/처리 수수료',
    timingTradePrizePoint: '매우 빠른 거래 보너스/리베이트',
    rechargeInfo: '충전/취급 수수료',
    withdrawInfo: '인출/취급 수수료',
    exchangeInfo: '교환/취급 수수료'
  },
  teamReport: {
    title: '팀 보고서',
    goToReportDay: '일별 보고서 보기',
    timingTradeBetAmountServiceCharge: '매우 빠른 거래 주문/서비스 수수료',
    timingTradeBetPrizePoint: '매우 빠른 거래 보너스/리베이트',
    timingTradeUserAndCount: '고속 거래 수/거래 수',
    rechargeAmountFee: '충전금액/서비스 수수료',
    rechargePersonCount: '충전 횟수/거래 횟수',
    withdrawAmountFee: '출금 금액/서비스 수수료',
    withdrawPersonCount: '코인을 인출하는 사람 수/거래 수',
    firstRechargeUserAndCount: '첫 번째 충전 금액/인원',
    usernamePlaceholder: '하위 사용자 이름을 입력하세요',
    previewAllTradeInfo: '모든 고속 거래 정보 보기',
    coin: '통화',
    timingTradeBetAmount: '스피드 트레이딩 베팅 금액',
    profit: '이익',
    action: '액션',
    previewReportDay: '일별 보고서 보기'
  },
  teamTimingTradeInfo: {
    title: '팀 빠른 거래',
    profit: '이익',
    subTitle: '팀 스피드 트레이딩 정보',
    timingTradeAmountFee: '매우 빠른 거래 주문/서비스 수수료',
    timingTradePrizePoint: '매우 빠른 거래 보너스/리베이트',
    rechargeInfo: '충전/서비스 수수료',
    withdrawInfo: '출금/서비스 수수료',
    exchangeInfo: '교환/서비스 수수료'
  },
  teamReportDay: {
    title: '팀 일일 보고서',
    subTitle: '팀 [ {username} ] 일일 보고서',
    timingTradeBetAmountFee: '매우 빠른 거래 주문/서비스 수수료',
    timingTradeBetPrizePoint: '매우 빠른 거래 보너스/리베이트',
    rechargeAmountFee: '충전금액/서비스 수수료',
    rechargePersonCount: '충전 횟수/거래 횟수',
    timingTradeUserAndCount: '고속 거래 수/거래 수',
    firstRechargePersonCount: '첫 번째 충전 금액/거래 횟수',
    withdrawAmountFee: '출금 금액/서비스 수수료',
    withdrawPersonCount: '코인을 인출하는 사람 수/거래 수',
    exchangeAmountFee: '교환 금액/서비스 수수료'
  },
  share: {
    title: '공유하고 싶어요',
    qrCodeLabel: 'QR 코드',
    RegisterUrlLabel: '등록 주소',
    inviteCodeLabel: '초대 코드',
    hasNoInviteCode: '현재 계정에는 초대 코드가 없습니다.',
    generateInvitationCode: '원클릭 생성을 시도해보세요',
    tipsPart1: '위 QR 코드를 스캔하고 등록 정보를 입력하여 등록하세요',
    tipsPart2: '등록 주소를 복사하고 등록 정보를 입력하여 등록하세요',
    tipsPart3: '이 사이트의 등록 인터페이스를 수동으로 열고 등록하려면 초대 코드를 입력하세요',
    saveImageError: '이미지를 저장하지 못했습니다. 이미지를 길게 누른 후 저장해 보세요.'
  },

  myTeam: {
    title: '내 팀',
    usernamePlaceholder: '하위 사용자 이름을 입력하세요',
    point: '리베이트(속도/계약)',
    totalBalance: '균형',
    lastLoginTime: '마지막 로그인 시간',
    noLoginTime: '없음'
  },
  userDetail: {
    username: '사용자 이름',
    userType: '사용자 유형',
    title: '사용자 세부정보',
    pointPercentTiming: '매우 빠른 거래 리베이트',
    pointPercentContract: '계약 거래 리베이트',
    registerWay: '등록 방법',
    teamCounts: '팀 번호',
    teamOnline: '팀 온라인',
    balance: '균형',
    registerTime: '등록 시간',
    onlineStatus: '로그인 상태'
  },
  addUser: {
    title: '신규 사용자',
    addUserDirect: {
      userTypeLabel: '사용자 유형',
      usernameLabel: '사용자 이름',
      usernamePlaceholder: '계좌 개설 사용자 이름을 입력하세요',
      pointTimingLabel: '매우 빠른 거래 리베이트',
      pointContractLabel: '계약 거래 리베이트',
      tips: '초기 비밀번호는 "{password}"입니다. 계정을 개설한 후 제때에 비밀번호를 변경하도록 사용자에게 상기시켜주세요.',
      userTypeRequired: '계좌 개설 유형을 선택하세요',
      usernameRequired: '계좌 개설 사용자 이름을 입력하세요',
      pointTimingRequired: '빠른 거래 리베이트를 선택하세요',
      pointContractRequired: '계약 거래 리베이트를 선택하세요',
      copyTemplate: '\n         \uC0AC\uC6A9\uC790 \uC774\uB984: {\uC0AC\uC6A9\uC790 \uC774\uB984};\n         \uB85C\uADF8\uC778 \uBE44\uBC00\uBC88\uD638: {loginPassword};\n         \uB85C\uADF8\uC778 URL: {loginAddress};\n         \uB9E4\uC6B0 \uBE60\uB978 \uAC70\uB798 \uB9AC\uBCA0\uC774\uD2B8: {timingTradePoint};\n         \uACC4\uC57D \uAC70\uB798 \uB9AC\uBCA0\uC774\uD2B8: {contactTradePoint};\n         '
    }
  },
  recharge: {
    title: '입금',
    configIdLabel: '입금 채널',
    chainNameLabel: '체인 이름',
    amountLabel: '충전 금액',
    userCardNameLabel: '지급인',
    userCardNamePlaceholder: '지급인 이름을 입력하세요',
    fee: '서비스 수수료',
    receiveAmountTipsPart1: '충전',
    receiveAmountTipsPart2: ', 결제 필요',
    tipsPart1: '온라인 결제 인터페이스가 불안정하기 때문에 현재 오프라인 전송 및 충전만 지원합니다! ',
    tipsPart2: '실제 이체 금액을 사실대로 입력해 주세요. 그렇지 않으면 시스템 검토에 실패하여 충전 진행에 영향을 미칠 수 있습니다. ',
    emptyPart1: '사용 가능한 충전 채널이 없습니다, ',
    emptyPart2: '다시 시도하려면 터치하세요',
    amountRequired: '충전 금액은 비워둘 수 없습니다',
    maxPrecisionError: '충전 금액은 소수점 이하 {amountMaxPrecision}자리까지 가능합니다.',
    payUserNameError: '올바른 지불인을 입력하고 다시 시도하세요',
    userMobileLabel: '휴대폰번호',
    userMobilePlaceholder: '사용자의 휴대폰 번호를 입력하세요',
    needPayLabel: '결제해야 함',
    needPayPlaceholder: '금액을 입력하려면 클릭하세요'
  },
  payDetail: {
    title: '이전 정보',
    addressLabel: '입금 주소',
    rechargeAmount: '충전 금액',
    bankNameLabel: '은행',
    branchLabel: '지점 주소',
    cardName: '이름',
    cardNum: '카드 번호',
    uploadImgLabel: '결제 바우처',
    uploadImgPlaceholder: '결제 바우처 이미지를 업로드하려면 클릭하세요',
    uploadImgRequired: '결제 바우처 이미지를 업로드해주세요',
    vcTransferTipsPart1: '1. 입금하려면 입금 주소를 복사하거나 QR 코드를 스캔하세요.',
    vcTransferTipsPart2: '2. 입금 완료 후 결제 바우처 이미지 업로드',
    vcTransferTipsPart3: '입금 효율성을 높이기 위해 선명한 고화질 바우처 사진을 업로드하시기 바랍니다. 관련 정보 사진이 선명하지 않은 경우 시스템 감사가 실패하여 충전 진행에 영향을 미칠 수 있습니다. ',
    bankCardTips: '충전 효율성을 높이기 위해 입력하는 송금인과 송금인의 이름이 일치하는지 확인하세요. 관련 정보가 일치하지 않으면 시스템 검토를 통과하지 못하고 충전 진행에 영향을 미칠 수 있습니다. ',
    bankCardTransferSuccess: '성공적으로 이체했습니다'
  },
  rechargeOrder: {
    title: '입금주문',
    payAmount: '충전 금액',
    receiveAmount: '받은 금액'
  },
  identity: {
    title: '실명정보',
    subTitle: '실명인증에는 정보인증과 본인인증이 포함됩니다',
    name: '이름',
    idType: '문서 유형',
    idNum: 'ID 번호',
    demand: '수요',
    informationVer: '정보 확인',
    idAuthentication: '신원 인증',
    material: '재료'
  },

  verified: {
    title: '실명인증',
    idCardTypeLabel: '인증서 유형',
    idCardFrontSideImgLabel: '신분증 사진 앞면',
    idCardBackSideImgLabel: '증명사진 뒷면',
    idCardHandSideImgLabel: '휴대용 신분증 사진',
    nameLabel: '문서 이름',
    namePlaceholder: 'ID 이름을 입력하세요',
    idCardNumLabel: '인증서 번호',
    idCardNumPlaceholder: 'ID 번호를 입력하세요',
    fundPwdLabel: '펀드 비밀번호',
    fundPwdPlaceholder: '펀드 비밀번호를 입력하세요',
    tips: '인증정보를 한번 제출하면 수정이 불가능하니 꼭 확인하시고 정확하게 입력해주세요',
    idCardTypeRequired: '인증서 유형을 선택하세요',
    idCardFrontSideImgRequired: '신분증 앞면 사진을 업로드해 주세요.',
    idCardBackSideImgRequired: '신분증 뒷면 사진을 업로드해주세요',
    idCardHandSideImgRequired: '신분증 사진을 업로드해주세요',
    nameRequired: '인증서 이름을 입력하세요',
    idCardNumRequired: 'ID 번호를 입력하세요',
    fundPwdRequired: '펀드 비밀번호를 입력하세요',
    submitSuccess: '인증 요청이 성공적으로 제출되었습니다'
  },
  help: {
    title: '도움말 센터'
  },
  helpDetail: {
    title: '도움말 세부정보'
  },
  myMessage: {
    title: '내 비공개 메시지'
  },
  messageDetail: {
    title: '비공개 메시지 세부정보'
  },
  withdraw: {
    title: '코인 출금',
    tips: '자금의 안전과 출금의 효율성을 보장하기 위해, 입력된 정보가 정확한지 주의 깊게 확인하시기 바랍니다. 출금 과정에서 발생하는 처리 수수료는 잔액에서 차감됩니다.',
    receiveAmountTipsPart1: '철회',
    receiveAmountTipsPart2: ', 예상 도착 시간',
    fee: '서비스 수수료',
    myBalance: '내 [ {vcName} ] 잔액:',
    configIdLabel: '출금 채널',
    amountLabel: '출금 금액',
    fundLabel: '펀드 비밀번호',
    fundPlaceholder: '펀드 비밀번호를 입력하세요',
    googleCodeLabel: 'Google 인증 코드',
    googleCodePlaceholder: 'Google 인증 코드 6자리를 입력하세요',
    maxPrecisionError: '출금 금액은 소수점 이하 {amountMaxPrecision}자리까지 가능합니다.',
    amountRequired: '올바른 인출 금액을 입력하거나 선택하세요',
    bankCardError: '올바른 은행 카드를 선택하세요',
    fundPwdError: '올바른 펀드 비밀번호를 입력하세요',
    walletAddressError: '올바른 지갑 주소를 선택하세요',
    success: '출금 요청이 성공적으로 제출되었습니다. 처리를 기다려주세요',
    emptyPart1: '사용 가능한 통화 인출 채널이 없습니다, ',
    emptyPart2: '다시 시도하려면 터치하세요.'
  },
  withdrawOrder: {
    title: '철회 명령',
    requestAmount: '선하증권 금액',
    receiveAmount: '받은 금액'
  },
  locales: {
    title: '언어 전환'
  },
  lines: {
    title: '라인 선택',
    switchLine: '스위치 라인'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'FavoriteSuccess 삭제',
    addFavoriteSuccess: '선택한 통화를 성공적으로 추가했습니다.'
  },
  currencySelect: {
    currencyName: '통화',
    currencyPlaceholder: '통화를 선택하려면 클릭하세요.'
  },
  walletItem: {
    available: '사용 가능',
    convert: '변환됨(USDT)'
  },
  banks: {
    bankIdLabel: '은행',
    bankIdPlaceholder: '은행을 선택하려면 클릭하세요.'
  },
  banksPop: {
    title: '은행 선택',
    search: '은행 키워드 입력'
  },

  historyOrderDetail: {
    title: '주문 세부정보',
    coin: '거래 통화',
    amount: '주문 금액',
    buyInClose: '매수 가격',
    sellOutClose: '판매 가격',
    isQuest: '이 주문에 대해 질문이 있나요?',
    connectCustomer: '고객 서비스에 문의하시겠습니까?'
  },
  pointSelect: {
    prizeGroupPlaceholder: '사용자 리베이트를 선택하려면 클릭하세요.'
  },
  walletAddressSelect: {
    title: '지갑 주소 선택',
    label: '지갑 주소',
    placeholder: '지갑 주소를 선택하려면 클릭하세요'
  },
  myCardSelect: {
    title: '계정 선택',
    label: '수수료 계좌',
    placeholder: '계정을 선택하려면 클릭하세요.'
  },
  amountInput: {
    amountRange: '최소 {minAmount}, 최대 {maxAmount}',
    amountMin: '최소 {minAmount}, 상한 없음',
    amountErrorEmpty: '{label}이(가) 잘못되었습니다. 확인하고 다시 시도하세요',
    amountErrorOutRange: '{label}이(가) 범위를 벗어났습니다. 확인하고 다시 시도해 주세요.'
  },
  amountFormItem: {
    placeholderOnlyMin: '최소 {minAmount}, 상한 없음',
    placeholderHasMax: '최소 {minAmount}, 최대 {maxAmount}',
    amountErrorEmpty: '금액이 잘못되었습니다. 확인 후 다시 시도해 주세요.',
    amountErrorOutRange: '금액이 범위를 벗어났습니다. 확인하고 다시 시도하십시오.'
  },
  common: {
    remark: '비고',
    saveImage: '로컬 저장',
    online: '온라인',
    offline: '오프라인',
    profit: '이익과 손실',
    date: '날짜',
    period: '기간',
    pointAmount: '사용자 리베이트 금액',
    point: '사용자 리베이트',
    direction: '방향',
    winLoss: '이익',
    lose: '잃다',
    add: '더하다',
    win: '승리',
    edit: '수정',
    notBind: '바인딩되지 않음',
    alreadyBind: '이미 바인딩됨',
    enabled: '활성화됨',
    notEnabled: '활성화되지 않음',
    queryRange: '쿼리 범위',
    copy: '복사',
    orderNum: '주문 번호',
    null: '없음',
    noData: '아직 데이터가 없습니다',
    refreshSuccess: '새로 고침 성공',
    loadMoreData: '추가 데이터 로드',
    noMoreData: '더 이상 데이터가 없습니다',
    lookMore: '더 보기',
    more: '더'
  },
  date: {
    today: '오늘',
    yesterday: '어제',
    last7Days: '지난 7일',
    last14Days: '지난 14일',
    split: '에'
  },
  button: {
    save: '저장',
    logout: '로그아웃',
    confirm: '알았어',
    cancel: '취소',
    submit: '제출',
    addNow: '지금 추가',
    reset: '재설정',
    nextStep: '다음 단계',
    goCertification: '인증으로 이동'
  },
  confirm: {
    title: {
      logout: '로그아웃',
      unBindFundPassword: '언바운드 펀드 비밀번호',
      addUserDirect: '사용자 추가',
      addUserInfo: '사용자를 성공적으로 추가했습니다',
      jumpToRechargePage: '점프 확인',
      unAuthentication: '실명인증이 아닙니다.',
      noBindBankCard: '은행 카드가 추가되지 않았습니다',
      noBindCoinAddress: '지갑 주소가 추가되지 않았습니다',
      tradeConfirm: '거래 확인',
      sellOutSpotOrder: '포지션 매도',
      buyFinance: '구매 확인',
      receiveOrder: '주문 상환 약속'
    },
    content: {
      logout: '현재 계정에서 로그아웃하시겠습니까?',
      unBindFundPassword: '언바운드 펀드 비밀번호가 감지되었습니다. 계정 보안을 보장하려면 먼저 펀드 비밀번호를 바인딩하십시오.',
      addUserDirect: '새 사용자가 추가되려고 합니다. 정보가 올바른지 확인한 후 계속하려면 확인을 클릭하세요. 사용자 이름 [ {username} ], 사용자 유형 [ {userType} ], 로그인 비밀번호 [ {password} ], 내 속도 거래 리베이트 간의 차이 [ {diffPointTiming} ], 내 계약 거래 간의 리베이트 차이 [ {diffPointContract} ]',
      addUserInfo: '사용자 이름 [ {username} ]; <br /> 로그인 비밀번호 [ {password} ]; <br /> 로그인 URL [ {loginAddress} ]; <br /> 빠른 거래 리베이트 [ {pointPercentTiming} ]; <br / > />계약 거래 리베이트 [{pointPercentContract}];',
      jumpToRechargePage: '3자 충전 인터페이스가 곧 점프할 예정입니다. 계속하려면 확인을 클릭하세요.',
      unAuthentication: '계좌가 실명인증을 거치지 않은 것으로 감지되었습니다. 원활한 자금유통을 위해 실명인증을 먼저 진행해 주시기 바랍니다.',
      noBindBankCard: '계좌에 은행 카드가 연결되어 있지 않거나 활성화되지 않은 것으로 감지되었습니다. 정상적인 자금 흐름을 보장하려면 먼저 은행 카드를 추가하십시오.',
      noBindCoinAddress: '계좌에 가상 화폐 계좌가 바인딩되거나 활성화되어 있지 않은 것으로 감지되었습니다. 정상적인 자금 순환을 보장하기 위해 먼저 가상 화폐 계좌 주소를 추가하십시오.',
      tradeConfirm: '주문이 곧 제출됩니다. 주문 정보가 올바른지 확인하고 주문 확인을 클릭하여 제출하세요.',
      SellOutSpotOrder: '포지션 주문이 곧 매도될 예정입니다. 작업이 올바른지 확인하고 계속하려면 확인을 클릭하세요.',
      buyFinance: '[{coin}]을(를) 구매하려고 합니다. 공유: {amount}을(를) 구매하려고 합니다. 작업이 올바른지 확인하고 계속하려면 확인을 클릭하세요.',
      receiveOrder: '서약 주문({orderNum})이 곧 상환될 예정입니다. 작업이 올바른지 확인하고 계속하려면 확인을 클릭하세요.'
    }
  },
  message: {
    binSuccess: '바인딩 성공',
    successOperation: '작업 성공',
    logoutSuccess: '성공적으로 종료했습니다',
    editSuccess: '수정 성공',
    addSuccess: '추가 성공',
    copySuccess: '복사 성공',
    copyFailed: '복사 실패'
  },
  vux: {
    'inline-calendar': {
      week_day_0: '일',
      week_day_1: '일',
      week_day_2: '2',
      week_day_3: '삼',
      week_day_4: '4',
      week_day_5: '오',
      week_day_6: '토요일'
    },
    loading: {
      loading: '로드 중'
    }
  },
  helpItems: {
    title: {
      part1: '자산환산금액이 왜 바뀌나요? ',
      part2: 'OTC 거래 시 펀드 비밀번호를 잊어버린 경우 대처 방법',
      part3: 'OTC 거래가 완료된 후 자금은 어디로 흘러가나요? ',
      part4: '닉네임 수정 횟수를 왜 제한해야 하나요?',
      part5: '이전이란 무엇을 의미하며 왜 이전이 필요한가',
      part6: '사용자 계약의 계정 자산을 어떻게 계산하나요? ',
      part7: '포지션 개설 시 설정된 손절매 및 이익실현 수치는 얼마입니까? 어떻게 설정해야 하나요? ',
      part8: '계약 위험을 줄이는 방법은 무엇입니까? ',
      part9: '계약 체결 수량은 무엇을 의미하나요? ',
      part10: '강제청산 지시사항',
      part11: '계약 거래 규칙은 무엇인가요? ',
      part12: '계약 거래에서 마진이란 무엇인가요? ',
      part13: '지정가 주문과 시장가 주문이 무엇인가요? ',
      part14: '계약 거래의 위험은 무엇을 의미합니까',
      part15: '환전은 왜 필요한가요? ',
      part16: 'OTC 거래가 이체된 후 상대방이 제때에 이체를 받지 못한 이유는 무엇입니까? ',
      part17: 'OTC를 통해 테더(USDT)를 구매하는 방법은 무엇인가요? '
    },
    content: {
      part1: '자산의 전환 계산은 현재 위안화로 보유하고 있는 디지털 통화의 가치이며 디지털 자산의 가격 변동으로 인해 변경됩니다. 귀하의 디지털 자산 금액은 변경되지 않았습니다. ',
      part2: 'OTC 거래 펀드 비밀번호를 잊어버린 경우 "내 설정-펀드 비밀번호 설정 클릭"으로 이동하거나 고객 서비스에 문의하여 재설정하세요.',
      part3: 'OTC 구매 주문이 완료된 후 자금은 자산의 법정화폐 계좌에 입력됩니다. 계약 거래 또는 선물 거래를 위해 OTC 구매 자산을 사용해야 하는 경우 자금 이체 모듈로 이동하여 이체하세요. ',
      part4: '거래 보안상의 이유로 현재 닉네임은 한 번만 수정되도록 제한하고 있습니다. ',
      part5: '귀하의 다양한 계좌 간 자금의 독립성을 보장하고 합리적인 위험 통제를 용이하게 하기 위해 각 주요 거래 모듈의 계좌를 이에 따라 분할합니다. 이체란 다양한 거래 계좌 간 자산의 상호 전환을 의미합니다. ',
      part6: '<p>계약 계좌 자본, 계산 방법은 다음과 같습니다:</p> <p>계약 계좌 자본 = 포지션 증거금 + 포지션 변동 손익 + 당좌 계정 사용 가능 금액</p>',
      part7: '이익실현과 손절매는 귀하가 설정한 이익 상한선과 손실한도입니다. 설정된 손절매 금액에 도달하면 시스템이 자동으로 포지션을 청산합니다. 계약 매수 시 리스크 관리용으로 활용할 수 있으며, 반설정 이익실현 금액은 증가액 x 수량 x 레버리지 배수이므로, 합리적으로 리스크 관리를 위해 실제 자산 상황에 맞춰 손절매 설정을 권장합니다. . ',
      part8: '남은 계좌의 사용 가능한 자산을 자금 이체를 통해 컨트랙트 계좌로 이체하거나, 포지션을 줄여 리스크를 줄일 수 있습니다. ',
      part9: '개시 포지션의 수량은 구매하려는 통화의 수량을 나타냅니다. 예: BTC/USDT 거래 쌍의 시작 페이지에서 "롱 매수"를 선택하고 가격을 1,000 USDT로 입력하고 수량을 10 BTC로 입력합니다. 즉, 단가 1,000에 10 BTC를 구매할 것으로 예상됩니다. USDT. ',
      part10: '<p>리스크는 자산의 리스크를 측정하는 지표입니다. 리스크가 100%가 되면 포지션이 청산된 것으로 간주됩니다. 리스크 = (포지션 증거금/계약 계좌 자본)*100%. 사용자가 포지션을 잃지 않도록 시스템은 리스크 조정 비율을 설정하며, 리스크가 시스템에서 설정한 리스크 값에 도달하면 시스템은 강제로 포지션을 청산합니다. 예를 들어, 시스템에서 설정한 조정 비율이 10%인 경우 위험 수준이 90% 이상이면 시스템에 의해 모든 포지션이 강제 폐쇄됩니다. </p> <p>참고: 과도한 리스크로 인해 시스템이 청산을 강제하는 경우 모든 포지션이 청산되므로 불필요한 손실을 피하기 위해 리스크를 합리적으로 관리하시기 바랍니다.</p>',
      part11: '<p> 거래 유형</p> <p>거래 유형은 두 가지 방향으로 나뉩니다: 롱 포지션 개설(매수) 및 숏 포지션 개설(매도):</p> <p>매수 및 이동 매수(강세)는 현재 지수가 상승할 가능성이 있다고 생각하고 설정한 가격이나 현재 시장 가격으로 특정 수의 신규 계약을 매수하기를 희망한다는 의미입니다. </p> <p>공매도(약세)는 현재 지수가 하락할 수 있다고 믿고 자신이 설정한 가격이나 현재 시장 가격으로 특정 수의 신규 계약을 매도하기를 희망한다는 의미입니다. </p> <p>주문 방법</p> <p>지정가 주문: 주문 가격과 수량을 직접 지정해야 합니다.</p> <p>시장가 주문: 지정가 주문만 설정하면 됩니다. 주문 수량, 가격은 현재 시장 가격입니다</p> <p>포지션</p> <p>제출한 개시 주문이 완료되면 이를 포지션이라고 합니다</p> <p>계약 납품 문제</p> <p>플랫폼 계약은 배송 시간이 정해져 있지 않은 무기한 계약입니다. 시스템 청산 조건이 충족되지 않거나 수동으로 포지션을 청산하지 않는 한 포지션을 영구적으로 유지할 수 있습니다. </p> <p>시스템이 포지션을 청산합니다.</p> <p>1: 이익 정지 및 손실 정지 설정에 도달하면 시스템이 자동으로 포지션을 청산합니다.</p> <p>2: 리스크가 너무 높으면 시스템이 강제로 포지션을 청산합니다 </p>',
      part12: '<p>계약 거래에서 사용자는 계약 가격과 수량, 그리고 해당 레버리지 배수에 따라 계약 이행에 대한 재정적 보증으로 자금을 지불함으로써 계약 구매 및 판매에 참여할 수 있습니다. 자금의 종류는 계약금입니다. 사용자가 포지션을 개설하면 증거금이 점유되며, 개설 증거금이 많을수록 계정 위험이 높아집니다. </p> <p>마진 = (시가 * 수량) / 레버리지 배수</p>',
      part13: '지정가 주문은 플랫폼에 위탁하여 거래할 것으로 예상되는 가격을 의미하며, 시장가 주문은 플랫폼에 현재 가격으로 직접 거래하도록 위탁하는 것을 의미합니다. 포지션 개설 규칙에 따르면 시장가 주문이 지정가 주문보다 우선합니다. 지정가 주문을 선택하는 경우, 불합리한 개시 가격으로 인한 손실을 피하기 위해 현재 통화 시장 가격을 기준으로 합리적으로 포지션을 개시하시기 바랍니다. ',
      part14: '위험도는 계약 계정의 위험 지표입니다. 위험도가 100%에 해당하면 청산으로 간주됩니다. 위험이 50%를 초과하는 경우 청산으로 인한 손실을 피하기 위해 포지션을 개설할 때 주의해야 합니다. 계약 자산에 사용 가능한 자금을 보충하거나 포지션을 줄여 위험을 줄일 수 있습니다. ',
      part15: '교환의 기능은 귀하의 자산에 있는 다양한 통화의 자금이 원활하게 유통되도록 하는 것입니다. 선물 계좌에서 획득한 QCC는 자유롭게 USDT로 전환하여 거래할 수 있습니다. 다른 계좌의 USDT도 자유롭게 QCC로 전환하여 거래할 수 있습니다. ',
      part16: '먼저 송금 시 입력하는 결제 수단이 주문 세부정보 페이지에 표시된 내용과 정확히 일치하는지 확인하세요. 그런 다음 결제 수단이 즉시 결제인지 지연 결제인지 확인하세요. 마지막으로, 시스템 점검이나 기타 사유가 있는지 해당 은행 및 결제 기관에 문의하시기 바랍니다. ',
      part17: '<p>방법 1: OTC 구매 및 판매 목록을 통해 구매 및 판매하려는 주문을 선택하세요. </p> <p>방법 2: 게시 버튼을 클릭하여 빠른 거래를 위해 필요에 따라 매수 또는 매도 주문을 게시하세요. 시스템은 귀하를 구매 및 판매 사용자와 신속하게 연결해 드립니다. </p> <p>참고: 구매 주문이 15분 후에도 결제되지 않으면 시스템이 자동으로 주문을 취소하므로 기한 내에 결제해 주시기 바랍니다. 당일 3회 이상 주문 취소 시 당일에는 다시 거래가 불가능하며, 다음날 거래 허가가 복원됩니다. </p>'
    }
  }
};

/***/ }),

/***/ "HNSI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HQNd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HbsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cube-slide-item"},[_vm._t("default",function(){return [_c('a',{attrs:{"href":_vm.item.url}},[_c('img',{attrs:{"src":_vm.item.image}})])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HsJn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabItem = exports.Tab = undefined;

var _Tab = __webpack_require__("cFY4");

var _Tab2 = _interopRequireDefault(_Tab);

var _TabItem = __webpack_require__("GRCs");

var _TabItem2 = _interopRequireDefault(_TabItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tab = _Tab2.default;
exports.TabItem = _TabItem2.default;

/***/ }),

/***/ "HwW6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: '登錄',
    usernameLabel: '用戶名',
    usernamePlaceholder: '2-10位以英文開頭的英文數字組合',
    loginPasswordLabel: '登錄密碼',
    loginPasswordPlaceholder: '請輸入你的登錄密碼',
    googleCodeLabel: '谷歌驗證碼',
    googleCodePlaceholder: '請輸入6位谷歌驗證碼',
    hasNoAccount: '還沒有賬號,',
    goRegister: '去註冊',
    onlineCustom: '在線客服',
    loginArgument: '繼續登錄即代表同意',
    userArgument: '《用戶協議》',
    registerNotEnabled: '未開放註冊功能, 請聯繫管理員',
    usernameRequired: '請輸入正確的用戶名',
    loginPasswordRequired: '請輸入正確的登錄密碼',
    googleCodeRequired: '請輸入正確的谷歌驗證碼',
    loginButton: '登錄'
  },
  register: {
    title: '註冊',
    usernameLabel: '用戶名',
    usernamePlaceholder: '請輸入註冊的用戶名',
    loginPasswordLabel: '登錄密碼',
    loginPasswordPlaceholder: '請輸入註冊用戶的登錄密碼',
    loginPasswordPreLabel: '確認登錄密碼',
    loginPasswordPrePlaceholder: '請再次輸入登錄密碼',
    fudPasswordLabel: '資金密碼',
    fudPasswordPlaceholder: '請輸入資金密碼',
    inviteCodeLabel: '邀請碼',
    inviteCodePlaceholder: '請輸入6位數邀請碼',
    registerNeed: '繼續註冊代表同意',
    registerArgument: '《註冊協議》',
    usernameRequired: '請輸入正確的用戶名',
    loginPasswordRequired: '請輸入正確的登錄密碼',
    loginPasswordPreRequired: '請輸入正確的確認登錄密碼',
    fundPasswordRequired: '請輸入正確的資金密碼',
    inviteCodeRequired: '請輸入正確的邀請碼',
    diffLoginPasswordError: '兩次登錄密碼輸入不一致',
    registerSuccess: '註冊成功',
    registerButton: '註冊',
    emailLabel: '郵箱',
    emailPlaceholder: '請輸入你的郵箱地址',
    emailCodeLabel: '驗證碼',
    emailCodePlaceholder: '請輸入你的郵箱驗證碼',
    second: '秒',
    getEmailCodeButton: '獲取驗證碼',
    emailRequired: '請輸入正確的郵箱地址後重試',
    emailCodeRequired: '請輸入正確的郵箱驗證碼後重試'
  },
  home: {
    hotCoin: {
      title: '熱門交易',
      more: '更多'
    },
    poster: {
      title: '快捷充幣',
      enter: '立即進入>',
      subTitle: '支持BTC，USDT，ETH等'
    },
    quickMenus: {
      futuresTrading: '期貨交易',
      helpCenter: '幫助中心'
    },
    ranking: {
      increase: {
        title: '漲幅榜'
      },
      clinch: {
        title: '成交額榜'
      }
    }
  },
  tabBar: {
    home: '首頁',
    price: '行情',
    trade: '交易',
    fund: '資產',
    user: '我的'
  },
  currency: {
    favorite: '自選',
    allCurrency: '現貨',
    dayVol: '24H額',
    addFavor: '+ 添加自選'
  },
  trade: {
    bills: '訂單',
    todayOpen: '開盤',
    star: '自選',
    vol: '成交量',
    low: '最低',
    high: '最高',
    timing: '極速',
    spot: '期貨',
    buyMore: '買多',
    buyEmpty: '買空',
    indicator: '指標',
    indicatorSettings: '指標設置',
    balance: '我的餘額',
    fee: '服務費',
    ruleIdError: '請選擇到期時間',
    deleteFavoriteSuccess: '刪除自選幣成功',
    addFavoriteSuccess: '添加自選幣成功',
    buyIn: '買入',
    sellOut: '賣出',
    holding: '持倉',
    history: '歷史',
    spotOrderConfirm: {
      title: '確認買入',
      amountPlaceholder: '請輸入購買數量'
    },
    spotTradeOrder: {
      holding: {
        coin: '幣種',
        buyInAmountPrice: '買入總價/單價',
        buyInCount: '數量',
        actions: '操作',
        sellOut: '賣出',
        profit: '盈亏'
      }
    },
    orderConfirm: {
      title: '訂單確認',
      coinName: '幣種',
      direction: '方向',
      price: '現價',
      balance: '餘額',
      fee: '服務費',
      buyMoreLabel: '買多',
      buyEmptyLabel: '買空',
      buyQuantity: '買入數量',
      buyAmount: '購買金額',
      submit: '確認訂單'
    },
    kline: {
      open: '開:',
      close: '收:',
      change: '漲跌:'
    }
  },
  finance: {
    title: '金融'
  },
  allFinance: {
    title: '理財',
    all: '全部'
  },
  financeOrders: {
    title: '質押訂單',
    holdingLabel: '在持',
    historyLabel: '歷史',
    holding: {
      amount: '質押金額',
      rateStr: '收益金額/收益率',
      vcCount: '質押幣數量',
      cycle: '持倉週期',
      day: '天',
      calcStartDate: '起息日期',
      serviceAmount: '服務費',
      redeemOrder: '贖回'
    },
    history: {
      incomeAmount: '收益金額',
      rateStr: '收益率',
      amount: '質押金額',
      vcCount: '質押幣數量',
      calcStartDate: '起息日期',
      calcEndDate: '終息日期',
      cycle: '週期天數',
      serviceAmount: '服務費',
      day: '天'
    }
  },
  financeOrderBills: {
    title: '質押收益賬單',
    amount: '金額',
    balance: '餘額'
  },
  financeItem: {
    rateStr: '收益率',
    buyType: '買入類型',
    cycle: '週期天數',
    exchangeRate: '兌換匯率(虛擬幣兌換餘額)',
    day: '天',
    cycleType: '週期類型',
    serviceRateStr: '服務費率'
  },
  buyFinance: {
    title: '購買',
    rateStr: '收益率',
    name: '名稱',
    buyType: '買入類型',
    cycle: '週期天數',
    cycleType: '週期類型',
    exchangeRate: '兌換匯率(虛擬幣兌換餘額)',
    serviceRateStr: '服務費率',
    remark: '備註',
    buyAmountLabel: '買入金額 ({coin})',
    descriptionTitle: '產品說明',
    descriptionPart1: '1.本產品為非保本理財產品，市場波動可能導致本金損失，請謹慎投資.',
    descriptionPart2: '2.回款結算規則：',
    descriptionPart3: '如果結算價＜掛鉤價，到期後結算BTC；結算數量=投資金額*(1+天數*年化收益率/365).',
    descriptionPart4: '如果結算價≥掛鉤價，到期後結算USDT；結算數量=投資金額*掛鉤價*(1+天數*年化收益率/365）.',
    descriptionPart5: '3.實際年化收益率隨市場實時變動，請以實際買入成交為準.',
    descriptionPart6: '4.投資金額隨市場實時折算得出，請以實際買入成交為準.',
    descriptionPart7: '5.產品購買後可在我的持幣頁面進行查看，到期結束後回款會自動發放至現貨賬戶.',
    buyButton: '購買 [{coin}]'
  },
  fund: {
    description: '資產',
    recharge: '充幣',
    withdraw: '提幣',
    exchange: '劃轉',
    empty: '錢包空空 去'
  },
  userCenter: {
    lastLogin: '上次登錄',
    myTeam: '我的團隊',
    identity: '實名認證',
    zskAccount: '轉數快賬戶',
    walletAddress: '錢包地址',
    bankCard: '銀行賬戶',
    userBills: '帳變記錄',
    timingTradeOrder: '極速持倉',
    spotTradeOrder: '期貨持倉',
    contactTradeOrder: '合約持倉',
    userReport: '用戶報表',
    teamReport: '團隊報表',
    share: '我要分享',
    customer: '聯繫客服',
    helpCenter: '幫助中心',
    platform: '平台介紹',
    profit: '今日盈虧',
    balance: '我的餘額',
    withdraw: '提幣',
    recharge: '充幣',
    creditStoreLabel: '信用積分'
  },
  settings: {
    title: '設置',
    fundPassword: '資金密碼',
    googleValidator: '谷歌驗證器',
    editLoginPassword: '修改登錄密碼',
    switchLocale: '切換語言'
  },
  editFundPassword: {
    title: '修改資金密碼',
    currentPasswordLabel: '當前密碼',
    currentPasswordPlaceholder: '請輸入當前資金密碼',
    newPasswordLabel: '新密碼',
    newPasswordPlaceholder: '請輸入修改的資金密碼',
    prePasswordLabel: '確認密碼',
    prePasswordPlaceholder: '清再次輸入修改的資金密碼',
    tips: '資金密碼是進行交易的重要憑證, 清謹慎設置並牢記',
    currentPasswordRequired: '請輸入當前的資金密碼',
    newPasswordRequired: '請輸入要修改的資金密碼',
    prePasswordRequired: '請再次輸入要修改的資金密碼',
    prePasswordDiff: '兩次密碼輸入不一致'
  },
  bindFundPassword: {
    title: '綁定資金密碼',
    fundPasswordLabel: '資金密碼',
    fundPasswordPlaceholder: '請輸入資金密碼',
    fundPasswordPreLabel: '確認密碼',
    fundPasswordPrePlaceholder: '請再次輸入資金密碼',
    fundPasswordRequired: '請輸入正確的資金密碼',
    fundPasswordPreRequired: '請輸入正確的確認密碼',
    fundPasswordDiff: '兩次密碼輸入不一致',
    bindSuccess: '資金密碼綁定成功',
    tips: '資金密碼是進行交易的重要憑證, 請謹慎設置並牢記'
  },
  editLoginPassword: {
    title: '修改登錄密碼',
    currentPasswordLabel: '當前密碼',
    currentPasswordPlaceholder: '請輸入當前登錄密碼',
    newPasswordLabel: '新密碼',
    newPasswordPlaceholder: '請輸入修改的登錄密碼',
    prePasswordLabel: '確認密碼',
    prePasswordPlaceholder: '清再次輸入修改的登錄密碼',
    tips: '登錄密碼是進行登錄認證等的重要憑證, 請謹慎設置並牢記',
    currentPasswordRequired: '請輸入當前的登錄密碼',
    newPasswordRequired: '請輸入要修改的登錄密碼',
    prePasswordRequired: '請再次輸入要修改的登錄密碼',
    prePasswordDiff: '兩次密碼輸入不一致'
  },
  bindGoogleValidator: {
    title: '綁定谷歌驗證器',
    qrCodeLabel: '二維碼',
    keyLabel: '密鑰',
    loginPasswordLabel: '登錄密碼',
    loginPasswordPlaceholder: '請輸入你的登錄密碼',
    googleCodeLabel: '谷歌驗證碼',
    googleCodePlaceholder: '請輸入6位谷歌驗證碼',
    tipsPart1: '在應用商店搜索谷歌驗證器',
    tipsPart2: '使用谷歌驗證器掃描上圖二維碼, 或手動輸入密鑰進行綁定',
    tipsPart3: '在上方輸入6位谷歌驗證碼, 點擊確認提交',
    loginPasswordRequired: '請輸入登錄密碼',
    googleCodeRequired: '請輸入6位谷歌驗證碼'
  },
  walletAddress: {
    title: '錢包地址',
    add: '+ 添加錢包地址',
    remark: '備註',
    addButton: '添加錢包地址',
    tips: '若要修改或刪除地址信息，請聯繫客服'
  },
  addWalletAddress: {
    title: '添加錢包地址',
    vcChainNameIdLabel: '鏈類型',
    vcAccountLabel: '錢包地址',
    vcAccountPlaceholder: '請輸入錢包地址',
    remarkLabel: '備註',
    remarkPlaceholder: '請輸入備註內容',
    fundPasswordLabel: '資金密碼',
    fundPasswordPlaceholder: '請輸入你的資金密碼',
    tips: '添加後的錢包地址不可修改, 請核實信息無誤',
    vcIdRequired: '請選擇正確的幣種',
    vcChainNameIdRequired: '請選擇正確的鏈類型',
    vcAccountRequired: '請輸入正確的錢包地址',
    fundPwdRequired: '請輸入正確的資金密碼',
    addSuccess: '錢包地址添加成功'
  },
  receiveWays: {
    title: '我的銀行卡',
    add: '+ 添加銀行卡',
    tips: '若要修改或者刪除銀行卡信息，請聯繫客服',
    addCardButton: '添加銀行卡'
  },
  zskAccount: {
    title: '轉數快賬戶',
    add: '+ 添加轉數快賬戶',
    tips: '若要修改或刪除賬戶信息, 請聯繫客服',
    addCardButton: '添加賬戶'
  },
  addZskAccount: {
    title: '新增轉數快賬戶',
    withdrawNameLabel: '姓名',
    withdrawNamePlaceholder: '請輸入姓名',
    withdrawNameRequired: '姓名不允許為空',
    zskLabel: '轉數快',
    zskPlaceholder: '請輸入轉數快',
    fundPasswordLabel: '資金密碼',
    fundPasswordPlaceholder: '請輸入你的資金密碼',
    tips: '請謹慎填寫添加賬戶的信息, 如因為信息填寫錯誤導致提現不到賬的問題, 公司概不負責'
  },
  addBankCard: {
    title: '新增銀行卡',
    withdrawNameLabel: '姓名',
    withdrawNamePlaceholder: '請輸入姓名',
    withdrawNameRequired: '姓名不允許為空',
    zskLabel: '轉數快',
    zskPlaceholder: '請輸入轉數快',
    zskRequired: '請輸入正確的轉數快',
    cardNumLabel: '銀行卡號',
    cardNumPlaceholder: '請輸入銀行卡號',
    branchLabel: '支行地址',
    branchPlaceholder: '請輸入銀行卡支行地址',
    fundPasswordLabel: '資金密碼',
    fundPasswordPlaceholder: '請輸入資金密碼',
    tips: '銀行卡是進行交易提現的重要數據, 請謹慎填寫, 如因卡信息填寫錯誤導致提現不到賬等問題, 公司概不負責。 ',
    backIdRequired: '請選擇開戶行',
    cardNumRequired: '請輸入正確的銀行卡號',
    fundPwdRequired: '請輸入正確的資金密碼',
    idCardPlaceholder: '請輸入身份證號',
    idCardLabel: '身份證號',
    idCardRequired: '請輸入正確的身份證號',
    cciPlaceholder: '請輸入銀行卡CCI',
    branchCodePlaceholder: '請輸入支行編號',
    branchCodeLabel: '支行編號',
    katakanaPlaceholder: '請輸入片假名',
    katakanaLabel: '片假名'
  },
  userBills: {
    title: '帳變記錄',
    vcName: '幣種',
    amount: '金額',
    balance: '餘額'
  },
  timingTradeOrder: {
    title: '極速交易訂單',
    waiting: {
      title: '在持訂單',
      amount: '金額',
      period: '週期',
      receivePrice: '買入價',
      settlement: '結算中'
    },
    history: {
      title: '歷史訂單',
      buyInClose: '買入價',
      saleOutClose: '賣出價'
    }
  },
  spotTradeOrder: {
    title: '期货交易订单',
    waiting: {
      title: '在持订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      buyInTime: '买入时间'
    },
    history: {
      title: '历史订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      sellOutAmount: '卖出总价',
      sellOutPrice: '卖出单价',
      sellOutTime: '卖出时间'
    }
  },
  userReport: {
    title: '用戶報表',
    profit: '盈利',
    timingTradeAmountFee: '極速交易下單/手續費',
    timingTradePrizePoint: '極速交易獎金/返點',
    rechargeInfo: '充值/手續費',
    withdrawInfo: '提現/手續費',
    exchangeInfo: '兌換/手續費'
  },
  userReportDay: {
    title: '用戶日報表',
    profit: '盈利',
    timingTradeAmountFee: '極速交易下單/手續費',
    timingTradePrizePoint: '極速交易獎金/返點',
    rechargeInfo: '充值/手續費',
    withdrawInfo: '提現/手續費',
    exchangeInfo: '兌換/手續費'
  },
  teamReport: {
    title: '團隊報表',
    goToReportDay: '查看日報表',
    timingTradeBetAmountServiceCharge: '極速交易下單/服務費',
    timingTradeBetPrizePoint: '極速交易獎金/返點',
    timingTradeUserAndCount: '極速交易人數/筆數',
    rechargeAmountFee: '充值金額/服務費',
    rechargePersonCount: '充值人數/筆數',
    withdrawAmountFee: '提幣金額/服務費',
    withdrawPersonCount: '提幣人數/筆數',
    firstRechargeUserAndCount: '首充金額/人數',
    usernamePlaceholder: '輸入下級用戶名',
    previewAllTradeInfo: '查看所有極速交易信息',
    coin: '幣種',
    timingTradeBetAmount: '極速交易投注金額',
    profit: '盈利',
    action: '操作',
    previewReportDay: '查看日報表'
  },
  teamTimingTradeInfo: {
    title: '團隊極速交易',
    profit: '盈利',
    subTitle: '團隊極速交易信息',
    timingTradeAmountFee: '極速交易下單/服務費',
    timingTradePrizePoint: '極速交易獎金/返點',
    rechargeInfo: '充值/服務費',
    withdrawInfo: '提現/服務費',
    exchangeInfo: '兌換/服務費'
  },
  teamReportDay: {
    title: '團隊日報表',
    subTitle: '團隊 [ {username} ]日報表',
    timingTradeBetAmountFee: '極速交易下單/服務費',
    timingTradeBetPrizePoint: '極速交易獎金/返點',
    rechargeAmountFee: '充值金額/服務費',
    rechargePersonCount: '充值人數/筆數',
    timingTradeUserAndCount: '極速交易人數/筆數',
    firstRechargePersonCount: '首充金額/筆數',
    withdrawAmountFee: '提幣金額/服務費',
    withdrawPersonCount: '提幣人數/筆數',
    exchangeAmountFee: '兌換金額/服務費'
  },
  share: {
    title: '我要分享',
    qrCodeLabel: '二維碼',
    registerUrlLabel: '註冊地址',
    inviteCodeLabel: '邀請碼',
    hasNoInviteCode: '當前賬戶沒有邀請碼,',
    generateInvitationCode: '試試一鍵生成',
    tipsPart1: '掃描以上二維碼填寫註冊信息進行註冊',
    tipsPart2: '複製註冊地址填寫註冊信息進行註冊',
    tipsPart3: '手動打開本站點註冊界面填寫邀請碼進行註冊',
    saveImageError: '圖片保存失敗，試試長按圖片並保存'
  },
  myTeam: {
    title: '我的團隊',
    usernamePlaceholder: '輸入下級用戶名',
    point: '返點(極速/合約)',
    totalBalance: '餘額',
    lastLoginTime: '上次登錄時間',
    noLoginTime: '無'
  },
  userDetail: {
    username: '用戶名',
    userType: '用戶類型',
    title: '用戶詳情',
    pointPercentTiming: '極速交易返點',
    pointPercentContract: '合約交易返點',
    registerWay: '註冊方式',
    teamCounts: '團隊人數',
    teamOnline: '團隊在線',
    balance: '餘額',
    registerTime: '註冊時間',
    onlineStatus: '登錄狀態'
  },
  addUser: {
    title: '新增用戶',
    addUserDirect: {
      userTypeLabel: '用戶類型',
      usernameLabel: '用戶名',
      usernamePlaceholder: '請輸入開戶用戶名',
      pointTimingLabel: '極速交易返點',
      pointContractLabel: '合約交易返點',
      tips: '初始密碼為: "{password}"; 開戶後請及時提醒用戶修改密碼',
      userTypeRequired: '請選擇開戶類型',
      usernameRequired: '請輸入開戶用戶名',
      pointTimingRequired: '請選擇極速交易返點',
      pointContractRequired: '請選擇合約交易返點',
      copyTemplate: '\n        \u7528\u6236\u540D: {username};\n        \u767B\u9304\u5BC6\u78BC: {loginPassword};\n        \u767B\u9304\u7DB2\u5740: {loginAddress};\n        \u6975\u901F\u4EA4\u6613\u8FD4\u9EDE: {timingTradePoint};\n        \u5408\u7D04\u4EA4\u6613\u8FD4\u9EDE: {contactTradePoint};\n        '
    }
  },
  recharge: {
    title: '充幣',
    configIdLabel: '充幣通道',
    chainNameLabel: '鏈名稱',
    amountLabel: '充值金額',
    userCardNameLabel: '付款人',
    userCardNamePlaceholder: '請輸入付款人姓名',
    fee: '服務費',
    receiveAmountTipsPart1: '充值',
    receiveAmountTipsPart2: ', 需支付',
    tipsPart1: '因為在線支付接口不穩定，目前僅支持線下轉賬充值！ ',
    tipsPart2: '請如實填寫實際轉賬金額，否則可能導致系統審核無法通過，影響充值進度。 ',
    emptyPart1: '暫無可用的充值通道, ',
    emptyPart2: '輕觸重試',
    amountRequired: '充值金額不能為空',
    maxPrecisionError: '充值金額最多{amountMaxPrecision}位小數',
    payUserNameError: '請輸入正確的付款人後重試',
    userMobileLabel: '手機號',
    userMobilePlaceholder: '請輸入用戶手機號',
    needPayLabel: '需支付',
    needPayPlaceholder: '點擊輸入金額'
  },
  payDetail: {
    title: '轉賬信息',
    addressLabel: '充幣地址',
    rechargeAmount: '充幣金額',
    bankNameLabel: '銀行',
    branchLabel: '支行地址',
    cardName: '姓名',
    cardNum: '卡號',
    uploadImgLabel: '支付憑證',
    uploadImgPlaceholder: '點擊上傳支付憑證圖片',
    uploadImgRequired: '請上傳支付憑證圖片',
    vcTransferTipsPart1: '1. 複製充幣地址或掃描二維碼進行充幣',
    vcTransferTipsPart2: '2. 充幣完成後上傳支付憑證圖片',
    vcTransferTipsPart3: '為提高充幣的效率, 請確保上傳清晰高清的憑證圖片, 如相關信息圖片不清晰可能導致系統審核無法通過，影響充值進度。 ',
    bankCardTips: '為提高充幣的效率, 請確保使用填寫的轉賬人與匯款人名稱一致; 如相關信息不符合可能導致系統審核無法通過，影響充值進度。 ',
    bankCardTransferSuccess: '我已轉賬成功'
  },
  rechargeOrder: {
    title: '充幣訂單',
    payAmount: '充值金額',
    receiveAmount: '到賬金額'
  },
  identity: {
    title: '實名信息',
    subTitle: '實名認證包括信息認證, 身份認證',
    name: '姓名',
    idType: '證件類型',
    idNum: '證件號碼',
    demand: '要求',
    informationVer: '信息認證',
    idAuthentication: '身份認證',
    material: '材料'
  },
  verified: {
    title: '實名認證',
    idCardTypeLabel: '證件類型',
    idCardFrontSideImgLabel: '證件照正面',
    idCardBackSideImgLabel: '證件照背面',
    idCardHandSideImgLabel: '手持證件照',
    nameLabel: '證件姓名',
    namePlaceholder: '請輸入你的證件姓名',
    idCardNumLabel: '證件號碼',
    idCardNumPlaceholder: '請輸入證件號碼',
    fundPwdLabel: '資金密碼',
    fundPwdPlaceholder: '請輸入你的資金密碼',
    tips: '信息認證一旦提交，不可修改，請謹慎核對後正確填入',
    idCardTypeRequired: '請選擇證件類型',
    idCardFrontSideImgRequired: '請上傳證件正面照',
    idCardBackSideImgRequired: '請上傳證件背面照',
    idCardHandSideImgRequired: '請上傳手持證件照',
    nameRequired: '請輸入證件姓名',
    idCardNumRequired: '請輸入證件號碼',
    fundPwdRequired: '請輸入你的資金密碼',
    submitSuccess: '認證請求提交成功'
  },
  help: {
    title: '幫助中心'
  },
  helpDetail: {
    title: '幫助詳情'
  },
  myMessage: {
    title: '我的私信'
  },
  messageDetail: {
    title: '私信詳情'
  },
  withdraw: {
    title: '提幣',
    tips: '為保證資金安全及提現效率; 請仔細核對所填寫信息無誤, 提幣過程中產生的手續費將從餘額中扣除',
    receiveAmountTipsPart1: '提現',
    receiveAmountTipsPart2: ', 預計到賬',
    fee: '服務費',
    myBalance: '我的 [ {vcName} ] 餘額:',
    configIdLabel: '提幣通道',
    amountLabel: '提幣金額',
    fundLabel: '資金密碼',
    fundPlaceholder: '請輸入你的資金密碼',
    googleCodeLabel: '谷歌驗證碼',
    googleCodePlaceholder: '請輸入6位谷歌驗證碼',
    maxPrecisionError: '提幣金額最多{amountMaxPrecision}位小數',
    amountRequired: '請輸入或選擇正確的提幣金額',
    bankCardError: '請選擇正確的銀行卡',
    fundPwdError: '請輸入正確的資金密碼',
    walletAddressError: '請選擇正確的錢包地址',
    success: '提現請求提交成功, 請等待處理',
    emptyPart1: '暫無可用的提幣通道, ',
    emptyPart2: '輕觸重試'
  },
  withdrawOrder: {
    title: '提幣訂單',
    requestAmount: '提單金額',
    receiveAmount: '到賬金額'
  },
  locales: {
    title: '切換語言'
  },
  lines: {
    title: '線路選擇',
    switchLine: '切換線路'
  },
  currencyPop: {
    deleteFavoriteSuccess: '刪除自選幣成功',
    addFavoriteSuccess: '添加自選幣成功'
  },
  currencySelect: {
    currencyName: '幣種',
    currencyPlaceholder: '點擊選擇幣種'
  },
  walletItem: {
    available: '可用',
    convert: '折合(USDT)'
  },
  banks: {
    bankIdLabel: '銀行',
    bankIdPlaceholder: '點擊選擇銀行'
  },
  banksPop: {
    title: '選擇銀行',
    search: '輸入銀行關鍵字'
  },
  historyOrderDetail: {
    title: '訂單詳情',
    coin: '交易幣種',
    amount: '下單金額',
    buyInClose: '買入價',
    sellOutClose: '賣出價',
    isQuest: '對此訂單有疑問?',
    connectCustomer: '聯繫客服?'
  },
  pointSelect: {
    prizeGroupPlaceholder: '點擊選擇用戶返點'
  },
  walletAddressSelect: {
    title: '選擇錢包地址',
    label: '錢包地址',
    placeholder: '點擊選擇錢包地址'
  },
  myCardSelect: {
    title: '選擇賬戶',
    label: '收款賬戶',
    placeholder: '點擊選擇賬戶'
  },
  amountInput: {
    amountRange: '最小 {minAmount}, 最大{maxAmount}',
    amountMin: '最小 {minAmount}, 上不封頂',
    amountErrorEmpty: '{label}有誤, 請核實後重試',
    amountErrorOutRange: '{label}超出範圍, 請核實後重試'
  },
  amountFormItem: {
    placeholderOnlyMin: '最小 {minAmount}, 上不封頂',
    placeholderHasMax: '最小 {minAmount}, 最大{maxAmount}',
    amountErrorEmpty: '金額有誤, 請核實後重試',
    amountErrorOutRange: '金額超出範圍, 請核實後重試'
  },
  common: {
    remark: '備註',
    saveImage: '保存本地',
    online: '在線',
    offline: '已下線',
    profit: '盈虧',
    date: '日期',
    period: '週期',
    pointAmount: '用戶返點金額',
    point: '用戶返點',
    direction: '方向',
    winLoss: '收益',
    lose: '輸',
    add: '新增',
    win: '贏',
    edit: '修改',
    notBind: '未綁定',
    alreadyBind: '已綁定',
    enabled: '已啟用',
    notEnabled: '未啟用',
    queryRange: '查詢範圍',
    copy: '複製',
    orderNum: '訂單號',
    null: '無',
    noData: '暫無數據',
    refreshSuccess: '刷新成功',
    loadMoreData: '加載更多數據',
    noMoreData: '沒有更多數據了',
    lookMore: '查看更多',
    more: '更多'
  },
  date: {
    today: '今天',
    yesterday: '昨天',
    last7Days: '近7天',
    last14Days: '近14天',
    split: '至'
  },
  button: {
    save: '保存',
    logout: '登出',
    confirm: '確定',
    cancel: '取消',
    submit: '提交',
    addNow: '立即添加',
    reset: '重置',
    nextStep: '下一步',
    goCertification: '去認證'
  },
  confirm: {
    title: {
      logout: '退出登錄',
      unBindFundPassword: '未綁定資金密碼',
      addUserDirect: '新增用戶',
      addUserInfo: '新增用戶成功',
      jumpToRechargePage: '確認跳轉',
      unAuthentication: '未實名認證',
      noBindBankCard: '未添加銀行卡',
      noBindCoinAddress: '未添加錢包地址',
      tradeConfirm: '確認交易',
      sellOutSpotOrder: '持倉賣出',
      buyFinance: '確認購買',
      redeemOrder: '质押订单赎回'
    },
    content: {
      logout: '是否確認退出當前賬號?',
      unBindFundPassword: '檢測到未綁定資金密碼, 為保證賬號安全，請先綁定你的資金密碼',
      addUserDirect: '即將新增用戶, 請核實填寫信息無誤後點擊確認繼續, 用戶名[ {username} ], 用戶類型[ {userType} ], 登錄密碼[ {password} ], 與我的極速交易返點差額[ {diffPointTiming} ], 與我的合約交易返點差額[ {diffPointContract} ]',
      addUserInfo: '用戶名[ {username} ]; <br /> 登錄密碼[ {password} ];<br /> 登錄網址[ {loginAddress} ];<br /> 極速交易返點[ {pointPercentTiming} ];<br /> 合約交易返點[ {pointPercentContract} ]；',
      jumpToRechargePage: '即將跳轉三方充值界面，請點擊確認繼續',
      unAuthentication: '檢測到賬戶沒有進行實名認證， 為保證資金正常流通， 請先進行實名認證',
      noBindBankCard: '檢測到賬戶沒有綁定或啟用的銀行卡，為保證資金正常流通，請先添加銀行卡',
      noBindCoinAddress: '檢測到賬戶沒有綁定或啟用的虛擬幣賬戶，為保證資金正常流通，請先添加虛擬幣賬戶地址',
      tradeConfirm: '即將提交訂單, 請核實訂單信息無誤後點擊確認訂單進行提交',
      sellOutSpotOrder: '即將賣出持倉訂單, 請確認操作無誤後點擊確認繼續',
      buyFinance: '即將買入[{coin}], 買入份額: {amount}, 請確認操作無誤後點擊確認繼續',
      redeemOrder: '质押订单赎回'
    }
  },
  message: {
    bindSuccess: '綁定成功',
    successOperation: '操作成功',
    logoutSuccess: '退出成功',
    editSuccess: '修改成功',
    addSuccess: '修改成功',
    copySuccess: '複製成功',
    copyFailed: '複製失敗'
  },
  vux: {
    'inline-calendar': {
      week_day_0: '日',
      week_day_1: '一',
      week_day_2: '二',
      week_day_3: '三',
      week_day_4: '四',
      week_day_5: '五',
      week_day_6: '六'
    },
    loading: {
      loading: '加載中'
    }
  },
  helpItems: {
    title: {
      part1: '資產中的折合金額為什麼會產生變化？ ',
      part2: '忘記OTC交易的資金密碼處理辦法',
      part3: 'OTC交易買入完成後的資金流向哪裡？ ',
      part4: '為什麼要限制修改暱稱的次數',
      part5: '劃轉是什麼意思，為什麼需要劃轉',
      part6: '如何計算用戶合約的賬戶權益？ ',
      part7: '開倉中設定的止損止盈的數值作用是什麼？應當如何設定？ ',
      part8: '如何降低合約風險度？ ',
      part9: '合約開倉中的數量表示什麼？ ',
      part10: '關於強制平倉的說明',
      part11: '合約交易規則是什麼？ ',
      part12: '合約交易中的保證金是什麼？ ',
      part13: '什麼是限價委託和市價委託？ ',
      part14: '合約交易的風險度代表什麼',
      part15: '為什麼需要進行幣種兌換？ ',
      part16: '為什麼在OTC交易轉賬後，對方未及時收到轉款？ ',
      part17: '如何通過OTC購買泰達幣（USDT）？ '
    },
    content: {
      part1: '資產中折合計算的時當前持有數字貨幣折合人名幣的價值，因數字資產的價格波動而變化。您的數字資產數量並沒有改變。 ',
      part2: '如果你忘記OTC交易資金密碼，請到“我的-設置-點擊設置資金密碼”或聯繫客服進行重置',
      part3: 'OTC買入訂單完成後，資金將進入資產中的法幣賬戶。若需要將OTC買入資產進行合約交易或期貨交易，請至資金劃轉模塊進行劃轉。 ',
      part4: '出於您交易的安全原因，目前我們限制暱稱只能修改一次。 ',
      part5: '為了保障您的各個賬戶之間的資金獨立，有利於您進行合理的風險控制，特此將各大交易模塊的賬戶進行劃分。劃轉是指各個交易賬戶之間的資產進行互相轉換的過程。 ',
      part6: '<p>合約賬戶權益，計算方法如下：</p> <p>合約賬戶權益=持倉保證金+持倉浮動盈虧+當前賬戶可用金額</p>',
      part7: '止盈止損作為您設定的盈利上限和損失上限，達到設定的止盈止損金額，系統將自動平倉。可用於您在購買合約時的風險控制，一半設定的止盈數額為：漲幅金額x數量x槓桿倍數，設定的止損我們建議您根據自己的實際資產情況進行設定，合理控制風險。 ',
      part8: '您可以通過資金劃轉的方式，將其餘賬戶的可用資產劃入合約賬戶，或通過減少持倉，來降低風險度。 ',
      part9: '開倉中的數量表示您期望買入的幣種數量。例如：在BTC/USDT交易對的開倉頁面中選擇，買入做多，輸入價格為1000USDT，輸入數量為10BTC，則表示：您期望買入10個單價為1000USDT的BTC。 ',
      part10: '<p>風險度是衡量您的資產風險的指標，當風險度等於100%時，您的倉位被視為爆倉，風險度=（持倉保證金/合約賬戶權益）*100%，為了防止用戶穿倉，系統設定了風險度的調整比例，當風險度達到系統設定的風險值，系統將強制平倉。例如：系統設定的調整比例為10%，則當您的風險度大於等於90%時，您的所有倉位都將會被系統強制平倉。 </p> <p>注：若是風險度超標導致的系統強制平倉，是將您所有倉位都進行平倉，因此希望您可以合理的控制您的風險度，以免因此造成不必要的損失 </p>',
      part11: '<p> 交易類型</p> <p>交易類型分為開倉做多（買入）和開倉做空（賣出）兩個方向：</p> <p>買入做多（看漲）是指您認為當前指數有漲的可能，希望以您設定的價格或者當前市價，新買入一定數量的某種合約。 </p> <p>賣出做空（看跌）是指您認為當前指數有跌的可能，希望以您設定的價格或當前市價，新賣出一定數量的某種合約。 </p> <p>下單方式</p> <p>限價委託：您需要自己指定下單的價格和數量</p> <p>市價委託：您只需設定下單的數量，價格為當前市場價格</p> <p>持倉</p> <p>當您提交的開倉委託單成交後即稱之為持倉</p> <p>合約交割問題</p> <p>平台合約為永續合約，無設定交割時間。只要未達到系統爆倉條件或您 未手動平倉，您可永久持倉。 </p> <p>系統平倉</p> <p>1：達到止盈止損設定值，系統自動平倉</p> <p>2：風險度過高，系統強制平倉</p>',
      part12: '<p>在合約交易中，用戶根據合約價格和數量，根據對應的槓桿倍數，繳納資金作為欸履行合約的財力擔保，便可參與合約的買賣，這種資金就是合約保證金。用戶開倉將佔用保證金，佔用的開倉保證金越多，賬戶風險越高。 </p> <p>保證金=（開倉價格*數量）/槓桿倍數</p>',
      part13: '限價委託指的是您期望以什麼價格委託平台進行交易，市價委託是指直接以當前價格委託平台進行交易。在開倉交易的規則中，市價委託是優先於限價委託進行交易的。若您選擇限價委託請合理根據當前貨幣的行情價格進行開倉，避免因不合理的開倉價格造成損失。 ',
      part14: '風險度是您合約賬戶中風險指標，風險度等於100%被視為爆倉。我們建議您，當您的風險度超過50%時，需要謹慎開倉，以免因為爆倉而造成損失。可通過補充合約資產的可用資金，或減少持倉來降低您的風險。 ',
      part15: '兌換的作用是為了讓您的資產中不同幣種的資金可以進行順暢的流通，期貨賬戶中獲得的QCC可自由轉換成USDT進行交易。其他賬戶中的USDT也可自由的轉換成QCC進行交易。 ',
      part16: '首先請確保您轉賬時填寫的收款方式和訂單詳情頁的顯示的完全一致。然後請確認您的付款方式是即時到賬的，還是延遲到賬的。最後請聯繫您的銀行和支付機構，是否有系統維護或其他原因。 ',
      part17: '<p>方式一：通過OTC購買和售出列表選擇您想要購買的訂單進行買賣。 </p> <p>方式二：點擊發布按鈕，根據自己的需求發布買單或者賣單進行快速交易。系統將快速為您匹配買賣用戶。 </p> <p>注：買入訂單在15分鐘後若未支付，系統將自動取消訂單，請您及時支付。若當日取消訂單超過3次，當日無法再次進行交易，次日恢復交易權限。 </p>'
    }
  }
};

/***/ }),

/***/ "Hypd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

var _Carousel = __webpack_require__("We2T");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _Notice = __webpack_require__("jdYA");

var _Notice2 = _interopRequireDefault(_Notice);

var _HotCoins = __webpack_require__("myym");

var _HotCoins2 = _interopRequireDefault(_HotCoins);

var _Poster = __webpack_require__("rMGM");

var _Poster2 = _interopRequireDefault(_Poster);

var _Menus = __webpack_require__("Pm4T");

var _Menus2 = _interopRequireDefault(_Menus);

var _Ranking = __webpack_require__("1Mrm");

var _Ranking2 = _interopRequireDefault(_Ranking);

var _HomeHeader = __webpack_require__("QzIo");

var _HomeHeader2 = _interopRequireDefault(_HomeHeader);

var _QuickMenus = __webpack_require__("52YF");

var _QuickMenus2 = _interopRequireDefault(_QuickMenus);

var _cache = __webpack_require__("TuU3");

var _nameSpace = __webpack_require__("Eeb1");

var _system = __webpack_require__("Zplo");

var _vuex = __webpack_require__("NYxO");

var _isActive = __webpack_require__("FQHV");

var _isActive2 = _interopRequireDefault(_isActive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCoinListWithPriceTimer = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Home',
  components: { Carousel: _Carousel2.default, Notice: _Notice2.default, HotCoins: _HotCoins2.default, Poster: _Poster2.default, Menus: _Menus2.default, Ranking: _Ranking2.default, HomeHeader: _HomeHeader2.default, QuickMenus: _QuickMenus2.default },
  mixins: [_isActive2.default],
  data: function data() {
    return {
      dialogNotices: {
        visible: false,
        finishUpdateTime: '',
        cacheInfoKey: _cache.CACHE_INFO_KEYS.SYS_NOTICE,
        onlyShowOnce: false,
        items: [],
        currentIndex: 0
      },
      noticesPop: {
        visible: false
      },
      noticeDetail: {
        visible: false,
        info: {}
      }
    };
  },

  computed: (0, _extends4.default)({}, (0, _vuex.mapState)({
    locale: function locale(state) {
      return state.i18n.locale;
    },
    vcListState: function vcListState(state) {
      return state.vc.vcList;
    },
    tradeConfigState: function tradeConfigState(state) {
      return state.vc.tradeConfig;
    }
  }), (0, _vuex.mapGetters)(['cacheInfo', 'vcListNoSettleEnabled'])),
  watch: {
    cacheInfo: function cacheInfo() {
      if (this.isActive && !(0, _cache.checkCacheVersionIsRight)((0, _extends4.default)({}, this.dialogNotices, (0, _defineProperty3.default)({}, 'value_' + this.locale, !0)))) {
        this.initSystemNotices();
      }
      if (this.isActive && !(0, _cache.checkCacheVersionIsRight)((0, _extends4.default)({}, this.vcListState))) {
        this.$store.dispatch('getVcList');
      }
      if (this.isActive && !(0, _cache.checkCacheVersionIsRight)((0, _extends4.default)({}, this.tradeConfigState))) {
        this.$store.dispatch('getTradeConfig');
      }
    },
    locale: function locale() {
      var _this = this;

      if (this.isActive) {
        this.initSystemNotices();
        this.$store.dispatch('getVcList').then(function () {
          _this.getCoinListWithPriceInterval().then(function () {
            setTimeout(function () {
              _this.$refs['ranking'].$refs['coins-slide'].refresh();
            }, 60);
          });
        });
        this.$store.dispatch('getTradeConfig');
      }
    }
  },
  methods: {
    initSystemNotices: function initSystemNotices() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        var cacheNoticeInfo = (0, _cache.initStateInCacheHas)(_nameSpace.__SYSTEM_NOTICE__) || {};
        if ((0, _cache.checkCacheVersionIsRight)(cacheNoticeInfo)) {
          _this2.dialogNotices.items = cacheNoticeInfo['value_' + _this2.locale].data;
          _this2.dialogNotices.finishUpdateTime = cacheNoticeInfo['value_' + _this2.locale].finishUpdateTime;
        } else {
          (0, _system.sysNoticeList)({ languageCode: _this2.locale }).then(function (res) {
            if (res.success) {
              var notices = res.data;

              if (notices) {
                _this2.dialogNotices.finishUpdateTime = (0, _cache.cacheObjByKey)(_nameSpace.__SYSTEM_NOTICE__, notices)['value_' + _this2.locale].finishUpdateTime;
                _this2.dialogNotices.items = notices;
              }
            } else {
              _this2.$message.error(res.message);
              return reject(new Error(res.message));
            }
          }).catch(function (err) {
            _this2.$message.error(err.message);
            return reject(err);
          });
        }
      });
    },
    clickNoticeItem: function clickNoticeItem(index) {
      if (!this.dialogNotices.items[index]) return;
      this.noticeDetail.info = this.dialogNotices.items[index];
      this.noticeDetail.visible = true;
    },
    visibilityChange: function visibilityChange() {
      if (document.visibilityState === 'hidden') {
        clearTimeout(getCoinListWithPriceTimer);
      } else {
        this.getCoinListWithPriceInterval();
      }
    },
    getCoinListWithPriceInterval: function getCoinListWithPriceInterval() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        clearTimeout(getCoinListWithPriceTimer);
        if (!_this3.isActive) {
          return;
        }
        _this3.$store.dispatch('getCoinListWithPrice').then(function () {
          getCoinListWithPriceTimer = setTimeout(function () {
            _this3.getCoinListWithPriceInterval();
          }, 3000);
          return resolve();
        }).catch(function () {
          getCoinListWithPriceTimer = setTimeout(function () {
            _this3.getCoinListWithPriceInterval();
          }, 3000);
          return resolve();
        });
      });
    }
  },
  activated: function activated() {
    var _this4 = this;

    document.addEventListener('visibilitychange', this.visibilityChange);
    this.initSystemNotices();
    this.$store.dispatch('getTradeConfig');
    // 获取系统币种列表信息
    this.$store.dispatch('getVcList').then(function () {
      _this4.getCoinListWithPriceInterval();
    }).catch(function (err) {
      console.log(err);
    });
  },
  deactivated: function deactivated() {
    clearTimeout(getCoinListWithPriceTimer);
    document.removeEventListener('visibilitychange', this.visibilityChange);
  }
};

/***/ }),

/***/ "I3vB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Clinch',
  filters: {},
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['locale', 'vcListNoSettleEnabled']), (0, _vuex.mapState)({
    coinListWithPrice: function coinListWithPrice(state) {
      return state.vc.coinListWithPrice;
    }
  }), {
    clinchCoinList: function clinchCoinList() {
      var _this = this;

      if (!this.coinListWithPrice.length || !this.vcListNoSettleEnabled.length) return [];
      return this.vcListNoSettleEnabled.map(function (settleItem) {
        return _this.coinListWithPrice.find(function (coinWithPriceItem) {
          return settleItem.id === coinWithPriceItem.a;
        });
      }).filter(function (item) {
        return !!item;
      }).sort(function (pre, next) {
        return next.j - pre.j;
      });
    }
  }),
  methods: {
    clickVcItem: function clickVcItem(currency) {
      var _this2 = this;

      this.$store.dispatch('setVcId', currency.a).then(function () {
        _this2.$router.push('/trade');
      }).catch(function (err) {
        _this2.$message.error(err.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "IL/Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuexI18n = __webpack_require__("kmDT");

var _vuexI18n2 = _interopRequireDefault(_vuexI18n);

var _vux = __webpack_require__("pM0a");

var _vux2 = _interopRequireDefault(_vux);

var _app = __webpack_require__("WSTi");

var _app2 = _interopRequireDefault(_app);

var _user = __webpack_require__("bREw");

var _user2 = _interopRequireDefault(_user);

var _vc = __webpack_require__("67RI");

var _vc2 = _interopRequireDefault(_vc);

var _getters = __webpack_require__("UjVw");

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  modules: {
    vux: _vux2.default,
    app: _app2.default,
    user: _user2.default,
    vc: _vc2.default,
    i18n: _vuexI18n2.default.store
  },
  getters: _getters2.default
});

exports.default = store;

/***/ }),

/***/ "JAV0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: '登录',
    usernameLabel: '用户名',
    usernamePlaceholder: '2-10位以英文开头的英文数字组合',
    loginPasswordLabel: '登录密码',
    loginPasswordPlaceholder: '请输入你的登录密码',
    googleCodeLabel: '谷歌验证码',
    googleCodePlaceholder: '请输入6位谷歌验证码',
    hasNoAccount: '还没有账号,',
    goRegister: '去注册',
    onlineCustom: '在线客服',
    loginArgument: '继续登录即代表同意',
    userArgument: '《用户协议》',
    registerNotEnabled: '未开放注册功能, 请联系管理员',
    usernameRequired: '请输入正确的用户名',
    loginPasswordRequired: '请输入正确的登录密码',
    googleCodeRequired: '请输入正确的谷歌验证码',
    loginButton: '登录'
  },
  register: {
    title: '注册',
    usernameLabel: '用户名',
    usernamePlaceholder: '请输入注册的用户名',
    loginPasswordLabel: '登录密码',
    loginPasswordPlaceholder: '请输入注册用户的登录密码',
    loginPasswordPreLabel: '确认登录密码',
    loginPasswordPrePlaceholder: '请再次输入登录密码',
    fudPasswordLabel: '资金密码',
    fudPasswordPlaceholder: '请输入资金密码',
    inviteCodeLabel: '邀请码',
    inviteCodePlaceholder: '请输入6位数邀请码',
    registerNeed: '继续注册代表同意',
    registerArgument: '《注册协议》',
    usernameRequired: '请输入正确的用户名',
    loginPasswordRequired: '请输入正确的登录密码',
    loginPasswordPreRequired: '请输入正确的确认登录密码',
    fundPasswordRequired: '请输入正确的资金密码',
    inviteCodeRequired: '请输入正确的邀请码',
    diffLoginPasswordError: '两次登录密码输入不一致',
    registerSuccess: '注册成功',
    registerButton: '注册',
    emailLabel: '邮箱',
    emailPlaceholder: '请输入你的邮箱地址',
    emailCodeLabel: '验证码',
    emailCodePlaceholder: '请输入你的邮箱验证码',
    second: '秒',
    getEmailCodeButton: '获取验证码',
    emailRequired: '请输入正确的邮箱地址后重试',
    emailCodeRequired: '请输入正确的邮箱验证码后重试'
  },
  home: {
    hotCoin: {
      title: '热门交易',
      more: '更多'
    },
    poster: {
      title: '快捷充币',
      enter: '立即进入>',
      subTitle: '支持BTC，USDT，ETH等'
    },
    quickMenus: {
      futuresTrading: '期货交易',
      helpCenter: '帮助中心'
    },
    ranking: {
      increase: {
        title: '涨幅榜'
      },
      clinch: {
        title: '成交额榜'
      }
    }
  },
  tabBar: {
    home: '首页',
    price: '行情',
    trade: '交易',
    fund: '资产',
    user: '我的'
  },
  currency: {
    favorite: '自选',
    allCurrency: '现货',
    dayVol: '24H额',
    addFavor: '+添加自选'
  },
  trade: {
    bills: '订单',
    todayOpen: '开盘',
    star: '自选',
    vol: '成交量',
    low: '最低',
    high: '最高',
    timing: '极速',
    spot: '期货',
    buyMore: '买多',
    buyEmpty: '买空',
    indicator: '指标',
    indicatorSettings: '指标设置',
    balance: '我的余额',
    fee: '服务费',
    ruleIdError: '请选择到期时间',
    deleteFavoriteSuccess: '删除自选币成功',
    addFavoriteSuccess: '添加自选币成功',
    buyIn: '买入',
    sellOut: '卖出',
    holding: '持仓',
    history: '历史',
    spotOrderConfirm: {
      title: '确认买入',
      amountPlaceholder: '请输入购买数量'
    },
    spotTradeOrder: {
      holding: {
        coin: '币种',
        buyInAmountPrice: '买入总价/单价',
        buyInCount: '数量',
        actions: '操作',
        sellOut: '卖出',
        profit: '盈亏'
      }
    },
    orderConfirm: {
      title: '订单确认',
      coinName: '币种',
      direction: '方向',
      price: '现价',
      balance: '余额',
      fee: '服务费',
      buyMoreLabel: '买多',
      buyEmptyLabel: '买空',
      buyQuantity: '买入数量',
      buyAmount: '买入金额',
      submit: '确认订单'
    },
    kline: {
      open: '开:',
      close: '收:',
      change: '涨跌:'
    }
  },
  finance: {
    title: '金融'
  },
  allFinance: {
    title: '理财',
    all: '全部'
  },
  financeOrders: {
    title: '质押订单',
    holdingLabel: '在持',
    historyLabel: '历史',
    holding: {
      amount: '质押金额',
      rateStr: '收益金额/收益率',
      vcCount: '质押币数量',
      cycle: '持仓周期',
      day: '天',
      calcStartDate: '起息日期',
      serviceAmount: '服务费',
      redeemOrder: '赎回'
    },
    history: {
      incomeAmount: '收益金额',
      rateStr: '收益率',
      amount: '质押金额',
      vcCount: '质押币数量',
      calcStartDate: '起息日期',
      calcEndDate: '终息日期',
      cycle: '周期天数',
      serviceAmount: '服务费',
      day: '天'
    }
  },
  financeOrderBills: {
    title: '质押收益账单',
    amount: '金额',
    balance: '余额'
  },
  financeItem: {
    rateStr: '收益率',
    buyType: '买入类型',
    cycle: '周期天数',
    exchangeRate: '兑换汇率(虚拟币兑换余额)',
    day: '天',
    cycleType: '周期类型',
    serviceRateStr: '服务费率'
  },
  buyFinance: {
    title: '购买',
    rateStr: '收益率',
    name: '名称',
    buyType: '买入类型',
    cycle: '周期天数',
    cycleType: '周期类型',
    exchangeRate: '兑换汇率(虚拟币兑换余额)',
    serviceRateStr: '服务费率',
    remark: '备注',
    buyAmountLabel: '买入金额 ({coin})',
    descriptionTitle: '产品说明',
    descriptionPart1: '1.本產品為非保本理財產品，市場波動可能導致本金損失，請謹慎投資.',
    descriptionPart2: '2.回款結算規則：',
    descriptionPart3: '如果結算價＜掛鉤價，到期後結算BTC；結算數量=投資金額*(1+天數*年化收益率/365).',
    descriptionPart4: '如果結算價≥掛鉤價，到期後結算USDT；結算數量=投資金額*掛鉤價*(1+天數*年化收益率/365）.',
    descriptionPart5: '3.實際年化收益率隨市場實時變動，請以實際買入成交為準.',
    descriptionPart6: '4.投資金額隨市場實時折算得出，請以實際買入成交為準.',
    descriptionPart7: '5.產品購買後可在我的持幣頁面進行查看，到期結束後回款會自動發放至現貨賬戶.',
    buyButton: '购买 [{coin}]'
  },
  fund: {
    description: '资产',
    recharge: '充币',
    withdraw: '提币',
    exchange: '划转',
    empty: '钱包空空 去'
  },
  userCenter: {
    lastLogin: '上次登录',
    myTeam: '我的团队',
    identity: '实名认证',
    walletAddress: '钱包地址',
    zskAccount: '转数快账户',
    bankCard: '银行账户',
    userBills: '帐变记录',
    timingTradeOrder: '极速持仓',
    spotTradeOrder: '期货持仓',
    contactTradeOrder: '合约持仓',
    userReport: '用户报表',
    teamReport: '团队报表',
    share: '我要分享',
    customer: '联系客服',
    helpCenter: '帮助中心',
    platform: '平台介绍',
    profit: '今日盈亏',
    balance: '我的余额',
    withdraw: '提币',
    recharge: '充币',
    creditStoreLabel: '信用积分'
  },
  settings: {
    title: '设置',
    fundPassword: '资金密码',
    googleValidator: '谷歌验证器',
    editLoginPassword: '修改登录密码',
    switchLocale: '切换语言'
  },
  editFundPassword: {
    title: '修改资金密码',
    currentPasswordLabel: '当前密码',
    currentPasswordPlaceholder: '请输入当前资金密码',
    newPasswordLabel: '新密码',
    newPasswordPlaceholder: '请输入修改的资金密码',
    prePasswordLabel: '确认密码',
    prePasswordPlaceholder: '清再次输入修改的资金密码',
    tips: '资金密码是进行交易的重要凭证, 清谨慎设置并牢记',
    currentPasswordRequired: '请输入当前的资金密码',
    newPasswordRequired: '请输入要修改的资金密码',
    prePasswordRequired: '请再次输入要修改的资金密码',
    prePasswordDiff: '两次密码输入不一致'
  },
  bindFundPassword: {
    title: '绑定资金密码',
    fundPasswordLabel: '资金密码',
    fundPasswordPlaceholder: '请输入资金密码',
    fundPasswordPreLabel: '确认密码',
    fundPasswordPrePlaceholder: '请再次输入资金密码',
    fundPasswordRequired: '请输入正确的资金密码',
    fundPasswordPreRequired: '请输入正确的确认密码',
    fundPasswordDiff: '两次密码输入不一致',
    bindSuccess: '资金密码绑定成功',
    tips: '资金密码是进行交易的重要凭证, 请谨慎设置并牢记'
  },
  editLoginPassword: {
    title: '修改登录密码',
    currentPasswordLabel: '当前密码',
    currentPasswordPlaceholder: '请输入当前登录密码',
    newPasswordLabel: '新密码',
    newPasswordPlaceholder: '请输入修改的登录密码',
    prePasswordLabel: '确认密码',
    prePasswordPlaceholder: '清再次输入修改的登录密码',
    tips: '登录密码是进行登录认证等的重要凭证, 请谨慎设置并牢记',
    currentPasswordRequired: '请输入当前的登录密码',
    newPasswordRequired: '请输入要修改的登录密码',
    prePasswordRequired: '请再次输入要修改的登录密码',
    prePasswordDiff: '两次密码输入不一致'
  },
  bindGoogleValidator: {
    title: '绑定谷歌验证器',
    qrCodeLabel: '二维码',
    keyLabel: '密钥',
    loginPasswordLabel: '登录密码',
    loginPasswordPlaceholder: '请输入你的登录密码',
    googleCodeLabel: '谷歌验证码',
    googleCodePlaceholder: '请输入6位谷歌验证码',
    tipsPart1: '在应用商店搜索谷歌验证器',
    tipsPart2: '使用谷歌验证器扫描上图二维码, 或手动输入密钥进行绑定',
    tipsPart3: '在上方输入6位谷歌验证码, 点击确认提交',
    loginPasswordRequired: '请输入登录密码',
    googleCodeRequired: '请输入6位谷歌验证码'
  },
  walletAddress: {
    title: '钱包地址',
    add: '+ 添加钱包地址',
    remark: '备注',
    addButton: '添加钱包地址',
    tips: '若要修改或删除地址信息，请联系客服'
  },
  addWalletAddress: {
    title: '添加钱包地址',
    vcChainNameIdLabel: '链类型',
    vcAccountLabel: '钱包地址',
    vcAccountPlaceholder: '请输入钱包地址',
    remarkLabel: '备注',
    remarkPlaceholder: '请输入备注内容',
    fundPasswordLabel: '资金密码',
    fundPasswordPlaceholder: '请输入你的资金密码',
    tips: '添加后的钱包地址不可修改, 请核实信息无误',
    vcIdRequired: '请选择正确的币种',
    vcChainNameIdRequired: '请选择正确的链类型',
    vcAccountRequired: '请输入正确的钱包地址',
    fundPwdRequired: '请输入正确的资金密码',
    addSuccess: '钱包地址添加成功'
  },
  receiveWays: {
    title: '我的银行卡',
    add: '+ 添加银行卡',
    tips: '若要修改或者删除银行卡信息，请联系客服',
    addCardButton: '添加银行卡'
  },
  zskAccount: {
    title: '转数快账户',
    add: '+ 添加转数快账户',
    tips: '若要修改或删除账户信息, 请联系客服',
    addCardButton: '添加账户'
  },
  addZskAccount: {
    title: '新增转数快账户',
    withdrawNameLabel: '姓名',
    withdrawNamePlaceholder: '请输入姓名',
    withdrawNameRequired: '姓名不允许为空',
    zskLabel: '转数快',
    zskPlaceholder: '请输入转数快',
    fundPasswordLabel: '资金密码',
    fundPasswordPlaceholder: '请输入你的资金密码',
    tips: '请谨慎填写添加账户的信息, 如因为信息填写错误导致提现不到账的问题, 公司概不负责'
  },
  addBankCard: {
    title: '新增银行卡',
    cardNumLabel: '银行卡号',
    withdrawNameLabel: '姓名',
    withdrawNamePlaceholder: '请输入姓名',
    withdrawNameRequired: '姓名不允许为空',
    zskLabel: '转数快',
    zskPlaceholder: '请输入转数快',
    zskRequired: '请输入正确的转数快',
    cardNumPlaceholder: '请输入银行卡号',
    branchLabel: '支行地址',
    branchPlaceholder: '请输入银行卡支行地址',
    fundPasswordLabel: '资金密码',
    fundPasswordPlaceholder: '请输入资金密码',
    tips: '银行卡是进行交易提现的重要数据, 请谨慎填写, 如因卡信息填写错误导致提现不到账等问题, 公司概不负责。',
    backIdRequired: '请选择开户行',
    cardNumRequired: '请输入正确的银行卡号',
    fundPwdRequired: '请输入正确的资金密码',
    idCardPlaceholder: '请输入身份证号',
    idCardLabel: '身份证号',
    idCardRequired: '请输入正确的身份证号',
    cciPlaceholder: '请输入银行卡CCI',
    branchCodePlaceholder: '请输入支行编号',
    branchCodeLabel: '支行编号',
    katakanaPlaceholder: '请输入片假名',
    katakanaLabel: '片假名'
  },
  userBills: {
    title: '帐变记录',
    vcName: '币种',
    amount: '金额',
    balance: '余额'
  },
  timingTradeOrder: {
    title: '极速交易订单',
    waiting: {
      title: '在持订单',
      amount: '金额',
      period: '周期',
      receivePrice: '买入价',
      settlement: '结算中'
    },
    history: {
      title: '历史订单',
      buyInClose: '买入价',
      saleOutClose: '卖出价'
    }
  },
  spotTradeOrder: {
    title: '期货交易订单',
    waiting: {
      title: '在持订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      buyInTime: '买入时间'
    },
    history: {
      title: '历史订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      sellOutAmount: '卖出总价',
      sellOutPrice: '卖出单价',
      sellOutTime: '卖出时间'
    }
  },
  userReport: {
    title: '用户报表',
    profit: '盈利',
    timingTradeAmountFee: '极速交易下单/手续费',
    timingTradePrizePoint: '极速交易奖金/返点',
    rechargeInfo: '充值/手续费',
    withdrawInfo: '提现/手续费',
    exchangeInfo: '兑换/手续费'
  },
  userReportDay: {
    title: '用户日报表',
    profit: '盈利',
    timingTradeAmountFee: '极速交易下单/手续费',
    timingTradePrizePoint: '极速交易奖金/返点',
    rechargeInfo: '充值/手续费',
    withdrawInfo: '提现/手续费',
    exchangeInfo: '兑换/手续费'
  },
  teamReport: {
    title: '团队报表',
    goToReportDay: '查看日报表',
    timingTradeBetAmountServiceCharge: '极速交易下单/服务费',
    timingTradeBetPrizePoint: '极速交易奖金/返点',
    timingTradeUserAndCount: '极速交易人数/笔数',
    rechargeAmountFee: '充值金额/服务费',
    rechargePersonCount: '充值人数/笔数',
    withdrawAmountFee: '提币金额/服务费',
    withdrawPersonCount: '提币人数/笔数',
    firstRechargeUserAndCount: '首充金额/人数',
    usernamePlaceholder: '输入下级用户名',
    previewAllTradeInfo: '查看所有极速交易信息',
    coin: '币种',
    timingTradeBetAmount: '极速交易投注金额',
    profit: '盈利',
    action: '操作',
    previewReportDay: '查看日报表'
  },
  teamTimingTradeInfo: {
    title: '团队极速交易',
    profit: '盈利',
    subTitle: '团队极速交易信息',
    timingTradeAmountFee: '极速交易下单/服务费',
    timingTradePrizePoint: '极速交易奖金/返点',
    rechargeInfo: '充值/服务费',
    withdrawInfo: '提现/服务费',
    exchangeInfo: '兑换/服务费'
  },
  teamReportDay: {
    title: '团队日报表',
    subTitle: '团队 [ {username} ]日报表',
    timingTradeBetAmountFee: '极速交易下单/服务费',
    timingTradeBetPrizePoint: '极速交易奖金/返点',
    rechargeAmountFee: '充值金额/服务费',
    rechargePersonCount: '充值人数/笔数',
    timingTradeUserAndCount: '极速交易人数/笔数',
    firstRechargePersonCount: '首充金额/笔数',
    withdrawAmountFee: '提币金额/服务费',
    withdrawPersonCount: '提币人数/笔数',
    exchangeAmountFee: '兑换金额/服务费'
  },
  share: {
    title: '我要分享',
    qrCodeLabel: '二维码',
    registerUrlLabel: '注册地址',
    inviteCodeLabel: '邀请码',
    hasNoInviteCode: '当前账户没有邀请码,',
    generateInvitationCode: '试试一键生成',
    tipsPart1: '扫描以上二维码填写注册信息进行注册',
    tipsPart2: '复制注册地址填写注册信息进行注册',
    tipsPart3: '手动打开本站点注册界面填写邀请码进行注册',
    saveImageError: '图片保存失败，试试长按图片并保存'
  },
  myTeam: {
    title: '我的团队',
    usernamePlaceholder: '输入下级用户名',
    point: '返点(极速/合约)',
    totalBalance: '余额',
    lastLoginTime: '上次登录时间',
    noLoginTime: '无'
  },
  userDetail: {
    username: '用户名',
    userType: '用户类型',
    title: '用户详情',
    pointPercentTiming: '极速交易返点',
    pointPercentContract: '合约交易返点',
    registerWay: '注册方式',
    teamCounts: '团队人数',
    teamOnline: '团队在线',
    balance: '余额',
    registerTime: '注册时间',
    onlineStatus: '登录状态'
  },
  addUser: {
    title: '新增用户',
    addUserDirect: {
      userTypeLabel: '用户类型',
      usernameLabel: '用户名',
      usernamePlaceholder: '请输入开户用户名',
      pointTimingLabel: '极速交易返点',
      pointContractLabel: '合约交易返点',
      tips: '初始密码为: "{password}"; 开户后请及时提醒用户修改密码',
      userTypeRequired: '请选择开户类型',
      usernameRequired: '请输入开户用户名',
      pointTimingRequired: '请选择极速交易返点',
      pointContractRequired: '请选择合约交易返点',
      copyTemplate: '\n        \u7528\u6237\u540D: {username};\n        \u767B\u5F55\u5BC6\u7801: {loginPassword};\n        \u767B\u5F55\u7F51\u5740: {loginAddress};\n        \u6781\u901F\u4EA4\u6613\u8FD4\u70B9: {timingTradePoint};\n        \u5408\u7EA6\u4EA4\u6613\u8FD4\u70B9: {contactTradePoint};\n        '
    }
  },
  recharge: {
    title: '充币',
    configIdLabel: '充币通道',
    chainNameLabel: '链名称',
    amountLabel: '充值金额',
    userCardNameLabel: '付款人',
    userCardNamePlaceholder: '请输入付款人姓名',
    fee: '服务费',
    receiveAmountTipsPart1: '充值',
    receiveAmountTipsPart2: ', 需支付',
    tipsPart1: '因为在线支付接口不稳定，目前仅支持线下转账充值！',
    tipsPart2: '请如实填写实际转账金额，否则可能导致系统审核无法通过，影响充值进度。',
    emptyPart1: '暂无可用的充值通道, ',
    emptyPart2: '轻触重试',
    amountRequired: '充值金额不能为空',
    maxPrecisionError: '充值金额最多{amountMaxPrecision}位小数',
    payUserNameError: '请输入正确的付款人后重试',
    userMobileLabel: '手机号',
    userMobilePlaceholder: '请输入用户手机号',
    needPayLabel: '需支付',
    needPayPlaceholder: '点击输入金额'
  },
  payDetail: {
    title: '转账信息',
    addressLabel: '充币地址',
    rechargeAmount: '充币金额',
    bankNameLabel: '银行',
    branchLabel: '支行地址',
    cardName: '姓名',
    cardNum: '卡号',
    uploadImgLabel: '支付凭证',
    uploadImgPlaceholder: '点击上传支付凭证图片',
    uploadImgRequired: '请上传支付凭证图片',
    vcTransferTipsPart1: '1. 复制充币地址或扫描二维码进行充币',
    vcTransferTipsPart2: '2. 充币完成后上传支付凭证图片',
    vcTransferTipsPart3: '为提高充币的效率, 请确保上传清晰高清的凭证图片, 如相关信息图片不清晰可能导致系统审核无法通过，影响充值进度。',
    bankCardTips: '为提高充币的效率, 请确保使用填写的转账人与汇款人名称一致; 如相关信息不符合可能导致系统审核无法通过，影响充值进度。',
    bankCardTransferSuccess: '我已转账成功'
  },
  rechargeOrder: {
    title: '充币订单',
    payAmount: '充值金额',
    receiveAmount: '到账金额'
  },
  identity: {
    title: '实名信息',
    subTitle: '实名认证包括信息认证, 身份认证',
    name: '姓名',
    idType: '证件类型',
    idNum: '证件号码',
    demand: '要求',
    informationVer: '信息认证',
    idAuthentication: '身份认证',
    material: '材料'
  },
  verified: {
    title: '实名认证',
    idCardTypeLabel: '证件类型',
    idCardFrontSideImgLabel: '证件照正面',
    idCardBackSideImgLabel: '证件照背面',
    idCardHandSideImgLabel: '手持证件照',
    nameLabel: '证件姓名',
    namePlaceholder: '请输入你的证件姓名',
    idCardNumLabel: '证件号码',
    idCardNumPlaceholder: '请输入证件号码',
    fundPwdLabel: '资金密码',
    fundPwdPlaceholder: '请输入你的资金密码',
    tips: '信息认证一旦提交，不可修改，请谨慎核对后正确填入',
    idCardTypeRequired: '请选择证件类型',
    idCardFrontSideImgRequired: '请上传证件正面照',
    idCardBackSideImgRequired: '请上传证件背面照',
    idCardHandSideImgRequired: '请上传手持证件照',
    nameRequired: '请输入证件姓名',
    idCardNumRequired: '请输入证件号码',
    fundPwdRequired: '请输入你的资金密码',
    submitSuccess: '认证请求提交成功'
  },
  help: {
    title: '帮助中心'
  },
  helpDetail: {
    title: '帮助详情'
  },
  myMessage: {
    title: '我的私信'
  },
  messageDetail: {
    title: '私信详情'
  },
  withdraw: {
    title: '提币',
    tips: '为保证资金安全及提现效率; 请仔细核对所填写信息无误, 提币过程中产生的手续费将从余额中扣除',
    receiveAmountTipsPart1: '提现',
    receiveAmountTipsPart2: ', 预计到账',
    fee: '服务费',
    myBalance: '我的 [ {vcName} ] 余额:',
    configIdLabel: '提币通道',
    amountLabel: '提币金额',
    fundLabel: '资金密码',
    fundPlaceholder: '请输入你的资金密码',
    googleCodeLabel: '谷歌验证码',
    googleCodePlaceholder: '请输入6位谷歌验证码',
    maxPrecisionError: '提币金额最多{amountMaxPrecision}位小数',
    amountRequired: '请输入或选择正确的提币金额',
    bankCardError: '请选择正确的银行卡',
    fundPwdError: '请输入正确的资金密码',
    walletAddressError: '请选择正确的钱包地址',
    success: '提现请求提交成功, 请等待处理',
    emptyPart1: '暂无可用的提币通道, ',
    emptyPart2: '轻触重试'
  },
  withdrawOrder: {
    title: '提币订单',
    requestAmount: '提单金额',
    receiveAmount: '到账金额'
  },
  locales: {
    title: '切换语言'
  },
  lines: {
    title: '线路选择',
    switchLine: '切换线路'
  },
  currencyPop: {
    deleteFavoriteSuccess: '删除自选币成功',
    addFavoriteSuccess: '添加自选币成功'
  },
  currencySelect: {
    currencyName: '币种',
    currencyPlaceholder: '点击选择币种'
  },
  walletItem: {
    available: '可用',
    convert: '折合(USDT)'
  },
  banks: {
    bankIdLabel: '银行',
    bankIdPlaceholder: '点击选择银行'
  },
  banksPop: {
    title: '选择银行',
    search: '输入银行关键字'
  },
  historyOrderDetail: {
    title: '订单详情',
    coin: '交易币种',
    amount: '下单金额',
    buyInClose: '买入价',
    sellOutClose: '卖出价',
    isQuest: '对此订单有疑问?',
    connectCustomer: '联系客服?'
  },
  pointSelect: {
    prizeGroupPlaceholder: '点击选择用户返点'
  },
  walletAddressSelect: {
    title: '选择钱包地址',
    label: '钱包地址',
    placeholder: '点击选择钱包地址'
  },
  myCardSelect: {
    title: '选择账户',
    label: '收款账户',
    placeholder: '点击选择账户'
  },
  amountInput: {
    amountRange: '最小 {minAmount}, 最大{maxAmount}',
    amountMin: '最小 {minAmount}, 上不封顶',
    amountErrorEmpty: '{label}有误, 请核实后重试',
    amountErrorOutRange: '{label}超出范围, 请核实后重试'
  },
  amountFormItem: {
    placeholderOnlyMin: '最小 {minAmount}, 上不封顶',
    placeholderHasMax: '最小 {minAmount}, 最大{maxAmount}',
    amountErrorEmpty: '金额有误, 请核实后重试',
    amountErrorOutRange: '金额超出范围, 请核实后重试'
  },
  common: {
    remark: '备注',
    saveImage: '保存本地',
    online: '在线',
    offline: '已下线',
    profit: '盈亏',
    date: '日期',
    period: '周期',
    pointAmount: '用户返点金额',
    point: '用户返点',
    direction: '方向',
    winLoss: '收益',
    lose: '输',
    add: '新增',
    win: '赢',
    edit: '修改',
    notBind: '未绑定',
    alreadyBind: '已绑定',
    enabled: '已启用',
    notEnabled: '未启用',
    queryRange: '查询范围',
    copy: '复制',
    orderNum: '订单号',
    null: '无',
    noData: '暂无数据',
    refreshSuccess: '刷新成功',
    loadMoreData: '加载更多数据',
    noMoreData: '没有更多数据了',
    lookMore: '查看更多',
    more: '更多'
  },
  date: {
    today: '今天',
    yesterday: '昨天',
    last7Days: '近7天',
    last14Days: '近14天',
    split: '至'
  },
  button: {
    save: '保存',
    logout: '登出',
    confirm: '确定',
    cancel: '取消',
    submit: '提交',
    addNow: '立即添加',
    reset: '重置',
    nextStep: '下一步',
    goCertification: '去认证'
  },
  confirm: {
    title: {
      logout: '退出登录',
      unBindFundPassword: '未绑定资金密码',
      addUserDirect: '新增用户',
      addUserInfo: '新增用户成功',
      jumpToRechargePage: '确认跳转',
      unAuthentication: '未实名认证',
      noBindBankCard: '未添加银行卡',
      noBindCoinAddress: '未添加钱包地址',
      tradeConfirm: '确认交易',
      sellOutSpotOrder: '持仓卖出',
      buyFinance: '确认购买',
      redeemOrder: '質押訂單贖回'
    },
    content: {
      logout: '是否确认退出当前账号?',
      unBindFundPassword: '检测到未绑定资金密码, 为保证账号安全，请先绑定你的资金密码',
      addUserDirect: '即将新增用户, 请核实填写信息无误后点击确认继续, 用户名[ {username} ], 用户类型[ {userType} ], 登录密码[ {password} ], 与我的极速交易返点差额[ {diffPointTiming} ], 与我的合约交易返点差额[ {diffPointContract} ]',
      addUserInfo: '用户名[ {username} ]; <br /> 登录密码[ {password} ];<br /> 登录网址[ {loginAddress} ];<br /> 极速交易返点[ {pointPercentTiming} ];<br /> 合约交易返点[ {pointPercentContract} ]；',
      jumpToRechargePage: '即将跳转三方充值界面，请点击确认继续',
      unAuthentication: '检测到账户没有进行实名认证， 为保证资金正常流通， 请先进行实名认证',
      noBindBankCard: '检测到账户没有绑定或启用的银行卡，为保证资金正常流通，请先添加银行卡',
      noBindCoinAddress: '检测到账户没有绑定或启用的虚拟币账户，为保证资金正常流通，请先添加虚拟币账户地址',
      tradeConfirm: '即将提交订单, 请核实订单信息无误后点击确认订单进行提交',
      sellOutSpotOrder: '即将卖出持仓订单, 请确认操作无误后点击确认继续',
      buyFinance: '即将买入[{coin}], 买入份额: {amount}, 请确认操作无误后点击确认继续',
      redeemOrder: '即將贖回質押訂單({orderNum}), 請確認操作無誤後點擊確認繼續'
    }
  },
  message: {
    bindSuccess: '绑定成功',
    successOperation: '操作成功',
    logoutSuccess: '退出成功',
    editSuccess: '修改成功',
    addSuccess: '添加成功',
    copySuccess: '复制成功',
    copyFailed: '复制失败'
  },
  vux: {
    'inline-calendar': {
      week_day_0: '日',
      week_day_1: '一',
      week_day_2: '二',
      week_day_3: '三',
      week_day_4: '四',
      week_day_5: '五',
      week_day_6: '六'
    },
    loading: {
      loading: '加载中'
    }
  },
  helpItems: {
    title: {
      part1: '资产中的折合金额为什么会产生变化？',
      part2: '忘记OTC交易的资金密码处理办法',
      part3: 'OTC交易买入完成后的资金流向哪里？',
      part4: '为什么要限制修改昵称的次数',
      part5: '划转是什么意思，为什么需要划转',
      part6: '如何计算用户合约的账户权益？',
      part7: '开仓中设定的止损止盈的数值作用是什么？应当如何设定？',
      part8: '如何降低合约风险度？',
      part9: '合约开仓中的数量表示什么？',
      part10: '关于强制平仓的说明',
      part11: '合约交易规则是什么？',
      part12: '合约交易中的保证金是什么？',
      part13: '什么是限价委托和市价委托？',
      part14: '合约交易的风险度代表什么',
      part15: '为什么需要进行币种兑换？',
      part16: '为什么在OTC交易转账后，对方未及时收到转款？',
      part17: '如何通过OTC购买泰达币（USDT）？'
    },
    content: {
      part1: '资产中折合计算的时当前持有数字货币折合人名币的价值，因数字资产的价格波动而变化。您的数字资产数量并没有改变。',
      part2: '如果你忘记OTC交易资金密码，请到“我的-设置-点击设置资金密码”或联系客服进行重置',
      part3: 'OTC买入订单完成后，资金将进入资产中的法币账户。若需要将OTC买入资产进行合约交易或期货交易，请至资金划转模块进行划转。',
      part4: '出于您交易的安全原因，目前我们限制昵称只能修改一次。',
      part5: '为了保障您的各个账户之间的资金独立，有利于您进行合理的风险控制，特此将各大交易模块的账户进行划分。划转是指各个交易账户之间的资产进行互相转换的过程。',
      part6: '<p>合约账户权益，计算方法如下：</p> <p>合约账户权益=持仓保证金+持仓浮动盈亏+当前账户可用金额</p>',
      part7: '止盈止损作为您设定的盈利上限和损失上限，达到设定的止盈止损金额，系统将自动平仓。可用于您在购买合约时的风险控制，一半设定的止盈数额为：涨幅金额x数量x杠杆倍数，设定的止损我们建议您根据自己的实际资产情况进行设定，合理控制风险。',
      part8: '您可以通过资金划转的方式，将其余账户的可用资产划入合约账户，或通过减少持仓，来降低风险度。',
      part9: '开仓中的数量表示您期望买入的币种数量。例如：在BTC/USDT交易对的开仓页面中选择，买入做多，输入价格为1000USDT，输入数量为10BTC，则表示：您期望买入10个单价为1000USDT的BTC。',
      part10: '<p>风险度是衡量您的资产风险的指标，当风险度等于100%时，您的仓位被视为爆仓，风险度=（持仓保证金/合约账户权益）*100%，为了防止用户穿仓，系统设定了风险度的调整比例，当风险度达到系统设定的风险值，系统将强制平仓。例如：系统设定的调整比例为10%，则当您的风险度大于等于90%时，您的所有仓位都将会被系统强制平仓。</p> <p>注：若是风险度超标导致的系统强制平仓，是将您所有仓位都进行平仓，因此希望您可以合理的控制您的风险度，以免因此造成不必要的损失 </p>',
      part11: '<p> 交易类型</p> <p>交易类型分为开仓做多（买入）和开仓做空（卖出）两个方向：</p> <p>买入做多（看涨）是指您认为当前指数有涨的可能，希望以您设定的价格或者当前市价，新买入一定数量的某种合约。</p> <p>卖出做空（看跌）是指您认为当前指数有跌的可能，希望以您设定的价格或当前市价，新卖出一定数量的某种合约。</p> <p>下单方式</p> <p>限价委托：您需要自己指定下单的价格和数量</p> <p>市价委托：您只需设定下单的数量，价格为当前市场价格</p> <p>持仓</p> <p>当您提交的开仓委托单成交后即称之为持仓</p> <p>合约交割问题</p> <p>平台合约为永续合约，无设定交割时间。只要未达到系统爆仓条件或您 未手动平仓，您可永久持仓。</p> <p>系统平仓</p> <p>1：达到止盈止损设定值，系统自动平仓</p> <p>2：风险度过高，系统强制平仓</p>',
      part12: '<p>在合约交易中，用户根据合约价格和数量，根据对应的杠杆倍数，缴纳资金作为欸履行合约的财力担保，便可参与合约的买卖，这种资金就是合约保证金。用户开仓将占用保证金，占用的开仓保证金越多，账户风险越高。</p> <p>保证金=（开仓价格*数量）/杠杆倍数</p>',
      part13: '限价委托指的是您期望以什么价格委托平台进行交易，市价委托是指直接以当前价格委托平台进行交易。在开仓交易的规则中，市价委托是优先于限价委托进行交易的。若您选择限价委托请合理根据当前货币的行情价格进行开仓，避免因不合理的开仓价格造成损失。',
      part14: '风险度是您合约账户中风险指标，风险度等于100%被视为爆仓。我们建议您，当您的风险度超过50%时，需要谨慎开仓，以免因为爆仓而造成损失。可通过补充合约资产的可用资金，或减少持仓来降低您的风险。',
      part15: '兑换的作用是为了让您的资产中不同币种的资金可以进行顺畅的流通，期货账户中获得的QCC可自由转换成USDT进行交易。其他账户中的USDT也可自由的转换成QCC进行交易。',
      part16: '首先请确保您转账时填写的收款方式和订单详情页的显示的完全一致。然后请确认您的付款方式是即时到账的，还是延迟到账的。最后请联系您的银行和支付机构，是否有系统维护或其他原因。',
      part17: '<p>方式一：通过OTC购买和售出列表选择您想要购买的订单进行买卖。</p> <p>方式二：点击发布按钮，根据自己的需求发布买单或者卖单进行快速交易。系统将快速为您匹配买卖用户。</p> <p>注：买入订单在15分钟后若未支付，系统将自动取消订单，请您及时支付。若当日取消订单超过3次，当日无法再次进行交易，次日恢复交易权限。</p>'
    }
  }
};

/***/ }),

/***/ "JNpj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sysBannerList = undefined;

var _request = __webpack_require__("vLgD");

var _request2 = _interopRequireDefault(_request);

var _prefix = __webpack_require__("jnOm");

var _prefix2 = _interopRequireDefault(_prefix);

var _auth = __webpack_require__("Pfph");

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***
 * 新增用户链接
 * @param data
 * @returns {AxiosPromise}
 */
var sysBannerList = exports.sysBannerList = function sysBannerList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/sys-banner/list',
    method: 'post',
    data: data
  });
};

/***/ }),

/***/ "JOEE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KVNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KkZG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ky9I":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "L4cg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue__ = __webpack_require__("0B0L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue__ = __webpack_require__("qlyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c657749e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_SlideItem_vue__ = __webpack_require__("HbsZ");
function injectStyle (ssrContext) {
  __webpack_require__("jiRX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_SlideItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c657749e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_SlideItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LSai":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/***
 * 默认使用的主题颜色
 * @type {string}
 */
var themeModeDefault = exports.themeModeDefault = 'theme-dark';

/***
 * 支持的主题列表
 * @type {({theme: string, label: string, key: number}|{theme: string, label: string, key: number})[]}
 */
var themes = exports.themes = [{ theme: 'theme-light', label: '亮色', key: 0 }, { theme: 'theme-dark', label: '暗色', key: 1 }];

var THEME_DARK = exports.THEME_DARK = 'theme-dark';

var THEME_LIGHT = exports.THEME_LIGHT = 'theme-light';

/***/ }),

/***/ "LTeK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: 'تسجيل الدخول',
    usernameLabel: 'اسم المستخدم',
    usernamePlaceholder: '2-10 أحرف تبدأ بحرف وتحتوي على أرقام وحروف',
    loginPasswordLabel: 'كلمة المرور',
    loginPasswordPlaceholder: 'يرجى إدخال كلمة المرور',
    googleCodeLabel: 'رمز Google',
    googleCodePlaceholder: 'يرجى إدخال رمز Google المكون من 6 أرقام',
    hasNoAccount: 'لا تملك حسابًا،',
    goRegister: 'اذهب للتسجيل',
    onlineCustom: 'دعم العملاء',
    loginArgument: 'بالاستمرار في تسجيل الدخول، فإنك توافق على',
    userArgument: 'اتفاقية المستخدم',
    registerNotEnabled: 'التسجيل غير مفتوح، يرجى الاتصال بالإدارة',
    usernameRequired: 'يرجى إدخال اسم المستخدم الصحيح',
    loginPasswordRequired: 'يرجى إدخال كلمة المرور الصحيحة',
    googleCodeRequired: 'يرجى إدخال رمز Google الصحيح',
    loginButton: 'تسجيل الدخول'
  },
  register: {
    title: 'تسجيل',
    usernameLabel: 'اسم المستخدم',
    usernamePlaceholder: 'يرجى إدخال اسم المستخدم للتسجيل',
    loginPasswordLabel: 'كلمة المرور',
    loginPasswordPlaceholder: 'يرجى إدخال كلمة مرور المستخدم للتسجيل',
    loginPasswordPreLabel: 'تأكيد كلمة المرور',
    loginPasswordPrePlaceholder: 'يرجى إدخال كلمة المرور مرة أخرى',
    fudPasswordLabel: 'كلمة مرور الأموال',
    fudPasswordPlaceholder: 'يرجى إدخال كلمة مرور الأموال',
    inviteCodeLabel: 'كود الدعوة',
    inviteCodePlaceholder: 'يرجى إدخال كود الدعوة المكون من 6 أرقام',
    registerNeed: 'بالاستمرار في التسجيل، فإنك توافق على',
    registerArgument: 'اتفاقية التسجيل',
    usernameRequired: 'يرجى إدخال اسم المستخدم الصحيح',
    loginPasswordRequired: 'يرجى إدخال كلمة المرور الصحيحة',
    loginPasswordPreRequired: 'يرجى إدخال كلمة المرور لتأكيد التسجيل',
    fundPasswordRequired: 'يرجى إدخال كلمة مرور الأموال الصحيحة',
    inviteCodeRequired: 'يرجى إدخال كود الدعوة الصحيح',
    diffLoginPasswordError: 'كلمتا المرور المدخلتان غير متطابقتين',
    registerSuccess: 'تم التسجيل بنجاح',
    registerButton: 'تسجيل',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'يرجى إدخال عنوان البريد الإلكتروني',
    emailCodeLabel: 'رمز البريد الإلكتروني',
    emailCodePlaceholder: 'يرجى إدخال رمز البريد الإلكتروني',
    second: 'ثانية',
    getEmailCodeButton: 'الحصول على رمز التحقق',
    emailRequired: 'يرجى إدخال عنوان البريد الإلكتروني الصحيح وإعادة المحاولة',
    emailCodeRequired: 'يرجى إدخال رمز البريد الإلكتروني الصحيح وإعادة المحاولة'
  },
  home: {
    hotCoin: {
      title: 'التداولات الساخنة',
      more: 'المزيد'
    },
    poster: {
      title: 'الشحن السريع',
      enter: 'دخول فوري>',
      subTitle: 'يدعم BTC، USDT، ETH، وغيرها'
    },
    quickMenus: {
      futuresTrading: 'تداول العقود الآجلة',
      helpCenter: 'مركز المساعدة'
    },
    ranking: {
      increase: {
        title: 'الأكثر ارتفاعًا'
      },
      clinch: {
        title: 'الأعلى حجمًا'
      }
    }
  },
  tabBar: {
    home: 'الرئيسية',
    price: 'الأسعار',
    trade: 'التداول',
    fund: 'الأصول',
    user: 'حسابي'
  },
  currency: {
    favorite: 'المفضلة',
    allCurrency: 'جميع العملات',
    dayVol: 'حجم 24 ساعة',
    addFavor: '+ إضافة إلى المفضلة'
  },
  trade: {
    bills: 'الفواتير',
    todayOpen: 'الافتتاح اليوم',
    star: 'المفضلة',
    vol: 'حجم التداول',
    low: 'الأدنى',
    high: 'الأعلى',
    timing: 'التوقيت',
    spot: 'الفوري',
    buyMore: 'شراء المزيد',
    buyEmpty: 'بيع',
    indicator: 'المؤشر',
    indicatorSettings: 'إعدادات المؤشر',
    balance: 'رصيدي',
    fee: 'الرسوم',
    ruleIdError: 'يرجى اختيار وقت الانتهاء',
    deleteFavoriteSuccess: 'تم حذف العملة المفضلة بنجاح',
    addFavoriteSuccess: 'تم إضافة العملة المفضلة بنجاح',
    buyIn: 'شراء',
    sellOut: 'بيع',
    holding: 'الاحتفاظ',
    history: 'السجل',
    spotOrderConfirm: {
      title: 'تأكيد الشراء',
      amountPlaceholder: 'يرجى إدخال كمية الشراء'
    },
    spotTradeOrder: {
      holding: {
        coin: 'العملة',
        buyInAmountPrice: 'إجمالي السعر / السعر الفردي',
        buyInCount: 'الكمية',
        actions: 'الإجراءات',
        sellOut: 'بيع',
        profit: 'الربح والخسارة'
      }
    },
    orderConfirm: {
      title: 'تأكيد الطلب',
      coinName: 'العملة',
      direction: 'الاتجاه',
      price: 'السعر الحالي',
      balance: 'الرصيد',
      fee: 'الرسوم',
      buyMoreLabel: 'شراء المزيد',
      buyEmptyLabel: 'بيع',
      buyQuantity: 'كمية الشراء',
      buyAmount: 'مبلغ الشراء',
      submit: 'تأكيد الطلب'
    },
    kline: {
      open: 'فتح:',
      close: 'إغلاق:',
      change: 'التغير:'
    }
  },
  finance: {
    title: 'المالية'
  },
  allFinance: {
    title: 'التمويل',
    all: 'الكل'
  },
  financeOrders: {
    title: 'طلبات الرهن',
    holdingLabel: 'في الاحتفاظ',
    historyLabel: 'السجل',
    holding: {
      amount: 'مبلغ الرهن',
      rateStr: 'مبلغ الأرباح / نسبة الأرباح',
      vcCount: 'كمية العملة المرهونة',
      cycle: 'دورة الاحتفاظ',
      day: 'يوم',
      calcStartDate: 'تاريخ بدء الاحتساب',
      serviceAmount: 'رسوم الخدمة',
      redeemOrder: 'استرداد'
    },
    history: {
      incomeAmount: 'مبلغ الأرباح',
      rateStr: 'نسبة الأرباح',
      amount: 'مبلغ الرهن',
      vcCount: 'كمية العملة المرهونة',
      calcStartDate: 'تاريخ بدء الاحتساب',
      calcEndDate: 'تاريخ انتهاء الاحتساب',
      cycle: 'دورة الأيام',
      serviceAmount: 'رسوم الخدمة',
      day: 'يوم'
    }
  },
  financeOrderBills: {
    title: 'فواتير أرباح الرهن',
    amount: 'المبلغ',
    balance: 'الرصيد'
  },
  financeItem: {
    rateStr: 'نسبة الأرباح',
    buyType: 'نوع الشراء',
    cycle: 'دورة الأيام',
    exchangeRate: 'سعر الصرف (تحويل العملة الافتراضية إلى الرصيد)',
    day: 'يوم',
    cycleType: 'نوع الدورة',
    serviceRateStr: 'نسبة رسوم الخدمة'
  },
  buyFinance: {
    title: 'شراء',
    rateStr: 'معدل العائد',
    name: 'الاسم',
    buyType: 'نوع الشراء',
    cycle: 'عدد أيام الدورة',
    cycleType: 'نوع الدورة',
    exchangeRate: 'سعر الصرف (تبادل العملة الافتراضية مع الرصيد)',
    serviceRateStr: 'معدل الخدمة',
    remark: 'ملاحظة',
    buyAmountLabel: 'مبلغ الشراء ({coin})',
    descriptionTitle: 'وصف المنتج',
    descriptionPart1: '1. هذا المنتج هو منتج مالي غير مضمون، قد تؤدي تقلبات السوق إلى خسارة رأس المال، يرجى الاستثمار بحذر.',
    descriptionPart2: '2. قواعد تسوية المدفوعات:',
    descriptionPart3: 'إذا كان سعر التسوية < السعر المرتبط، سيتم تسوية BTC عند الاستحقاق؛ كمية التسوية = مبلغ الاستثمار * (1 + عدد الأيام * معدل العائد السنوي / 365).',
    descriptionPart4: 'إذا كان سعر التسوية ≥ السعر المرتبط، سيتم تسوية USDT عند الاستحقاق؛ كمية التسوية = مبلغ الاستثمار * السعر المرتبط * (1 + عدد الأيام * معدل العائد السنوي / 365).',
    descriptionPart5: '3. يتغير معدل العائد السنوي الفعلي مع تقلبات السوق في الوقت الفعلي، يرجى الاعتماد على الصفقة الفعلية.',
    descriptionPart6: '4. يتم تحويل مبلغ الاستثمار وفقًا لسعر السوق في الوقت الفعلي، يرجى الاعتماد على الصفقة الفعلية.',
    descriptionPart7: "5. يمكن عرض المبلغ المستثمر في صفحة 'حيازة العملات' الخاصة بي، بعد انتهاء الاستحقاق سيتم تحويل المدفوعات تلقائيًا إلى حساب التداول الفوري.",
    buyButton: 'شراء [{coin}]'
  },
  fund: {
    description: 'الأصول',
    recharge: 'شحن العملة',
    withdraw: 'سحب العملة',
    exchange: 'التحويل',
    empty: 'المحفظة فارغة، اذهب إلى'
  },
  userCenter: {
    lastLogin: 'آخر تسجيل دخول',
    myTeam: 'فريقي',
    identity: 'تحقق الهوية',
    walletAddress: 'عنوان المحفظة',
    zskAccount: 'حساب ZSK',
    bankCard: 'الحساب البنكي',
    userBills: 'سجل المعاملات',
    timingTradeOrder: 'حيازة سريعة',
    spotTradeOrder: 'حيازة العقود الآجلة',
    contactTradeOrder: 'حيازة العقود',
    userReport: 'تقرير المستخدم',
    teamReport: 'تقرير الفريق',
    share: 'أريد المشاركة',
    customer: 'اتصل بالدعم',
    helpCenter: 'مركز المساعدة',
    platform: 'مقدمة المنصة',
    profit: 'الربح اليومي',
    balance: 'رصيدي',
    withdraw: 'سحب العملة',
    recharge: 'شحن العملة',
    creditStoreLabel: 'النقاط الائتمانية'
  },
  settings: {
    title: 'الإعدادات',
    fundPassword: 'كلمة مرور الأموال',
    googleValidator: 'مدقق جوجل',
    editLoginPassword: 'تغيير كلمة مرور الدخول',
    switchLocale: 'تبديل اللغة'
  },
  editFundPassword: {
    title: 'تغيير كلمة مرور الأموال',
    currentPasswordLabel: 'كلمة المرور الحالية',
    currentPasswordPlaceholder: 'يرجى إدخال كلمة المرور الحالية للأموال',
    newPasswordLabel: 'كلمة المرور الجديدة',
    newPasswordPlaceholder: 'يرجى إدخال كلمة المرور الجديدة للأموال',
    prePasswordLabel: 'تأكيد كلمة المرور',
    prePasswordPlaceholder: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
    tips: 'كلمة مرور الأموال هي شهادة هامة للمعاملات، يرجى ضبطها بعناية وتذكرها',
    currentPasswordRequired: 'يرجى إدخال كلمة المرور الحالية للأموال',
    newPasswordRequired: 'يرجى إدخال كلمة المرور الجديدة للأموال',
    prePasswordRequired: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
    prePasswordDiff: 'كلمتا المرور غير متطابقتين'
  },
  bindFundPassword: {
    title: 'ربط كلمة مرور الأموال',
    fundPasswordLabel: 'كلمة مرور الأموال',
    fundPasswordPlaceholder: 'يرجى إدخال كلمة مرور الأموال',
    fundPasswordPreLabel: 'تأكيد كلمة المرور',
    fundPasswordPrePlaceholder: 'يرجى إدخال كلمة مرور الأموال مرة أخرى',
    fundPasswordRequired: 'يرجى إدخال كلمة مرور الأموال الصحيحة',
    fundPasswordPreRequired: 'يرجى إدخال تأكيد كلمة المرور الصحيحة',
    fundPasswordDiff: 'كلمتا المرور غير متطابقتين',
    bindSuccess: 'تم ربط كلمة مرور الأموال بنجاح',
    tips: 'كلمة مرور الأموال هي شهادة هامة للمعاملات، يرجى ضبطها بعناية وتذكرها'
  },
  editLoginPassword: {
    title: 'تغيير كلمة مرور الدخول',
    currentPasswordLabel: 'كلمة المرور الحالية',
    currentPasswordPlaceholder: 'يرجى إدخال كلمة المرور الحالية للدخول',
    newPasswordLabel: 'كلمة المرور الجديدة',
    newPasswordPlaceholder: 'يرجى إدخال كلمة المرور الجديدة للدخول',
    prePasswordLabel: 'تأكيد كلمة المرور',
    prePasswordPlaceholder: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
    tips: 'كلمة مرور الدخول هي شهادة هامة للمصادقة، يرجى ضبطها بعناية وتذكرها',
    currentPasswordRequired: 'يرجى إدخال كلمة المرور الحالية للدخول',
    newPasswordRequired: 'يرجى إدخال كلمة المرور الجديدة للدخول',
    prePasswordRequired: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
    prePasswordDiff: 'كلمتا المرور غير متطابقتين'
  },
  bindGoogleValidator: {
    title: 'ربط مدقق جوجل',
    qrCodeLabel: 'رمز الاستجابة السريعة',
    keyLabel: 'المفتاح',
    loginPasswordLabel: 'كلمة مرور الدخول',
    loginPasswordPlaceholder: 'يرجى إدخال كلمة مرور الدخول الخاصة بك',
    googleCodeLabel: 'رمز التحقق من جوجل',
    googleCodePlaceholder: 'يرجى إدخال رمز التحقق من جوجل المكون من 6 أرقام',
    tipsPart1: 'ابحث عن مدقق جوجل في متجر التطبيقات',
    tipsPart2: 'استخدم مدقق جوجل لمسح رمز الاستجابة السريعة أعلاه، أو أدخل المفتاح يدويًا لإتمام الربط',
    tipsPart3: 'أدخل رمز التحقق من جوجل المكون من 6 أرقام أعلاه، ثم انقر على تأكيد للإرسال',
    loginPasswordRequired: 'يرجى إدخال كلمة مرور الدخول',
    googleCodeRequired: 'يرجى إدخال رمز التحقق من جوجل المكون من 6 أرقام'
  },
  walletAddress: {
    title: 'عنوان المحفظة',
    add: '+ إضافة عنوان المحفظة',
    remark: 'ملاحظة',
    addButton: 'إضافة عنوان المحفظة',
    tips: 'إذا كنت ترغب في تعديل أو حذف معلومات العنوان، يرجى الاتصال بالدعم'
  },
  addWalletAddress: {
    title: 'إضافة عنوان المحفظة',
    vcChainNameIdLabel: 'نوع السلسلة',
    vcAccountLabel: 'عنوان المحفظة',
    vcAccountPlaceholder: 'يرجى إدخال عنوان المحفظة',
    remarkLabel: 'ملاحظة',
    remarkPlaceholder: 'يرجى إدخال محتوى الملاحظة',
    fundPasswordLabel: 'كلمة مرور الأموال',
    fundPasswordPlaceholder: 'يرجى إدخال كلمة مرور الأموال الخاصة بك',
    tips: 'لا يمكن تعديل عنوان المحفظة بعد الإضافة، يرجى التحقق من صحة المعلومات',
    vcIdRequired: 'يرجى اختيار نوع العملة الصحيح',
    vcChainNameIdRequired: 'يرجى اختيار نوع السلسلة الصحيح',
    vcAccountRequired: 'يرجى إدخال عنوان المحفظة الصحيح',
    fundPwdRequired: 'يرجى إدخال كلمة مرور الأموال الصحيحة',
    addSuccess: 'تمت إضافة عنوان المحفظة بنجاح'
  },
  receiveWays: {
    title: 'بطاقاتي البنكية',
    add: '+ إضافة بطاقة بنكية',
    tips: 'إذا كنت ترغب في تعديل أو حذف معلومات البطاقة البنكية، يرجى الاتصال بالدعم',
    addCardButton: 'إضافة بطاقة بنكية'
  },

  zskAccount: {
    title: 'حساب ZSK',
    add: '+ إضافة حساب ZSK',
    tips: 'إذا كنت تريد تعديل أو حذف معلومات الحساب، يرجى الاتصال بخدمة العملاء',
    addCardButton: 'إضافة حساب'
  },
  addZskAccount: {
    title: 'إضافة حساب ZSK جديد',
    withdrawNameLabel: 'الاسم',
    withdrawNamePlaceholder: 'الرجاء إدخال الاسم',
    withdrawNameRequired: 'الاسم لا يمكن أن يكون فارغًا',
    zskLabel: 'ZSK',
    zskPlaceholder: 'الرجاء إدخال ZSK',
    fundPasswordLabel: 'كلمة مرور الأموال',
    fundPasswordPlaceholder: 'الرجاء إدخال كلمة مرور الأموال',
    tips: 'يرجى توخي الحذر عند ملء معلومات إضافة الحساب، حيث أن الشركة ليست مسؤولة عن مشاكل السحب الناتجة عن الأخطاء في المعلومات المدخلة'
  },
  addBankCard: {
    title: 'إضافة بطاقة مصرفية جديدة',
    cardNumLabel: 'رقم البطاقة المصرفية',
    withdrawNameLabel: 'الاسم',
    withdrawNamePlaceholder: 'الرجاء إدخال الاسم',
    withdrawNameRequired: 'الاسم لا يمكن أن يكون فارغًا',
    zskLabel: 'ZSK',
    zskPlaceholder: 'الرجاء إدخال ZSK',
    zskRequired: 'الرجاء إدخال ZSK صحيح',
    cardNumPlaceholder: 'الرجاء إدخال رقم البطاقة المصرفية',
    branchLabel: 'عنوان الفرع',
    branchPlaceholder: 'الرجاء إدخال عنوان فرع البنك',
    fundPasswordLabel: 'كلمة مرور الأموال',
    fundPasswordPlaceholder: 'الرجاء إدخال كلمة مرور الأموال',
    tips: 'البطاقة المصرفية هي معلومات هامة للمعاملات والسحب، يرجى توخي الحذر عند ملء المعلومات. الشركة ليست مسؤولة عن مشاكل السحب الناتجة عن الأخطاء في المعلومات المدخلة.',
    backIdRequired: 'الرجاء اختيار البنك',
    cardNumRequired: 'الرجاء إدخال رقم البطاقة المصرفية الصحيح',
    fundPwdRequired: 'الرجاء إدخال كلمة مرور الأموال الصحيحة',
    idCardPlaceholder: 'الرجاء إدخال رقم الهوية',
    idCardLabel: 'رقم الهوية',
    idCardRequired: 'الرجاء إدخال رقم الهوية الصحيح',
    cciPlaceholder: 'الرجاء إدخال CCI للبطاقة المصرفية',
    branchCodePlaceholder: 'الرجاء إدخال رمز الفرع',
    branchCodeLabel: 'رمز الفرع',
    katakanaPlaceholder: 'الرجاء إدخال Katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'سجلات الحساب',
    vcName: 'العملة',
    amount: 'المبلغ',
    balance: 'الرصيد'
  },
  timingTradeOrder: {
    title: 'أوامر التداول السريع',
    waiting: {
      title: 'الأوامر الحالية',
      amount: 'المبلغ',
      period: 'الفترة',
      receivePrice: 'سعر الشراء',
      settlement: 'جاري التسوية'
    },
    history: {
      title: 'الأوامر السابقة',
      buyInClose: 'سعر الشراء',
      saleOutClose: 'سعر البيع'
    }
  },
  spotTradeOrder: {
    title: 'أوامر تداول العقود',
    waiting: {
      title: 'الأوامر الحالية',
      buyInAmount: 'إجمالي سعر الشراء',
      buyInPrice: 'سعر الشراء لكل وحدة',
      buyInCount: 'عدد الشراء',
      buyInTime: 'وقت الشراء'
    },
    history: {
      title: 'الأوامر السابقة',
      buyInAmount: 'إجمالي سعر الشراء',
      buyInPrice: 'سعر الشراء لكل وحدة',
      buyInCount: 'عدد الشراء',
      sellOutAmount: 'إجمالي سعر البيع',
      sellOutPrice: 'سعر البيع لكل وحدة',
      sellOutTime: 'وقت البيع'
    }
  },
  userReport: {
    title: 'تقرير المستخدم',
    profit: 'الأرباح',
    timingTradeAmountFee: 'رسوم/طلب التداول السريع',
    timingTradePrizePoint: 'جائزة/نقاط تداول سريع',
    rechargeInfo: 'إيداع/رسوم',
    withdrawInfo: 'سحب/رسوم',
    exchangeInfo: 'تحويل/رسوم'
  },
  userReportDay: {
    title: 'تقرير المستخدم اليومي',
    profit: 'الأرباح',
    timingTradeAmountFee: 'رسوم/طلب التداول السريع',
    timingTradePrizePoint: 'جائزة/نقاط تداول سريع',
    rechargeInfo: 'إيداع/رسوم',
    withdrawInfo: 'سحب/رسوم',
    exchangeInfo: 'تحويل/رسوم'
  },
  teamReport: {
    title: 'تقرير الفريق',
    goToReportDay: 'عرض التقرير اليومي',
    timingTradeBetAmountServiceCharge: 'رسوم/طلب التداول السريع',
    timingTradeBetPrizePoint: 'جائزة/نقاط تداول سريع',
    timingTradeUserAndCount: 'عدد/أفراد تداول سريع',
    rechargeAmountFee: 'مبلغ/رسوم الإيداع',
    rechargePersonCount: 'عدد/أفراد الإيداع',
    withdrawAmountFee: 'مبلغ/رسوم السحب',
    withdrawPersonCount: 'عدد/أفراد السحب',
    firstRechargeUserAndCount: 'مبلغ/عدد الإيداع الأول',
    usernamePlaceholder: 'أدخل اسم المستخدم الفرعي',
    previewAllTradeInfo: 'عرض جميع معلومات التداول السريع',
    coin: 'العملة',
    timingTradeBetAmount: 'مبلغ رهان التداول السريع',
    profit: 'الأرباح',
    action: 'الإجراء',
    previewReportDay: 'عرض التقرير اليومي'
  },
  teamTimingTradeInfo: {
    title: 'معلومات التداول السريع للفريق',
    profit: 'الأرباح',
    subTitle: 'معلومات التداول السريع للفريق',
    timingTradeAmountFee: 'رسوم/طلب التداول السريع',
    timingTradePrizePoint: 'جائزة/نقاط تداول سريع',
    rechargeInfo: 'إيداع/رسوم',
    withdrawInfo: 'سحب/رسوم',
    exchangeInfo: 'تحويل/رسوم'
  },
  teamReportDay: {
    title: 'تقرير الفريق اليومي',
    subTitle: 'تقرير الفريق اليومي [ {username} ]',
    timingTradeBetAmountFee: 'رسوم/طلب التداول السريع',
    timingTradeBetPrizePoint: 'جائزة/نقاط تداول سريع',
    rechargeAmountFee: 'مبلغ/رسوم الإيداع',
    rechargePersonCount: 'عدد/أفراد الإيداع',
    timingTradeUserAndCount: 'عدد/أفراد تداول سريع',
    firstRechargePersonCount: 'مبلغ/عدد الإيداع الأول',
    withdrawAmountFee: 'مبلغ/رسوم السحب',
    withdrawPersonCount: 'عدد/أفراد السحب',
    exchangeAmountFee: 'مبلغ/رسوم التحويل'
  },
  share: {
    title: 'أريد المشاركة',
    qrCodeLabel: 'رمز الاستجابة السريعة',
    registerUrlLabel: 'رابط التسجيل',
    inviteCodeLabel: 'رمز الدعوة',
    hasNoInviteCode: 'الحساب الحالي ليس لديه رمز دعوة،',
    generateInvitationCode: 'حاول إنشاء رمز بدعوة بنقرة واحدة',
    tipsPart1: 'مسح رمز الاستجابة السريعة أعلاه لملء معلومات التسجيل وإجراء التسجيل',
    tipsPart2: 'نسخ رابط التسجيل لملء معلومات التسجيل وإجراء التسجيل',
    tipsPart3: 'افتح يدوياً واجهة التسجيل في هذا الموقع لملء رمز الدعوة وإجراء التسجيل',
    saveImageError: 'فشل حفظ الصورة، حاول الضغط على الصورة لفترة طويلة ثم حفظها'
  },
  myTeam: {
    title: 'فريقي',
    usernamePlaceholder: 'أدخل اسم المستخدم الفرعي',
    point: 'نقاط المكافأة (تداول سريع/عقود)',
    totalBalance: 'الرصيد الإجمالي',
    lastLoginTime: 'آخر تسجيل دخول',
    noLoginTime: 'لا يوجد'
  },

  userDetail: {
    username: 'اسم المستخدم',
    userType: 'نوع المستخدم',
    title: 'تفاصيل المستخدم',
    pointPercentTiming: 'نسبة استرداد التجارة السريعة',
    pointPercentContract: 'نسبة استرداد التجارة بالعقد',
    registerWay: 'طريقة التسجيل',
    teamCounts: 'عدد الفريق',
    teamOnline: 'الفريق على الإنترنت',
    balance: 'الرصيد',
    registerTime: 'وقت التسجيل',
    onlineStatus: 'حالة تسجيل الدخول'
  },
  addUser: {
    title: 'إضافة مستخدم',
    addUserDirect: {
      userTypeLabel: 'نوع المستخدم',
      usernameLabel: 'اسم المستخدم',
      usernamePlaceholder: 'الرجاء إدخال اسم مستخدم الحساب',
      pointTimingLabel: 'نسبة استرداد التجارة السريعة',
      pointContractLabel: 'نسبة استرداد التجارة بالعقد',
      tips: 'كلمة المرور الافتراضية هي: "{password}"؛ يرجى تذكير المستخدم بتغيير كلمة المرور بعد التسجيل',
      userTypeRequired: 'الرجاء اختيار نوع الحساب',
      usernameRequired: 'الرجاء إدخال اسم مستخدم الحساب',
      pointTimingRequired: 'الرجاء اختيار نسبة استرداد التجارة السريعة',
      pointContractRequired: 'الرجاء اختيار نسبة استرداد التجارة بالعقد',
      copyTemplate: 'اسم المستخدم: {username}; كلمة المرور: {loginPassword}; عنوان تسجيل الدخول: {loginAddress}; نسبة استرداد التجارة السريعة: {timingTradePoint}; نسبة استرداد التجارة بالعقد: {contactTradePoint};'
    }
  },
  recharge: {
    title: 'إعادة شحن',
    configIdLabel: 'قناة الشحن',
    chainNameLabel: 'اسم السلسلة',
    amountLabel: 'مبلغ الشحن',
    userCardNameLabel: 'اسم الدافع',
    userCardNamePlaceholder: 'الرجاء إدخال اسم الدافع',
    fee: 'رسوم الخدمة',
    receiveAmountTipsPart1: 'إعادة شحن',
    receiveAmountTipsPart2: '، تحتاج لدفع',
    tipsPart1: 'بسبب عدم استقرار واجهة الدفع عبر الإنترنت، يتم دعم التحويل البنكي فقط حاليًا!',
    tipsPart2: 'الرجاء إدخال مبلغ التحويل الفعلي بدقة لتجنب تأخير في عملية المراجعة.',
    emptyPart1: 'لا توجد قنوات شحن متاحة،',
    emptyPart2: 'انقر لإعادة المحاولة',
    amountRequired: 'مبلغ الشحن لا يمكن أن يكون فارغًا',
    maxPrecisionError: 'أقصى عدد للأرقام العشرية هو {amountMaxPrecision}',
    payUserNameError: 'الرجاء إدخال اسم دافع صحيح ثم حاول مرة أخرى',
    userMobileLabel: 'رقم الهاتف المحمول',
    userMobilePlaceholder: 'الرجاء إدخال رقم الهاتف المحمول',
    needPayLabel: 'مطلوب الدفع',
    needPayPlaceholder: 'انقر لإدخال المبلغ'
  },
  payDetail: {
    title: 'تفاصيل التحويل',
    addressLabel: 'عنوان الشحن',
    rechargeAmount: 'مبلغ الشحن',
    bankNameLabel: 'البنك',
    branchLabel: 'عنوان الفرع',
    cardName: 'الاسم',
    cardNum: 'رقم البطاقة',
    uploadImgLabel: 'إيصال الدفع',
    uploadImgPlaceholder: 'انقر لتحميل صورة إيصال الدفع',
    uploadImgRequired: 'الرجاء تحميل صورة إيصال الدفع',
    vcTransferTipsPart1: '1. انسخ عنوان الشحن أو امسح رمز QR لإجراء الشحن',
    vcTransferTipsPart2: '2. بعد الانتهاء من الشحن، قم بتحميل صورة إيصال الدفع',
    vcTransferTipsPart3: 'لضمان كفاءة عملية الشحن، الرجاء تحميل صورة إيصال واضحة ودقيقة، عدم وضوح الصورة قد يؤدي إلى تأخير في عملية المراجعة.',
    bankCardTips: 'لضمان كفاءة عملية الشحن، الرجاء استخدام اسم الدافع المطابق لاسم المحول، عدم تطابق المعلومات قد يؤدي إلى تأخير في عملية المراجعة.',
    bankCardTransferSuccess: 'لقد قمت بالتحويل بنجاح'
  },
  rechargeOrder: {
    title: 'طلب الشحن',
    payAmount: 'مبلغ الشحن',
    receiveAmount: 'المبلغ المستلم'
  },
  identity: {
    title: 'معلومات الهوية',
    subTitle: 'التوثيق يشمل التحقق من المعلومات، والتحقق من الهوية',
    name: 'الاسم',
    idType: 'نوع الوثيقة',
    idNum: 'رقم الوثيقة',
    demand: 'المتطلبات',
    informationVer: 'التحقق من المعلومات',
    idAuthentication: 'التحقق من الهوية',
    material: 'المواد'
  },
  verified: {
    title: 'توثيق الهوية',
    idCardTypeLabel: 'نوع الوثيقة',
    idCardFrontSideImgLabel: 'صورة الجهة الأمامية للوثيقة',
    idCardBackSideImgLabel: 'صورة الجهة الخلفية للوثيقة',
    idCardHandSideImgLabel: 'صورة مع الوثيقة باليد',
    nameLabel: 'اسم الوثيقة',
    namePlaceholder: 'الرجاء إدخال اسم الوثيقة',
    idCardNumLabel: 'رقم الوثيقة',
    idCardNumPlaceholder: 'الرجاء إدخال رقم الوثيقة',
    fundPwdLabel: 'كلمة مرور الصندوق',
    fundPwdPlaceholder: 'الرجاء إدخال كلمة مرور الصندوق',
    tips: 'بمجرد تقديم المعلومات، لا يمكن تعديلها، الرجاء التحقق بدقة قبل الإدخال',
    idCardTypeRequired: 'الرجاء اختيار نوع الوثيقة',
    idCardFrontSideImgRequired: 'الرجاء تحميل صورة الجهة الأمامية للوثيقة',
    idCardBackSideImgRequired: 'الرجاء تحميل صورة الجهة الخلفية للوثيقة',
    idCardHandSideImgRequired: 'الرجاء تحميل صورة مع الوثيقة باليد',
    nameRequired: 'الرجاء إدخال اسم الوثيقة',
    idCardNumRequired: 'الرجاء إدخال رقم الوثيقة',
    fundPwdRequired: 'الرجاء إدخال كلمة مرور الصندوق',
    submitSuccess: 'تم تقديم طلب التوثيق بنجاح'
  },
  help: {
    title: 'مركز المساعدة'
  },
  helpDetail: {
    title: 'تفاصيل المساعدة'
  },
  myMessage: {
    title: 'رسائلي الخاصة'
  },
  messageDetail: {
    title: 'تفاصيل الرسالة الخاصة'
  },
  withdraw: {
    title: 'سحب',
    tips: 'لضمان أمان الأموال وكفاءة السحب، الرجاء التحقق من صحة المعلومات المدخلة، سيتم خصم رسوم المعاملة من الرصيد',
    receiveAmountTipsPart1: 'سحب',
    receiveAmountTipsPart2: '، المبلغ المتوقع للوصول',
    fee: 'رسوم الخدمة',
    myBalance: 'رصيدي [{vcName}] :',
    configIdLabel: 'قناة السحب',
    amountLabel: 'مبلغ السحب',
    fundLabel: 'كلمة مرور الصندوق',
    fundPlaceholder: 'الرجاء إدخال كلمة مرور الصندوق',
    googleCodeLabel: 'رمز جوجل',
    googleCodePlaceholder: 'الرجاء إدخال رمز جوجل المكون من 6 أرقام',
    maxPrecisionError: 'أقصى عدد للأرقام العشرية هو {amountMaxPrecision}',
    amountRequired: 'الرجاء إدخال أو اختيار مبلغ السحب الصحيح',
    bankCardError: 'الرجاء اختيار بطاقة بنكية صحيحة',
    fundPwdError: 'الرجاء إدخال كلمة مرور الصندوق الصحيحة',
    walletAddressError: 'الرجاء اختيار عنوان محفظة صحيح',
    success: 'تم تقديم طلب السحب بنجاح، الرجاء الانتظار للمعالجة',
    emptyPart1: 'لا توجد قنوات سحب متاحة،',
    emptyPart2: 'انقر لإعادة المحاولة'
  },
  withdrawOrder: {
    title: 'طلب السحب',
    requestAmount: 'مبلغ الطلب',
    receiveAmount: 'المبلغ المستلم'
  },
  locales: {
    title: 'تغيير اللغة'
  },
  lines: {
    title: 'اختيار الخطوط',
    switchLine: 'تغيير الخطوط'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'تم حذف العملة المفضلة بنجاح',
    addFavoriteSuccess: 'تم إضافة العملة المفضلة بنجاح'
  },
  currencySelect: {
    currencyName: 'اسم العملة',
    currencyPlaceholder: 'انقر لاختيار العملة'
  },

  walletItem: {
    available: 'متاح',
    convert: 'يعادل (USDT)'
  },
  banks: {
    bankIdLabel: 'البنك',
    bankIdPlaceholder: 'انقر لاختيار البنك'
  },
  banksPop: {
    title: 'اختر البنك',
    search: 'أدخل كلمات مفتاحية للبنك'
  },
  historyOrderDetail: {
    title: 'تفاصيل الطلب',
    coin: 'العملة المتداولة',
    amount: 'مبلغ الطلب',
    buyInClose: 'سعر الشراء',
    sellOutClose: 'سعر البيع',
    isQuest: 'هل لديك استفسار بخصوص هذا الطلب؟',
    connectCustomer: 'اتصل بخدمة العملاء؟'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'انقر لاختيار معدل النقاط للمستخدم'
  },
  walletAddressSelect: {
    title: 'اختر عنوان المحفظة',
    label: 'عنوان المحفظة',
    placeholder: 'انقر لاختيار عنوان المحفظة'
  },
  myCardSelect: {
    title: 'اختر الحساب',
    label: 'حساب المستلم',
    placeholder: 'انقر لاختيار الحساب'
  },
  amountInput: {
    amountRange: 'الحد الأدنى {minAmount}، الحد الأقصى {maxAmount}',
    amountMin: 'الحد الأدنى {minAmount}، لا حد أقصى',
    amountErrorEmpty: 'هناك خطأ في {label}، يرجى التحقق والمحاولة مرة أخرى',
    amountErrorOutRange: '{label} خارج النطاق، يرجى التحقق والمحاولة مرة أخرى'
  },
  amountFormItem: {
    placeholderOnlyMin: 'الحد الأدنى {minAmount}، لا حد أقصى',
    placeholderHasMax: 'الحد الأدنى {minAmount}، الحد الأقصى {maxAmount}',
    amountErrorEmpty: 'هناك خطأ في المبلغ، يرجى التحقق والمحاولة مرة أخرى',
    amountErrorOutRange: 'المبلغ خارج النطاق، يرجى التحقق والمحاولة مرة أخرى'
  },
  common: {
    remark: 'ملاحظة',
    saveImage: 'حفظ محليًا',
    online: 'متصل',
    offline: 'غير متصل',
    profit: 'الأرباح والخسائر',
    date: 'التاريخ',
    period: 'الفترة',
    pointAmount: 'مبلغ نقاط المستخدم',
    point: 'نقاط المستخدم',
    direction: 'الاتجاه',
    winLoss: 'الربح والخسارة',
    lose: 'خسارة',
    add: 'إضافة',
    win: 'ربح',
    edit: 'تعديل',
    notBind: 'غير مرتبط',
    alreadyBind: 'مرتبط بالفعل',
    enabled: 'مفعل',
    notEnabled: 'غير مفعل',
    queryRange: 'نطاق البحث',
    copy: 'نسخ',
    orderNum: 'رقم الطلب',
    null: 'لا يوجد',
    noData: 'لا توجد بيانات',
    refreshSuccess: 'تم التحديث بنجاح',
    loadMoreData: 'تحميل المزيد من البيانات',
    noMoreData: 'لا توجد بيانات أخرى',
    lookMore: 'عرض المزيد',
    more: 'المزيد'
  },
  date: {
    today: 'اليوم',
    yesterday: 'أمس',
    last7Days: 'آخر 7 أيام',
    last14Days: 'آخر 14 أيام',
    split: 'إلى'
  },
  button: {
    save: 'حفظ',
    logout: 'تسجيل الخروج',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    submit: 'إرسال',
    addNow: 'أضف الآن',
    reset: 'إعادة تعيين',
    nextStep: 'الخطوة التالية',
    goCertification: 'الذهاب للتحقق'
  },
  confirm: {
    title: {
      logout: 'تسجيل الخروج',
      unBindFundPassword: 'لم يتم ربط كلمة المرور الخاصة بالأموال',
      addUserDirect: 'إضافة مستخدم جديد',
      addUserInfo: 'تم إضافة المستخدم بنجاح',
      jumpToRechargePage: 'تأكيد الانتقال',
      unAuthentication: 'لم يتم التحقق من الهوية',
      noBindBankCard: 'لم يتم إضافة بطاقة بنكية',
      noBindCoinAddress: 'لم يتم إضافة عنوان محفظة',
      tradeConfirm: 'تأكيد التداول',
      sellOutSpotOrder: 'بيع الأمر المحتفظ به',
      buyFinance: 'تأكيد الشراء',
      redeemOrder: 'استرداد الطلب'
    },
    content: {
      logout: 'هل أنت متأكد من أنك تريد تسجيل الخروج من الحساب الحالي؟',
      unBindFundPassword: 'تم الكشف عن أن كلمة المرور الخاصة بالأموال لم يتم ربطها، لضمان أمان الحساب، يرجى ربط كلمة المرور الخاصة بك أولاً',
      addUserDirect: 'سيتم إضافة مستخدم جديد، يرجى التحقق من صحة المعلومات المدخلة ثم النقر على تأكيد للاستمرار، اسم المستخدم [ {username} ]، نوع المستخدم [ {userType} ]، كلمة المرور [ {password} ]، الفرق في نسبة النقاط بين تداولاتي السريعة وتداولاتي بالعقود [ {diffPointTiming} ]، الفرق في نسبة النقاط بين تداولاتي بالعقود وتداولاتي بالعقود [ {diffPointContract} ]',
      addUserInfo: 'اسم المستخدم [ {username} ]؛<br />كلمة المرور [ {password} ]؛<br />عنوان تسجيل الدخول [ {loginAddress} ]؛<br />نسبة النقاط في التداولات السريعة [ {pointPercentTiming} ]؛<br />نسبة النقاط في تداول العقود [ {pointPercentContract} ]؛',
      jumpToRechargePage: 'سيتم الانتقال إلى واجهة الشحن الخارجية، يرجى النقر على تأكيد للاستمرار',
      unAuthentication: 'تم الكشف عن أن الحساب لم يتم التحقق من الهوية، لضمان تدفق الأموال بشكل طبيعي، يرجى إجراء التحقق من الهوية أولاً',
      noBindBankCard: 'تم الكشف عن أن الحساب لم يتم إضافة أو تفعيل بطاقة بنكية، لضمان تدفق الأموال بشكل طبيعي، يرجى إضافة بطاقة بنكية أولاً',
      noBindCoinAddress: 'تم الكشف عن أن الحساب لم يتم إضافة أو تفعيل عنوان محفظة للعملات الرقمية، لضمان تدفق الأموال بشكل طبيعي، يرجى إضافة عنوان محفظة للعملات الرقمية أولاً',
      tradeConfirm: 'سيتم تقديم الطلب، يرجى التحقق من صحة معلومات الطلب ثم النقر على تأكيد الطلب لتقديمه',
      sellOutSpotOrder: 'سيتم بيع الأمر المحتفظ به، يرجى التأكد من صحة العملية ثم النقر على تأكيد للاستمرار',
      buyFinance: 'سيتم شراء [{coin}]، الكمية المشتراة: {amount}، يرجى التأكد من صحة العملية ثم النقر على تأكيد للاستمرار',
      redeemOrder: 'سيتم استرداد الطلب ({orderNum})، يرجى التأكد من صحة العملية ثم النقر على تأكيد للاستمرار'
    }
  },
  message: {
    bindSuccess: 'تم الربط بنجاح',
    successOperation: 'تمت العملية بنجاح',
    logoutSuccess: 'تم تسجيل الخروج بنجاح',
    editSuccess: 'تم التعديل بنجاح',
    addSuccess: 'تمت الإضافة بنجاح',
    copySuccess: 'تم النسخ بنجاح',
    copyFailed: 'فشل النسخ'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'الأحد',
      week_day_1: 'الاثنين',
      week_day_2: 'الثلاثاء',
      week_day_3: 'الأربعاء',
      week_day_4: 'الخميس',
      week_day_5: 'الجمعة',
      week_day_6: 'السبت'
    },
    loading: {
      loading: 'جارٍ التحميل'
    }
  },
  helpItems: {
    title: {
      part1: 'لماذا يحدث تغيير في قيمة الموجودات؟',
      part2: 'ماذا أفعل إذا نسيت كلمة مرور معاملات OTC؟',
      part3: 'أين تذهب الأموال بعد إكمال عملية شراء OTC؟',
      part4: 'لماذا يقتصر تعديل الاسم المستعار؟',
      part5: 'ماذا يعني التحويل؟ ولماذا هو مطلوب؟',
      part6: 'كيف يتم حساب حقوق حساب المستخدم في العقود؟',
      part7: 'ما هو دور القيم المحددة لجني الأرباح ووقف الخسائر في العقود؟ وكيف يجب تحديدها؟',
      part8: 'كيف يمكن تقليل نسبة المخاطرة في العقود؟',
      part9: 'ماذا تعني الكمية في فتح العقود؟',
      part10: 'توضيح بشأن الإغلاق القسري',
      part11: 'ما هي قواعد تداول العقود؟',
      part12: 'ما هو الهامش في تداول العقود؟',
      part13: 'ما هو الطلب المحدد والسوقي؟',
      part14: 'ماذا تعني نسبة المخاطرة في العقود؟',
      part15: 'لماذا يجب القيام بتحويل العملات؟',
      part16: 'لماذا لم يستلم الطرف الآخر التحويل فوراً بعد معاملات OTC؟',
      part17: 'كيف تشتري Tether (USDT) من خلال OTC؟'
    },
    content: {
      part1: 'قيمة الأصول المحسوبة هي قيمة العملات الرقمية التي تمتلكها محولة إلى العملة المحلية، وهي تتغير بسبب تقلبات أسعار الأصول الرقمية. كمية الأصول الرقمية الخاصة بك لم تتغير.',
      part2: "إذا نسيت كلمة مرور معاملات OTC، يرجى الذهاب إلى 'الإعدادات - إعداد كلمة مرور المعاملات' أو الاتصال بخدمة العملاء لإعادة تعيينها.",
      part3: 'بعد إكمال طلب شراء OTC، ستدخل الأموال إلى حساب العملات الورقية. إذا كنت بحاجة إلى استخدام الأصول المشتراة في العقود أو التداول الآجل، يرجى الانتقال إلى وحدة التحويل.',
      part4: 'لحماية أمان معاملاتك، يقتصر تعديل الاسم المستعار على مرة واحدة.',
      part5: 'لتأكيد استقلالية أموال حساباتك المختلفة والسيطرة على المخاطر، يتم تقسيم الحسابات إلى وحدات تداول مختلفة. التحويل يعني عملية تحويل الأصول بين هذه الحسابات.',
      part6: '<p>يتم حساب حقوق حساب العقود كالتالي:</p> <p>حقوق حساب العقود = هامش الصفقات المفتوحة + الأرباح والخسائر العائمة + المبلغ المتاح حاليًا في الحساب</p>',
      part7: 'جني الأرباح ووقف الخسائر هما الحدين الأقصى للأرباح والخسائر التي تحددها، وسيتم إغلاق الصفقة تلقائيًا عند الوصول إلى هذه الحدود. يُستخدمان للتحكم في المخاطر عند شراء العقود. يُفضل تحديد حد جني الأرباح كالتالي: مقدار الربح × الكمية × الرافعة المالية. نوصي بتحديد حد وقف الخسارة بناءً على حالتك المالية الفعلية للتحكم في المخاطر بشكل مناسب.',
      part8: 'يمكنك تقليل نسبة المخاطرة عن طريق تحويل الأصول المتاحة من الحسابات الأخرى إلى حساب العقود، أو عن طريق تقليل حجم الصفقات المفتوحة.',
      part9: 'الكمية في فتح العقود تشير إلى كمية العملات التي ترغب في شرائها. على سبيل المثال، في صفحة فتح عقود BTC/USDT، إذا اخترت شراء طويل وأدخلت السعر 1000 USDT والكمية 10 BTC، فهذا يعني أنك ترغب في شراء 10 BTC بسعر 1000 USDT لكل منها.',
      part10: '<p>نسبة المخاطرة هي مقياس للمخاطر في حسابك. عندما تصل نسبة المخاطرة إلى 100%، يتم اعتبار حسابك مغلقًا بالقوة. نسبة المخاطرة = (هامش الصفقات المفتوحة / حقوق حساب العقود) × 100%. لمنع المستخدمين من التعرض لخسائر كبيرة، يتم ضبط نسبة المخاطرة المسموح بها في النظام. عند الوصول إلى هذه النسبة، سيتم إغلاق جميع الصفقات المفتوحة تلقائيًا. على سبيل المثال، إذا كانت النسبة المسموح بها 10%، فسيتم إغلاق جميع الصفقات عندما تصل نسبة المخاطرة إلى 90% أو أكثر.</p> <p>ملاحظة: إذا تم إغلاق الصفقات بالقوة بسبب تجاوز نسبة المخاطرة، سيتم إغلاق جميع الصفقات المفتوحة. لذلك، نوصيك بالتحكم في نسبة المخاطرة بشكل مناسب لتجنب الخسائر غير الضرورية.</p>',
      part11: '<p>أنواع الصفقات</p> <p>الصفقات تنقسم إلى فتح شراء طويل (شراء) وفتح بيع قصير (بيع):</p> <p>الشراء الطويل (التفاؤلي) يعني أنك تتوقع ارتفاع السعر، وترغب في شراء كمية معينة من العقود بالسعر المحدد أو بالسعر الحالي للسوق.</p> <p>البيع القصير (التشاؤمي) يعني أنك تتوقع انخفاض السعر، وترغب في بيع كمية معينة من العقود بالسعر المحدد أو بالسعر الحالي للسوق.</p> <p>طرق الطلب</p> <p>الطلب المحدد: تقوم بتحديد السعر والكمية التي ترغب في تداولها بنفسك.</p> <p>الطلب السوقي: تقوم بتحديد الكمية فقط، ويتم تنفيذ الصفقة بالسعر الحالي للسوق.</p> <p>الصفقات المفتوحة</p> <p>عند تنفيذ طلب فتح صفقة، يتم اعتباره صفقة مفتوحة.</p> <p>مسألة تسوية العقود</p> <p>عقود المنصة هي عقود دائمة، ولا يوجد وقت محدد للتسوية. طالما لم يتم الوصول إلى شروط إغلاق الصفقة بالقوة أو لم تقم بإغلاق الصفقة يدويًا، يمكنك الاحتفاظ بالصفقة بشكل دائم.</p> <p>الإغلاق القسري</p> <p>1: الوصول إلى حدود جني الأرباح أو وقف الخسائر المحددة، سيتم إغلاق الصفقة تلقائيًا.</p> <p>2: نسبة المخاطرة العالية، سيتم إغلاق الصفقة بالقوة من قبل النظام.</p>',
      part12: '<p>في تداول العقود، يقوم المستخدم بدفع مبلغ من المال بناءً على سعر العقد والكمية والرافعة المالية المطلوبة كضمان للصفقة. هذا المبلغ هو هامش العقد. كلما زاد حجم الهامش المستخدم في فتح الصفقات، زادت نسبة المخاطرة في الحساب.</p> <p>هامش = (سعر العقد × الكمية) / الرافعة المالية</p>',
      part13: 'الطلب المحدد يعني تحديد السعر الذي ترغب في تداول العقد به، بينما الطلب السوقي يعني تنفيذ الصفقة بالسعر الحالي للسوق. في قواعد فتح الصفقات، يتم تنفيذ الطلب السوقي أولاً قبل الطلب المحدد. إذا اخترت الطلب المحدد، يرجى تحديد السعر بناءً على الحالة الحالية للسوق لتجنب الخسائر الناتجة عن الأسعار غير المناسبة.',
      part14: 'نسبة المخاطرة هي مؤشر للمخاطر في حساب العقود الخاص بك. عندما تصل نسبة المخاطرة إلى 100%، يتم اعتبار الحساب مغلقًا بالقوة. نوصي بأن تكون حذرًا عند فتح الصفقات إذا كانت نسبة المخاطرة تجاوزت 50% لتجنب الخسائر الناتجة عن الإغلاق القسري. يمكنك تقليل نسبة المخاطرة عن طريق إضافة أموال متاحة إلى حساب العقود أو تقليل حجم الصفقات المفتوحة.',
      part15: 'التحويل يسمح لك بتحويل أصولك بين العملات المختلفة لتسهيل التداول. يمكن تحويل QCC المكتسبة في حساب العقود إلى USDT للتداول. يمكن أيضًا تحويل USDT في الحسابات الأخرى إلى QCC للتداول.',
      part16: 'تأكد أولاً من تطابق طريقة الدفع مع التفاصيل الموجودة في صفحة الطلب. ثم تحقق من أن طريقة الدفع فورية وليست مؤجلة. أخيرًا، اتصل بالبنك أو مقدم الخدمة المالية للتأكد من عدم وجود صيانة نظام أو أسباب أخرى للتأخير.',
      part17: '<p>الطريقة الأولى: اختر الطلبات التي ترغب في شرائها أو بيعها من قائمة شراء وبيع OTC.</p> <p>الطريقة الثانية: اضغط على زر النشر وقم بإنشاء طلب شراء أو بيع حسب الحاجة لإجراء التداول بسرعة. سيقوم النظام بمطابقة المستخدمين بسرعة.</p> <p>ملاحظة: إذا لم يتم دفع طلب الشراء خلال 15 دقيقة، سيتم إلغاؤه تلقائيًا. يرجى الدفع في الوقت المناسب. إذا تم إلغاء الطلبات أكثر من ثلاث مرات في اليوم، لن تتمكن من التداول مجددًا في نفس اليوم، وسيتم استعادة حقوق التداول في اليوم التالي.</p>'
    }
  }
};

/***/ }),

/***/ "LVcC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: 'Login',
    usernameLabel: 'Username',
    usernamePlaceholder: '2-10 English digit',
    loginPasswordLabel: 'Login password',
    loginPasswordPlaceholder: 'Please enter your login password',
    googleCodeLabel: 'Google verification code',
    googleCodePlaceholder: 'Please enter a 6-digit Google verification code',
    hasNoAccount: 'No account yet,',
    goRegister: 'Go to register',
    onlineCustom: 'Online customer service',
    loginArgument: 'Continuing to log in means agreeing',
    userArgument: '《User Agreement》',
    registerNotEnabled: 'The registration function is not open, please contact the administrator',
    usernameRequired: 'Please enter a correct username',
    loginPasswordRequired: 'Please enter the correct login password',
    googleCodeRequired: 'Please enter the correct Google verification code',
    loginButton: 'login'
  },
  register: {
    title: 'Register',
    usernameLabel: 'Username',
    usernamePlaceholder: 'Please enter the registered username',
    loginPasswordLabel: 'Login password',
    loginPasswordPlaceholder: 'Please enter the login password of the registered user',
    loginPasswordPreLabel: 'Confirm login password',
    loginPasswordPrePlaceholder: 'Please enter the login password again',
    fudPasswordLabel: 'Fund password',
    fudPasswordPlaceholder: 'Please enter the fund password',
    inviteCodeLabel: 'Invitation Code',
    inviteCodePlaceholder: 'Please enter a 6-digit invitation code',
    registerNeed: 'Continue to register means agree',
    registerArgument: '《Registration Agreement》',
    usernameRequired: 'Please enter a correct username',
    loginPasswordRequired: 'Please enter the correct login password',
    loginPasswordPreRequired: 'Please enter the correct confirmation login password',
    fundPasswordRequired: 'Please enter the correct fund password',
    inviteCodeRequired: 'Please enter the correct invitation code',
    diffLoginPasswordError: 'The two login passwords are inconsistent',
    registerSuccess: 'Successful registration',
    registerButton: 'Register',
    emailLabel: 'Email',
    emailPlaceholder: 'Please enter your email address',
    emailCodeLabel: 'Verification code',
    emailCodePlaceholder: 'Please enter your email verification code',
    second: 'second',
    getEmailCodeButton: 'Get code',
    emailRequired: 'Please enter a correct email address and try again',
    emailCodeRequired: 'Please enter the correct email verification code and try again'
  },
  home: {
    hotCoin: {
      title: 'Hot Deals',
      more: 'More'
    },
    poster: {
      title: 'Quick deposit',
      enter: 'Enter Now >',
      subTitle: 'Support BTC, USDT, ETH, etc.'
    },
    quickMenus: {
      futuresTrading: 'Futures Trading',
      helpCenter: 'Help Center'
    },
    ranking: {
      increase: {
        title: 'Rising list'
      },
      clinch: {
        title: 'Turnover List'
      }
    }
  },
  tabBar: {
    home: 'Home',
    price: 'Market',
    trade: 'Trade',
    fund: 'Asset',
    user: 'Profile'
  },
  currency: {
    favorite: 'Optional',
    allCurrency: 'Spot',
    dayVol: '24H',
    addFavor: '+ Add Favor'
  },
  trade: {
    bills: 'Bills',
    todayOpen: 'Open',
    star: 'Star',
    vol: 'Volume',
    low: 'Lowest',
    high: 'Highest',
    timing: 'Timing',
    spot: 'Futures',
    buyMore: 'Buy More',
    buyEmpty: 'Buy Empty',
    indicator: 'Indicator',
    indicatorSettings: 'Indicator Settings',
    balance: 'My balance',
    fee: 'Service fee',
    ruleIdError: 'Please select an expiration time',
    deleteFavoriteSuccess: 'Delete favorite currency successfully',
    addFavoriteSuccess: 'Add favorite currency successfully',
    buyIn: 'Buy',
    sellOut: 'Sell',
    holding: 'Holding',
    history: 'History',
    spotOrderConfirm: {
      title: 'Confirm Buy',
      amountPlaceholder: 'Please enter buy in count'
    },
    spotTradeOrder: {
      holding: {
        coin: 'currency',
        buyInAmountPrice: 'Buy Amount/Price',
        buyInCount: 'Quantity',
        actions: 'Operation',
        sellOut: 'Sell',
        profit: 'Profit'
      }
    },
    orderConfirm: {
      title: 'Order Confirm',
      coinName: 'Coin',
      direction: 'Direction',
      price: 'Price',
      balance: 'Balance',
      fee: 'Service Fee',
      buyMoreLabel: 'Buy More',
      buyEmptyLabel: 'Buy Empty',
      buyQuantity: 'Buy Quantity',
      buyAmount: 'Buy Amount',
      submit: 'Confirm order'
    },
    kline: {
      open: 'Open:',
      close: 'Close:',
      change: 'Change:'
    }
  },
  finance: {
    title: 'Finance'
  },
  allFinance: {
    title: 'Financial management',
    all: 'All'
  },
  financeOrders: {
    title: 'Pledge order',
    holdingLabel: 'Holding',
    historyLabel: 'History',
    holding: {
      amount: 'Pledge amount',
      rateStr: 'Income amount/yield',
      vcCount: 'Number of pledged coins',
      cycle: 'Position cycle',
      day: 'Day',
      calcStartDate: 'Start value date',
      serviceAmount: 'Service Fee',
      redeemOrder: 'Redeem'
    },
    history: {
      incomeAmount: 'Income amount',
      rateStr: 'Yield',
      amount: 'Pledge amount',
      vcCount: 'Number of pledged coins',
      calcStartDate: 'Start value date',
      calcEndDate: 'End Date',
      cycle: 'Cycle days',
      serviceAmount: 'Service Fee',
      day: 'day'
    }
  },
  financeOrderBills: {
    title: 'Pledge income bill',
    amount: 'Amount',
    balance: 'Balance'
  },
  financeItem: {
    rateStr: 'yield',
    buyType: 'Buy Type',
    cycle: 'cycle days',
    exchangeRate: 'Exchange rate (virtual currency exchange balance)',
    day: 'day',
    cycleType: 'cycle type',
    serviceRateStr: 'Service Rate'
  },
  buyFinance: {
    title: 'Buy',
    rateStr: 'yield',
    name: 'name',
    buyType: 'Buy Type',
    cycle: 'cycle days',
    cycleType: 'cycle type',
    exchangeRate: 'Exchange rate (virtual currency exchange balance)',
    serviceRateStr: 'Service Rate',
    remark: 'remark',
    buyAmountLabel: 'Buy Amount ({coin})',
    descriptionTitle: 'Product Description',
    descriptionPart1: '1. This product is a non-principal-guaranteed wealth management product. Market fluctuations may lead to principal losses. Please invest carefully.',
    descriptionPart2: '2. Payment settlement rules:',
    descriptionPart3: 'If the settlement price < linked price, BTC will be settled after maturity; settlement amount = investment amount * (1+ days * annualized rate of return / 365).',
    descriptionPart4: 'If the settlement price ≥ linked price, USDT will be settled after maturity; settlement amount = investment amount * linked price * (1+ days * annualized rate of return / 365).',
    descriptionPart5: '3. The actual annualized rate of return changes with the market in real time, please refer to the actual purchase transaction.',
    descriptionPart6: '4. The investment amount is converted according to the market in real time, please refer to the actual purchase transaction.',
    descriptionPart7: '5. After the product is purchased, it can be viewed on my currency holding page, and the refund will be automatically issued to the spot account after the expiration date.',
    buyButton: 'Buy [{coin}]'
  },
  fund: {
    description: 'Assets',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    exchange: 'Transfer',
    empty: 'Wallet is empty, go'
  },
  userCenter: {
    lastLogin: 'Last login',
    myTeam: 'My Team',
    identity: 'Authentication',
    walletAddress: 'Wallet address',
    zskAccount: 'ZSK Account',
    bankCard: 'Bank account',
    userBills: 'User Bills',
    timingTradeOrder: 'Timing Trade Order',
    spotTradeOrder: 'Futures Trade Order',
    contactTradeOrder: 'Contract position',
    userReport: 'User Report',
    teamReport: 'Team report',
    share: 'Share',
    customer: 'Customer service',
    helpCenter: 'Help Center',
    platform: 'Platform Introduction',
    profit: 'Profit',
    balance: 'Balance',
    withdraw: 'Withdraw',
    recharge: 'Recharge',
    creditStoreLabel: 'Credit Store'
  },
  settings: {
    title: 'Settings',
    fundPassword: 'Fund password',
    googleValidator: 'Google Validator',
    editLoginPassword: 'Edit Login Password',
    switchLocale: 'Switch language'
  },
  editFundPassword: {
    title: 'Change Fund Password',
    currentPasswordLabel: 'current password',
    currentPasswordPlaceholder: 'Please enter the current fund password',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Please enter the modified fund password',
    prePasswordLabel: 'Confirm password',
    prePasswordPlaceholder: 'Clear and re-enter the modified fund password',
    tips: 'The fund password is an important certificate for transactions, please set it carefully and keep it in mind',
    currentPasswordRequired: 'Please enter the current fund password',
    newPasswordRequired: 'Please enter the fund password to be modified',
    prePasswordRequired: 'Please enter the fund password to be modified again',
    prePasswordDiff: 'Two password inputs are inconsistent'
  },
  bindFundPassword: {
    title: 'Bind fund password',
    fundPasswordLabel: 'Fund Password',
    fundPasswordPlaceholder: 'Please input fund password',
    fundPasswordPreLabel: 'Confirm Password',
    fundPasswordPrePlaceholder: 'Please input fund password agagin',
    fundPasswordRequired: 'Fund password is required',
    fundPasswordPreRequired: 'Confirm password is required',
    fundPasswordDiff: 'Two password inputs are inconsistent',
    bindSuccess: 'Bind Success',
    tips: 'The fund password is an important certificate for transactions, please set it carefully and keep it in mind'
  },
  editLoginPassword: {
    title: 'Change login password',
    currentPasswordLabel: 'Current password',
    currentPasswordPlaceholder: 'Please enter the current login password',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Please enter the modified login password',
    prePasswordLabel: 'Confirm password',
    prePasswordPlaceholder: 'Clear and re-enter the modified login password',
    tips: 'The login password is an important credential for login authentication, etc., please set it carefully and keep it in mind',
    currentPasswordRequired: 'Please enter the current login password',
    newPasswordRequired: 'Please enter the login password to be modified',
    prePasswordRequired: 'Please re-enter the login password to be modified',
    prePasswordDiff: 'Two password inputs are inconsistent'
  },
  bindGoogleValidator: {
    title: 'Bind Google Authenticator',
    qrCodeLabel: 'QR code',
    keyLabel: 'Key',
    loginPasswordLabel: 'Login password',
    loginPasswordPlaceholder: 'Please enter your login password',
    googleCodeLabel: 'Google verification code',
    googleCodePlaceholder: 'Please enter a 6-digit Google verification code',
    tipsPart1: 'Search Google Authenticator in the app store',
    tipsPart2: 'Use Google Authenticator to scan the QR code above, or manually enter the key for binding',
    tipsPart3: 'Enter the 6-digit Google verification code above, click Confirm to submit',
    loginPasswordRequired: 'Please enter the login password',
    googleCodeRequired: 'Please enter a 6-digit Google verification code'
  },
  walletAddress: {
    title: 'Wallet Address',
    add: '+ Add Address',
    remark: 'Remark',
    addButton: 'Add wallet address',
    tips: 'If you want to modify or delete address information, please contact customer service'
  },
  addWalletAddress: {
    title: 'Add wallet address',
    vcChainNameIdLabel: 'Chain type',
    vcAccountLabel: 'Wallet address',
    vcAccountPlaceholder: 'Please enter wallet address',
    remarkLabel: 'Remarks',
    remarkPlaceholder: 'Please enter the remark content',
    fundPasswordLabel: 'Fund Password',
    fundPasswordPlaceholder: 'Please enter your fund password',
    tips: 'The added wallet address cannot be modified, please verify that the information is correct',
    vcIdRequired: 'Please select the correct currency',
    vcChainNameIdRequired: 'Please select the correct chain type',
    vcAccountRequired: 'Please enter the correct wallet address',
    fundPwdRequired: 'Please enter the correct fund password',
    addSuccess: 'Wallet address added successfully'
  },
  receiveWays: {
    title: 'My Bank Card',
    add: '+ Add bank card',
    tips: 'If you want to modify or delete bank card information, please contact customer service',
    addCardButton: 'Add bank card'
  },
  zskAccount: {
    title: 'Fast account',
    add: '+ Add fast account',
    tips: 'To modify or delete account information, please contact customer service',
    addCardButton: 'Add account'
  },
  addZskAccount: {
    title: 'Add a fast account',
    withdrawNameLabel: 'Name',
    withdrawNamePlaceholder: 'Please enter name',
    withdrawNameRequired: 'Name is required',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Please enter the fast speed',
    fundPasswordLabel: 'Fund password',
    fundPasswordPlaceholder: 'Please enter your fund password',
    tips: 'Please carefully fill in the information of the added account, the company will not be responsible for the problem that the withdrawal fails to arrive due to incorrect information'
  },
  addBankCard: {
    title: 'Add a new bank card',
    withdrawNameLabel: 'Name',
    withdrawNamePlaceholder: 'Please enter name',
    withdrawNameRequired: 'Name is required',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Please enter ZSK',
    zskRequired: 'ZSK is required',
    cardNumLabel: 'Bank account number',
    cardNumPlaceholder: 'Please enter the bank card number',
    branchLabel: 'Branch address',
    branchPlaceholder: 'Please enter the bank card branch address',
    fundPasswordLabel: 'Fund password',
    fundPasswordPlaceholder: 'Please enter the fund password',
    tips: 'The bank card is an important data for transaction cash withdrawal, please fill in carefully, the company will not be responsible for any problems such as failure to receive cash due to incorrect card information filling. ',
    backIdRequired: 'Please select the account bank',
    cardNumRequired: 'Please enter the correct bank card number',
    fundPwdRequired: 'Please enter the correct fund password',
    idCardPlaceholder: 'Please enter your ID number',
    idCardLabel: 'ID card number',
    idCardRequired: 'Please enter the correct ID number',
    cciPlaceholder: 'Please enter CCI',
    branchCodePlaceholder: 'Please enter branch code',
    branchCodeLabel: 'Branch code',
    katakanaPlaceholder: 'Please enter katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Account Change Record',
    vcName: 'Currency',
    amount: 'Amount',
    balance: 'Balance'
  },
  timingTradeOrder: {
    title: 'Timing trade order',
    waiting: {
      title: 'Orders in progress',
      amount: 'Amount',
      period: 'period',
      receivePrice: 'Buy price',
      settlement: 'settlement in progress'
    },
    history: {
      title: 'Historical Orders',
      buyInClose: 'Buy price',
      saleOutClose: 'sale price'
    }
  },
  spotTradeOrder: {
    title: '期货交易订单',
    waiting: {
      title: '在持订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      buyInTime: '买入时间'
    },
    history: {
      title: '历史订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      sellOutAmount: '卖出总价',
      sellOutPrice: '卖出单价',
      sellOutTime: '卖出时间'
    }
  },
  userReport: {
    title: 'User Report',
    profit: 'Profit',
    timingTradeAmountFee: 'Extremely fast trading order/handling fee',
    timingTradePrizePoint: 'Extremely fast trading bonus/rebate',
    rechargeInfo: 'Recharge/handling fee',
    withdrawInfo: 'Withdrawal/handling fee',
    exchangeInfo: 'Exchange/handling fee'
  },
  userReportDay: {
    title: 'User Daily Report',
    profit: 'Profit',
    timingTradeAmountFee: 'Extremely fast trading order/handling fee',
    timingTradePrizePoint: 'Extremely fast trading bonus/rebate',
    rechargeInfo: 'Recharge/handling fee',
    withdrawInfo: 'Withdrawal/handling fee',
    exchangeInfo: 'Exchange/handling fee'
  },
  teamReport: {
    goToReportDay: 'Report Day',
    timingTradeBetAmountServiceCharge: 'Timing Trade Amount/Services',
    timingTradeBetPrizePoint: 'Timing Trade Prize/Point',
    timingTradeUserAndCount: 'Timing Trade Users/Counts',
    rechargeAmountFee: 'Recharge Amount/Services',
    rechargePersonCount: 'Recharge Users/Counts',
    withdrawAmountFee: 'Withdraw Amount/Services',
    withdrawPersonCount: 'Withdraw Users/Counts',
    firstRechargeUserAndCount: 'First Recharge Amount/Counts',
    title: 'Team Report',
    usernamePlaceholder: 'Enter the lower-level username',
    previewAllTradeInfo: 'View all speed trade information',
    coin: 'currency',
    timingTradeBetAmount: 'Extremely fast trading betting amount',
    profit: 'Profit',
    action: 'operation',
    previewReportDay: 'View the daily report'
  },
  teamTimingTradeInfo: {
    title: 'Team Speed Trading',
    profit: 'Profit',
    subTitle: 'Team speed transaction information',
    timingTradeAmountFee: 'Extremely fast trading order/service fee',
    timingTradePrizePoint: 'Extremely fast trading bonus/rebate',
    rechargeInfo: 'Recharge/Service Fee',
    withdrawInfo: 'Withdrawal/Service Fee',
    exchangeInfo: 'Exchange/Service Fee'
  },
  teamReportDay: {
    title: 'Team Daily Report',
    subTitle: 'Team [ {username} ] Daily Report',
    timingTradeBetAmountFee: 'Extremely fast trading order/service fee',
    timingTradeUserAndCount: 'Timing Trade Users/Counts',
    timingTradeBetPrizePoint: 'Fast Trading Bonus/Rebate',
    rechargeAmountFee: 'Recharge amount/service fee',
    rechargePersonCount: 'Recharge person/number of transactions',
    firstRechargePersonCount: 'First Recharge Amount/Counts',
    withdrawAmountFee: 'Withdrawal amount/service fee',
    withdrawPersonCount: 'The number of people withdrawing money/transactions',
    exchangeAmountFee: 'Exchange Amount/Service Fee'
  },
  share: {
    title: 'Share',
    qrCodeLabel: 'QR code',
    registerUrlLabel: 'Registration address',
    inviteCodeLabel: 'Invitation Code',
    hasNoInviteCode: 'The current account has no invitation code,',
    generateInvitationCode: 'Try to generate with one click',
    tipsPart1: 'Scan the above QR code to fill in the registration information to register',
    tipsPart2: 'Copy the registration address and fill in the registration information to register',
    tipsPart3: 'Manually open the registration interface of this site and fill in the invitation code to register',
    saveImageError: 'Failed to save the picture, try to long press the picture and save'
  },
  myTeam: {
    title: 'My Team',
    usernamePlaceholder: 'Enter the lower-level username',
    point: 'rebate (speed/contract)',
    totalBalance: 'Balance',
    lastLoginTime: 'Last Login Time',
    noLoginTime: 'none'
  },
  userDetail: {
    title: 'User Detail',
    username: 'Username',
    userType: 'User Type',
    pointPercentTiming: 'Timing Point',
    pointPercentContract: 'Contract Point',
    registerWay: 'Registration method',
    teamCounts: 'Team number',
    teamOnline: 'team online',
    balance: 'Balance',
    registerTime: 'Registration time',
    onlineStatus: 'login status'
  },
  addUser: {
    title: 'Add User',
    addUserDirect: {
      userTypeLabel: 'User Type',
      usernameLabel: 'Username',
      usernamePlaceholder: 'Please enter the account username',
      pointTimingLabel: 'Extremely fast transaction rebate',
      pointContractLabel: 'Contract transaction rebate',
      tips: 'The initial password is: "{password}"; please remind the user to change the password in time after opening the account',
      userTypeRequired: 'Please select the account type',
      usernameRequired: 'Please enter the account username',
      pointTimingRequired: 'Please select the fast transaction rebate',
      pointContractRequired: 'Please select contract transaction rebate',
      copyTemplate: '\n         Username: {username};\n         Login password: {loginPassword};\n         Login URL: {loginAddress};\n         Fast trading rebate: {timingTradePoint};\n         Contract trading rebate: {contactTradePoint};\n         '
    }
  },
  recharge: {
    title: 'Recharge',
    configIdLabel: 'Recharge channel',
    chainNameLabel: 'Chain name',
    amountLabel: 'Deposit Amount',
    userCardNameLabel: 'Payer',
    userCardNamePlaceholder: 'Please enter the name of the payer',
    fee: 'service fee',
    receiveAmountTipsPart1: 'Recharge',
    receiveAmountTipsPart2: ', Need pay',
    tipsPart1: 'Because the online payment interface is unstable, only offline transfer and recharge are currently supported! ',
    tipsPart2: 'Please fill in the actual transfer amount truthfully, otherwise it may cause the system to fail the review and affect the recharge progress. ',
    emptyPart1: 'No Recharge Channel, ',
    emptyPart2: 'Tap to retry',
    amountRequired: 'The recharge amount cannot be empty',
    maxPrecisionError: 'The recharge amount can have up to {amountMaxPrecision} decimal places',
    payUserNameError: 'Please enter a correct payer and try again',
    userMobileLabel: 'Mobile',
    userMobilePlaceholder: 'Please input your mobile',
    needPayLabel: 'Need Pay',
    needPayPlaceholder: 'Please Input Amount'
  },
  payDetail: {
    title: 'Transfer Information',
    addressLabel: 'Deposit address',
    rechargeAmount: 'Amount',
    bankNameLabel: 'Bank',
    branchLabel: 'Branch address',
    cardName: 'Name',
    cardNum: 'card number',
    uploadImgLabel: 'Payment Credentials',
    uploadImgPlaceholder: 'Click to upload payment voucher image',
    uploadImgRequired: 'Please upload payment voucher picture',
    vcTransferTipsPart1: '1. Copy the deposit address or scan the QR code to deposit',
    vcTransferTipsPart2: '2. Upload the payment voucher picture after the deposit is completed',
    vcTransferTipsPart3: 'In order to improve the efficiency of deposit, please make sure to upload a clear and high-definition certificate picture, if the relevant information picture is not clear, it may cause the system to fail the review and affect the deposit progress. ',
    bankCardTips: 'In order to improve the efficiency of depositing money, please make sure that the name of the transferor and the remitter are the same; if the relevant information does not match, it may cause the system to fail the review and affect the progress of the deposit. ',
    bankCardTransferSuccess: 'I have transferred successfully'
  },
  rechargeOrder: {
    title: 'Deposit order',
    payAmount: 'Amount',
    receiveAmount: 'Receive Amount'
  },
  identity: {
    title: 'Real name information',
    subTitle: 'Real-name authentication includes information authentication, identity authentication',
    name: 'Name',
    idType: 'Document type',
    idNum: 'ID number',
    demand: 'Require',
    informationVer: 'Information Verification',
    idAuthentication: 'Authentication',
    material: 'Material'
  },
  verified: {
    title: 'Verified',
    idCardTypeLabel: 'Certificate type',
    idCardFrontSideImgLabel: 'Card Front SideImgLabel',
    idCardBackSideImgLabel: 'The back of the ID photo',
    idCardHandSideImgLabel: 'Hand-held ID photo',
    nameLabel: 'Document name',
    namePlaceholder: 'Please enter your ID name',
    idCardNumLabel: 'ID card number',
    idCardNumPlaceholder: 'Please enter the ID number',
    fundPwdLabel: 'Fund password',
    fundPwdPlaceholder: 'Please enter your fund password',
    tips: 'Once the information authentication is submitted, it cannot be modified, please check it carefully and fill it in correctly',
    idCardTypeRequired: 'Please select the card type',
    idCardFrontSideImgRequired: 'Please upload a front photo of the ID card',
    idCardBackSideImgRequired: 'Please upload a photo of the back of the ID card',
    idCardHandSideImgRequired: 'Please upload a hand-held ID photo',
    nameRequired: 'Please enter the name of the document',
    idCardNumRequired: 'Please enter the ID number',
    fundPwdRequired: 'Please enter your fund password',
    submitSuccess: 'Authentication request submitted successfully'
  },
  help: {
    title: 'Help Center'
  },
  helpDetail: {
    title: 'Help Details'
  },
  myMessage: {
    title: 'My Message'
  },
  messageDetail: {
    title: 'Message details'
  },
  withdraw: {
    title: 'Withdraw coins',
    tips: 'In order to ensure the safety of funds and the efficiency of withdrawal; please carefully check that the information filled in is correct, the services fee generated during the withdrawal process will be deducted from the balance',
    receiveAmountTipsPart1: 'Withdraw',
    receiveAmountTipsPart2: ', expected to arrive',
    fee: 'Service fee',
    myBalance: 'My [{vcName}] balance:',
    configIdLabel: 'Withdrawal channel',
    amountLabel: 'Withdrawal amount',
    fundLabel: 'Fund password',
    fundPlaceholder: 'Please enter your fund password',
    googleCodeLabel: 'Google verification code',
    googleCodePlaceholder: 'Please enter a 6-digit Google verification code',
    maxPrecisionError: 'The withdrawal amount can have up to {amountMaxPrecision} decimal places',
    amountRequired: 'Please enter or select the correct withdrawal amount',
    bankCardError: 'Please select the correct bank card',
    fundPwdError: 'Please enter the correct fund password',
    walletAddressError: 'Please select the correct wallet address',
    success: 'The withdrawal request was submitted successfully, please wait for processing',
    emptyPart1: 'There is no withdrawal channel available, ',
    emptyPart2: 'Tap to retry'
  },
  withdrawOrder: {
    title: 'Withdrawal order',
    requestAmount: 'Amount',
    receiveAmount: 'Receive Amount'
  },
  locales: {
    title: 'Switch language'
  },
  lines: {
    title: 'Lines',
    switchLine: 'Switch Line'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Delete favorite currency successfully',
    addFavoriteSuccess: 'Add favorite currency successfully'
  },
  currencySelect: {
    currencyName: 'currency',
    currencyPlaceholder: 'Click to select currency'
  },
  walletItem: {
    available: 'available',
    convert: 'convert (USDT)'
  },
  banks: {
    bankIdLabel: 'Bank',
    bankIdPlaceholder: 'Click to select a bank'
  },
  banksPop: {
    title: 'Select Bank',
    search: 'Input bank keywords'
  },
  historyOrderDetail: {
    title: 'Order Details',
    coin: 'Transaction currency',
    amount: 'order amount',
    buyInClose: 'Buy price',
    sellOutClose: 'Sell price',
    isQuest: 'Have any questions about this order?',
    connectCustomer: 'Contact customer service?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Click to select user rebate'
  },
  walletAddressSelect: {
    title: 'Select wallet address',
    label: 'Wallet address',
    placeholder: 'Click to select wallet address'
  },
  myCardSelect: {
    title: 'Select account',
    label: 'receiving account',
    placeholder: 'Click to select an account'
  },
  amountInput: {
    amountRange: 'Min {minAmount}, Max {maxAmount}',
    amountMin: 'Min {minAmount}, Uncapped',
    amountErrorEmpty: '{label} is required',
    amountErrorOutRange: '{label} is out of range'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Min {minAmount}, Uncapped',
    placeholderHasMax: 'Min {minAmount}, Max {maxAmount}',
    amountErrorEmpty: 'The amount is incorrect',
    amountErrorOutRange: 'The amount is out of range'
  },
  common: {
    remark: 'Remark',
    saveImage: 'Save Image',
    online: 'Online',
    offline: 'Offline',
    profit: 'Profit',
    date: 'Date',
    period: 'Period',
    pointAmount: 'Point Amount',
    point: 'User rebate',
    direction: 'Direction',
    winLoss: 'Income',
    lose: 'Lose',
    add: 'Add',
    win: 'Win',
    edit: 'Modify',
    notBind: 'Unbound',
    alreadyBind: 'Already Bound',
    enabled: 'Enabled',
    notEnabled: 'NotEnabled',
    queryRange: 'Query Range',
    copy: 'Copy',
    orderNum: 'Order',
    null: 'Null',
    noData: 'No Data',
    refreshSuccess: 'Refresh Success',
    loadMoreData: 'Load more data',
    noMoreData: 'No more data',
    lookMore: 'More',
    more: 'More'
  },
  date: {
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Nearly 7 days',
    last14Days: 'Nearly 14 days',
    split: 'To'
  },
  button: {
    save: 'Save',
    logout: 'Logout',
    confirm: 'OK',
    cancel: 'Cancel',
    submit: 'Submit',
    addNow: 'Add now',
    reset: 'reset',
    nextStep: 'Next',
    goCertification: 'Go to certification'
  },
  confirm: {
    title: {
      logout: 'Logout',
      unBindFundPassword: 'Unbound fund password',
      addUserDirect: 'Add User',
      addUserInfo: 'Add user successfully',
      jumpToRechargePage: 'Confirm Jump',
      unAuthentication: 'Un authentication',
      noBindBankCard: 'No bank card',
      noBindCoinAddress: 'No wallet address',
      tradeConfirm: 'Confirm transaction',
      sellOutSpotOrder: 'Position to sell',
      buyFinance: 'Confirm Purchase',
      redeemOrder: 'Pledge order redemption'
    },
    content: {
      logout: 'Are you sure to log out of the current account?',
      unBindFundPassword: 'An unbound fund password has been detected, to ensure account security, please bind your fund password first',
      addUserDirect: 'A new user will be added soon, please verify that the information is correct and click OK to continue, user name [ {username} ], user type [ {userType} ], login password [ {password} ], and the difference between my speed trading rebate [ {diffPointTiming} ], and my contract transaction rebate difference [ {diffPointContract} ]',
      addUserInfo: 'Username [ {username} ]; <br /> Login password [ {password} ];<br /> Login URL [ {loginAddress} ];<br /> Extreme transaction rebate [ {pointPercentTiming} ];<br /> /> Contract transaction rebate [{pointPercentContract}];',
      jumpToRechargePage: 'About to jump to the three-party recharge interface, please click confirm to continue',
      unAuthentication: 'It is detected that the account has not undergone real-name authentication. In order to ensure the normal circulation of funds, please perform real-name authentication first',
      noBindBankCard: 'It is detected that the account is not bound or activated with a bank card. In order to ensure the normal circulation of funds, please bind the bank card first',
      noBindCoinAddress: 'It is detected that the account has no bound or enabled virtual currency account. In order to ensure the normal circulation of funds, please add the virtual currency account address first',
      tradeConfirm: 'The order is about to be submitted, please verify the order information is correct and click Confirm Order to submit',
      sellOutSpotOrder: 'The position order is about to be sold, please confirm that the operation is correct and click OK to continue',
      buyFinance: 'About to buy [{coin}], buy share: {amount}, please confirm that the operation is correct and click OK to continue',
      redeemOrder: 'The pledge order ({orderNum}) is about to be redeemed, please confirm that the operation is correct and click Confirm to continue'
    }
  },
  message: {
    bindSuccess: 'Bind successfully',
    successOperation: 'Operation succeeded',
    logoutSuccess: 'Exit successfully',
    editSuccess: 'Modified successfully',
    addSuccess: 'Add successfully',
    copySuccess: 'Copy success',
    copyFailed: 'Copy failed'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Day',
      week_day_1: 'One',
      week_day_2: 'two',
      week_day_3: 'three',
      week_day_4: 'four',
      week_day_5: 'five',
      week_day_6: 'Six'
    },
    loading: {
      loading: 'loading'
    }
  },
  helpItems: {
    title: {
      part1: 'Why does the converted amount in assets change? ',
      part2: 'Forgetting the fund password handling method for OTC transactions',
      part3: 'Where will the funds flow after the OTC transaction purchase is completed? ',
      part4: 'Why do you want to limit the number of times you can modify your nickname',
      part5: 'What is the meaning of transfer, why is it necessary to transfer',
      part6: 'How to calculate the account equity of the user contract? ',
      part7: 'What is the value of the stop loss and take profit set in the opening position? How should it be set? ',
      part8: 'How to reduce contract risk? ',
      part9: 'What does the quantity in the contract open position indicate? ',
      part10: 'Instructions on forced liquidation',
      part11: 'What are the contract trading rules? ',
      part12: 'What is the margin in contract trading? ',
      part13: 'What is limit order and market order? ',
      part14: 'What does the risk of contract transactions represent',
      part15: 'Why do you need currency conversion? ',
      part16: 'Why did the other party not receive the transfer in time after the OTC transaction transfer? ',
      part17: 'How to buy Tether (USDT) through OTC? '
    },
    content: {
      part1: 'The value of digital currency currently held in Renminbi when converted into assets will change due to price fluctuations of digital assets. The number of your digital assets has not changed. ',
      part2: 'If you forget the OTC transaction fund password, please go to "My-Settings-Click to set the fund password" or contact customer service to reset',
      part3: 'After the OTC buy order is completed, the funds will enter the legal currency account in the asset. If you need to use OTC purchased assets for contract trading or futures trading, please go to the fund transfer module to transfer. ',
      part4: 'For the security reasons of your transaction, we currently limit the nickname to be modified only once. ',
      part5: 'In order to ensure the independence of funds between your various accounts and to facilitate your reasonable risk control, the accounts of the major trading modules are hereby divided. Transfer refers to the process of mutual conversion of assets between various trading accounts. ',
      part6: '<p>Contract account equity, the calculation method is as follows:</p> <p>Contract account equity = position margin + position floating profit and loss + current account available amount</p>',
      part7: 'Take profit and stop loss are the profit limit and loss limit set by you. When the set stop profit and stop loss amount is reached, the system will automatically close the position. It can be used for your risk control when purchasing contracts. Half of the set take profit amount is: increase amount x quantity x leverage multiple, and set stop loss. We recommend that you set it according to your actual asset situation to reasonably control risks. ',
      part8: 'You can transfer the available assets of the remaining accounts to the contract account by transferring funds, or reduce the risk by reducing the position. ',
      part9: 'The quantity in the open position indicates the quantity of currency you expect to buy. For example: on the opening page of the BTC/USDT trading pair, choose to buy long, enter the price as 1000USDT, and enter the quantity as 10BTC, which means: you expect to buy 10 BTC with a unit price of 1000USDT. ',
      part10: '<p>The risk degree is an indicator to measure the risk of your assets. When the risk degree is equal to 100%, your position is considered liquidated. The risk degree=(position margin/contract account equity)*100%, in order To prevent users from overrunning their positions, the system sets the adjustment ratio of the risk degree. When the risk degree reaches the risk value set by the system, the system will force liquidation. For example: if the adjustment ratio set by the system is 10%, then when your risk degree is greater than or equal to 90%, all your positions will be forcibly closed by the system. </p> <p>Note: If the system forces liquidation caused by excessive risk, all your positions will be closed, so I hope you can reasonably control your risk to avoid unnecessary losses< /p>',
      part11: '<p>Trade type</p> <p>Trade type is divided into two directions: open long position (buy) and open short position (sell):</p> <p>Buy long (Calling) means that you believe that the current index may rise, and hope to buy a certain amount of certain contracts at the price you set or the current market price. </p> <p>Short selling (bearish) means that you believe that the current index may fall, and hope to sell a certain number of certain contracts at the price you set or the current market price. </p> <p>How to place an order</p> <p>Limit order: you need to specify the price and quantity of the order</p> <p>Market order: you only need to set the quantity of the order, The price is the current market price</p> <p>Position</p> <p>When the opening order you submit is completed, it is called a position</p> <p>Contract delivery issues</p> < p>The platform contract is a perpetual contract with no set delivery time. As long as the system liquidation conditions are not met or you do not close the position manually, you can hold the position permanently. </p> <p>The system closes the position</p> <p>1: The system automatically closes the position when the set value of stop profit and stop loss is reached</p> <p>2: The risk is too high, the system forces the position to be closed< /p>',
      part12: '<p>In the contract transaction, the user can participate in the transaction of the contract by paying funds as the financial guarantee for the performance of the contract according to the contract price and quantity, according to the corresponding leverage multiple, and this fund is the contract margin. The user will occupy the margin when opening a position, and the more the margin for opening a position is occupied, the higher the risk of the account. </p> <p>Margin = (opening price * quantity) / leverage ratio</p>',
      part13: 'Limit order refers to the price you expect to entrust the platform to conduct transactions, and market order refers to directly entrust the platform to conduct transactions at the current price. In the rules for opening positions, market orders are prioritized over limit orders. If you choose a limit order, please open a position reasonably according to the market price of the current currency to avoid losses caused by unreasonable opening prices. ',
      part14: 'Risk level is the risk indicator in your contract account, and risk level equal to 100% is considered liquidation. We suggest that you, when your risk exceeds 50%, you need to open positions carefully to avoid losses due to liquidation. You can reduce your risk by replenishing the available funds of contract assets, or reducing positions. ',
      part15: 'The function of the exchange is to allow the smooth circulation of funds in different currencies in your assets, and the QCC obtained in the futures account can be freely converted into USDT for trading. USDT in other accounts can also be freely converted into QCC for transactions. ',
      part16: 'First of all, please make sure that the payment method you fill in when transferring money is exactly the same as that displayed on the order details page. Then please confirm whether your payment method is instant or delayed. Finally, please contact your bank and payment institution for system maintenance or other reasons. ',
      part17: '<p>Method 1: Select the order you want to buy through the OTC buy and sell list to buy or sell. </p> <p>Method 2: Click the publish button to publish buy or sell orders according to your needs for quick transactions. The system will quickly match you with buyers and sellers. </p> <p>Note: If the purchase order is not paid after 15 minutes, the system will automatically cancel the order, please pay in time. If the order is canceled more than 3 times on the same day, the transaction cannot be carried out again on the same day, and the trading authority will be restored on the next day. </p>'
    }
  }
};

/***/ }),

/***/ "LgDY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/***
 * 系统配置group字典映射表
 * @type {{}}
 */
var configGroupCode = exports.configGroupCode = {
  REGISTER: 'REGISTER',
  PORTAL: 'PORTAL',
  WITHDRAW: 'WITHDRAW',
  RECHARGE: 'RECHARGE',
  GLOBAL: 'GLOBAL'

  /***
   * 获取指定分组的配置信息
   * @param systemConfig
   * @param groupCode
   * @returns {{config: {}}|{}}
   */
};function findSystemConfigItem(systemConfig, groupCode, state) {
  if (!systemConfig || !systemConfig.length) return { config: {} };
  return (systemConfig.find(function (configItm) {
    return configItm.group === configGroupCode[groupCode];
  }) || {
    config: {}
  }).config;
}

/***
 * 单个配置组信息
 */
exports.default = {
  GLOBAL_systemConfig: function GLOBAL_systemConfig(state) {
    return findSystemConfigItem((state.app.systemConfig['value_' + state.i18n.locale] || {}).data || [], configGroupCode.GLOBAL, state);
  },
  REGISTER_systemConfig: function REGISTER_systemConfig(state) {
    return findSystemConfigItem((state.app.systemConfig['value_' + state.i18n.locale] || {}).data || [], configGroupCode.REGISTER);
  },
  PORTAL_systemConfig: function PORTAL_systemConfig(state) {
    return findSystemConfigItem((state.app.systemConfig['value_' + state.i18n.locale] || {}).data || [], configGroupCode.PORTAL);
  },
  WITHDRAW_systemConfig: function WITHDRAW_systemConfig(state) {
    return findSystemConfigItem((state.app.systemConfig['value_' + state.i18n.locale] || {}).data || [], configGroupCode.WITHDRAW);
  },
  RECHARGE_systemConfig: function RECHARGE_systemConfig(state) {
    return findSystemConfigItem((state.app.systemConfig['value_' + state.i18n.locale] || {}).data || [], configGroupCode.RECHARGE);
  }
};

/***/ }),

/***/ "M1Iu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("bwrR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xzd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4246162_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("vkUY");
function injectStyle (ssrContext) {
  __webpack_require__("fNWv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4246162_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MJT1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _SlideItem = __webpack_require__("L4cg");

var _SlideItem2 = _interopRequireDefault(_SlideItem);

var _betterScroll = __webpack_require__("GQaK");

var _betterScroll2 = _interopRequireDefault(_betterScroll);

var _scroll = __webpack_require__("QMhb");

var _scroll2 = _interopRequireDefault(_scroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_CHANGE = 'change'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var EVENT_SELECT = 'click';
var EVENT_SCROLL_END = 'scroll-end';
var EVENT_SCROLL = 'scroll';

var DIRECTION_H = 'horizontal';
var DIRECTION_V = 'vertical';

var DEFAULT_OPTIONS = {
  momentum: false,
  click: true,
  observeDOM: false,
  bounce: false
};

exports.default = {
  name: 'Slide',
  mixins: [_scroll2.default],
  props: {
    data: {
      type: Array,
      default: function _default() {
        /* istanbul ignore next */
        return [];
      }
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    loop: {
      type: Boolean,
      default: true
    },
    threshold: {
      type: Number,
      default: 0.3
    },
    speed: {
      type: Number,
      default: 400
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 4000
    },
    showDots: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: DIRECTION_H
    },
    // The props allowVertical, stopPropagation could be removed in next minor version.
    allowVertical: {
      type: Boolean,
      default: undefined,
      deprecated: {
        replacedBy: 'options'
      }
    },
    stopPropagation: {
      type: Boolean,
      default: undefined,
      deprecated: {
        replacedBy: 'options'
      }
    },
    refreshResetCurrent: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      dots: 0,
      currentPageIndex: this.initialIndex || 0
    };
  },
  created: function created() {
    var _this = this;

    this._dataWatchers = [];
    var needRefreshProps = ['data', 'loop', 'autoPlay', 'options.eventPassthrough', 'threshold', 'speed', 'allowVertical'];
    needRefreshProps.forEach(function (key) {
      _this._dataWatchers.push(_this.$watch(key, function () {
        // To fix the render bug when add items since loop.
        if (key === 'data') {
          _this._destroy();
        }

        /* istanbul ignore next */
        _this.$nextTick(function () {
          _this.refresh();
        });
      }));
    });
  },

  watch: {
    initialIndex: function initialIndex(newIndex) {
      if (newIndex !== this.currentPageIndex) {
        this.slide && this.slide.goToPage(newIndex);
      }
    }
  },
  methods: {
    clickItem: function clickItem(item, index) {
      /* istanbul ignore next */
      this.$emit(EVENT_SELECT, item, index);
    },
    refresh: function refresh() {
      /* istanbul ignore if */
      if (this.slide === null) {
        return;
      }
      this._destroy();
      clearTimeout(this._timer);

      if (this.slide && this.refreshResetCurrent) {
        this.currentPageIndex = 0;
      }
      this._updateSlideDom();
      if (this.showDots) {
        this._initDots();
      }
      if (this.currentPageIndex >= this.dots.length) {
        this.currentPageIndex = this.dots.length - 1;
      }
      this._initSlide();

      if (this.autoPlay) {
        this._play();
      }
    },
    _destroy: function _destroy() {
      this.slide && this.slide.destroy();
    },
    _refresh: function _refresh() {
      this._updateSlideDom(true);
      this.slide.refresh();
    },
    _updateSlideDom: function _updateSlideDom(isResize) {
      this._setSlideStyle(isResize);
    },
    _setSlideStyle: function _setSlideStyle(isResize) {
      this.children = this.$refs.slideGroup.children;

      var target = this.direction === DIRECTION_H ? 'width' : 'height';
      var allSize = 0;
      var slideSize = this.$refs.slide['client' + (target[0].toUpperCase() + target.slice(1))];
      var len = this.children.length;
      for (var i = 0; i < len; i++) {
        var child = this.children[i];
        child.style[target] = slideSize + 'px';
        allSize += slideSize;
      }
      if (this.loop && !isResize && len > 1) {
        allSize += 2 * slideSize;
      }
      this.$refs.slideGroup.style[target] = allSize + 'px';
    },
    _initSlide: function _initSlide() {
      var _this2 = this;

      var eventPassthrough = this.direction === DIRECTION_H && this.allowVertical ? DIRECTION_V : '';

      var options = (0, _assign2.default)({}, DEFAULT_OPTIONS, {
        scrollX: this.direction === DIRECTION_H,
        scrollY: this.direction === DIRECTION_V,
        eventPassthrough: eventPassthrough,
        snap: {
          loop: this.loop,
          threshold: this.threshold,
          speed: this.speed
        },
        stopPropagation: this.stopPropagation
      }, this.options);

      this.slide = new _betterScroll2.default(this.$refs.slide, options);

      this.slide.on('scrollEnd', this._onScrollEnd);

      this.slide.goToPage(this.currentPageIndex, 0, 0);

      /* dispatch scroll position constantly */
      if (this.options.listenScroll && this.options.probeType === 3) {
        this.slide.on('scroll', this._onScroll);
      }
      var slideEl = this.$refs.slide;
      slideEl.removeEventListener('touchend', this._touchEndEvent, false);
      this._touchEndEvent = function () {
        if (_this2.autoPlay) {
          _this2._play();
        }
      };
      slideEl.addEventListener('touchend', this._touchEndEvent, false);

      this.slide.on('beforeScrollStart', function () {
        if (_this2.autoPlay) {
          clearTimeout(_this2._timer);
        }
      });
    },
    _onScrollEnd: function _onScrollEnd() {
      var _slide$getCurrentPage = this.slide.getCurrentPage(),
          pageX = _slide$getCurrentPage.pageX,
          pageY = _slide$getCurrentPage.pageY;

      var pageIndex = this.direction === DIRECTION_H ? pageX : pageY;
      if (this.currentPageIndex !== pageIndex) {
        this.currentPageIndex = pageIndex;
        this.$emit(EVENT_CHANGE, pageIndex);
      }

      this.$emit(EVENT_SCROLL_END, pageIndex);

      if (this.autoPlay) {
        this._play();
      }
    },
    _onScroll: function _onScroll(pos) {
      this.$emit(EVENT_SCROLL, pos);
    },
    _initDots: function _initDots() {
      this.dots = new Array(this.children.length);
    },
    _play: function _play() {
      var _this3 = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        _this3.slide.next();
      }, this.interval);
    },
    _deactivated: function _deactivated() {
      clearTimeout(this._timer);
      clearTimeout(this._resizeTimer);
      window.removeEventListener('resize', this._resizeHandler);
      var slideEl = this.$refs.slide;
      if (slideEl) {
        slideEl.removeEventListener('touchend', this._touchEndEvent, false);
      }
    },
    _resizeHandler: function _resizeHandler() {
      var _this4 = this;

      /* istanbul ignore if */
      if (!this.slide) {
        return;
      }
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(function () {
        /* istanbul ignore if */
        if (_this4.slide.isInTransition) {
          _this4._onScrollEnd();
        } else {
          if (_this4.autoPlay) {
            _this4._play();
          }
        }
        _this4._refresh();
      }, 60);
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$nextTick(function () {
      _this5.refresh();
    });

    window.addEventListener('resize', this._resizeHandler);
  },
  activated: function activated() {
    /* istanbul ignore next */
    if (this.autoPlay) {
      this._play();
    }
    window.addEventListener('resize', this._resizeHandler);
  },
  deactivated: function deactivated() {
    /* istanbul ignore next */
    this._deactivated();
  },
  destroyed: function destroyed() {
    this._deactivated();
    this._destroy();
    this.slide = null;

    this._dataWatchers.forEach(function (cancalWatcher) {
      cancalWatcher();
    });
    this._dataWatchers = null;
  },

  components: {
    SlideItem: _SlideItem2.default
  }
};

/***/ }),

/***/ "MLsm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mqi+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

exports.generateDictArrListByKey = generateDictArrListByKey;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***
 * 根据传入参数的字典key生成{label: 'xx', value: 'xx'}格式的数组
 * @param dict
 * @param dictKey
 * @returns {*[]|{label: *, value: string, key: number}[]}
 */
function generateDictArrListByKey(dict, dictKey) {
  var excludeKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (!dict || !dictKey || !dict[dictKey]) return [];
  var result = [];
  var keys = excludeKeys.split(',');
  (0, _keys2.default)(dict[dictKey]).forEach(function (key) {
    if (keys.includes(key)) return;

    result.push({
      key: key,
      label: dict[dictKey][key],
      value: key
    });
  });
  return result;
}

/***/ }),

/***/ "MuQJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "MuS8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__("ABCa");

var _index2 = _interopRequireDefault(_index);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Header',
  components: { XHeader: _index2.default },
  props: {
    pageTitle: {
      required: false
    },
    showFilter: {
      required: false,
      type: Boolean,
      default: false
    },
    zIndex: {}
  },
  data: function data() {
    return {};
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    route: function route(state) {
      return state.route;
    },
    isHeaderArea: function isHeaderArea(state) {
      return state.route.meta.isHeaderArea;
    }
  }), {
    leftVisible: function leftVisible() {
      if (this.pageTitle) return true;
      return !this.route.meta.isTabBar;
    },
    title: function title() {
      if (this.pageTitle) return this.pageTitle;
      if (this.route.meta.title) return this.$t(this.route.meta.title);
      return '';
    },
    headerVisible: function headerVisible() {
      if (this.pageTitle) return true;
      return this.isHeaderArea;
    }
  }),
  methods: {}
};

/***/ }),

/***/ "NDc1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.install = undefined;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _Confirm = __webpack_require__("/PDB");

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeOptions($vm, options) {
  var defaults = {};
  for (var i in $vm.$options.props) {
    if (i !== 'value') {
      defaults[i] = $vm.$options.props[i].default;
    }
  }
  var _options = (0, _objectAssign2.default)({}, defaults, options);
  for (var _i in _options) {
    $vm[_i] = _options[_i];
  }
}

var $vm = void 0;

var plugin = {
  install: function install(vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var Confirm = vue.extend(_Confirm2.default);

    if (!$vm) {
      $vm = new Confirm({
        el: document.createElement('div'),
        propsData: {
          title: ''
        }
      });
      document.body.appendChild($vm.$el);
    }

    var confirm = {
      show: function show(options) {
        if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object') {
          mergeOptions($vm, options);
        }
        if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object' && (options.onShow || options.onHide)) {
          options.onShow && options.onShow();
        }
        this.$watcher && this.$watcher();
        this.$watcher = $vm.$watch('showValue', function (val) {
          if (!val && options && options.onHide) {
            options.onHide();
          }
        });

        $vm.$off('on-cancel');
        $vm.$off('on-confirm');

        $vm.$on('on-cancel', function () {
          options && options.onCancel && options.onCancel();
        });
        $vm.$on('on-confirm', function (msg, ev) {
          options && options.onConfirm && options.onConfirm(msg, ev);
        });
        $vm.showValue = true;
      },
      hide: function hide() {
        $vm.showValue = false;
      },
      isVisible: function isVisible() {
        return $vm.showValue;
      }
    };

    // all Vux's plugins are included in this.$vux
    // if (!vue.$vux) {
    //   vue.$vux = {
    //     confirm
    //   }
    // } else {
    //   vue.$vux.confirm = confirm
    // }
    vue.prototype.$confirm = confirm;

    vue.mixin({
      created: function created() {
        this.$vux = vue.$vux;
      }
    });
  }
};

exports.default = plugin;
var install = exports.install = plugin.install;

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _vuexRouterSync = __webpack_require__("9JMe");

var _numberPrecision = __webpack_require__("qy1k");

var _numberPrecision2 = _interopRequireDefault(_numberPrecision);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

__webpack_require__("mWYR");

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _stroage = __webpack_require__("DsOT");

var _nameSpace = __webpack_require__("Eeb1");

var _filters = __webpack_require__("Q0Ca");

var filters = _interopRequireWildcard(_filters);

var _clipboard = __webpack_require__("qorP");

var _clipboard2 = _interopRequireDefault(_clipboard);

var _config = __webpack_require__("2uFj");

var _config2 = _interopRequireDefault(_config);

var _color = __webpack_require__("GTMH");

var _color2 = _interopRequireDefault(_color);

var _Confirm = __webpack_require__("NDc1");

var _Confirm2 = _interopRequireDefault(_Confirm);

__webpack_require__("UoMW");

__webpack_require__("TagB");

__webpack_require__("KkZG");

__webpack_require__("P1I3");

var _index = __webpack_require__("oVYx");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("L0gA");

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__("bSmc");

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__("M10M");

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__("8wRb");

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__("NXWw");

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__("63CM");

var _index14 = _interopRequireDefault(_index13);

__webpack_require__("cdCv");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

__webpack_require__("hKoQ").polyfill();

_vue2.default.prototype.$NP = _numberPrecision2.default;

_numberPrecision2.default.enableBoundaryChecking(false);

_vue2.default.use(_index6.default, {
  $layout: 'VIEW_BOX'
});
_vue2.default.use(_Confirm2.default);

(0, _keys2.default)(filters).forEach(function (key) {
  _vue2.default.filter(key, filters[key]);
});

_vue2.default.use(_index8.default);
_vue2.default.use(_index2.default);
_vue2.default.use(_index12.default);

_vue2.default.directive('TransferDom', _index14.default);
_vue2.default.directive('Color', _color2.default);

if (Object({"NODE_ENV":"production","VUE_APP_LOGO":"../../statics/images/fxmt/","VUE_APP_NAME":"FXMT","SYMBOL":"","DEFAULT_LANGUAGE":"kr","FAVICON_PATH":"static/images/icon/fxmt/favicon.ico","VUE_APP_LINES_URL":"https://qilinotc.oss-ap-southeast-1.aliyuncs.com/circuit-folder/240513153713995.json","VUE_APP_DEFAULT_TYPE":0,"VUE_APP_BRANCH_CODE_ENABLED":false,"EXCLUDE_VC_TYPE":"1,2,3,4"}).platform === 'app') {
  _vue2.default.use(_index10.default, _store2.default);
}

_vue2.default.use(_index4.default, _router2.default);

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

_router2.default.beforeEach(function (to, from, next) {
  if (/\/http/.test(to.path)) {
    var url = to.path.split('http')[1];
    window.location.href = 'http' + url;
  } else {
    if (_router.redirectList.find(function (item) {
      return to.path === item;
    })) {
      next();
    } else {
      if ((0, _stroage.getStorage)(_nameSpace.__TOKEN__) && _store2.default.state.user.token) {
        return next();
      } else {

        return next('/login');
      }
    }
  }
});

_vue2.default.prototype.$loading = {
  visible: _store2.default.state.vux.loading.visible,
  show: function show(txt) {
    _store2.default.commit('updateLoadingStatus', { isLoading: true, loadingTxt: txt });
  },
  hide: function hide(txt) {
    if (txt) {
      setTimeout(function () {
        _store2.default.commit('updateLoadingStatus', { isLoading: false, loadingTxt: txt });
      }, 2000);
    } else {
      _store2.default.commit('updateLoadingStatus', { isLoading: false });
    }
  }
};

_vue2.default.prototype.$copy = function (val, evt) {
  if (!val) return;
  (0, _clipboard2.default)(val, evt);
};

_vue2.default.prototype.$config = _config2.default;

document.title = "FXMT";

exports.default = new _vue2.default({
  store: _store2.default,
  router: _router2.default,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ "NQ/5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O17w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menus-container"},[_c('div',{staticClass:"menus-content"},[_c('div',{staticClass:"menu-item"},[_c('div',{staticClass:"menu-content",on:{"click":function($event){return _vm.$store.dispatch('showCustomerService')}}},[_c('i',{staticClass:"iconfont icon-custom"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.customer')))])])]),_vm._v(" "),_c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.$router.push('/help')}}},[_c('div',{staticClass:"menu-content"},[_c('i',{staticClass:"iconfont icon-help"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.helpCenter')))])])]),_vm._v(" "),_c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.$store.dispatch('showLocalePop')}}},[_c('div',{staticClass:"menu-content"},[_c('i',{staticClass:"iconfont icon-language"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.toggleLocale')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P/YF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lang-kr.ded0a48.png";

/***/ }),

/***/ "P0Uk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"currencies-container"},[_c('div',{staticClass:"title txt-color"},[_c('div',{staticClass:"left"},[_c('i',{staticClass:"iconfont icon-coin home-icon-color"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('home.hotCoin.title')))])]),_vm._v(" "),_c('div',{staticClass:"more",on:{"click":function($event){return _vm.$router.push('/currency')}}},[_vm._v("\n      "+_vm._s(_vm.$t('home.hotCoin.more'))+"\n    ")])]),_vm._v(" "),(_vm.hotCoinList.length)?_c('ul',{staticClass:"currencies-content"},_vm._l((_vm.hotCoinList),function(currency){return _c('li',{key:currency.id,on:{"click":function($event){return _vm.clickVcItem(currency)}}},[_c('div',{staticClass:"currency"},[_c('div',{staticClass:"currency-name"},[_c('b',{staticClass:"txt-color"},[_vm._v(_vm._s(currency.c))])])]),_vm._v(" "),_c('div',{directives:[{name:"color",rawName:"v-color",value:(currency.l),expression:"currency.l"}],staticClass:"price-usdt"},[_vm._v(_vm._s(currency.g))]),_vm._v(" "),_c('div',{directives:[{name:"color",rawName:"v-color",value:(currency.l),expression:"currency.l"}],staticClass:"price-change"},[_vm._v(_vm._s(currency['changePer'] >= 0 ? "+" : '')+_vm._s(currency['changePerStr'] || '0%'))])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P1I3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pfph":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '/auth';

/***/ }),

/***/ "Pm4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue__ = __webpack_require__("avVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue__ = __webpack_require__("xjY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db3cd30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Menus_vue__ = __webpack_require__("O17w");
function injectStyle (ssrContext) {
  __webpack_require__("awgN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0db3cd30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Menus_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db3cd30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Menus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PyGi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toThousandFilterWithScale = toThousandFilterWithScale;
exports.toThousandFilterVc = toThousandFilterVc;
exports.toThousandFilterVcBalance = toThousandFilterVcBalance;
exports.formatVCAmountZh = formatVCAmountZh;
exports.formatVCAmountEn = formatVCAmountEn;
exports.getFullNum = getFullNum;

var _utils = __webpack_require__("oAV5");

var _numberPrecision = __webpack_require__("qy1k");

var _numberPrecision2 = _interopRequireDefault(_numberPrecision);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 将数字转为科学计数(可传入参数截取几位小数[是截取不是四舍五入])
 * @param num
 * @param scale
 * @returns {string|*}
 */
function toThousandFilterWithScale(num) {
  var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (!+num) return num;
  var scaleNum = (0, _utils.setMaxScale)(num, scale, true);
  return scaleNum.toString().replace(/^-?\d+/g, function (m) {
    return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
  });
}

/**
 * 将虚拟币金额转为带8为小数
 * @param num
 * @returns {string|*}
 */
function toThousandFilterVc(num) {
  // return toThousandFilterWithScale(num, 8)
  // return setMaxScale(num, 8, false)
  if (!+num) return num;
  return num.toString().replace(/^-?\d+/g, function (m) {
    return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
  });
  // return num
}
/**
 * 将虚拟币金额转为带20为小数
 * @param num
 * @returns {string|*}
 */
function toThousandFilterVcBalance(num) {
  return (0, _utils.setMaxScale)(num, 10, false);
  // return num
}

/**
 * 简化金额显示排序(中文)
 * @param num
 * @returns {string|*}
 */
function formatVCAmountZh(num) {
  if (num < 0) {
    return '0';
  } else if (num > 0 && num <= 10000) {
    return toThousandFilterWithScale(_numberPrecision2.default.divide(num, 1000)) + '仟';
  } else if (num > 10000 && num <= 10000000) {
    return toThousandFilterWithScale(_numberPrecision2.default.divide(num, 10000)) + '万';
  } else if (num > 10000000 && num <= 1000000000000) {
    return toThousandFilterWithScale(_numberPrecision2.default.divide(num, 100000000)) + '亿';
  } else if (num > 1000000000000 && num <= 1000000000000000) {
    return toThousandFilterWithScale(_numberPrecision2.default.divide(num, 1000000000000)) + '万亿';
  }
}

/**
 * 简化金额显示排序(英文)
 * @param num
 * @param digits
 * @returns {string|*}
 */
function formatVCAmountEn(num, digits) {
  var si = [{ value: 1, symbol: '' }, { value: 1E3, symbol: 'K' }, { value: 1E6, symbol: 'M' }, { value: 1E9, symbol: 'G' }, { value: 1E12, symbol: 'T' }, { value: 1E15, symbol: 'P' }, { value: 1E18, symbol: 'E' }];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i = void 0;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
}

/***
 * 将科学计数法转换成常规数字
 * @param num
 * @returns {string|*}
 */
function getFullNum(num) {
  // 处理非数字
  if (isNaN(num)) {
    return num;
  };

  // 处理不需要转换的数字
  var str = '' + num;
  if (!/e/i.test(str)) {
    return num;
  };

  return num.toFixed(18).replace(/\.?0+$/, '');
}

/* export function transferToNumber (inputNumber) {
  if (isNaN(inputNumber)) {
    return inputNumber
  }
  inputNumber = '' + inputNumber
  inputNumber = parseFloat(inputNumber)
  let eFormat = inputNumber.toExponential() // 转换为标准的科学计数法形式（字符串）
  let tmpArray = eFormat.match(/\d(?:\.(\d*))?e([+-]\d+)/) // 分离出小数值和指数值
  return inputNumber.toFixed(Math.max(0, (tmpArray[1] || '').length - tmpArray[2]))
} */

/***/ }),

/***/ "QMhb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    // the options of BetterScroll
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};

/***/ }),

/***/ "QzIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue__ = __webpack_require__("yB64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue__ = __webpack_require__("2pWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d0dde5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_HomeHeader_vue__ = __webpack_require__("wP7n");
function injectStyle (ssrContext) {
  __webpack_require__("WFf0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61d0dde5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d0dde5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_HomeHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "R0Cy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinch-container"},[(_vm.clinchCoinList.length)?_c('ul',{staticClass:"clinch-t-body"},_vm._l((_vm.clinchCoinList),function(currency){return _c('li',{on:{"click":function($event){return _vm.clickVcItem(currency)}}},[_c('div',{staticClass:"currency-type"},[_c('span',{staticClass:"type txt-color"},[_vm._v(_vm._s(currency.c))])]),_vm._v(" "),_c('div',{staticClass:"price txt-color"},[_c('span',[_vm._v(_vm._s(_vm._f("getFullNum")(currency.g)))])]),_vm._v(" "),_c('div',{staticClass:"volume"},[(_vm.locale === 'zh-CN')?_c('span',[_vm._v(_vm._s(_vm._f("formatVCAmountZh")(currency.j)))]):_c('span',[_vm._v(_vm._s(_vm._f("formatVCAmountEn")(currency.j)))])])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RJTy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
};

/***/ }),

/***/ "ST6S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _Tab = __webpack_require__("HsJn");

var _Slide = __webpack_require__("vJdA");

var _Slide2 = _interopRequireDefault(_Slide);

var _SlideItem = __webpack_require__("L4cg");

var _SlideItem2 = _interopRequireDefault(_SlideItem);

var _Increase = __webpack_require__("1Fm+");

var _Increase2 = _interopRequireDefault(_Increase);

var _Clinch = __webpack_require__("mgPS");

var _Clinch2 = _interopRequireDefault(_Clinch);

var _Coins = __webpack_require__("2BuD");

var _Coins2 = _interopRequireDefault(_Coins);

var _dict = __webpack_require__("Mqi+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Ranking',
  components: { Tab: _Tab.Tab, TabItem: _Tab.TabItem, Slide: _Slide2.default, SlideItem: _SlideItem2.default, Increase: _Increase2.default, Clinch: _Clinch2.default, Coins: _Coins2.default },
  data: function data() {
    return {
      tabs: [{ label: 'home.ranking.increase.title', component: 'Increase', key: 0, value: 0 }, { label: 'home.ranking.clinch.title', component: 'Clinch', key: 1, value: 1 }],
      currentTab: '1',
      currentTabIndex: 0,
      slideOptions: {
        listenScroll: true,
        probeType: 3,
        directionLockThreshold: 0,
        eventPassthrough: 'vertical'
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['dict', 'locale']), {
    vcTypeOptions: function vcTypeOptions() {
      var excludeKeys = "1,2,3,4";
      return (0, _dict.generateDictArrListByKey)(this.dict, 'VcTypeEnum', excludeKeys).map(function (item) {
        return (0, _extends3.default)({}, item, { component: 'Coins' });
      });
    }
  }),
  watch: {
    locale: function locale() {
      this.$nextTick(function () {
        // this.$refs['slide'].refresh()
      });
    }
  },
  methods: {
    clickTabItem: function clickTabItem(tabItem) {
      this.currentTab = tabItem.value;
      this.currentTabIndex = this.vcTypeOptions.findIndex(function (item) {
        return item.value === tabItem.value;
      });
    },
    slideOnChange: function slideOnChange(current) {
      this.currentTab = this.vcTypeOptions[current].value;
    }
  }
};

/***/ }),

/***/ "Sx3z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TCOM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__("0FxO");

exports.default = {
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && (0, _router.go)(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "TEkW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-container content-bg",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("icon",function(){return [_c('i',{staticClass:"iconfont icon-help cell-icon"})]}),_vm._v(" "),_c('div',{staticClass:"cell-content"},[_c('span',{staticClass:"label txt-color"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("value",function(){return [(_vm.value)?_c('span',{staticClass:"value cell-value-color"},[_vm._v(_vm._s(_vm.value))]):_vm._e()]})],2),_vm._v(" "),(_vm.isLink)?_c('i',{staticClass:"iconfont icon-arrow-right link"}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TagB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueToasted = __webpack_require__("IZMb");

var _vueToasted2 = _interopRequireDefault(_vueToasted);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var options = {
  icon: 'iconfont icon-status-success status',
  iconPack: 'custom-class',
  className: 'custom-toast',
  position: 'top-center',
  duration: 3 * 1000,
  fullWidth: true,
  theme: 'outline',
  action: {
    icon: 'iconfont icon-close action',
    // text: '关闭',
    onClick: function onClick(e, toastObject) {
      toastObject.goAway(0);
    }
  }
};

_vue2.default.use(_vueToasted2.default, options);

_vue2.default.prototype.$message = {
  success: function success(msg) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _vue2.default.toasted.show(msg, (0, _extends3.default)({
      type: 'success'
    }, opts, {
      action: opts.notClose ? null : (0, _extends3.default)({}, options.action, {
        icon: 'iconfont icon-close action success'
      })
    }));
  },
  error: function error(msg) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _vue2.default.toasted.show(msg, (0, _extends3.default)({
      type: 'error',
      icon: 'iconfont icon-error status'
    }, opts, {
      action: opts.notClose ? null : (0, _extends3.default)({}, options.action, {
        icon: 'iconfont icon-close action error'
      })
    }));
  },
  info: function info(msg) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _vue2.default.toasted.show(msg, (0, _extends3.default)({
      type: 'info',
      icon: 'iconfont icon-warning status'
    }, opts, {
      action: opts.notClose ? null : (0, _extends3.default)({}, options.action, {
        icon: 'iconfont icon-close action warning'
      })
    }));
  }
};

exports.default = _vue2.default.prototype.$message;

/***/ }),

/***/ "Tqs5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _popup = __webpack_require__("+v63");

var _popup2 = _interopRequireDefault(_popup);

var _dom = __webpack_require__("te2A");

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new _popup2.default({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && (0, _keys2.default)(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && _dom2.default.removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && _dom2.default.addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
};

/***/ }),

/***/ "TuU3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CACHE_KEYS_MAP = exports.CACHE_INFO_KEYS = undefined;

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _CACHE_KEYS_MAP;

exports.isNeedUpdateCacheInfo = isNeedUpdateCacheInfo;
exports.initStateInCacheHas = initStateInCacheHas;
exports.checkCacheVersionIsRight = checkCacheVersionIsRight;
exports.cacheObjByKey = cacheObjByKey;
exports.findTargetUpdateTimeByKey = findTargetUpdateTimeByKey;
exports.cacheHandler = cacheHandler;
exports.checkCacheVersionWithoutLocaleIsRight = checkCacheVersionWithoutLocaleIsRight;

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _stroage = __webpack_require__("DsOT");

var _nameSpace = __webpack_require__("Eeb1");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***
 * 缓存信息Key
 * @type {{SYS_CONFIG: string}}
 */
var CACHE_INFO_KEYS = exports.CACHE_INFO_KEYS = {
  SYS_CONFIG: 'SYS_CONFIG',
  SYS_NOTICE: 'SYS_NOTICE',
  VC_TIMING_TRADE_CONFIG: 'VC_TIMING_TRADE_CONFIG',
  BANKS: 'BANK',
  VC: 'VC',
  SYS_BANNER: 'SYS_BANNER',
  I18N_LANGUAGE: 'I18N_LANGUAGE'

  /***
   * 可缓存对象key与缓存信息对象映射Key
   * @type {{}}
   */
};var CACHE_KEYS_MAP = exports.CACHE_KEYS_MAP = (_CACHE_KEYS_MAP = {}, (0, _defineProperty3.default)(_CACHE_KEYS_MAP, _nameSpace.__DICT__, CACHE_INFO_KEYS.SYS_CONFIG), (0, _defineProperty3.default)(_CACHE_KEYS_MAP, _nameSpace.__SYSTEM_CONFIG__, CACHE_INFO_KEYS.SYS_CONFIG), (0, _defineProperty3.default)(_CACHE_KEYS_MAP, _nameSpace.__SYSTEM_NOTICE__, CACHE_INFO_KEYS.SYS_NOTICE), (0, _defineProperty3.default)(_CACHE_KEYS_MAP, _nameSpace.__BANK__, CACHE_INFO_KEYS.BANKS), (0, _defineProperty3.default)(_CACHE_KEYS_MAP, _nameSpace.__VC_LIST__, CACHE_INFO_KEYS.VC), (0, _defineProperty3.default)(_CACHE_KEYS_MAP, _nameSpace.__TRADE_CONFIG__, CACHE_INFO_KEYS.VC_TIMING_TRADE_CONFIG), (0, _defineProperty3.default)(_CACHE_KEYS_MAP, _nameSpace.__BANNER__, CACHE_INFO_KEYS.SYS_BANNER), (0, _defineProperty3.default)(_CACHE_KEYS_MAP, _nameSpace.__LOCALE_LIST__, CACHE_INFO_KEYS.I18N_LANGUAGE), _CACHE_KEYS_MAP);

/***
 * 默认激活刷新的缓存Key列表
 * @type {string[]}
 */
var ALWAYS_ACTIVE_CACHES = [CACHE_INFO_KEYS.SYS_CONFIG];

/***
 * 缓存Key对应的state中的action名映射
 * @type {{}}
 */
var DISPATCH_NAME_IN_CACHE_KEY = (0, _defineProperty3.default)({}, CACHE_INFO_KEYS.SYS_CONFIG, 'getSysConfigDict');

/***
 * 检测是否需要同步cache到store
 * @param cacheInfoRes
 * @returns {boolean}
 */
function isNeedUpdateCacheInfo(cacheInfoRes) {
  var cacheInfo = _store2.default.state.app.cacheInfo;

  if (!cacheInfo || cacheInfoRes.length !== cacheInfo.length) return true;
  return !!cacheInfoRes.find(function (cacheResItem) {
    return cacheInfo.find(function (cacheInfoItem) {
      return cacheInfoItem.type === cacheResItem.type && cacheInfoItem.finishUpdateTime !== cacheResItem.finishUpdateTime;
    });
  });
}

/** *
 * 初始化可缓存对象的初始值
 * @param cacheKey
 * @returns {undefined|any|{finishUpdateTime: string, cacheKey: *, cacheInfoKey: (*|string), value: boolean}}
 */
function initStateInCacheHas(cacheKey) {
  return (0, _stroage.getStorage)(cacheKey) || {
    cacheKey: cacheKey,
    cacheInfoKey: CACHE_KEYS_MAP[cacheKey] || ''
  };
}

/** *
 * 检查state中对象的版本信息是否正确
 * @param stateObj
 * @returns {boolean}
 */
function checkCacheVersionIsRight(stateObj) {
  if (!stateObj || !stateObj['value_' + _store2.default.getters.locale]) return false;
  var cacheUpdateTime = stateObj['value_' + _store2.default.getters.locale].finishUpdateTime;
  return !!_store2.default.state.app.cacheInfo.find(function (cacheItem) {
    return cacheItem.type === stateObj.cacheInfoKey && cacheItem.finishUpdateTime === cacheUpdateTime;
  });
}

/***
 * 缓存支持缓存版本号的内容
 * @param key
 * @param value
 */
function cacheObjByKey(key, value) {
  if (!key || !value || !CACHE_KEYS_MAP[key]) return;
  var cacheVersion = findTargetUpdateTimeByKey(key);
  var currentCacheInfo = initStateInCacheHas(key);
  var valueKey = 'value_' + _store2.default.getters.locale;
  var cacheTargetInfo = (0, _extends4.default)({}, currentCacheInfo, (0, _defineProperty3.default)({
    cacheKey: key,
    cacheInfoKey: CACHE_KEYS_MAP[key] || '',
    finishUpdateTime: cacheVersion
  }, valueKey, {
    data: value,
    finishUpdateTime: cacheVersion
  }));
  (0, _stroage.setStorage)(key, cacheTargetInfo);
  return cacheTargetInfo;
}

/***
 * 根据缓存对象Key查找对应的版本更新时间
 * @param cacheKey
 * @returns {string}
 */
function findTargetUpdateTimeByKey(cacheKey) {
  return (_store2.default.state.app.cacheInfo.find(function (item) {
    return item.type === CACHE_KEYS_MAP[cacheKey];
  }) || { finishUpdateTime: false }).finishUpdateTime;
}

/***
 * 缓存信息的处理函数
 * @param cacheRes
 * @returns {Array|*}
 */
function cacheHandler(cacheRes) {
  if (!cacheRes || !cacheRes.length) return [];
  var cacheInfo = _store2.default.state.app.cacheInfo;

  if (cacheInfo && cacheInfo.length) {
    return cacheRes.map(function (currentCacheItem) {
      var findTargetCacheInfo = cacheInfo.find(function (targetCacheItem) {
        if (currentCacheItem.type === targetCacheItem.type) {
          if (currentCacheItem.finishUpdateTime !== targetCacheItem.finishUpdateTime) {
            // 注册全局监听
            if (targetCacheItem.type === CACHE_INFO_KEYS.SYS_CONFIG) {
              DISPATCH_NAME_IN_CACHE_KEY[targetCacheItem.type] && _store2.default.dispatch(DISPATCH_NAME_IN_CACHE_KEY[targetCacheItem.type], { noCache: true });
            }
          }
          return true;
        }
      }) || currentCacheItem;
      return (0, _extends4.default)({}, findTargetCacheInfo, {
        finishUpdateTime: currentCacheItem.finishUpdateTime,
        isActive: findTargetCacheInfo.isActive || false
      });
    });
  } else {
    return cacheRes.map(function (item) {
      return (0, _extends4.default)({}, item, {
        isActive: !!ALWAYS_ACTIVE_CACHES.find(function (activeKey) {
          return activeKey === item.type;
        })
      });
    });
  }
}

/** *
 * 检查state中对象的版本信息是否正确(未携带语言区分)
 * @param stateObj
 * @returns {boolean}
 */
function checkCacheVersionWithoutLocaleIsRight(stateObj) {
  if (!stateObj || !stateObj.value) return false;
  var cacheUpdateTime = stateObj.finishUpdateTime;
  console.log(stateObj);
  return !!_store2.default.state.app.cacheInfo.find(function (cacheItem) {
    return cacheItem.type === stateObj.cacheInfoKey && cacheItem.finishUpdateTime === cacheUpdateTime;
  });
}

/***/ }),

/***/ "TxuI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/***
 * JsEncrypt解密私钥
 * @type {string}
 */
var serverRSAPrivateKey = exports.serverRSAPrivateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAK5m+QLjKYdRKMDRRELNbGDg1V57x6G/YzSzJqYroR/4fuTcZBQlTI4IEA2e5gmGKTE8BunmYYXuiLQ0tlZQ6qxiGOlABUy+2/xmSTrGA0OcAkiX9q5r+3TgxmnCD7MVEu8FXuOIt88yfI+ugYd1Adkcx6el1FfyjcKGx2RaJcUHAgMBAAECgYBKEID/sOkaBmWAPV7337V/DvyOO5L0JgtDfjGTsEOlCCsbll0KES0JxHLM1gZrVQZ5Wjy1aJlR/5MetKQa1BJUnv8UXxg12wQTCMrDb5stIEe+qrAg/44SoPNpdVWDaQ9GTA3fyMjCaxLpsqrd8KAE+deufrCHlvLWFhBov7UpAQJBAON61xJP/3bdm0Tf2Dv37f8nXyOpRtr2Lf4SsQ1LpP/DFl1FBTftYE6c+1j78vquiQqcE1DWC9B+gAq9ZmfFS9ECQQDERI+68rMEyxvqnI+NEvGUa/TWZsHbfxzN5UuS2lgfS2/qXLinGadw9YmKF7aD6QFkZQuzaTs2pBMWgaastjFXAkEA4z9OJ48fR+GuQSnVXGMbsK/mTTvH+um/nHeTxBJzbMW5S8etpOdQNHiCZ6yaWW+Om7i7Wx/ZgZk91HzNFpF0YQJAU0QzJkEpKfNxmItra5KJ40oZyYw22oSHF+MbuOXhVQWQKYHE5T/BBe9ltqxwxm3oJUupNyiB8qCRaI8Aw21YaQJAFkksbFwCRcfVQHIq7vcPk7S6SkY8izC9bD+hfw2ce0kJJtbryPTyVGNXL9FaG9pKqiYDkyXuzR2bYJwDjyb+ng==';

/***/ }),

/***/ "UNGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("CMqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("d6cP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_3077eb4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("VWG3");
function injectStyle (ssrContext) {
  __webpack_require__("jaVk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_3077eb4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UjVw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _systemConfig = __webpack_require__("LgDY");

var _systemConfig2 = _interopRequireDefault(_systemConfig);

var _config = __webpack_require__("2uFj");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _systemConfig2.default, {
  token: function token(state) {
    return state.user.token;
  },
  dict: function dict(state) {
    var dictObj = (state.app.dict['value_' + state.i18n.locale] || {}).data || {};
    if (_config2.default.platform === 'RIVER') {
      return (0, _extends3.default)({}, dictObj, {
        TradeOrderDirectionEnum: (0, _extends3.default)({}, dictObj.TradeOrderDirectionEnum, {
          '1': 'More',
          '2': 'Short'
        })
      });
    } else {
      return dictObj;
    }
  },
  vcList: function vcList(state) {
    return (state.vc.vcList['value_' + state.i18n.locale] || {}).data || [];
  },
  vcListNoSettleEnabled: function vcListNoSettleEnabled(state, getters) {
    return getters.vcList.filter(function (item) {
      return !item['settleVc'] && item.enabled;
    });
  },
  vcListEnabled: function vcListEnabled(state, getters) {
    return getters.vcList.filter(function (item) {
      return item.enabled;
    });
  },
  cacheInfo: function cacheInfo(state) {
    return state.app.cacheInfo || {};
  },
  locale: function locale(state) {
    return state.i18n.locale;
  },
  vcId: function vcId(state) {
    return state.vc.vcId;
  },
  currentLocale: function currentLocale(state) {
    return state.app.currentLocale;
  },
  tradeConfig: function tradeConfig(state) {
    return (state.vc.tradeConfig['value_' + state.i18n.locale] || {}).data || [];
  },
  localeList: function localeList(state) {
    return state.app.localeList.value;
  }
});

/***/ }),

/***/ "UoMW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***
 * rem适配
 */
function remAdaptation() {
  var htmlNode = document.documentElement;
  htmlNode.style.fontSize = document.documentElement.clientWidth / 23.4375 + 'px';
}

window.addEventListener('resize', remAdaptation);

remAdaptation();

/***/ }),

/***/ "V+au":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "V2D1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Currencies',
  props: {},
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['vcListNoSettleEnabled']), (0, _vuex.mapState)({
    coinListWithPrice: function coinListWithPrice(state) {
      return state.vc.coinListWithPrice;
    }
  }), {
    hotCoinList: function hotCoinList() {
      var _this = this;

      if (!this.coinListWithPrice.length) return [];
      return this.vcListNoSettleEnabled.map(function (settleItem) {
        return _this.coinListWithPrice.find(function (coinWithPriceItem) {
          return settleItem.id === coinWithPriceItem.a;
        });
      }).filter(function (item) {
        return !!item;
      });
    }
  }),
  methods: {
    clickVcItem: function clickVcItem(currency) {
      var _this2 = this;

      this.$store.dispatch('setVcId', currency.a).then(function () {
        _this2.$router.push('/trade');
      }).catch(function (err) {
        _this2.$message.error(err.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "VWG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",function(){return [_c('div',[_vm._t("title",function(){return [_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VY92":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vp4h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: 'Giriş',
    usernameLabel: 'Kullanıcı adı',
    usernamePlaceholder: '2-10 İngilizce rakam',
    loginPasswordLabel: 'Giriş şifresi',
    loginPasswordPlaceholder: 'Lütfen giriş şifrenizi giriniz',
    googleCodeLabel: 'Google doğrulama kodu',
    googleCodePlaceholder: 'Lütfen 6 basamaklı bir Google doğrulama kodu girin',
    hasNoAccount: 'Henüz hesap yok',
    goRegister: 'Kaydolmak için gidin',
    onlineCustom: 'Çevrimiçi müşteri hizmetleri',
    loginArgument: 'Giriş yapmaya devam etmek, kabul etmek anlamına gelir',
    userArgument: '《Kullanıcı Sözleşmesi》',
    registerNotEnabled: 'Kayıt fonksiyonu açık değil, lütfen yönetici ile iletişime geçin',
    usernameRequired: 'Lütfen doğru bir kullanıcı adı giriniz',
    loginPasswordRequired: 'Lütfen doğru giriş şifresini giriniz',
    googleCodeRequired: 'Lütfen doğru Google doğrulama kodunu girin',
    loginButton: 'giriş yap'
  },
  register: {
    title: 'Kaydol',
    usernameLabel: 'Kullanıcı adı',
    usernamePlaceholder: 'Lütfen kayıtlı kullanıcı adını girin',
    loginPasswordLabel: 'Giriş şifresi',
    loginPasswordPlaceholder: 'Lütfen kayıtlı kullanıcının oturum açma şifresini girin',
    loginPasswordPreLabel: 'Giriş şifresini onaylayın',
    loginPasswordPrePlaceholder: 'Lütfen giriş şifresini tekrar girin',
    fudPasswordLabel: 'Fon şifresi',
    fudPasswordPlaceholder: 'Lütfen fon şifresini giriniz',
    inviteCodeLabel: 'Davetiye Kodu',
    inviteCodePlaceholder: 'Lütfen 6 haneli bir davet kodu giriniz',
    registerNeed: 'Kayıt olmaya devam etmek, kabul etmek anlamına gelir',
    registerArgument: '《Kayıt Sözleşmesi》',
    usernameRequired: 'Lütfen doğru bir kullanıcı adı giriniz',
    loginPasswordRequired: 'Lütfen doğru giriş şifresini giriniz',
    loginPasswordPreRequired: 'Lütfen doğru onay giriş şifresini girin',
    fundPasswordRequired: 'Lütfen doğru fon şifresini giriniz',
    inviteCodeRequired: 'Lütfen doğru davet kodunu giriniz',
    diffLoginPasswordError: 'İki giriş şifresi tutarsız',
    registerSuccess: 'Başarılı kayıt',
    registerButton: 'Kaydol',
    emailLabel: 'E-posta',
    emailPlaceholder: 'Lütfen e-posta adresinizi giriniz',
    emailCodeLabel: 'Doğrulama kodu',
    emailCodePlaceholder: 'Lütfen e-posta doğrulama kodunuzu girin',
    second: 'ikinci',
    getEmailCodeButton: 'Kodu al',
    emailRequired: 'Lütfen doğru bir e-posta adresi girin ve tekrar deneyin',
    emailCodeRequired: 'Lütfen doğru e-posta doğrulama kodunu girin ve tekrar deneyin'
  },
  home: {
    hotCoin: {
      title: 'Tawaran hebat',
      more: 'fazla'
    },
    poster: {
      title: 'Hızlı para yatırma',
      enter: 'Şimdi Girin >',
      subTitle: 'BTC, USDT, ETH vb.\'yi destekleyin'
    },
    quickMenus: {
      futuresTrading: 'Vadeli İşlemler',
      helpCenter: 'Yardım Merkezi'
    },
    ranking: {
      increase: {
        title: 'Yükselen liste'
      },
      clinch: {
        title: 'Ciro Listesi'
      }
    }
  },
  tabBar: {
    home: 'ev',
    price: 'Pazar',
    trade: 'Ticaret',
    fund: 'Varlık',
    user: 'profili'
  },
  currency: {
    favorite: 'İsteğe bağlı',
    allCurrency: 'Nokta',
    dayVol: '24H',
    addFavor: '+ İyilik Ekle'
  },
  trade: {
    bills: 'Faturalar',
    todayOpen: 'Açık',
    star: 'Yıldız',
    vol: 'Hacim',
    low: 'En düşük',
    high: 'En yüksek',
    timing: 'hızlı',
    spot: 'vadeli işlemler',
    buyMore: 'Daha Fazla Satın Al',
    buyEmpty: 'Boş Satın Al',
    indicator: 'Gösterge',
    indicatorSettings: 'Gösterge Ayarları',
    balance: 'Bakiyem',
    fee: 'Hizmet ücreti',
    ruleIdError: 'Lütfen bir süre sonu seçin',
    deleteFavoriteSuccess: 'Favori para birimini başarıyla sil',
    addFavoriteSuccess: 'Favori para birimi başarıyla eklendi',
    buyIn: 'satın al',
    sellOut: 'Sat',
    holding: 'tutma pozisyonu',
    history: 'Geçmiş',
    spotOrderConfirm: {
      title: 'Satın Almayı Onayla',
      amountPlaceholder: 'Lütfen satın alma miktarını girin'
    },
    spotTradeOrder: {
      holding: {
        coin: 'para birimi',
        buyInAmountPrice: 'Alış Miktarı/Fiyatı',
        buyInCount: 'Miktar',
        actions: 'İşlem',
        sellOut: 'Sat',
        profit: '盈亏'
      }
    },
    orderConfirm: {
      title: 'Sipariş Onayı',
      coinName: 'Para',
      direction: 'Yön',
      price: 'Fiyat',
      balance: 'Bakiye',
      fee: 'Hizmet Bedeli',
      buyMoreLabel: 'Daha Fazla Satın Al',
      buyEmptyLabel: 'Boş Satın Al',
      buyQuantity: 'Miktar satın al',
      buyAmount: 'Satın Alma Tutarı',
      submit: 'Siparişi onayla'
    },
    kline: {
      open: 'Aç:',
      close: 'Kapat:',
      change: 'Değiştir:'
    }
  },
  finance: {
    title: 'Finans'
  },
  allFinance: {
    title: 'Finansal yönetim',
    all: 'hepsi'
  },
  financeOrders: {
    title: 'Taahhüt emri',
    holdingLabel: 'tutma',
    historyLabel: 'Geçmiş',
    holding: {
      amount: 'Taahhüt tutarı',
      rateStr: 'gelir miktarı/verim',
      vcCount: 'Rehin verilen coin sayısı',
      cycle: 'Konum döngüsü',
      day: 'gün',
      calcStartDate: 'Başlangıç ​​değeri tarihi',
      serviceAmount: 'Hizmet Ücreti',
      redeemOrder: 'Kullan'
    },
    history: {
      incomeAmount: 'gelir miktarı',
      rateStr: 'verim',
      amount: 'Taahhüt tutarı',
      vcCount: 'Rehin verilen coin sayısı',
      calcStartDate: 'Başlangıç ​​değeri tarihi',
      calcEndDate: 'Bitiş Tarihi',
      cycle: 'döngü günleri',
      serviceAmount: 'Hizmet Ücreti',
      day: 'gün'
    }
  },
  financeOrderBills: {
    title: 'Rehin gelir faturası',
    amount: 'miktar',
    balance: 'Denge'
  },
  financeItem: {
    rateStr: 'verim',
    buyType: 'Satın Alma Türü',
    cycle: 'döngü günleri',
    exchangeRate: 'Döviz kuru (sanal döviz kuru bakiyesi)',
    day: 'gün',
    cycleType: 'döngü türü',
    serviceRateStr: 'Hizmet Ücreti'
  },
  buyFinance: {
    title: 'Satın al',
    rateStr: 'verim',
    name: 'İsim',
    buyType: 'Satın Alma Türü',
    cycle: 'döngü günleri',
    cycleType: 'döngü türü',
    exchangeRate: 'Döviz kuru (sanal döviz kuru bakiyesi)',
    serviceRateStr: 'Hizmet Oranı',
    remark: 'yorum',
    buyAmountLabel: 'Satın Alma Miktarı ({coin})',
    descriptionTitle: 'Ürün Açıklaması',
    descriptionPart1: '1. Bu ürün anapara garantisi olmayan bir servet yönetimi ürünüdür. Piyasa dalgalanmaları anapara kayıplarına neden olabilir. Lütfen dikkatli yatırım yapın.',
    descriptionPart2: '2. Ödeme düzenleme kuralları:',
    descriptionPart3: 'Uzlaşma fiyatı < bağlantılı fiyat ise, BTC vade sonunda kapatılacaktır; takas tutarı = yatırım tutarı * (1+ gün * yıllık getiri oranı / 365).',
    descriptionPart4: 'Uzlaşma fiyatı sabit fiyat ≥ ise, USDT vade sonunda kapatılacaktır; takas tutarı = yatırım tutarı * sabit fiyat * (1+ gün * yıllık getiri oranı / 365).',
    descriptionPart5: '3. Gerçek yıllık getiri oranı piyasa ile gerçek zamanlı olarak değişir, lütfen gerçek satın alma işlemine bakın.',
    descriptionPart6: '4. Yatırım tutarı gerçek zamanlı olarak piyasaya göre dönüştürülür, lütfen gerçek satın alma işlemine bakın.',
    descriptionPart7: '5. Ürün satın alındıktan sonra para tutma sayfamda görüntülenebilir ve son kullanma tarihinden sonra para iadesi otomatik olarak spot hesaba yapılır.',
    buyButton: '[{coin}] satın al'
  },

  fund: {
    description: 'Varlıklar',
    recharge: 'Yeniden doldurma',
    withdraw: 'Çekilme',
    exchange: 'Transfer',
    empty: 'Cüzdan boş, git'
  },
  userCenter: {
    lastLogin: 'Son giriş',
    myTeam: 'Ekibim',
    identity: 'Doğrulama',
    walletAddress: 'Cüzdan adresi',
    zskAccount: 'ZSK Hesabı',
    bankCard: 'Banka hesabı',
    userBills: 'Kullanıcı Faturaları',
    timingTradeOrder: 'Ticaret Emrini Zamanlama',
    spotTradeOrder: 'vadeli pozisyonlar',
    contactTradeOrder: 'Sözleşme pozisyonu',
    userReport: 'Kullanıcı Raporu',
    teamReport: 'Ekip raporu',
    share: 'Paylaş',
    customer: 'Müşteri hizmetleri',
    helpCenter: 'Yardım Merkezi',
    platform: 'Platform Tanıtımı',
    profit: 'Kar',
    balance: 'Bakiye',
    withdraw: 'Çekilme',
    recharge: 'Yeniden doldurma',
    creditStoreLabel: 'Kredi Deposu'
  },
  settings: {
    title: 'Ayarlar',
    fundPassword: 'Fon şifresi',
    googleValidator: 'Google Doğrulayıcı',
    editLoginPassword: 'Giriş Şifresini Düzenle',
    switchLocale: 'Dili değiştir'
  },
  editFundPassword: {
    title: 'Fon Şifresini Değiştir',
    currentPasswordLabel: 'geçerli parola',
    currentPasswordPlaceholder: 'Lütfen mevcut fon şifresini giriniz',
    newPasswordLabel: 'Yeni Şifre',
    newPasswordPlaceholder: 'Lütfen değiştirilen fon şifresini giriniz',
    prePasswordLabel: 'Şifreyi onayla',
    prePasswordPlaceholder: 'Değiştirilen fon şifresini silin ve tekrar girin',
    tips: 'Fon şifresi işlemler için önemli bir sertifikadır, lütfen dikkatlice ayarlayın ve aklınızda bulundurun',
    currentPasswordRequired: 'Lütfen mevcut fon şifresini giriniz',
    newPasswordRequired: 'Değiştirilecek fon şifresini giriniz',
    prePasswordRequired: 'Değiştirilecek fon şifresini tekrar giriniz',
    prePasswordDiff: 'İki parola girişi tutarsız'
  },
  bindFundPassword: {
    title: 'Bağlama fonu şifresi',
    fundPasswordLabel: 'Fon Şifresi',
    fundPasswordPlaceholder: 'Lütfen fon şifresini girin',
    fundPasswordPreLabel: 'Şifreyi Onayla',
    fundPasswordPrePlaceholder: 'Lütfen fon şifresini tekrar girin',
    fundPasswordRequired: 'Fon şifresi gerekli',
    fundPasswordPreRequired: 'Parolayı onaylayın gerekli',
    fundPasswordDiff: 'İki şifre girişi tutarsız',
    bindSuccess: 'Bağlama Başarısı',
    tips: 'Fon şifresi işlemler için önemli bir sertifikadır, lütfen dikkatli bir şekilde ayarlayın ve aklınızda bulundurun'
  },
  editLoginPassword: {
    title: 'Giriş şifresini değiştir',
    currentPasswordLabel: 'Mevcut şifre',
    currentPasswordPlaceholder: 'Lütfen geçerli oturum açma parolasını girin',
    newPasswordLabel: 'Yeni Şifre',
    newPasswordPlaceholder: 'Lütfen değiştirilen giriş şifresini girin',
    prePasswordLabel: 'Şifreyi onayla',
    prePasswordPlaceholder: 'Değiştirilen oturum açma parolasını temizleyin ve yeniden girin',
    tips: 'Oturum açma parolası, oturum açma kimlik doğrulaması vb. için önemli bir kimlik bilgisidir, lütfen dikkatli bir şekilde ayarlayın ve aklınızda bulundurun',
    currentPasswordRequired: 'Lütfen geçerli oturum açma parolasını girin',
    newPasswordRequired: 'Lütfen değiştirilecek giriş şifresini giriniz',
    prePasswordRequired: 'Lütfen değiştirilecek giriş şifresini tekrar girin',
    prePasswordDiff: 'İki parola girişi tutarsız'
  },
  bindGoogleValidator: {
    title: 'Google Authenticator\'ı Bağla',
    qrCodeLabel: 'QR kodu',
    keyLabel: 'Anahtar',
    loginPasswordLabel: 'Giriş şifresi',
    loginPasswordPlaceholder: 'Lütfen giriş şifrenizi giriniz',
    googleCodeLabel: 'Google doğrulama kodu',
    googleCodePlaceholder: 'Lütfen 6 basamaklı bir Google doğrulama kodu girin',
    tipsPart1: 'Google Authenticator\'ı uygulama mağazasında arayın',
    tipPart2: 'Yukarıdaki QR kodunu taramak için Google Authenticator\'ı kullanın veya bağlama için anahtarı manuel olarak girin',
    tipPart3: 'Yukarıdaki 6 haneli Google doğrulama kodunu girin, göndermek için Onayla\'yı tıklayın',
    loginPasswordRequired: 'Lütfen oturum açma şifresini giriniz',
    googleCodeRequired: 'Lütfen 6 basamaklı bir Google doğrulama kodu girin'
  },
  walletAddress: {
    title: 'Cüzdan Adresi',
    add: '+ Adres Ekle',
    remark: 'Açıklama',
    addButton: 'Cüzdan adresi ekle',
    tips: 'Adres bilgilerini değiştirmek veya silmek isterseniz, lütfen müşteri hizmetleri ile iletişime geçin'
  },
  addWalletAddress: {
    title: 'Cüzdan adresi ekle',
    vcChainNameIdLabel: 'Zincir tipi',
    vcAccountLabel: 'Cüzdan adresi',
    vcAccountPlaceholder: 'Lütfen cüzdan adresini girin',
    commentLabel: 'Açıklamalar',
    commentPlaceholder: 'Lütfen açıklama içeriğini girin',
    fundPasswordLabel: 'Fon Şifresi',
    fundPasswordPlaceholder: 'Lütfen fon şifrenizi giriniz',
    tips: 'Eklenen cüzdan adresi değiştirilemez, lütfen bilgilerin doğru olduğunu doğrulayın',
    vcIdRequired: 'Lütfen doğru para birimini seçin',
    vcChainNameIdRequired: 'Lütfen doğru zincir tipini seçin',
    vcAccountRequired: 'Lütfen doğru cüzdan adresini giriniz',
    fundPwdRequired: 'Lütfen doğru fon şifresini giriniz',
    addSuccess: 'Cüzdan adresi başarıyla eklendi'
  },
  receiveWays: {
    title: 'Banka Kartım',
    add: '+ Banka kartı ekle',
    tips: 'Banka kartı bilgilerini değiştirmek veya silmek isterseniz, lütfen müşteri hizmetleri ile iletişime geçin',
    addCardButton: 'Banka kartı ekle'
  },
  zskAccount: {
    title: 'Hızlı hesap',
    add: '+ Hızlı hesap ekle',
    tips: 'Hesap bilgilerini değiştirmek veya silmek için lütfen müşteri hizmetleri ile iletişime geçin',
    addCardButton: 'Hesap ekle'
  },
  addZskAccount: {
    title: 'Hızlı hesap ekle',
    withdrawNameLabel: 'Ad',
    withdrawNamePlaceholder: 'Lütfen adı giriniz',
    withdrawNameRequired: 'İsim gereklidir',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Lütfen hızlı hız kimliğini girin',
    fundPasswordLabel: 'Fon parolası',
    fundPasswordPlaceholder: 'Lütfen fon şifrenizi giriniz',
    tips: 'Lütfen eklenen hesabın bilgilerini dikkatli bir şekilde doldurun, yanlış bilgi nedeniyle para çekme işleminin gerçekleşmemesinden şirket sorumlu olmayacaktır'
  },
  addBankCard: {
    title: 'Yeni bir banka kartı ekle',
    withdrawNameLabel: 'Ad',
    withdrawNamePlaceholder: 'Lütfen adı giriniz',
    withdrawNameRequired: 'İsim gereklidir',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Lütfen ZSK kimliğini girin',
    zskRequired: 'ZSK kimliği gerekli',
    cardNumLabel: 'Banka hesap numarası',
    cardNumPlaceholder: 'Lütfen banka kartı numarasını giriniz',
    branchLabel: 'Şube adresi',
    branchPlaceholder: 'Lütfen banka kartı şube adresini giriniz',
    fundPasswordLabel: 'Fon parolası',
    fundPasswordPlaceholder: 'Lütfen fon şifresini giriniz',
    tips: 'Banka kartı nakit çekme işlemi için önemli bir veridir, lütfen dikkatli bir şekilde doldurun, kart bilgilerinin yanlış doldurulması nedeniyle nakit alınamaması gibi sorunlardan şirket sorumlu olmayacaktır. ',
    backIdRequired: 'Lütfen hesap bankasını seçin',
    cardNumRequired: 'Lütfen doğru banka kartı numarasını giriniz',
    fundPwdRequired: 'Lütfen doğru fon şifresini girin',
    idCardPlaceholder: 'Lütfen kimlik numaranızı giriniz',
    idCardLabel: 'Kimlik kartı numarası',
    idCardRequired: 'Lütfen doğru kimlik numarasını girin',
    cciPlaceholder: 'Lütfen banka kartını girin CCI',
    branchCodePlaceholder: 'Lütfen şube kodunu giriniz',
    branchCodeLabel: 'Şube Kodu',
    katakanaPlaceholder: 'Lütfen katakana\'yı girin',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Hesap Değişikliği Kaydı',
    vcName: 'Para Birimi',
    amount: 'Miktar',
    balance: 'Bakiye'
  },
  timingTradeOrder: {
    title: 'Ticaret emrini zamanlama',
    waiting: {
      title: 'Siparişler devam ediyor',
      amount: 'Tutar',
      period: 'dönem',
      receivePrice: 'Alış fiyatı',
      settlement: 'uzlaşma devam ediyor'
    },
    history: {
      title: 'Tarihsel Emirler',
      buyInClose: 'Alış fiyatı',
      saleOutClose: 'indirimli fiyat'
    }
  },
  spotTradeOrder: {
    title: 'Perintah Dagangan Niaga Hadapan',
    waiting: {
      title: 'Pesanan sedang berjalan',
      buyInAmount: 'jumlah harga belian',
      buyInPrice: 'Beli harga seunit',
      buyInCount: 'Kuantiti Beli',
      buyInTime: 'beli masa'
    },
    history: {
      title: 'Perintah Sejarah',
      buyInAmount: 'jumlah harga belian',
      buyInPrice: 'Beli harga seunit',
      buyInCount: 'Kuantiti Beli',
      sellOutAmount: 'Jumlah harga jualan',
      sellOutPrice: 'Jual harga seunit',
      sellOutTime: 'masa jual'
    }
  },
  userReport: {
    title: 'Kullanıcı Raporu',
    profit: 'Kar',
    timingTradeAmountFee: 'Son derece hızlı işlem emri/işlem ücreti',
    timingTradePrizePoint: 'Son derece hızlı işlem bonusu/indirimi',
    rechargeInfo: 'Şarj/taşıma ücreti',
    withdrawInfo: 'Para çekme/işlem ücreti',
    exchangeInfo: 'Değişim/işlem ücreti'
  },
  userReportDay: {
    title: 'Kullanıcı Günlük Raporu',
    profit: 'Kar',
    timingTradeAmountFee: 'Son derece hızlı işlem emri/işlem ücreti',
    timingTradePrizePoint: 'Son derece hızlı işlem bonusu/indirimi',
    rechargeInfo: 'Şarj/taşıma ücreti',
    withdrawInfo: 'Para çekme/işlem ücreti',
    exchangeInfo: 'Değişim/işlem ücreti'
  },
  teamReport: {
    goToReportDay: 'Rapor Günü',
    timingTradeBetAmountServiceCharge: 'Ticaret Miktarını/Hizmetlerini Zamanlama',
    timingTradeBetPrizePoint: 'Zamanlama Ticaret Ödülü/Puan',
    timingTradeUserAndCount: 'Ticaret Kullanıcılarını/Sayılarını Zamanlama',
    rechargeAmountFee: 'Yükleme Miktarı/Hizmetleri',
    rechargePersonCount: 'Kullanıcıları/Sayıları Yeniden Yükle',
    withdrawAmountFee: 'Çekme Miktarı/Hizmetleri',
    withdrawPersonCount: 'Kullanıcıları/Sayıları Geri Çek',
    firstRechargeUserAndCount: 'İlk Şarj Miktarı/Sayıları',
    title: 'Ekip Raporu',
    usernamePlaceholder: 'Alt düzey kullanıcı adını girin',
    previewAllTradeInfo: 'Tüm hızlı ticaret bilgilerini görüntüle',
    coin: 'para birimi',
    timingTradeBetAmount: 'Son derece hızlı ticaret bahis miktarı',
    profit: 'Kar',
    action: 'işlem',
    previewReportDay: 'Günlük raporu görüntüle'
  },
  teamTimingTradeInfo: {
    title: 'Takım Hızı Ticareti',
    profit: 'Kar',
    subTitle: 'Ekip hızı işlem bilgisi',
    timingTradeAmountFee: 'Son derece hızlı işlem emri/hizmet ücreti',
    timingTradePrizePoint: 'Son derece hızlı işlem bonusu/indirimi',
    rechargeInfo: 'Şarj/Hizmet Ücreti',
    withdrawInfo: 'Para Çekme/Hizmet Ücreti',
    exchangeInfo: 'Değişim/Hizmet Ücreti'
  },
  teamReportDay: {
    title: 'Ekip Günlük Raporu',
    subTitle: 'Ekip [ {username} ] Günlük Raporu',
    timingTradeBetAmountFee: 'Son derece hızlı işlem emri/hizmet ücreti',
    timingTradeUserAndCount: 'Ticaret Kullanıcılarını/Sayılarını Zamanlama',
    timingTradeBetPrizePoint: 'Hızlı İşlem Bonusu/İndirimi',
    rechargeAmountFee: 'Şarj miktarı/hizmet ücreti',
    rechargePersonCount: 'Kişiyi/işlem sayısını yeniden şarj et',
    firstRechargePersonCount: 'İlk Şarj Miktarı/Sayıları',
    drawAmountFee: 'Çekilen miktar/hizmet ücreti',
    drawPersonCount: 'Para/işlem çeken kişi sayısı',
    exchangeAmountFee: 'Değişim Tutarı/Hizmet Ücreti'
  },
  share: {
    title: 'Paylaş',
    qrCodeLabel: 'QR kodu',
    registerUrlLabel: 'Kayıt adresi',
    inviteCodeLabel: 'Davetiye Kodu',
    hasNoInviteCode: 'Cari hesabın davet kodu yok',
    buildInvitationCode: 'Tek tıkla oluşturmayı dene',
    tipPart1: 'Kayıt olmak için kayıt bilgilerini doldurmak için yukarıdaki QR kodunu tarayın',
    tipPart2: 'Kayıt adresini kopyalayın ve kayıt olmak için kayıt bilgilerini doldurun',
    tipPart3: 'Kayıt olmak için bu sitenin kayıt arayüzünü manuel olarak açın ve davet kodunu girin',
    saveImageError: 'Resim kaydedilemedi, resme uzun basıp kaydetmeyi deneyin'
  },
  myTeam: {
    title: 'Ekibim',
    usernamePlaceholder: 'Alt düzey kullanıcı adını girin',
    point: 'indirim (hız/sözleşme)',
    totalBalance: 'Bakiye',
    lastLoginTime: 'Son Giriş Zamanı',
    noLoginTime: 'yok'
  },
  userDetail: {
    title: 'Kullanıcı Detayı',
    username: 'Kullanıcı adı',
    userType: 'Kullanıcı Türü',
    pointPercentTiming: 'Zamanlama Noktası',
    pointPercentContract: 'Sözleşme Noktası',
    registerWay: 'Kayıt yöntemi',
    teamCounts: 'Takım numarası',
    teamOnline: 'ekip çevrimiçi',
    balance: 'Denge',
    registerTime: 'Kayıt zamanı',
    onlineStatus: 'giriş durumu'
  },
  addUser: {
    title: 'Kullanıcı Ekle',
    addUserDirect: {
      userTypeLabel: 'Kullanıcı Türü',
      usernameLabel: 'Kullanıcı adı',
      usernamePlaceholder: 'Lütfen hesabın kullanıcı adını girin',
      pointTimingLabel: 'Son derece hızlı işlem indirimi',
      pointContractLabel: 'Sözleşme işlemi indirimi',
      tips: 'İlk şifre: "{şifre}"; lütfen hesabı açtıktan sonra kullanıcıya şifreyi zamanında değiştirmesini hatırlatın',
      userTypeRequired: 'Lütfen hesap türünü seçin',
      usernameRequired: 'Lütfen hesabın kullanıcı adını giriniz',
      pointTimingRequired: 'Lütfen hızlı işlem indirimini seçin',
      pointContractRequired: 'Lütfen sözleşme işlem indirimini seçin',
      copyTemplate: '\n          Kullan\u0131c\u0131 ad\u0131: {kullan\u0131c\u0131 ad\u0131};\n          Oturum a\xE7ma \u015Fifresi: {loginPassword};\n          Giri\u015F URL\'si: {loginAddress};\n          H\u0131zl\u0131 ticaret indirimi: {timingTradePoint};\n          S\xF6zle\u015Fme ticareti indirimi: {contactTradePoint};\n          '
    }
  },
  recharge: {
    title: 'Şarj',
    configIdLabel: 'Kanalı şarj et',
    chainNameLabel: 'Zincir adı',
    amountLabel: 'Yatırılan Tutar',
    userCardNameLabel: 'Ödeyen',
    userCardNamePlaceholder: 'Lütfen ödeyenin adını girin',
    fee: 'hizmet ücreti',
    ReceiveAmountTipsPart1: 'Yükle',
    ReceiveAmountTipsPart2: ', Ödeme gerekiyor',
    tipsPart1: 'Çevrimiçi ödeme arayüzü kararsız olduğundan, şu anda yalnızca çevrimdışı aktarım ve yeniden ödeme destekleniyor! ',
    tipsPart2: 'Lütfen gerçek transfer tutarını doğru bir şekilde girin, aksi takdirde sistemin incelemede başarısız olmasına neden olabilir ve yeniden yükleme sürecini etkileyebilir. ',
    emptyPart1: 'Yükleme Kanalı Yok,',
    emptyPart2: 'Tekrar denemek için dokunun',
    amountRequired: 'Yükleme miktarı boş olamaz',
    maxPrecisionError: 'Yükleme miktarı en fazla {amountMaxPrecision} ondalık basamağa sahip olabilir',
    payUserNameError: 'Lütfen doğru bir ödeme yapan kişi girin ve tekrar deneyin',
    userMobileLabel: 'Mobil',
    userMobilePlaceholder: 'Lütfen cep telefonunuzu girin',
    needPayLabel: 'Ödeme Gerekiyor',
    needPayPlaceholder: 'Lütfen Tutarı Girin'
  },
  payDetail: {
    title: 'Bilgi Aktarımı',
    addressLabel: 'Para yatırma adresi',
    rechargeAmount: 'Miktar',
    bankNameLabel: 'Banka',
    branchLabel: 'Şube adresi',
    cardName: 'İsim',
    cardNum: 'kart numarası',
    uploadImgLabel: 'Ödeme Bilgileri',
    uploadImgPlaceholder: 'Ödeme fişi resmini yüklemek için tıklayın',
    uploadImgRequired: 'Lütfen ödeme çeki resmini yükleyin',
    vcTransferTipsPart1: '1. Para yatırma adresini kopyalayın veya para yatırmak için QR kodunu tarayın',
    vcTransferTipsPart2: '2. Para yatırma işlemi tamamlandıktan sonra ödeme makbuzu resmini yükleyin',
    vcTransferTipsPart3: 'Para yatırma verimliliğini artırmak için, lütfen net ve yüksek tanımlı bir sertifika resmi yüklediğinizden emin olun, ilgili bilgi resmi net değilse, sistemin incelemede başarısız olmasına ve yatırma işleminin ilerlemesini etkilemesine neden olabilir. ',
    bankCardTips: 'Para yatırma verimliliğini artırmak için lütfen havale edenin ve havale edenin adının aynı olduğundan emin olun; ilgili bilgilerin eşleşmemesi, sistemin incelemede başarısız olmasına neden olabilir ve para yatırma işleminin ilerlemesini etkileyebilir. ',
    bankCardTransferSuccess: 'Başarıyla transfer ettim'
  },
  rechargeOrder: {
    title: 'Para yatırma emri',
    payAmount: 'Tutar',
    receiveAmount: 'Alınan Tutar'
  },
  identity: {
    title: 'Gerçek ad bilgisi',
    subTitle: 'Gerçek ad kimlik doğrulaması, bilgi kimlik doğrulamasını, kimlik kimlik doğrulamasını içerir',
    name: 'İsim',
    idType: 'Belge türü',
    idNum: 'Kimlik numarası',
    demand: 'Gereksinim',
    informationVer: 'Bilgi Doğrulama',
    idAuthentication: 'Kimlik Doğrulama',
    material: 'Malzeme'
  },
  verified: {
    title: 'Doğrulandı',
    idCardTypeLabel: 'Sertifika türü',
    idCardFrontSideImgLabel: 'Card Front SideImgLabel',
    idCardBackSideImgLabel: 'Kimlik fotoğrafının arkası',
    idCardHandSideImgLabel: 'Elde kimlik fotoğrafı',
    nameLabel: 'Belge adı',
    namePlaceholder: 'Lütfen kimlik adınızı girin',
    idCardNumLabel: 'Kimlik kartı numarası',
    idCardNumPlaceholder: 'Lütfen kimlik numarasını giriniz',
    fundPwdLabel: 'Fon parolası',
    fundPwdPlaceholder: 'Lütfen fon şifrenizi giriniz',
    tips: 'Bilgi doğrulaması gönderildikten sonra değiştirilemez, lütfen dikkatlice kontrol edin ve doğru şekilde doldurun',
    idCardTypeRequired: 'Lütfen kart tipini seçiniz',
    idCardFrontSideImgRequired: 'Lütfen kimlik kartının önden fotoğrafını yükleyin',
    idCardBackSideImgRequired: 'Lütfen kimlik kartının arka yüzünün fotoğrafını yükleyiniz',
    idCardHandSideImgRequired: 'Lütfen elde tutulan bir kimlik fotoğrafı yükleyin',
    nameRequired: 'Lütfen belgenin adını giriniz',
    idCardNumRequired: 'Lütfen kimlik numarasını giriniz',
    fundPwdRequired: 'Lütfen fon şifrenizi giriniz',
    submitSuccess: 'Kimlik doğrulama isteği başarıyla gönderildi'
  },
  help: {
    title: 'Yardım Merkezi'
  },
  helpDetail: {
    title: 'Yardım Ayrıntıları'
  },
  myMessage: {
    title: 'Mesajım'
  },
  messageDetail: {
    title: 'Mesaj ayrıntıları'
  },
  withdraw: {
    title: 'Para çek',
    tips: 'Fonların güvenliğini ve para çekme işleminin etkinliğini sağlamak için; lütfen girilen bilgilerin doğruluğunu dikkatlice kontrol ediniz, para çekme işlemi sırasında oluşan hizmet bedeli bakiyeden düşülecektir',
    receiveAmountTipsPart1: 'Çek',
    receiveAmountTipsPart2: ', gelmesi bekleniyor',
    fee: 'Hizmet ücreti',
    myBalance: '[{vcName}] bakiyem:',
    configIdLabel: 'Para çekme kanalı',
    amountLabel: 'Çekilme tutarı',
    fundLabel: 'Fon şifresi',
    fundPlaceholder: 'Lütfen fon şifrenizi giriniz',
    googleCodeLabel: 'Google doğrulama kodu',
    googleCodePlaceholder: 'Lütfen 6 basamaklı bir Google doğrulama kodu girin',
    maxPrecisionError: 'Para çekme miktarı en fazla {amountMaxPrecision} ondalık basamağa sahip olabilir',
    amountRequired: 'Lütfen doğru para çekme miktarını girin veya seçin',
    bankCardError: 'Lütfen doğru banka kartını seçin',
    fundPwdError: 'Lütfen doğru fon şifresini girin',
    walletAddressError: 'Lütfen doğru cüzdan adresini seçin',
    success: 'Para çekme talebi başarıyla gönderildi, lütfen işlenmesini bekleyin',
    emptyPart1: 'Kullanılabilir para çekme kanalı yok,',
    emptyPart2: 'Tekrar denemek için dokunun'
  },
  withdrawOrder: {
    title: 'Para çekme emri',
    requestAmount: 'Tutar',
    receiveAmount: 'Alınan Tutar'
  },
  locales: {
    title: 'Dili değiştir'
  },
  lines: {
    title: 'Çizgiler',
    switchLine: 'Hat Değiştir'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Favori para birimini başarıyla sil',
    addFavoriteSuccess: 'Favori para birimi başarıyla eklendi'
  },
  currencySelect: {
    currencyName: 'para birimi',
    currencyPlaceholder: 'Para birimini seçmek için tıklayın'
  },
  walletItem: {
    available: 'Müsait',
    convert: 'dönüştür (USDT)'
  },
  banks: {
    bankIdLabel: 'Banka',
    bankIdPlaceholder: 'Bir banka seçmek için tıklayın'
  },
  banksPop: {
    title: 'Banka Seç',
    search: 'Giriş bankası anahtar sözcükleri'
  },
  historyOrderDetail: {
    title: 'Sipariş Ayrıntıları',
    coin: 'İşlem para birimi',
    amount: 'sipariş tutarı',
    buyInClose: 'Alış fiyatı',
    sellOutClose: 'Satış fiyatı',
    isQuest: 'Bu siparişle ilgili sorunuz var mı?',
    connectCustomer: 'Müşteri hizmetleriyle iletişime geçilsin mi?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Kullanıcı indirimini seçmek için tıklayın'
  },
  walletAddressSelect: {
    title: 'Cüzdan adresi seçin',
    label: 'Cüzdan adresi',
    placeholder: 'Cüzdan adresini seçmek için tıklayın'
  },
  myCardSelect: {
    title: 'Hesap seçin',
    label: 'alıcı hesap',
    placeholder: 'Bir hesap seçmek için tıklayın'
  },
  amountInput: {
    amountRange: 'Min {minAmount}, Maks {maxAmount}',
    amountMin: 'Min {minAmount}, Sınırsız',
    amountErrorEmpty: '{label} gerekli',
    amountErrorOutRange: '{label} aralığın dışında'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Min {minAmount}, Sınırsız',
    placeholderHasMax: 'Min {minAmount}, Maks {maxAmount}',
    amountErrorEmpty: 'Miktar yanlış',
    amountErrorOutRange: 'Miktar aralığın dışında'
  },
  common: {
    remark: 'Açıklama',
    saveImage: 'Resmi Kaydet',
    online: 'Çevrimiçi',
    offline: 'Çevrimdışı',
    profit: 'Kar',
    date: 'Tarih',
    period: 'Dönem',
    pointAmount: 'Puan Tutarı',
    point: 'Kullanıcı indirimi',
    direction: 'Yön',
    winLoss: 'Gelir',
    lose: 'Kaybetmek',
    add: 'Ekle',
    win: 'Kazanmak',
    edit: 'Değiştir',
    notBind: 'İlişkisiz',
    alreadyBind: 'Zaten Bağlı',
    enabled: 'Etkin',
    notEnabled: 'NotEnabled',
    queryRange: 'Sorgu Aralığı',
    copy: 'Kopyala',
    orderNum: 'Sipariş',
    null: 'Sıfır',
    noData: 'Veri Yok',
    freshSuccess: 'Yenileme Başarısı',
    loadMoreData: 'Daha fazla veri yükle',
    noMoreData: 'Daha fazla veri yok',
    lookMore: 'Daha',
    more: 'Daha'
  },
  date: {
    today: 'Bugün',
    yesterday: 'Dün',
    last7Days: 'Yaklaşık 7 gün',
    last14Days: 'Yaklaşık 14 gün',
    split: 'Kime'
  },
  button: {
    save: 'Kaydet',
    logout: 'Çıkış',
    confirm: 'Tamam',
    cancel: 'İptal',
    submit: 'Gönder',
    addNow: 'Şimdi ekle',
    reset: 'sıfırla',
    nextStep: 'İleri',
    goCertification: 'Sertifikaya git'
  },
  confirm: {
    title: {
      logout: 'Çıkış',
      unBindFundPassword: 'Bağlantısız fon şifresi',
      addUserDirect: 'Kullanıcı Ekle',
      addUserInfo: 'Kullanıcı başarıyla eklendi',
      jumpToRechargePage: 'Atlamayı Onayla',
      unAuthentication: 'UnAuthentication',
      noBindBankCard: 'Banka kartı yok',
      noBindCoinAddress: 'Cüzdan adresi yok',
      tradeConfirm: 'İşlemi onaylayın',
      sellOutSpotOrder: 'satış pozisyonu',
      buyFinance: 'satın almayı onayla',
      redeemOrder: 'Taahhüt emri itfa'
    },
    content: {
      logout: 'Cari hesaptan çıkmak istediğinizden emin misiniz?',
      unBindFundPassword: 'Bağlantısız bir fon şifresi tespit edildi, hesap güvenliğini sağlamak için lütfen önce fon şifrenizi bağlayın',
      addUserDirect: 'Yakında yeni bir kullanıcı eklenecek, lütfen bilgilerin doğru olduğunu doğrulayın ve devam etmek için Tamam\'ı tıklayın, kullanıcı adı [ {username}], kullanıcı türü [ {userType} ], oturum açma şifresi [ {password}] ve hızlı ticaret indirimim [ {diffPointTiming} ] ile sözleşme işlemi indirimim arasındaki fark [ {diffPointContract} ]',
      addUserInfo: 'Kullanıcı adı [ {kullanıcıadı}]; <br /> Oturum açma parolası [ {password} ];<br /> Oturum Açma URL\'si [ {loginAddress} ];<br /> Aşırı işlem indirimi [ {pointPercentTiming} ];<br /> /> Sözleşme işlem indirimi [{pointPercentContract} ];',
      jumpToRechargePage: 'Üç taraf şarj arayüzüne atlamak üzere, devam etmek için lütfen onayla\'yı tıklayın',
      unAuthentication: 'Hesabın gerçek adla kimlik doğrulamasından geçmediği tespit edildi. Fonların normal dolaşımını sağlamak için lütfen önce gerçek adla kimlik doğrulaması yapın',
      noBindBankCard: 'Hesabın bir banka kartı ile bağlı olmadığı veya aktifleştirilmediği tespit edildi. Paranın normal dolaşımını sağlamak için lütfen önce banka kartını bağlayın',
      noBindCoinAddress: 'Hesabın bağlı veya etkin sanal para birimi hesabı olmadığı algılandı. Fonların normal dolaşımını sağlamak için lütfen önce sanal para hesap adresini ekleyin',
      tradeConfirm: 'Sipariş gönderilmek üzere, lütfen sipariş bilgilerinin doğru olduğunu onaylayın ve göndermek için Siparişi Onayla\'ya tıklayın',
      sellOutSpotOrder: 'Konum emri satılmak üzere, lütfen işlemin doğru olduğunu onaylayın ve devam etmek için Tamam\'ı tıklayın.',
      buyFinance: '[{coin}] satın almak üzere, hisse satın alın: {amount}, lütfen işlemin doğru olduğunu onaylayın ve devam etmek için Tamam\'ı tıklayın',
      redeemOrder: 'Katkı siparişi ({orderNum}) kullanılmak üzere, lütfen işlemin doğru olduğunu onaylayın ve devam etmek için Onayla\'yı tıklayın.'
    }
  },
  message: {
    bindSuccess: 'Bağlama başarılı',
    successOperation: 'İşlem başarılı oldu',
    logoutSuccess: 'Başarıyla çık',
    editSuccess: 'Başarıyla değiştirildi',
    addSuccess: 'Ekleme başarıyla',
    copySuccess: 'Kopyalama başarılı',
    copyFailed: 'Kopyalama başarısız oldu'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Gün',
      week_day_1: 'Bir',
      week_day_2: 'iki',
      week_day_3: 'üç',
      week_day_4: 'dört',
      week_day_5: 'beş',
      week_day_6: 'Altı'
    },
    loading: {
      loading: 'yükleniyor'
    }
  },
  helpItems: {
    title: {
      part1: 'Varlıklarda dönüştürülen miktar neden değişiyor? ',
      part2: 'OTC işlemleri için fon şifresi işleme yönteminin unutulması',
      part3: 'OTC işlemi satın alma işlemi tamamlandıktan sonra fonlar nereye akacak? ',
      part4: 'Takma adınızı değiştirme sayısını neden sınırlamak istiyorsunuz',
      part5: 'Transferin anlamı nedir, neden transfer etmek gerekir',
      part6: 'Kullanıcı sözleşmesinin hesap öz sermayesi nasıl hesaplanır? ',
      part7: 'Açılış pozisyonunda belirlenen zararı durdur ve karı al\'ın değeri nedir? Nasıl ayarlanmalıdır? ',
      part8: 'Sözleşme riski nasıl azaltılır? ',
      part9: 'Sözleşme açık pozisyonundaki miktar neyi gösteriyor? ',
      part10: 'Zorla tasfiyeye ilişkin talimatlar',
      part11: 'Sözleşmeli ticaret kuralları nelerdir? ',
      part12: 'Sözleşmeli ticarette marj nedir? ',
      part13: 'Limit emri ve piyasa emri nedir? ',
      part14: 'Sözleşme işlemlerinin riski neyi temsil eder',
      part15: 'Neden para birimi dönüştürmeye ihtiyacınız var? ',
      part16: 'OTC işlem aktarımından sonra karşı taraf neden zamanında havaleyi almadı? ',
      part17: 'Tether (USDT) OTC aracılığıyla nasıl satın alınır? '
    },
    content: {
      part1: 'Şu anda Renminbi\'de tutulan dijital para biriminin varlığa dönüştürüldüğünde değeri, dijital varlıkların fiyat dalgalanmaları nedeniyle değişecektir. Dijital varlıklarınızın sayısı değişmedi. ',
      part2: 'OTC işlem fonu şifresini unutursanız, lütfen "Ayarlarım-Fon şifresini ayarlamak için tıklayın" bölümüne gidin veya sıfırlamak için müşteri hizmetleri ile iletişime geçin',
      part3: 'OTC satın alma emri tamamlandıktan sonra fonlar, varlıktaki yasal para birimi hesabına girecektir. Sözleşme ticareti veya vadeli işlem ticareti için OTC satın alınan varlıkları kullanmanız gerekiyorsa, transfer etmek için lütfen fon transferi modülüne gidin. ',
      part4: 'İşleminizin güvenlik nedeniyle, şu anda takma adı yalnızca bir kez değiştirilecek şekilde sınırlıyoruz. ',
      part5: 'Çeşitli hesaplarınız arasında fonların bağımsızlığını sağlamak ve makul risk kontrolünüzü kolaylaştırmak için, ana ticaret modüllerinin hesapları burada bölünmüştür. Transfer, varlıkların çeşitli ticaret hesapları arasında karşılıklı olarak dönüştürülmesi sürecini ifade eder. ',
      part6: '<p>Sözleşme hesabı özkaynağı, hesaplama yöntemi aşağıdaki gibidir:</p> <p>Sözleşme hesap özkaynağı = pozisyon marjı + pozisyon değişken kâr ve zarar + cari hesap kullanılabilir tutarı</p>',
      part7: 'Kar al ve zararı durdur, sizin tarafınızdan belirlenen kar limiti ve kayıp limitidir. Belirlenen zararı durdur ve zararı durdur tutarına ulaşıldığında, sistem otomatik olarak pozisyonu kapatacaktır. Sözleşme satın alırken risk kontrolünüz için kullanılabilir. Belirlenen kar alma tutarının yarısı şu şekildedir: artış miktarı x miktar x çoklu kaldıraç ve zararı durdurmayı ayarlayın. Riskleri makul bir şekilde kontrol etmek için bunu gerçek varlık durumunuza göre ayarlamanızı öneririz. ',
      part8: 'Kalan hesapların mevcut varlıklarını para transferi yaparak sözleşme hesabına aktarabilir veya pozisyonu düşürerek riski azaltabilirsiniz. ',
      part9: 'Açık pozisyondaki miktar, satın almayı beklediğiniz döviz miktarını gösterir. Örneğin: BTC/USDT ticaret çiftinin açılış sayfasında, uzun satın almayı seçin, fiyatı 1000USDT olarak girin ve miktarı 10BTC olarak girin, bunun anlamı: 1000USDT birim fiyatıyla 10 BTC almayı bekliyorsunuz. ',
      part10: '<p>Risk derecesi, varlıklarınızın riskini ölçmek için bir göstergedir. Risk derecesi %100\'e eşit olduğunda pozisyonunuz tasfiye edilmiş sayılır. Risk derecesi=(pozisyon marjı/sözleşme hesabı özkaynağı)*%100, kullanıcıların pozisyonlarını aşmasını önlemek için, sistem risk derecesinin düzeltme oranını ayarlar. Risk derecesi sistem tarafından belirlenen risk değerine ulaştığında sistem tasfiyeye zorlar. Örneğin, sistem tarafından ayarlanan düzeltme oranı %10 ise, risk dereceniz %90\'dan büyük veya eşit olduğunda, tüm pozisyonlarınız sistem tarafından zorunlu olarak kapatılır. </p> <p>Not: Sistem, aşırı risk nedeniyle tasfiyeye zorlarsa, tüm pozisyonlarınız kapatılacaktır, bu nedenle gereksiz kayıpları önlemek için riskinizi makul bir şekilde kontrol edebileceğinizi umuyorum</p>',
      part11: '<p>Ticaret türü</p> <p>Ticaret türü iki yöne ayrılır: açık uzun pozisyon (alış) ve açık kısa pozisyon (satış):</p> <p>Uzun alış (Arama) anlamına gelir mevcut endeksin yükselebileceğine inandığınız ve belirlediğiniz fiyattan veya cari piyasa fiyatından belirli miktarda sözleşme satın almayı umduğunuzu. </p> <p>Açığa satış (düşüş), mevcut endeksin düşebileceğine inandığınız ve belirli sayıda sözleşmeyi belirlediğiniz fiyattan veya mevcut piyasa fiyatından satmayı umduğunuz anlamına gelir. </p> <p>Nasıl emir verilir</p> <p>Limit emir: emrin fiyatını ve miktarını belirtmeniz gerekir</p> <p>Piyasa emri: sadece miktarı belirlemeniz gerekir Emrin, Fiyat cari piyasa fiyatıdır</p> <p>Pozisyon</p> <p>Gönderdiğiniz açılış emri tamamlandığında buna pozisyon denir</p> <p>Sözleşme teslim sorunları </p> < p>Platform sözleşmesi, belirli bir teslim süresi olmayan kalıcı bir sözleşmedir. Sistem tasfiye koşulları sağlanmadığı veya pozisyonu manuel olarak kapatmadığınız sürece pozisyonu kalıcı olarak tutabilirsiniz. </p> <p>Sistem pozisyonu kapatır</p> <p>1: Kârı durdur ve zararı durdur ayarlanan değerine ulaşıldığında sistem otomatik olarak pozisyonu kapatır</p> <p>2: Risk çok yüksekse, sistem konumu kapatmaya zorlar< /p>',
      part12: '<p>Sözleşme işleminde, kullanıcı, sözleşme fiyatına ve miktarına göre, karşılık gelen kaldıraç katına göre sözleşmenin ifası için mali teminat olarak fon ödeyerek sözleşme işlemine katılabilir ve bu fon sözleşme marjıdır. Kullanıcı, bir pozisyon açarken marjı işgal edecektir ve bir pozisyon açma marjı ne kadar fazla işgal edilirse, hesabın riski o kadar yüksek olur. </p> <p>Margin = (açılış fiyatı * miktar) / kaldıraç oranı</p>',
      part13: 'Limit emri, platforma işlem yapması için emanet etmeyi beklediğiniz fiyatı ifade eder ve piyasa emri, platformun cari fiyattan işlem yapması için doğrudan emanet etmesi anlamına gelir. Pozisyon açma kurallarında, piyasa emirleri limit emirlere göre önceliklidir. Bir limit emri seçerseniz, makul olmayan açılış fiyatlarından kaynaklanan kayıpları önlemek için lütfen mevcut para biriminin piyasa fiyatına göre makul bir pozisyon açın. ',
      part14: 'Risk seviyesi, sözleşme hesabınızdaki risk göstergesidir ve %100\'e eşit olan risk seviyesi tasfiye olarak kabul edilir. Riskiniz %50\'yi aştığında, tasfiye nedeniyle kayıp yaşamamak için dikkatli pozisyon açmanızı öneririz. Sözleşme varlıklarının mevcut fonlarını yenileyerek veya pozisyonları azaltarak riskinizi azaltabilirsiniz. ',
      part15: 'Değiş tokuşun işlevi, varlıklarınızda farklı para birimlerindeki fonların sorunsuz dolaşımını sağlamaktır ve vadeli işlem hesabında elde edilen QCC, alım satım için serbestçe USDT\'ye dönüştürülebilir. Diğer hesaplardaki USDT de işlemler için serbestçe QCC\'ye dönüştürülebilir. ',
      part16: 'Öncelikle, para transferi yaparken doldurduğunuz ödeme yönteminin, sipariş ayrıntıları sayfasında görüntülenenle tamamen aynı olduğundan emin olun. O zaman lütfen ödeme yönteminizin anında mı yoksa gecikmeli mi olduğunu onaylayın. Son olarak, sistem bakımı veya başka nedenlerle lütfen bankanız ve ödeme kurumunuzla iletişime geçin. ',
      part17: '<p>Yöntem 1: Almak veya satmak için OTC alış ve satış listesinden satın almak istediğiniz siparişi seçin. </p> <p>Yöntem 2: Hızlı işlemler için ihtiyacınıza göre alım veya satım emirlerini yayınlamak için yayınla düğmesini tıklayın. Sistem sizi hızlı bir şekilde alıcı ve satıcılarla eşleştirecektir. </p> <p>Not: Satınalma siparişinin ödemesi 15 dakika içerisinde yapılmadığı takdirde sistem siparişi otomatik olarak iptal edecektir, lütfen zamanında ödeme yapınız. Emir aynı gün içinde 3 defadan fazla iptal edilirse aynı gün içinde tekrar işlem yapılamaz ve ertesi gün alım satım yetkisi geri gelir. </p>'
    }
  }
};

/***/ }),

/***/ "Vr/s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W478":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Poster',
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['tradeConfig', 'vcId'])),
  methods: {}
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "W5Ro":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,UklGRi4AAABXRUJQVlA4TCEAAAAv/kAqAA8w//M///MfWiCTtqnzSt89AyWi/xNAnt7b/gQA"

/***/ }),

/***/ "W92K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WAoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]}),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])]})],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WFf0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WNks":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _index = __webpack_require__("HD9R");

var _index2 = _interopRequireDefault(_index);

var _Header = __webpack_require__("3mzj");

var _Header2 = _interopRequireDefault(_Header);

var _Cell = __webpack_require__("C5nv");

var _Cell2 = _interopRequireDefault(_Cell);

var _nameSpace = __webpack_require__("Ypiv");

var _i18n = __webpack_require__("mWYR");

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Locales',
  components: { Popup: _index2.default, HeaderCommon: _Header2.default, Cell: _Cell2.default },
  data: function data() {
    return {
      nextLocale: _i18n2.default.locale()
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['localeList']), (0, _vuex.mapState)({
    localePopVisible: function localePopVisible(state) {
      return state.app.localePopVisible;
    }
  }), {
    currentVisibleVModel: {
      get: function get() {
        return this.localePopVisible;
      },
      set: function set(val) {
        this.$store.commit(_nameSpace.SET_LOCALE_POP_VISIBLE, val);
      }
    },
    sysLocaleConfigList: function sysLocaleConfigList() {
      if (!this.localeList) return [];
      return this.localeList.filter(function (item) {
        return item.enabled;
      }).map(function (item) {
        return (0, _extends3.default)({}, _i18n.i18nLocales[item.code], item);
      });
    }
  }),
  watch: {
    cacheInfo: function cacheInfo() {
      if (this.currentVisibleVModel) {
        this.$store.dispatch('getSysLocaleList');
      }
    },
    currentVisibleVModel: function currentVisibleVModel(val) {
      var _this = this;

      if (val) {
        this.$store.dispatch('getSysLocaleList');
      } else {
        setTimeout(function () {
          _this.nextLocale = _i18n2.default.locale();
        }, 400);
      }
    }
  },
  methods: {
    saveLocale: function saveLocale() {
      if (this.nextLocale === this.locale) {
        this.currentVisibleVModel = false;
      } else {
        this.$i18n.set(this.nextLocale);
        this.$locale.set(this.nextLocale);
        this.$store.commit(_nameSpace.SET_CURRENT_LOCALE, this.nextLocale);
        this.currentVisibleVModel = false;
      }
    },
    closePop: function closePop() {
      this.currentVisibleVModel = false;
    }
  }
};

/***/ }),

/***/ "WSTi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends4 = __webpack_require__("Dd8w");

var _extends5 = _interopRequireDefault(_extends4);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _stroage = __webpack_require__("DsOT");

var _nameSpace = __webpack_require__("Eeb1");

var _nameSpace2 = __webpack_require__("Ypiv");

var _dom = __webpack_require__("vNF5");

var _theme = __webpack_require__("LSai");

var _cache = __webpack_require__("TuU3");

var _system = __webpack_require__("Zplo");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    theme: (0, _stroage.getStorage)(_nameSpace.__THEME_MODE__) || _theme.themeModeDefault,
    systemConfig: (0, _cache.initStateInCacheHas)(_nameSpace.__SYSTEM_CONFIG__),
    dict: (0, _cache.initStateInCacheHas)(_nameSpace.__DICT__),
    cacheInfo: (0, _stroage.getStorage)(_nameSpace.__CACHE_INFO__) || null,
    customerVisible: false,
    hideBalance: (0, _stroage.getStorage)(_nameSpace.__HIDE_BALANCE__) || null,
    localePopVisible: false,
    contractTradeDetailMessage: {},
    currentLocale: (0, _stroage.getStorage)(_nameSpace.__LOCALE__) || '',
    localeList: (0, _cache.initStateInCacheHas)(_nameSpace.__LOCALE_LIST__) || null
  },
  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_CURRENT_LOCALE, function (state, locale) {
    state.currentLocale = locale;
    (0, _stroage.setStorage)(_nameSpace.__LOCALE__, locale);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_CONTRACT_TRADE_DETAIL_MESSAGE, function (state, contractTradeDetailMessage) {
    state.contractTradeDetailMessage = contractTradeDetailMessage;
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_LOCALE_POP_VISIBLE, function (state, localePopVisible) {
    state.localePopVisible = localePopVisible;
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_HIDE_BALANCE, function (state, hideBalance) {
    state.hideBalance = hideBalance;
    (0, _stroage.setStorage)(_nameSpace.__HIDE_BALANCE__, state.hideBalance);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_THEME_MODE, function (state, theme) {
    state.theme = theme;
    (0, _stroage.setStorage)(_nameSpace.__THEME_MODE__, state.theme);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_CUSTOMER_VISIBLE, function (state, customerVisible) {
    state.customerVisible = customerVisible;
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_CACHE_INFO, function (state, cacheInfo) {
    state.cacheInfo = cacheInfo;
    (0, _stroage.setStorage)(_nameSpace.__CACHE_INFO__, cacheInfo);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_SYSTEM_CONFIG, function (state, systemConfig) {
    state.systemConfig = systemConfig;
    (0, _stroage.setStorage)(_nameSpace.__SYSTEM_CONFIG__, systemConfig);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_DICT, function (state, dict) {
    state.dict = dict;
    (0, _stroage.setStorage)(_nameSpace.__DICT__, dict);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_LOCALE_LIST, function (state, localeList) {
    state.localeList = localeList;
    (0, _stroage.setStorage)(_nameSpace.__LOCALE_LIST__, localeList);
  }), _mutations),
  actions: {
    showLocalePop: function showLocalePop(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve) {
        commit(_nameSpace2.SET_LOCALE_POP_VISIBLE, true);
        resolve();
      });
    },
    toggleHideBalance: function toggleHideBalance(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          hideBalance = _ref3.hideBalance;

      return new _promise2.default(function (resolve) {
        if (hideBalance !== undefined) {
          if (hideBalance === state.hideBalance) {
            return resolve();
          }
        }
        commit(_nameSpace2.SET_HIDE_BALANCE, !state.hideBalance);
        resolve();
      });
    },
    initCacheInfo: function initCacheInfo(_ref4) {
      var commit = _ref4.commit;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          clearTimer = _ref5.clearTimer;

      return new _promise2.default(function (resolve, reject) {
        (0, _system.sysCacheRefreshList)({}).then(function (res) {
          if (res.success) {
            if ((0, _cache.isNeedUpdateCacheInfo)(res.data)) {
              commit(_nameSpace2.SET_CACHE_INFO, (0, _cache.cacheHandler)(res.data));
            }
            resolve(res);
          } else {
            reject(new Error(res.message));
          }
        }).catch(reject);
      });
    },
    getSysConfigDict: function getSysConfigDict(_ref6) {
      var commit = _ref6.commit,
          state = _ref6.state,
          getters = _ref6.getters;

      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          noCache = _ref7.noCache;

      return new _promise2.default(function (resolve, reject) {
        if (!noCache && (0, _cache.checkCacheVersionIsRight)(state.systemConfig) && (0, _cache.checkCacheVersionIsRight)(state.dict)) {
          return resolve();
        } else {
          (0, _system.sysConfigSimpleList)({}).then(function (res) {
            if (res.success) {
              var _res$data = res.data,
                  dict = _res$data.dict,
                  list = _res$data.list;

              commit(_nameSpace2.SET_SYSTEM_CONFIG, (0, _extends5.default)({}, state.systemConfig, (0, _defineProperty3.default)({}, 'value_' + getters.locale, {
                data: list,
                finishUpdateTime: (0, _cache.findTargetUpdateTimeByKey)(_nameSpace.__SYSTEM_CONFIG__)
              })));
              commit(_nameSpace2.SET_DICT, (0, _extends5.default)({}, state.dict, (0, _defineProperty3.default)({}, 'value_' + getters.locale, {
                data: dict,
                finishUpdateTime: (0, _cache.findTargetUpdateTimeByKey)(_nameSpace.__DICT__)
              })));
              return resolve();
            } else {
              return reject(new Error(res.message));
            }
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    },
    initThemeMode: function initThemeMode(_ref8) {
      var state = _ref8.state;

      return new _promise2.default(function (resolve) {
        if ((0, _dom.hasClass)(document.documentElement, state.theme)) {
          resolve();
        } else {
          (0, _dom.addClass)(document.documentElement, state.theme);
          resolve();
        }
      });
    },
    showCustomerService: function showCustomerService(_ref9) {
      var commit = _ref9.commit,
          state = _ref9.state,
          getters = _ref9.getters,
          rootState = _ref9.rootState;

      return new _promise2.default(function (resolve, reject) {
        if (!rootState.user.token && !getters.PORTAL_systemConfig['unLoginAllowOpenCustomerUrl']) {
          return reject(new Error('Not Allow Open Customer'));
        }
        if (state.customerVisible) return resolve();
        commit(_nameSpace2.SET_CUSTOMER_VISIBLE, true);
        setTimeout(function () {
          resolve();
        }, 400);
      });
    },
    updateCustomerService: function updateCustomerService(_ref10, customerVisible) {
      var commit = _ref10.commit,
          state = _ref10.state,
          getters = _ref10.getters,
          rootState = _ref10.rootState;

      return new _promise2.default(function (resolve, reject) {
        if (customerVisible && !rootState.user.token && !getters.PORTAL_systemConfig['unLoginAllowOpenCustomerUrl']) {
          return reject(new Error('Not Allow Open Customer'));
        }
        if (!!state.customerVisible === !!customerVisible) return resolve();
        commit(_nameSpace2.SET_CUSTOMER_VISIBLE, customerVisible);
        setTimeout(function () {
          resolve();
        }, 400);
      });
    },
    setThemeMode: function setThemeMode(_ref11, themeMode) {
      var commit = _ref11.commit,
          state = _ref11.state;

      return new _promise2.default(function (resolve, reject) {
        if (!themeMode || !_theme.themes.find(function (themeItm) {
          return themeMode === themeItm.theme;
        })) return reject(new Error('没有找到对应的主题色, 请正确选择主题色'));

        var transitionStyleNode = document.createElement('style');
        transitionStyleNode.innerText = 'body * { transition: all .4s linear }';
        document.head.appendChild(transitionStyleNode);

        (0, _dom.removeClass)(document.body, state.theme);

        commit(_nameSpace2.SET_THEME_MODE, themeMode);

        (0, _dom.addClass)(document.body, themeMode);
        setTimeout(function () {
          document.head.removeChild(transitionStyleNode);
        }, 450);
        resolve();
      });
    },
    switchThemeMode: function switchThemeMode(_ref12) {
      var commit = _ref12.commit,
          state = _ref12.state;

      var targetMode = void 0;
      if (state.theme === _theme.THEME_DARK) {
        targetMode = _theme.THEME_LIGHT;
      } else {
        targetMode = _theme.THEME_DARK;
      }

      var transitionStyleNode = document.createElement('style');
      transitionStyleNode.innerText = 'body * { transition: all .25s }';
      document.head.appendChild(transitionStyleNode);

      (0, _dom.removeClass)(document.documentElement, state.theme);

      commit(_nameSpace2.SET_THEME_MODE, targetMode);

      (0, _dom.addClass)(document.documentElement, targetMode);
      setTimeout(function () {
        document.head.removeChild(transitionStyleNode);
      }, 250);
    },

    /***
     * 获取系统支持的语言列表
     * @param commit
     * @param state
     * @param getters
     * @param noCache
     */
    getSysLocaleList: function getSysLocaleList(_ref13) {
      var commit = _ref13.commit,
          state = _ref13.state,
          getters = _ref13.getters;

      var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          noCache = _ref14.noCache;

      return new _promise2.default(function (resolve, reject) {
        if (!noCache && (0, _cache.checkCacheVersionWithoutLocaleIsRight)(state.localeList)) {
          return resolve();
        }
        (0, _system.i18nLanguageSimpleList)({}).then(function (res) {
          if (res.success) {
            commit(_nameSpace2.SET_LOCALE_LIST, (0, _extends5.default)({}, state.localeList, {
              value: res.data,
              finishUpdateTime: (0, _cache.findTargetUpdateTimeByKey)(_nameSpace.__LOCALE_LIST__)
            }));
            return resolve();
          }
          return reject(new Error(res.message));
        }).catch(function (err) {
          console.log(err);
          return reject(err);
        });
      });
    }
  }
};

/***/ }),

/***/ "We2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__ = __webpack_require__("hd3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__ = __webpack_require__("hAqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ee52aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__ = __webpack_require__("5m/t");
function injectStyle (ssrContext) {
  __webpack_require__("W92K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72ee52aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ee52aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WgBt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xbrq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__("ABCa");

var _index2 = _interopRequireDefault(_index);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Header',
  components: { XHeader: _index2.default },
  props: {
    pageTitle: {
      required: false
    },
    showFilter: {
      required: false,
      type: Boolean,
      default: false
    },
    zIndex: {}
  },
  data: function data() {
    return {};
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    route: function route(state) {
      return state.route;
    },
    isHeaderArea: function isHeaderArea(state) {
      return state.route.meta.isHeaderArea;
    }
  }), {
    leftVisible: function leftVisible() {
      if (this.pageTitle) return true;
      return !this.route.meta.isTabBar;
    },
    title: function title() {
      if (this.pageTitle) return this.pageTitle;
      if (this.route.meta.title) return this.$t(this.route.meta.title);
      return '';
    },
    headerVisible: function headerVisible() {
      if (this.pageTitle) return true;
      return this.isHeaderArea;
    }
  }),
  methods: {}
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectList = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Home = __webpack_require__("jRHq");

var _Home2 = _interopRequireDefault(_Home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var redirectList = exports.redirectList = ['/login', '/register'];

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "M52x"));
    },
    redirect: '/home',
    children: [{
      path: '/home',
      component: _Home2.default,
      name: 'Home',
      meta: {
        isTabBar: true,
        title: 'home.title'
      }
    }, {
      path: '/currency',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "JKnI"));
      },
      name: 'Currency',
      meta: {
        isTabBar: true,
        title: 'currency.title'
      }
    }, {
      path: '/trade',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "7MtD"));
      },
      name: 'Trade',
      meta: {
        isTabBar: true,
        title: 'trade.title'
      }
    }, {
      path: '/fund',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "MlJf"));
      },
      name: 'Fund',
      meta: {
        isTabBar: true,
        title: 'fund.title'
      }
    }, {
      path: '/finance',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "WAlr"));
      },
      name: 'Finance',
      meta: {
        isTabBar: true,
        title: 'finance.title'
      }
    }, {
      path: '/all-finance',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "VYKL"));
      },
      name: 'AllFinance',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'allFinance.title'
      }
    }, {
      path: '/buy-finance',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(__webpack_require__.bind(null, "zsiE"));
      },
      name: 'BuyFinance',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'buyFinance.title'
      }
    }, {
      path: '/finance-orders',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "qTbF"));
      },
      name: 'FinanceOrders',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'financeOrders.title'
      }
    }, {
      path: '/finance-order-bills',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(__webpack_require__.bind(null, "ok1X"));
      },
      name: 'FinanceOrderBills',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'financeOrderBills.title'
      }
    }, {
      path: '/user-center',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, "kpmR"));
      },
      name: 'UserCenter',
      meta: {
        isTabBar: true,
        title: 'userCenter.title'
      }
    }, {
      path: '/contract-trade',
      component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "Qp4d"));
      },
      name: 'ContractTrade',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: '合约交易'
      }
    }, {
      path: '/user-bills',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "1CwQ"));
      },
      name: 'UserBills',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'userBills.title'
      }
    }, {
      path: '/settings',
      component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "eoPo"));
      },
      name: 'Settings',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'settings.title'
      }
    }, {
      path: '/edit-login-password',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(__webpack_require__.bind(null, "iHnF"));
      },
      name: 'EditLoginPassword',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'editLoginPassword.title'
      }
    }, {
      path: '/bind-fund-password',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(__webpack_require__.bind(null, "LW8i"));
      },
      name: 'BindFundPassword',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'bindFundPassword.title'
      }
    }, {
      path: '/bind-google-validator',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(__webpack_require__.bind(null, "SI5i"));
      },
      name: 'BindGoogleValidator',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'bindGoogleValidator.title'
      }
    }, {
      path: '/edit-fund-password',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(__webpack_require__.bind(null, "rkLw"));
      },
      name: 'EditFundPassword',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'editFundPassword.title'
      }
    }, {
      path: '/receive-ways',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(__webpack_require__.bind(null, "un5L"));
      },
      name: 'ReceiveWays',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'receiveWays.title'
      }
    }, {
      path: '/zsk-account',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, "HNFx"));
      },
      name: 'ZskAccount',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'zskAccount.title'
      }
    }, {
      path: '/add-zsk-account',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, "MdqL"));
      },
      name: 'AddZskAccount',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'addZskAccount.title'
      }
    }, {
      path: '/add-bank-card',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "WQ+7"));
      },
      name: 'AddBankCard',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'addBankCard.title'
      }
    }, {
      path: '/wallet-address',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(__webpack_require__.bind(null, "0CQD"));
      },
      name: 'WalletAddress',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'walletAddress.title'
      }
    }, {
      path: '/add-wallet-address',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(__webpack_require__.bind(null, "0G+Q"));
      },
      name: 'AddWalletAddress',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'addWalletAddress.title'
      }
    }, {
      path: '/help',
      component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "fO/Q"));
      },
      name: 'Help',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'help.title'
      }
    }, {
      path: '/help-detail/:helpIndex',
      component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "DIrH"));
      },
      name: 'HelpDetail',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'helpDetail.title'
      }
    }, {
      path: '/share',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "u8XC"));
      },
      name: 'Share',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'share.title'
      }
    }, {
      path: '/recharge',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "d6qp"));
      },
      name: 'Recharge',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'recharge.title'
      }
    }, {
      path: '/withdraw',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "MYXC"));
      },
      name: 'Withdraw',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'withdraw.title'
      }
    }, {
      path: '/recharge-order',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "5qi5"));
      },
      name: 'RechargeOrder',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'rechargeOrder.title'
      }
    }, {
      path: '/withdraw-order',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "Ju4/"));
      },
      name: 'WithdrawOrder',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'withdrawOrder.title'
      }
    }, {
      path: '/timing-trade-order',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "617o"));
      },
      name: 'TimingTradeOrder',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'timingTradeOrder.title'
      }
    }, {
      path: '/spot-holding',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "eMEY"));
      },
      name: 'SpotHolding',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: '期货持仓'
      }
    }, {
      path: '/contract-trade-order',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "B5dE"));
      },
      name: 'ContractTradeOrder',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'contractTradeOrder.title'
      }
    }, {
      path: '/my-team',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "15Da"));
      },
      name: 'MyTeam',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'myTeam.title'
      }
    }, {
      path: '/add-user',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "usSk"));
      },
      name: 'AddUser',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'addUser.title'
      }
    }, {
      path: '/user-report',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "+g/E"));
      },
      name: 'UserReport',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'userReport.title'
      }
    }, {
      path: '/user-report-day',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(__webpack_require__.bind(null, "X/W7"));
      },
      name: 'UserReportDay',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'userReportDay.title'
      }
    }, {
      path: '/team-report',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "wsY3"));
      },
      name: 'TeamReport',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'teamReport.title'
      }
    }, {
      path: '/team-report-day',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(__webpack_require__.bind(null, "tPbN"));
      },
      name: 'TeamReportDay',
      meta: {
        isTabBar: false,
        isHeaderArea: true,
        title: 'teamReportDay.title'
      }
    }, {
      path: '/add-to-home',
      component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "EKGr"));
      },
      name: 'AddToHome',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'addToHome.title'
      }
    }, {
      path: '/my-message',
      component: function component() {
        return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "48ce"));
      },
      name: 'MyMessage',
      meta: {
        isTabBar: false,
        isHeaderArea: false,
        title: 'myMessage.title'
      }
    }]
  }, {
    path: '/login',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "rwea"));
    }
  }, {
    path: '/register',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, "dQWc"));
    }
  }]
});

/***/ }),

/***/ "Ypiv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_THEME_MODE = exports.SET_THEME_MODE = 'SET_THEME_MODE';
var SET_TOKEN = exports.SET_TOKEN = 'SET_TOKEN';
var SET_USER_INFO = exports.SET_USER_INFO = 'SET_USER_INFO';
var SET_CUSTOMER_VISIBLE = exports.SET_CUSTOMER_VISIBLE = 'SET_CUSTOMER_VISIBLE';
var SET_CACHE_INFO = exports.SET_CACHE_INFO = 'SET_CACHE_INFO';
var SET_SYSTEM_CONFIG = exports.SET_SYSTEM_CONFIG = 'SET_SYSTEM_CONFIG';
var SET_DICT = exports.SET_DICT = 'SET_DICT';
var SET_HIDE_BALANCE = exports.SET_HIDE_BALANCE = 'SET_HIDE_BALANCE';
var SET_LOCALE_POP_VISIBLE = exports.SET_LOCALE_POP_VISIBLE = 'SET_LOCALE_POP_VISIBLE';
var SET_FAVORITE_CURRENCIES = exports.SET_FAVORITE_CURRENCIES = 'SET_FAVORITE_CURRENCIES';
var SET_VC_ID = exports.SET_VC_ID = 'SET_VC_ID';
var SET_TRADE_CONFIG = exports.SET_TRADE_CONFIG = 'SET_TRADE_CONFIG';
var SET_VC_LIST = exports.SET_VC_LIST = 'SET_VC_LIST';
var SET_CONTRACT_TRADE_CONFIG = exports.SET_CONTRACT_TRADE_CONFIG = 'SET_CONTRACT_TRADE_CONFIG';
var SET_CONTRACT_TRADE_DETAIL_MESSAGE = exports.SET_CONTRACT_TRADE_DETAIL_MESSAGE = 'SET_CONTRACT_TRADE_DETAIL_MESSAGE';
var SET_CURRENT_LOCALE = exports.SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE';
var SET_LOCALE_LIST = exports.SET_LOCALE_LIST = 'SET_LOCALE_LIST';
var SET_COIN_LIST_WITH_PRICE = exports.SET_COIN_LIST_WITH_PRICE = 'SET_COIN_LIST_WITH_PRICE';

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__ = __webpack_require__("RJTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__ = __webpack_require__("+kMp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6f37d428_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_vue__ = __webpack_require__("yqQW");
function injectStyle (ssrContext) {
  __webpack_require__("Sx3z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_flexbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_6f37d428_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_flexbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YyuS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z/xP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z5JB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
};

/***/ }),

/***/ "Zplo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nLanguageSimpleList = exports.sysNoticePage = exports.sysNoticeList = exports.sysCacheRefreshList = exports.sysConfigSimpleList = undefined;

var _request = __webpack_require__("vLgD");

var _request2 = _interopRequireDefault(_request);

var _prefix = __webpack_require__("jnOm");

var _prefix2 = _interopRequireDefault(_prefix);

var _auth = __webpack_require__("Pfph");

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***
 * 获取系统配置及字典列表
 * @param data
 * @returns {AxiosPromise}
 */
var sysConfigSimpleList = exports.sysConfigSimpleList = function sysConfigSimpleList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/sys-config/simple-list',
    method: 'post',
    data: data
  });
};

/***
 * 获取系统配置及字典列表
 * @param data
 * @returns {AxiosPromise}
 */
var sysCacheRefreshList = exports.sysCacheRefreshList = function sysCacheRefreshList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/sys-cache-refresh/list',
    method: 'post',
    data: data
  });
};

/***
 * 获取系统公告列表
 * @param data
 * @returns {AxiosPromise}
 */
var sysNoticeList = exports.sysNoticeList = function sysNoticeList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/sys-notice/list',
    method: 'post',
    data: data
  });
};

/***
 * 获取系统公告分页
 * @param data
 * @returns {AxiosPromise}
 */
var sysNoticePage = exports.sysNoticePage = function sysNoticePage(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/sys-notice/page',
    method: 'post',
    data: data
  });
};

/** *
 * 系统支持的语言列表
 * @param data
 * @returns {AxiosPromise}
 */
var i18nLanguageSimpleList = exports.i18nLanguageSimpleList = function i18nLanguageSimpleList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/i18n-language/simple-list',
    method: 'post',
    data: data
  });
};

/***/ }),

/***/ "Zts+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster-container content-bg",on:{"click":function($event){return _vm.$router.push('/recharge')}}},[_c('div',{staticClass:"title txt-color"},[_c('div',{staticClass:"left"},[_vm._v(_vm._s(_vm.$t('home.poster.title')))]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.$t('home.poster.enter')))])]),_vm._v(" "),_c('div',{staticClass:"sub-title sub-title-color"},[_vm._v("\n    "+_vm._s(_vm.$t('home.poster.subTitle'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aGcY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aMHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"increase-container"},[(_vm.increaseCoinList.length)?_c('ul',{staticClass:"increase-t-body"},_vm._l((_vm.increaseCoinList),function(currency){return _c('li',{key:currency.id,on:{"click":function($event){return _vm.clickVcItem(currency)}}},[_c('div',{staticClass:"currency-type"},[_c('span',{staticClass:"type txt-color"},[_vm._v(_vm._s(currency.c))]),_vm._v(" "),_c('span',{staticClass:"name symbol-txt-color"},[_vm._v("/USDT")])]),_vm._v(" "),_c('div',{staticClass:"price txt-color"},[_c('span',[_vm._v(_vm._s(_vm._f("getFullNum")(currency.g)))])]),_vm._v(" "),_c('div',{staticClass:"increase",class:currency.k >= 0 ? 'green-bg' : 'red-bg'},[_c('span',[_vm._v(_vm._s(currency.k >= 0 ? "+" : '')+_vm._s(currency['changePerStr'] || '0%'))])])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aqGt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: 'Log Masuk',
    usernameLabel: 'Nama pengguna',
    usernamePlaceholder: '2-10 kombinasi digit bahasa Inggeris bermula dengan bahasa Inggeris',
    loginPasswordLabel: 'kata laluan log masuk',
    loginPasswordPlaceholder: 'Sila masukkan kata laluan log masuk anda',
    googleCodeLabel: 'Kod pengesahan Google',
    googleCodePlaceholder: 'Sila masukkan kod pengesahan Google 6 digit',
    hasNoAccount: 'Belum ada akaun,',
    goRegister: 'Pergi untuk mendaftar',
    onlineCustom: 'Perkhidmatan pelanggan dalam talian',
    loginArgument: 'Teruskan log masuk bermakna bersetuju',
    userArgument: '《Perjanjian Pengguna》',
    registerNotEnabled: 'Fungsi pendaftaran tidak dibuka, sila hubungi pentadbir',
    usernameRequired: 'Sila masukkan nama pengguna yang betul',
    loginPasswordRequired: 'Sila masukkan kata laluan log masuk yang betul',
    googleCodeRequired: 'Sila masukkan kod pengesahan Google yang betul',
    loginButton: 'log masuk'
  },
  register: {
    title: 'Daftar',
    usernameLabel: 'Nama pengguna',
    usernamePlaceholder: 'Sila masukkan nama pengguna berdaftar',
    loginPasswordLabel: 'kata laluan log masuk',
    loginPasswordPlaceholder: 'Sila masukkan kata laluan log masuk pengguna berdaftar',
    loginPasswordPreLabel: 'Sahkan kata laluan log masuk',
    loginPasswordPrePlaceholder: 'Sila masukkan kata laluan log masuk sekali lagi',
    fudPasswordLabel: 'kata laluan dana',
    fudPasswordPlaceholder: 'Sila masukkan kata laluan dana',
    inviteCodeLabel: 'Kod Jemputan',
    inviteCodePlaceholder: 'Sila masukkan kod jemputan 6 digit',
    registerNeed: 'Teruskan mendaftar bermakna bersetuju',
    registerArgument: '《Perjanjian Pendaftaran》',
    usernameRequired: 'Sila masukkan nama pengguna yang betul',
    loginPasswordRequired: 'Sila masukkan kata laluan log masuk yang betul',
    loginPasswordPreRequired: 'Sila masukkan kata laluan log masuk pengesahan yang betul',
    fundPasswordRequired: 'Sila masukkan kata laluan dana yang betul',
    inviteCodeRequired: 'Sila masukkan kod jemputan yang betul',
    diffLoginPasswordError: 'Dua kata laluan log masuk tidak konsisten',
    registerSuccess: 'Pendaftaran berjaya',
    registerButton: 'Daftar',
    emailLabel: 'E-mel',
    emailPlaceholder: 'Sila masukkan alamat e-mel anda',
    emailCodeLabel: 'Kod pengesahan',
    emailCodePlaceholder: 'Sila masukkan kod pengesahan e-mel anda',
    second: 'kedua',
    getEmailCodeButton: 'Dapatkan kod',
    emailRequired: 'Sila masukkan alamat e-mel yang betul dan cuba lagi',
    emailCodeRequired: 'Sila masukkan kod pengesahan e-mel yang betul dan cuba lagi'
  },
  home: {
    hotCoin: {
      title: 'Tawaran hebat',
      more: 'lagi'
    },
    poster: {
      title: 'Deposit cepat',
      enter: 'Masuk sekarang>',
      subTitle: 'Sokong BTC, USDT, ETH, dsb.'
    },
    quickMenus: {
      futuresTrading: 'Perdagangan Niaga Hadapan',
      helpCenter: 'Pusat Bantuan'
    },
    ranking: {
      increase: {
        title: 'Senarai meningkat'
      },
      clinch: {
        title: 'Senarai Perolehan'
      }
    }
  },
  tabBar: {
    home: 'Rumah',
    price: 'sebut harga',
    trade: 'Perdagangan',
    fund: 'Aset',
    user: 'saya'
  },
  currency: {
    favorite: 'Pilihan',
    allCurrency: 'spot',
    dayVol: 'jumlah 24J',
    addFavor: '+ Add Favor'
  },
  trade: {
    bills: 'Bills',
    todayOpen: 'Buka',
    star: 'Pilihan',
    vol: 'Volume',
    low: 'paling rendah',
    high: 'tertinggi',
    timing: 'cepat',
    spot: 'niaga hadapan',
    buyMore: 'beli lagi',
    buyEmpty: 'beli pendek',
    indicator: 'Penunjuk',
    indicatorSettings: 'Tetapan Penunjuk',
    balance: 'baki saya',
    fee: 'yuran perkhidmatan',
    ruleIdError: 'Sila pilih masa tamat tempoh',
    deleteFavoriteSuccess: 'Berjaya memadam mata wang kegemaran',
    addFavoriteSuccess: 'Menambahkan mata wang yang dipilih berjaya',
    buyIn: 'beli',
    sellout: 'Jual',
    holding: 'memegang kedudukan',
    history: 'Sejarah',
    spotOrderConfirm: {
      title: 'Sahkan Beli',
      amountPlaceholder: 'Sila masukkan kuantiti pembelian'
    },
    spotTradeOrder: {
      holding: {
        coin: 'mata wang',
        buyInAmountPrice: 'Amaun/Harga Beli',
        buyInCount: 'Kuantiti',
        actions: 'Operasi',
        sellout: 'Jual',
        profit: 'Untung'
      }
    },
    orderConfirm: {
      title: 'Pengesahan Pesanan',
      coinName: 'mata wang',
      direction: 'arah',
      price: 'harga semasa',
      balance: 'Baki',
      fee: 'yuran perkhidmatan',
      buyMoreLabel: 'beli lebih banyak',
      buyEmptyLabel: 'beli pendek',
      buyQuantity: 'Beli kuantiti',
      buyAmount: 'Jumlah Belian',
      submit: 'Mengesahkan pesanan'
    },
    kline: {
      open: 'Buka:',
      close: 'tutup:',
      change: 'Naik dan turun:'
    }
  },

  finance: {
    title: 'Kewangan'
  },
  allFinance: {
    title: 'Pengurusan kewangan',
    all: 'semua'
  },
  financeOrders: {
    title: 'Perintah ikrar',
    holdingLabel: 'memegang',
    historyLabel: 'Sejarah',
    holding: {
      amount: 'Jumlah ikrar',
      rateStr: 'jumlah pendapatan/hasil',
      vcCount: 'Bilangan syiling yang dicagarkan',
      cycle: 'Kitaran kedudukan',
      day: 'hari',
      calcStartDate: 'Tarikh nilai mula',
      serviceAmount: 'Yuran Perkhidmatan',
      redeemOrder: 'Tebus'
    },
    history: {
      incomeAmount: 'jumlah pendapatan',
      rateStr: 'hasil',
      amount: 'Jumlah ikrar',
      vcCount: 'Bilangan syiling yang dicagarkan',
      calcStartDate: 'Tarikh nilai mula',
      calcEndDate: 'Tarikh Tamat',
      cycle: 'hari kitaran',
      serviceAmount: 'Yuran Perkhidmatan',
      day: 'hari'
    }
  },
  financeOrderBills: {
    title: 'Bil pendapatan ikrar',
    amount: 'jumlah',
    balance: 'Baki'
  },
  financeItem: {
    rateStr: 'hasil',
    buyType: 'Jenis Beli',
    cycle: 'hari kitaran',
    exchangeRate: 'Kadar pertukaran (baki pertukaran mata wang maya)',
    day: 'hari',
    cycleType: 'jenis kitaran',
    serviceRateStr: 'Kadar Perkhidmatan'
  },
  buyFinance: {
    title: 'Beli',
    rateStr: 'hasil',
    nama: 'nama',
    buyType: 'Jenis Beli',
    cycle: 'hari kitaran',
    cycleType: 'jenis kitaran',
    exchangeRate: 'Kadar pertukaran (baki pertukaran mata wang maya)',
    serviceRateStr: 'Kadar Perkhidmatan',
    remark: 'remark',
    buyAmountLabel: 'Amaun Beli ({coin})',
    descriptionTitle: 'Perihalan Produk',
    descriptionPart1: '1. Produk ini ialah produk pengurusan kekayaan yang tidak dijamin oleh prinsipal. Turun naik pasaran boleh menyebabkan kerugian prinsipal. Sila melabur dengan berhati-hati.',
    descriptionPart2: '2. Peraturan penyelesaian pembayaran:',
    descriptionPart3: 'Jika harga penyelesaian < harga terpaut, BTC akan diselesaikan selepas matang; jumlah penyelesaian = jumlah pelaburan * (1+ hari * kadar pulangan tahunan / 365).',
    descriptionPart4: 'Jika harga penyelesaian ≥ harga terpaut, USDT akan dijelaskan selepas matang; jumlah penyelesaian = jumlah pelaburan * harga terpaut * (1+ hari * kadar pulangan tahunan / 365).',
    descriptionPart5: '3. Kadar pulangan tahunan sebenar berubah dengan pasaran dalam masa nyata, sila rujuk transaksi pembelian sebenar.',
    descriptionPart6: '4. Amaun pelaburan ditukar mengikut pasaran dalam masa nyata, sila rujuk transaksi pembelian sebenar.',
    descriptionPart7: '5. Selepas produk dibeli, ia boleh dilihat pada halaman pegangan mata wang saya, dan bayaran balik akan dikeluarkan secara automatik ke akaun spot selepas tarikh tamat tempoh.',
    buyButton: 'Beli [{coin}]'
  },

  fund: {
    description: 'aset',
    recharge: 'Deposit',
    withdraw: 'Menarik diri',
    exchange: 'Pemindahan',
    empty: 'Dompet kosong, pergi'
  },
  userCenter: {
    lastLogin: 'Masa log masuk',
    myTeam: 'Pasukan Saya',
    identity: 'pengesahan nama sebenar',
    walletAddress: 'alamat dompet',
    zskAccount: 'Akaun pantas',
    bankCard: 'Akaun bank',
    userBills: 'Rekod Perubahan Akaun',
    timingTradeOrder: 'Kedudukan yang sangat pantas',
    spotTradeOrder: 'Kedudukan niaga hadapan',
    contactTradeOrder: 'Kedudukan kontrak',
    userReport: 'Laporan Pengguna',
    teamReport: 'laporan pasukan',
    share: 'Saya mahu berkongsi',
    customer: 'Hubungi perkhidmatan pelanggan',
    helpCenter: 'Pusat Bantuan',
    platform: 'Pengenalan Platform',
    profit: 'untung dan rugi hari ini',
    balance: 'Baki saya',
    withdraw: 'Menarik diri',
    recharge: 'Deposit',
    creditStoreLabel: 'Mata Kredit'
  },
  settings: {
    title: 'Tetapan',
    fundPassword: 'kata laluan dana',
    googleValidator: 'Google Validator',
    editLoginPassword: 'Tukar kata laluan log masuk',
    switchLocale: 'tukar bahasa'
  },
  editFundPassword: {
    title: 'Tukar Kata Laluan Dana',
    currentPasswordLabel: 'kata laluan semasa',
    currentPasswordPlaceholder: 'Sila masukkan kata laluan dana semasa',
    newPasswordLabel: 'Kata Laluan Baharu',
    newPasswordPlaceholder: 'Sila masukkan kata laluan dana yang diubah suai',
    prePasswordLabel: 'Sahkan kata laluan',
    prePasswordPlaceholder: 'Kosongkan dan masukkan semula kata laluan dana yang diubah suai',
    tips: 'Kata laluan dana ialah sijil penting untuk urus niaga, sila tetapkannya dengan teliti dan ingatkannya',
    currentPasswordRequired: 'Sila masukkan kata laluan dana semasa',
    newPasswordRequired: 'Sila masukkan kata laluan dana untuk diubah suai',
    prePasswordRequired: 'Sila masukkan kata laluan dana untuk diubah suai semula',
    prePasswordDiff: 'Dua input kata laluan tidak konsisten'
  },
  bindFundPassword: {
    title: 'Ikat kata laluan dana',
    fundPasswordLabel: 'kata laluan dana',
    fundPasswordPlaceholder: 'Sila masukkan kata laluan dana',
    fundPasswordPreLabel: 'Sahkan kata laluan',
    fundPasswordPrePlaceholder: 'Sila masukkan kata laluan dana sekali lagi',
    fundPasswordRequired: 'Sila masukkan kata laluan dana yang betul',
    fundPasswordPreRequired: 'Sila masukkan kata laluan pengesahan yang betul',
    fundPasswordDiff: 'Kedua-dua kata laluan tidak konsisten',
    bindSuccess: 'Kata laluan dana berjaya diikat',
    tips: 'Kata laluan dana ialah bukti kelayakan penting untuk urus niaga, sila tetapkannya dengan berhati-hati dan ingatkannya'
  },
  editLoginPassword: {
    title: 'Tukar kata laluan log masuk',
    currentPasswordLabel: 'kata laluan semasa',
    currentPasswordPlaceholder: 'Sila masukkan kata laluan log masuk semasa',
    newPasswordLabel: 'Kata Laluan Baharu',
    newPasswordPlaceholder: 'Sila masukkan kata laluan log masuk yang diubah suai',
    prePasswordLabel: 'Sahkan kata laluan',
    prePasswordPlaceholder: 'Kosongkan dan masukkan semula kata laluan log masuk yang diubah suai',
    tips: 'Kata laluan log masuk ialah bukti kelayakan penting untuk pengesahan log masuk, dsb., sila tetapkannya dengan berhati-hati dan ingatkannya',
    currentPasswordRequired: 'Sila masukkan kata laluan log masuk semasa',
    newPasswordRequired: 'Sila masukkan kata laluan log masuk untuk diubah suai',
    prePasswordRequired: 'Sila masukkan semula kata laluan log masuk untuk diubah suai',
    prePasswordDiff: 'Dua input kata laluan tidak konsisten'
  },
  bindGoogleValidator: {
    title: 'Bind Google Authenticator',
    qrCodeLabel: 'Kod QR',
    keyLabel: 'Kunci',
    loginPasswordLabel: 'kata laluan log masuk',
    loginPasswordPlaceholder: 'Sila masukkan kata laluan log masuk anda',
    googleCodeLabel: 'Kod pengesahan Google',
    googleCodePlaceholder: 'Sila masukkan kod pengesahan Google 6 digit',
    tipsPart1: 'Cari Google Authenticator dalam gedung aplikasi',
    tipsPart2: 'Gunakan Google Authenticator untuk mengimbas kod QR di atas, atau masukkan kekunci secara manual untuk mengikat',
    tipsPart3: 'Masukkan kod pengesahan Google 6 digit di atas, klik Sahkan untuk menyerahkan',
    loginPasswordDiperlukan: 'Sila masukkan kata laluan log masuk',
    googleCodeRequired: 'Sila masukkan kod pengesahan Google 6 digit'
  },
  walletAddress: {
    title: 'Alamat dompet',
    add: '+ tambah alamat dompet',
    remark: 'remark',
    addButton: 'Tambah alamat dompet',
    tips: 'Jika anda ingin mengubah suai atau memadam maklumat alamat, sila hubungi perkhidmatan pelanggan'
  },
  addWalletAddress: {
    title: 'Tambah alamat dompet',
    vcChainNameIdLabel: 'jenis rantai',
    vcAccountLabel: 'alamat dompet',
    vcAccountPlaceholder: 'Sila masukkan alamat dompet',
    remarkLabel: 'Remarks',
    remarkPlaceholder: 'Sila masukkan kandungan catatan',
    fundPasswordLabel: 'kata laluan dana',
    fundPasswordPlaceholder: 'Sila masukkan kata laluan dana anda',
    tips: 'Alamat dompet yang ditambahkan tidak boleh diubah suai, sila sahkan bahawa maklumat itu betul',
    vcIdRequired: 'Sila pilih mata wang yang betul',
    vcChainNameIdRequired: 'Sila pilih jenis rantai yang betul',
    vcAccountRequired: 'Sila masukkan alamat dompet yang betul',
    fundPwdRequired: 'Sila masukkan kata laluan dana yang betul',
    addSuccess: 'Alamat dompet berjaya ditambahkan'
  },
  receiveWays: {
    title: 'Kad Bank Saya',
    add: '+ Tambah kad bank',
    tips: 'Jika anda ingin mengubah suai atau memadam maklumat kad bank, sila hubungi perkhidmatan pelanggan',
    addCardButton: 'Tambah kad bank'
  },
  zskAccount: {
    title: 'Akaun pantas',
    add: '+ Tambah akaun pantas',
    tips: 'Untuk mengubah suai atau memadam maklumat akaun, sila hubungi perkhidmatan pelanggan',
    addCardButton: 'Tambah akaun'
  },
  addZskAccount: {
    title: 'Tambah akaun pantas',
    withdrawNameLabel: 'Nama',
    withdrawNamePlaceholder: 'Sila masukkan nama anda',
    withdrawNameRequired: 'Nama tidak dibenarkan kosong',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Sila masukkan ID kelajuan pantas',
    fundPasswordLabel: 'kata laluan dana',
    fundPasswordPlaceholder: 'Sila masukkan kata laluan dana anda',
    tips: 'Sila isi dengan teliti maklumat akaun yang ditambahkan, syarikat tidak akan bertanggungjawab terhadap masalah pengeluaran gagal tiba kerana maklumat yang salah'
  },
  addBankCard: {
    title: 'Tambah kad bank baharu',
    cardNumLabel: 'Nombor kad bank',
    withdrawNameLabel: 'Nama',
    withdrawNamePlaceholder: 'Sila masukkan nama anda',
    withdrawNameRequired: 'Nama tidak dibenarkan kosong',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Sila masukkan ID kelajuan pantas',
    zskRequired: 'Sila masukkan ID kelajuan yang betul',
    cardNumPlaceholder: 'Sila masukkan nombor kad bank',
    branchLabel: 'Alamat cawangan',
    branchPlaceholder: 'Sila masukkan alamat cawangan kad bank',
    fundPasswordLabel: 'kata laluan dana',
    fundPasswordPlaceholder: 'Sila masukkan kata laluan dana',
    tips: 'Kad bank adalah data penting untuk pengeluaran tunai transaksi, sila isi dengan teliti, syarikat tidak akan bertanggungjawab terhadap sebarang masalah seperti kegagalan menerima wang tunai kerana pengisian maklumat kad yang salah. ',
    backIdRequired: 'Sila pilih bank akaun',
    cardNumRequired: 'Sila masukkan nombor kad bank yang betul',
    fundPwdRequired: 'Sila masukkan kata laluan dana yang betul',
    idCardPlaceholder: 'Sila masukkan nombor ID anda',
    idCardLabel: 'Nombor kad ID',
    idCardRequired: 'Sila masukkan nombor ID yang betul',
    cciPlaceholder: 'Sila masukkan CCI kad bank',
    branchCodePlaceholder: 'Sila masukkan kod cawangan',
    branchCodeLabel: 'Kod Cawangan',
    katakanaPlaceholder: 'Sila masukkan katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Rekod Perubahan Akaun',
    vcName: 'Mata Wang',
    amount: 'jumlah',
    balance: 'Baki'
  },
  timingTradeOrder: {
    title: 'Pesanan Dagangan Amat Cepat',
    waiting: {
      title: 'Pesanan sedang berjalan',
      amount: 'jumlah',
      period: 'tempoh',
      receivePrice: 'Harga beli',
      settlement: 'penyelesaian sedang berjalan'
    },
    spotTradeOrder: {
      title: '期货交易订单',
      waiting: {
        title: '在持订单',
        buyInAmount: '买入总价',
        buyInPrice: '买入单价',
        buyInCount: '买入数量',
        buyInTime: '买入时间'
      },
      history: {
        title: '历史订单',
        buyInAmount: '买入总价',
        buyInPrice: '买入单价',
        buyInCount: '买入数量',
        sellOutAmount: '卖出总价',
        sellOutPrice: '卖出单价',
        sellOutTime: '卖出时间'
      }
    },
    history: {
      title: 'Perintah Sejarah',
      buyInClose: 'Harga beli',
      saleOutClose: 'harga jualan'
    }
  },
  userReport: {
    title: 'Laporan Pengguna',
    profit: 'Keuntungan',
    timingTradeAmountFee: 'Yuran pesanan/pengendalian dagangan yang sangat pantas',
    timingTradePrizePoint: 'Bonus/rebat dagangan yang sangat pantas',
    rechargeInfo: 'Caj semula/yuran pengendalian',
    withdrawInfo: 'Yuran pengeluaran/pengendalian',
    exchangeInfo: 'Yuran pertukaran/pengendalian'
  },
  userReportDay: {
    title: 'Laporan Harian Pengguna',
    profit: 'Keuntungan',
    timingTradeAmountFee: 'Yuran pesanan/pengendalian dagangan yang sangat pantas',
    timingTradePrizePoint: 'Bonus/rebat dagangan yang sangat pantas',
    rechargeInfo: 'Caj semula/yuran pengendalian',
    withdrawInfo: 'Yuran pengeluaran/pengendalian',
    exchangeInfo: 'Yuran pertukaran/pengendalian'
  },
  teamReport: {
    title: 'Laporan Pasukan',
    goToReportDay: 'Lihat laporan harian',
    timingTradeBetAmountServiceCharge: 'Caj pesanan/perkhidmatan dagangan yang sangat pantas',
    timingTradeBetPrizePoint: 'Bonus/Rebat Dagangan Cepat',
    timingTradeUserAndCount: 'Bilangan peniaga kelajuan/bilangan transaksi',
    rechargeAmountFee: 'Jumlah caj semula/yuran perkhidmatan',
    rechargePersonCount: 'Caj semula orang/bilangan transaksi',
    withdrawAmountFee: 'amaun pengeluaran/yuran perkhidmatan',
    withdrawPersonCount: 'Bilangan orang yang mengeluarkan wang/urus niaga',
    firstRechargeUserAndCount: 'Jumlah caj semula pertama/bilangan orang',
    usernamePlaceholder: 'Masukkan nama pengguna peringkat bawah',
    previewAllTradeInfo: 'Lihat semua maklumat perdagangan kelajuan',
    coin: 'mata wang',
    timingTradeBetAmount: 'Jumlah pertaruhan dagangan yang sangat pantas',
    profit: 'Keuntungan',
    action: 'operasi',
    previewReportDay: 'Lihat laporan harian'
  },
  teamTimingTradeInfo: {
    title: 'Perdagangan Kelajuan Pasukan',
    profit: 'Keuntungan',
    subTitle: 'Maklumat transaksi kelajuan pasukan',
    timingTradeAmountFee: 'Yuran pesanan/perkhidmatan dagangan yang sangat pantas',
    timingTradePrizePoint: 'Bonus/rebat dagangan yang sangat pantas',
    rechargeInfo: 'Caj semula/Yuran Perkhidmatan',
    withdrawInfo: 'Pengeluaran/Yuran Perkhidmatan',
    exchangeInfo: 'Yuran Pertukaran/Perkhidmatan'
  },
  teamReportDay: {
    title: 'Laporan Harian Pasukan',
    subTitle: 'Laporan Harian Pasukan [{username}]',
    timingTradeBetAmountFee: 'Yuran pesanan/perkhidmatan dagangan yang sangat pantas',
    timingTradeBetPrizePoint: 'Bonus/Rebat Dagangan Cepat',
    rechargeAmountFee: 'Jumlah caj semula/yuran perkhidmatan',
    rechargePersonCount: 'Caj semula orang/bilangan transaksi',
    timingTradeUserAndCount: 'Bilangan peniaga kelajuan/bilangan transaksi',
    firstRechargePersonCount: 'Jumlah caj semula pertama/bilangan transaksi',
    withdrawAmountFee: 'amaun pengeluaran/yuran perkhidmatan',
    withdrawPersonCount: 'Bilangan orang yang mengeluarkan wang/urus niaga',
    exchangeAmountFee: 'Amaun Pertukaran/Yuran Perkhidmatan'
  },
  share: {
    title: 'Saya ingin berkongsi',
    qrCodeLabel: 'Kod QR',
    registerUrlLabel: 'Alamat Pendaftaran',
    inviteCodeLabel: 'Kod Jemputan',
    hasNoInviteCode: 'Akaun semasa tidak mempunyai kod jemputan,',
    generateInvitationCode: 'Cuba jana dengan satu klik',
    tipsPart1: 'Imbas kod QR di atas untuk mengisi maklumat pendaftaran untuk mendaftar',
    tipsPart2: 'Salin alamat pendaftaran dan isi maklumat pendaftaran untuk mendaftar',
    tipsPart3: 'Buka secara manual antara muka pendaftaran tapak ini dan isikan kod jemputan untuk mendaftar',
    saveImageError: 'Gagal menyimpan gambar, cuba tekan lama gambar dan simpan'
  },
  myTeam: {
    title: 'Pasukan Saya',
    usernamePlaceholder: 'Masukkan nama pengguna peringkat bawah',
    point: 'rebat (kelajuan/kontrak)',
    totalBalance: 'Baki',
    lastLoginTime: 'Masa Log Masuk Terakhir',
    noLoginTime: 'tiada'
  },
  userDetail: {
    username: 'nama pengguna',
    userType: 'Jenis Pengguna',
    title: 'Butiran Pengguna',
    pointPercentTiming: 'Rebat transaksi yang sangat pantas',
    pointPercentContract: 'Rebat transaksi kontrak',
    registerWay: 'Kaedah pendaftaran',
    teamCounts: 'Nombor pasukan',
    teamOnline: 'pasukan dalam talian',
    balance: 'Baki',
    registerTime: 'Masa pendaftaran',
    onlineStatus: 'status log masuk'
  },
  addUser: {
    title: 'Tambah Pengguna',
    addUserDirect: {
      userTypeLabel: 'Jenis Pengguna',
      usernameLabel: 'Nama pengguna',
      usernamePlaceholder: 'Sila masukkan nama pengguna akaun',
      pointTimingLabel: 'Rebat transaksi yang sangat pantas',
      pointContractLabel: 'Rebat transaksi kontrak',
      tips: 'Kata laluan awal ialah: "{password}"; sila ingatkan pengguna untuk menukar kata laluan dalam masa selepas membuka akaun',
      userTypeRequired: 'Sila pilih jenis akaun',
      usernameRequired: 'Sila masukkan nama pengguna akaun',
      pointTimingRequired: 'Sila pilih rebat transaksi yang pantas',
      pointContractRequired: 'Sila pilih rebat transaksi kontrak',
      copyTemplate: '\n         Nama pengguna: {username};\n         Kata laluan log masuk: {loginPassword};\n         URL log masuk: {loginAddress};\n         Rebat dagangan pantas: {timingTradePoint};\n         Rebat dagangan kontrak: {contactTradePoint};\n         '
    }
  },
  recharge: {
    title: 'Deposit',
    configIdLabel: 'Saluran deposit',
    chainNameLabel: 'nama rantai',
    amountLabel: 'Jumlah cas semula',
    UserCardNameLabel: 'Pembayar',
    userCardNamePlaceholder: 'Sila masukkan nama pembayar',
    fee: 'yuran perkhidmatan',
    receiveAmountTipsPart1: 'Caj semula',
    receiveAmountTipsPart2: ', perlu bayar',
    tipsPart1: 'Oleh kerana antara muka pembayaran dalam talian tidak stabil, buat masa ini hanya caj semula pindahan luar talian disokong! ',
    tipsPart2: 'Sila isikan jumlah pemindahan sebenar dengan benar, jika tidak, ia boleh menyebabkan semakan sistem gagal dan menjejaskan kemajuan cas semula. ',
    emptyPart1: 'Tiada saluran cas semula tersedia, ',
    emptyPart2: 'Ketik untuk mencuba semula',
    amountRequired: 'Amaun caj semula tidak boleh kosong',
    maxPrecisionError: 'Amaun cas semula boleh mempunyai sehingga {amountMaxPrecision} tempat perpuluhan',
    payUserNameError: 'Sila masukkan pembayar yang betul dan cuba lagi',
    userMobileLabel: 'Nombor telefon mudah alih',
    userMobilePlaceholder: 'Sila masukkan nombor telefon mudah alih pengguna',
    needPayLabel: 'Perlu bayar',
    needPayPlaceholder: 'Klik untuk memasukkan jumlah'
  },
  payDetail: {
    title: 'Pemindahan maklumat',
    addressLabel: 'Alamat deposit',
    rechargeAmount: 'Amount Recharge',
    bankNameLabel: 'Bank',
    branchLabel: 'Alamat cawangan',
    cardName: 'Nama',
    cardNum: 'nombor kad',
    uploadImgLabel: 'Kelayakan Pembayaran',
    uploadImgPlaceholder: 'Klik untuk memuat naik imej baucar pembayaran',
    uploadImgRequired: 'Sila muat naik gambar baucar pembayaran',
    vcTransferTipsPart1: '1. Salin alamat deposit atau imbas kod QR untuk deposit',
    vcTransferTipsPart2: '2. Muat naik gambar baucar pembayaran selepas deposit selesai',
    vcTransferTipsPart3: 'Untuk meningkatkan kecekapan deposit, sila pastikan anda memuat naik gambar sijil yang jelas dan berdefinisi tinggi, jika gambar maklumat yang berkaitan tidak jelas, ia boleh menyebabkan sistem gagal dalam semakan dan menjejaskan kemajuan deposit. ',
    bankCardTips: 'Untuk meningkatkan kecekapan mendepositkan wang, sila pastikan bahawa nama pemindah dan penghantar adalah sama; jika maklumat yang berkaitan tidak sepadan, ia boleh menyebabkan sistem gagal dalam semakan dan menjejaskan kemajuan daripada deposit itu. ',
    bankCardTransferSuccess: 'Saya telah berjaya memindahkan'
  },
  rechargeOrder: {
    title: 'Pesanan deposit',
    payAmount: 'Jumlah caj semula',
    receiveAmount: 'jumlah yang diterima'
  },
  identiti: {
    title: 'Maklumat nama sebenar',
    subTitle: 'Pengesahan nama sebenar termasuk pengesahan maklumat, pengesahan identiti',
    name: 'nama',
    idType: 'jenis dokumen',
    idNum: 'nombor ID',
    demand: 'memerlukan',
    informationVer: 'Pengesahan Maklumat',
    idAuthentication: 'Authentication',
    material: 'Bahan'
  },
  verified: {
    title: 'Pengesahan nama sebenar',
    idCardTypeLabel: 'Jenis Sijil',
    idCardFrontSideImgLabel: 'Kad Front SideImgLabel',
    idCardBackSideImgLabel: 'Bahagian belakang foto ID',
    idCardHandSideImgLabel: 'foto ID genggam',
    nameLabel: 'Nama dokumen',
    namePlaceholder: 'Sila masukkan nama ID anda',
    idCardNumLabel: 'Nombor kad ID',
    idCardNumPlaceholder: 'Sila masukkan nombor ID',
    fundPwdLabel: 'kata laluan dana',
    fundPwdPlaceholder: 'Sila masukkan kata laluan dana anda',
    tips: 'Setelah pengesahan maklumat diserahkan, ia tidak boleh diubah suai, sila semak dengan teliti dan isi dengan betul',
    idCardTypeRequired: 'Sila pilih jenis kad',
    idCardFrontSideImgDiperlukan: 'Sila muat naik foto hadapan kad pengenalan',
    idCardBackSideImgRequired: 'Sila muat naik foto belakang kad pengenalan',
    idCardHandSideImgDiperlukan: 'Sila muat naik foto ID genggam',
    nameRequired: 'Sila masukkan nama dokumen',
    idCardNumRequired: 'Sila masukkan nombor ID',
    fundPwdDiperlukan: 'Sila masukkan kata laluan dana anda',
    submitSuccess: 'Permintaan pengesahan berjaya diserahkan'
  },
  help: {
    title: 'Pusat Bantuan'
  },
  helpDetail: {
    title: 'Butiran Bantuan'
  },
  myMessage: {
    title: 'Mesej Saya'
  },
  messageDetail: {
    title: 'Butiran mesej'
  },
  withdraw: {
    title: 'Menarik diri',
    tips: 'Untuk memastikan keselamatan dana dan kecekapan pengeluaran; sila semak dengan teliti bahawa maklumat yang diisi adalah betul, dan yuran pengendalian yang dijana semasa proses pengeluaran akan ditolak daripada baki',
    receiveAmountTipsPart1: 'Tarik balik',
    receiveAmountTipsPart2: ', dijangka tiba',
    fee: 'yuran perkhidmatan',
    myBalance: 'Baki [{vcName}] saya:',
    configIdLabel: 'saluran pengeluaran',
    amountLabel: 'amaun pengeluaran',
    fundLabel: 'kata laluan dana',
    fundPlaceholder: 'Sila masukkan kata laluan dana anda',
    googleCodeLabel: 'Kod pengesahan Google',
    googleCodePlaceholder: 'Sila masukkan kod pengesahan Google 6 digit',
    maxPrecisionError: 'Amaun pengeluaran boleh mempunyai sehingga {amountMaxPrecision} tempat perpuluhan',
    amountRequired: 'Sila masukkan atau pilih jumlah pengeluaran yang betul',
    bankCardError: 'Sila pilih kad bank yang betul',
    fundPwdError: 'Sila masukkan kata laluan dana yang betul',
    walletAddressError: 'Sila pilih alamat dompet yang betul',
    success: 'Permintaan pengeluaran telah berjaya diserahkan, sila tunggu untuk diproses',
    emptyPart1: 'Tiada saluran pengeluaran tersedia, ',
    emptyPart2: 'Ketik untuk mencuba semula'
  },
  withdrawOrder: {
    title: 'Pesanan pengeluaran',
    requestAmount: 'Jumlah bil muatan',
    receiveAmount: 'jumlah yang diterima'
  },
  locales: {
    title: 'Tukar bahasa'
  },
  lines: {
    title: 'Pilihan baris',
    switchLine: 'switch line'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Berjaya memadam mata wang kegemaran',
    addFavoriteSuccess: 'Tambah mata wang kegemaran berjaya'
  },
  currencySelect: {
    currencyName: 'mata wang',
    currencyPlaceholder: 'Klik untuk memilih mata wang'
  },
  walletItem: {
    available: 'tersedia',
    convert: 'tukar (USDT)'
  },
  banks: {
    bankIdLabel: 'Bank',
    bankIdPlaceholder: 'Klik untuk memilih bank'
  },
  banksPop: {
    title: 'Pilih Bank',
    search: 'Masukkan kata kunci bank'
  },
  historyOrderDetail: {
    title: 'Butiran Pesanan',
    coin: 'Mata wang urus niaga',
    amount: 'jumlah pesanan',
    buyInClose: 'Harga beli',
    sellOutClose: 'Harga jualan',
    isQuest: 'Ada sebarang soalan tentang pesanan ini?',
    connectCustomer: 'Hubungi perkhidmatan pelanggan?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Klik untuk memilih rebat pengguna'
  },
  walletAddressSelect: {
    title: 'Pilih alamat dompet',
    label: 'alamat dompet',
    placeholder: 'Klik untuk memilih alamat dompet'
  },
  myCardSelect: {
    title: 'Pilih akaun',
    label: 'menerima akaun',
    placeholder: 'Klik untuk memilih akaun'
  },
  amountInput: {
    amountRange: 'minimum {minAmount}, maksimum {maxAmount}',
    amountMin: 'Minimum {minAmount}, tiada had atas',
    amountErrorEmpty: '{label} salah, sila semak dan cuba lagi',
    amountErrorOutRange: '{label} berada di luar julat, sila semak dan cuba lagi'
  },
  amountFormItem: {
    placeholderOnlyMin: 'MinAmum {minAmount}, tiada had atas',
    placeholderHasMax: 'minimum {minAmount}, maksimum {maxAmount}',
    amountErrorEmpty: 'Jumlah adalah salah, sila cuba lagi selepas pengesahan',
    amountErrorOutRange: 'Jumlah di luar julat, sila sahkan dan cuba lagi'
  },
  common: {
    remark: 'remark',
    saveImage: 'Simpan setempat',
    online: 'dalam talian',
    offline: 'luar talian',
    profit: 'untung dan rugi',
    date: 'tarikh',
    period: 'tempoh',
    pointAmount: 'Jumlah rebat pengguna',
    point: 'Rebat pengguna',
    direction: 'arah',
    winLoss: 'Pendapatan',
    lose: 'kalah',
    add: 'Tambah baharu',
    win: 'menang',
    edit: 'Ubah suai',
    notBind: 'tidak terikat',
    alreadyBind: 'sudah terikat',
    enabled: 'didayakan',
    notEnabled: 'tidak didayakan',
    queryRange: 'Query Range',
    copy: 'Salin',
    orderNum: 'nombor pesanan',
    null: 'tiada',
    noData: 'Tiada data lagi',
    refreshSuccess: 'Segar semula berjaya',
    loadMoreData: 'Muatkan lebih banyak data',
    noMoreData: 'Tiada lagi data',
    lookMore: 'Lagi',
    more: 'Lagi'
  },
  date: {
    today: 'hari ini',
    yesterday: 'Semalam',
    last7Days: 'hampir 7 hari',
    last14Days: 'hampir 14 hari',
    split: 'ke'
  },
  button: {
    save: 'Simpan',
    logout: 'log keluar',
    confirm: 'OK',
    cancel: 'Batal',
    submit: 'Serahkan',
    addNow: 'Tambah sekarang',
    reset: 'set semula',
    nextStep: 'Seterusnya',
    goCertification: 'Pergi ke pensijilan'
  },
  confirm: {
    title: {
      logout: 'log keluar',
      unBindFundPassword: 'kata laluan dana tidak terikat',
      addUserDirect: 'Tambah Pengguna',
      addUserInfo: 'Tambah pengguna berjaya',
      jumpToRechargePage: 'Sahkan Lompat',
      unAuthentication: 'pengesahan nama tidak sebenar',
      noBindBankCard: 'Tiada kad bank ditambah',
      noBindCoinAddress: 'Tiada alamat dompet ditambah',
      tradeConfirm: 'Sahkan transaksi',
      sellOutSpotOrder: 'kedudukan untuk menjual',
      buyFinance: 'mengesahkan pembelian',
      redeemOrder: 'Ikrar penebusan perintah'
    },
    content: {
      logout: 'Adakah anda pasti untuk log keluar daripada akaun semasa?',
      unBindFundPassword: 'Kata laluan dana tidak terikat telah dikesan, untuk memastikan keselamatan akaun, sila ikat kata laluan dana anda dahulu',
      addUserDirect: 'Pengguna baharu akan ditambah tidak lama lagi, sila sahkan bahawa maklumat adalah betul dan klik OK untuk meneruskan, nama pengguna [ {username} ], jenis pengguna [ {userType} ], kata laluan log masuk [ {password} ], dan perbezaan antara rebat dagangan kelajuan saya [ {diffPointTiming} ], dan perbezaan rebat transaksi kontrak saya [ {diffPointContract} ]',
      addUserInfo: 'Nama pengguna [ {nama pengguna} ]; <br /> Kata laluan log masuk [ {kata laluan} ];<br /> URL Log Masuk [ {loginAddress} ];<br /> Rebat transaksi melampau [ {pointPercentTiming} ];<br / > /> Rebat transaksi kontrak [{pointPercentContract}];',
      jumpToRechargePage: 'Mengenai untuk melompat ke antara muka cas semula tiga pihak, sila klik sahkan untuk meneruskan',
      unAuthentication: 'Adalah dikesan bahawa akaun itu tidak menjalani pengesahan nama sebenar, untuk memastikan peredaran dana biasa, sila lakukan pengesahan nama sebenar dahulu',
      noBindBankCard: 'Adalah dikesan bahawa akaun tidak terikat atau didayakan dengan kad bank. Untuk memastikan peredaran dana biasa, sila tambah kad bank dahulu',
      noBindCoinAddress: 'Adalah dikesan bahawa akaun tersebut tidak mempunyai akaun mata wang maya terikat atau didayakan. Untuk memastikan peredaran dana biasa, sila tambah alamat akaun mata wang maya dahulu',
      tradeConfirm: 'Pesanan akan dihantar, sila sahkan maklumat pesanan adalah betul dan klik Sahkan Pesanan untuk menghantar',
      sellOutSpotOrder: 'Pesanan kedudukan akan dijual, sila sahkan bahawa operasi itu betul dan klik OK untuk meneruskan',
      buyFinance: 'Akan membeli [{coin}], beli bahagian: {amount}, sila sahkan bahawa operasi itu betul dan klik OK untuk meneruskan',
      redeemOrder: 'Pesanan ikrar ({orderNum}) akan ditebus, sila sahkan bahawa operasi itu betul dan klik Sahkan untuk meneruskan'
    }
  },
  message: {
    bindSuccess: 'Berjaya mengikat',
    successOperation: 'Operasi berjaya',
    logoutSuccess: 'Berjaya keluar',
    editSuccess: 'Berjaya diubah suai',
    addSuccess: 'Berjaya ditambahkan',
    copySuccess: 'Menyalin berjaya',
    copyFailed: 'Salin gagal'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Hari',
      week_day_1: 'Satu',
      week_day_2: 'dua',
      week_day_3: 'tiga',
      week_day_4: 'empat',
      week_day_5: 'lima',
      week_day_6: 'Enam'
    },
    loading: {
      loading: 'memuatkan'
    }
  },
  helpItems: {
    title: {
      part1: 'Mengapa amaun yang ditukar dalam aset berubah? ',
      part2: 'Melupakan kaedah pengendalian kata laluan dana untuk transaksi OTC',
      part3: 'Ke manakah aliran dana selepas pembelian transaksi OTC selesai? ',
      part4: 'Mengapa anda mahu mengehadkan bilangan kali anda boleh mengubah suai nama panggilan anda',
      part5: 'Apakah maksud pemindahan, mengapa perlu pemindahan',
      part6: 'Bagaimana untuk mengira ekuiti akaun kontrak pengguna? ',
      part7: 'Apakah nilai stop loss dan take profit yang ditetapkan dalam kedudukan pembukaan? Bagaimana ia harus ditetapkan? ',
      part8: 'Bagaimana untuk mengurangkan risiko kontrak? ',
      part9: 'Apakah yang ditunjukkan oleh kuantiti dalam kedudukan terbuka kontrak? ',
      part10: 'Arahan mengenai pembubaran paksa',
      part11: 'Apakah peraturan perdagangan kontrak? ',
      part12: 'Apakah margin dalam perdagangan kontrak? ',
      part13: 'Apakah pesanan had dan pesanan pasaran? ',
      part14: 'Apakah yang diwakili oleh risiko transaksi kontrak',
      part15: 'Mengapa anda memerlukan penukaran mata wang? ',
      part16: 'Mengapa pihak yang satu lagi tidak menerima pemindahan dalam masa selepas pemindahan transaksi OTC? ',
      part17: 'Bagaimana untuk membeli Tether (USDT) melalui OTC? '
    },
    content: {
      part1: 'Nilai mata wang digital yang kini dipegang dalam Renminbi apabila ditukar kepada aset akan berubah disebabkan turun naik harga aset digital. Bilangan aset digital anda tidak berubah. ',
      part2: 'Jika anda terlupa kata laluan dana transaksi OTC, sila pergi ke "Tetapan Saya-Klik untuk menetapkan kata laluan dana" atau hubungi perkhidmatan pelanggan untuk menetapkan semula',
      part3: 'Selepas pesanan belian OTC selesai, dana akan memasuki akaun mata wang sah dalam aset. Jika anda perlu menggunakan aset yang dibeli OTC untuk dagangan kontrak atau dagangan niaga hadapan, sila pergi ke modul pemindahan dana untuk memindahkan. ',
      part4: 'Atas sebab keselamatan transaksi anda, kami pada masa ini mengehadkan nama panggilan untuk diubah suai sekali sahaja. ',
      part5: 'Untuk memastikan kebebasan dana antara pelbagai akaun anda dan untuk memudahkan kawalan risiko munasabah anda, akaun modul perdagangan utama dengan ini dibahagikan. Pemindahan merujuk kepada proses penukaran aset bersama antara pelbagai akaun dagangan. ',
      part6: '<p>Ekuiti akaun kontrak, kaedah pengiraan adalah seperti berikut:</p> <p>Ekuiti akaun kontrak = margin kedudukan + untung rugi terapung kedudukan + jumlah akaun semasa tersedia</p>',
      part7: 'Ambil untung dan henti rugi ialah had untung dan had kerugian yang anda tetapkan. Apabila jumlah henti untung dan henti rugi yang ditetapkan tercapai, sistem akan menutup kedudukan secara automatik. Ia boleh digunakan untuk kawalan risiko anda semasa membeli kontrak. Separuh daripada amaun ambil untung yang ditetapkan ialah: tingkatkan amaun x kuantiti x berganda leverage dan tetapkan henti rugi. Kami mengesyorkan agar anda menetapkannya mengikut situasi aset sebenar anda untuk mengawal risiko secara munasabah . ',
      part8: 'Anda boleh memindahkan aset yang tersedia bagi akaun yang tinggal ke akaun kontrak dengan memindahkan dana, atau mengurangkan risiko dengan mengurangkan kedudukan. ',
      part9: 'Kuantiti dalam kedudukan terbuka menunjukkan kuantiti mata wang yang anda jangkakan untuk beli. Sebagai contoh: pada halaman pembukaan pasangan dagangan BTC/USDT, pilih untuk membeli panjang, masukkan harga sebagai 1000USDT, dan masukkan kuantiti sebagai 10BTC, yang bermaksud: anda menjangkakan untuk membeli 10 BTC dengan harga unit 1000USDT. ',
      part10: '<p>Ijazah risiko ialah penunjuk untuk mengukur risiko aset anda. Apabila tahap risiko bersamaan dengan 100%, kedudukan anda dianggap dibubarkan. Tahap risiko=(margin kedudukan/ekuiti akaun kontrak)*100 %, untuk mengelakkan pengguna daripada mengatasi kedudukan mereka, sistem menetapkan nisbah pelarasan tahap risiko. Apabila tahap risiko mencapai nilai risiko yang ditetapkan oleh sistem, sistem akan memaksa pembubaran. Contohnya: jika nisbah pelarasan yang ditetapkan oleh sistem ialah 10%, maka apabila tahap risiko anda lebih besar daripada atau sama dengan 90%, semua kedudukan anda akan ditutup secara paksa oleh sistem. </p> <p>Nota: Jika sistem memaksa pembubaran yang disebabkan oleh risiko yang berlebihan, semua kedudukan anda akan ditutup, jadi saya harap anda boleh mengawal risiko anda dengan munasabah untuk mengelakkan kerugian yang tidak perlu</p>',
      part11: '<p>Jenis dagangan</p> <p>Jenis dagangan terbahagi kepada dua arah: buka posisi beli (beli) dan buka posisi jual (jual):</p> <p>Beli lama (Panggilan) bermaksud bahawa anda percaya bahawa indeks semasa mungkin meningkat, dan berharap untuk membeli sejumlah kontrak tertentu pada harga yang anda tetapkan atau harga pasaran semasa. </p> <p>Jualan pendek (menurun) bermakna anda percaya bahawa indeks semasa mungkin jatuh, dan berharap untuk menjual beberapa kontrak tertentu pada harga yang anda tetapkan atau harga pasaran semasa. </p> <p>Cara membuat pesanan</p> <p>Had pesanan: anda perlu menyatakan harga dan kuantiti pesanan</p> <p>Pesanan pasaran: anda hanya perlu menetapkan kuantiti daripada pesanan , harga ialah harga pasaran semasa</p> <p>Kedudukan</p> <p>Apabila pesanan pembukaan yang anda serahkan selesai, ia dipanggil kedudukan</p> <p>Masalah penghantaran kontrak </p> <p>Kontrak platform ialah kontrak kekal tanpa masa penghantaran yang ditetapkan. Selagi syarat pembubaran sistem tidak dipenuhi atau anda tidak menutup kedudukan secara manual, anda boleh memegang jawatan itu secara kekal. </p> <p>Sistem menutup kedudukan</p> <p>1: Sistem secara automatik menutup kedudukan apabila nilai set stop untung dan stop loss dicapai</p> <p>2: Risiko terlalu tinggi, sistem memaksa kedudukan ditutup </p>',
      part12: '<p>Dalam transaksi kontrak, pengguna boleh mengambil bahagian dalam transaksi kontrak dengan membayar dana sebagai jaminan kewangan untuk pelaksanaan kontrak mengikut harga dan kuantiti kontrak, mengikut gandaan leveraj yang sepadan, dan dana ini adalah margin kontrak. Pengguna akan menduduki margin apabila membuka kedudukan, dan lebih banyak margin untuk membuka kedudukan diduduki, lebih tinggi risiko akaun. </p> <p>Margin = (harga pembukaan * kuantiti) / nisbah leverage</p>',
      part13: 'Pesanan had merujuk kepada harga yang anda jangkakan untuk mempercayakan platform untuk menjalankan urus niaga, dan pesanan pasaran merujuk kepada mempercayakan secara langsung platform untuk menjalankan urus niaga pada harga semasa. Dalam peraturan untuk membuka kedudukan, pesanan pasaran diutamakan berbanding pesanan had. Jika anda memilih pesanan had, sila buka kedudukan yang munasabah mengikut harga pasaran mata wang semasa untuk mengelakkan kerugian yang disebabkan oleh harga pembukaan yang tidak munasabah. ',
      part14: 'Tahap risiko ialah penunjuk risiko dalam akaun kontrak anda, dan tahap risiko bersamaan 100% dianggap pembubaran. Kami mencadangkan anda, apabila risiko anda melebihi 50%, anda perlu membuka posisi dengan berhati-hati untuk mengelakkan kerugian akibat pembubaran. Anda boleh mengurangkan risiko anda dengan menambah dana aset kontrak yang tersedia, atau mengurangkan kedudukan. ',
      part15: 'Fungsi pertukaran adalah untuk membolehkan peredaran dana lancar dalam mata wang berbeza dalam aset anda, dan QCC yang diperolehi dalam akaun niaga hadapan boleh ditukar secara bebas kepada USDT untuk dagangan. USDT dalam akaun lain juga boleh ditukar secara bebas kepada QCC untuk transaksi. ',
      part16: 'Pertama sekali, sila pastikan bahawa kaedah pembayaran yang anda isi semasa memindahkan wang adalah sama seperti yang dipaparkan pada halaman butiran pesanan. Kemudian sila sahkan sama ada kaedah pembayaran anda adalah segera atau tertangguh. Akhir sekali, sila hubungi bank dan institusi pembayaran anda untuk penyelenggaraan sistem atau sebab lain. ',
      part17: '<p>Kaedah 1: Pilih pesanan yang anda ingin beli melalui senarai beli dan jual OTC untuk membeli atau menjual. </p> <p>Kaedah 2: Klik butang terbitkan untuk menerbitkan pesanan beli atau jual mengikut keperluan anda untuk transaksi pantas. Sistem ini akan memadankan anda dengan cepat dengan pembeli dan penjual. </p> <p>Nota: Jika pesanan pembelian tidak dibayar selepas 15 minit, sistem akan membatalkan pesanan secara automatik, sila bayar dalam masa. Jika pesanan dibatalkan lebih daripada 3 kali pada hari yang sama, transaksi tidak boleh dijalankan semula pada hari yang sama, dan pihak berkuasa perdagangan akan dipulihkan pada hari berikutnya. </p>'
    }
  }
};

/***/ }),

/***/ "avVw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Menus'
};

/***/ }),

/***/ "awgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b+jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue__ = __webpack_require__("ivHe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue__ = __webpack_require__("wHkY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_91b59c1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_swiper_item_vue__ = __webpack_require__("3C/V");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_91b59c1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_swiper_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bCvt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cleanStyle = __webpack_require__("wmxo");

var _cleanStyle2 = _interopRequireDefault(_cleanStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'group',
  methods: {
    cleanStyle: _cleanStyle2.default
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "bREw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _mutations;

var _stroage = __webpack_require__("DsOT");

var _nameSpace = __webpack_require__("Eeb1");

var _nameSpace2 = __webpack_require__("Ypiv");

var _user = __webpack_require__("sF3y");

var _device = __webpack_require__("43sz");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingUserInfo = false;

exports.default = {
  state: {
    token: (0, _stroage.getStorage)(_nameSpace.__TOKEN__) || '',
    userInfo: (0, _stroage.getStorage)(_nameSpace.__USER_INFO__) || {},
    favoriteCurrencies: (0, _stroage.getStorage)(_nameSpace.__FAVORITE_CURRENCY__) || []
  },
  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_FAVORITE_CURRENCIES, function (state, favoriteCurrencies) {
    state.favoriteCurrencies = favoriteCurrencies;
    (0, _stroage.setStorage)(_nameSpace.__FAVORITE_CURRENCY__, favoriteCurrencies);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_TOKEN, function (state, token) {
    state.token = token;
    (0, _stroage.setStorage)(_nameSpace.__TOKEN__, token);
  }), (0, _defineProperty3.default)(_mutations, _nameSpace2.SET_USER_INFO, function (state, userInfo) {
    state.userInfo = (0, _extends3.default)({}, state.userInfo, userInfo);
    (0, _stroage.setStorage)(_nameSpace.__USER_INFO__, userInfo);
  }), _mutations),
  actions: {
    deleteUserFavoriteVc: function deleteUserFavoriteVc(_ref, _ref2) {
      var commit = _ref.commit;
      var vc = _ref2.vc;

      return new _promise2.default(function (resolve, reject) {
        (0, _user.userFavorVcDelete)({ vcId: vc.id }).then(function (res) {
          if (res.success) {
            commit(_nameSpace2.SET_FAVORITE_CURRENCIES, res.data);
            resolve(res);
          } else {
            reject(new Error(res.message));
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    addUserFavoriteVc: function addUserFavoriteVc(_ref3, _ref4) {
      var commit = _ref3.commit;
      var vc = _ref4.vc;

      return new _promise2.default(function (resolve, reject) {
        (0, _user.userFavorVcAdd)({ vcId: vc.id }).then(function (res) {
          if (res.success) {
            commit(_nameSpace2.SET_FAVORITE_CURRENCIES, res.data);
            resolve(res);
          } else {
            reject(new Error(res.message));
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    updateUserFavoriteCurrencies: function updateUserFavoriteCurrencies(_ref5) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        (0, _user.userFavorVcList)().then(function (res) {
          if (res.success) {
            commit(_nameSpace2.SET_FAVORITE_CURRENCIES, res.data);
            resolve(res.data);
          } else {
            reject(new Error(res.message));
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    loginByUsername: function loginByUsername(_ref6, userInfo) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState;

      return new _promise2.default(function (resolve, reject) {
        (0, _user.login)((0, _extends3.default)({}, userInfo, { deviceId: _device.deviceId, deviceType: _device.deviceType
        })).then(function (res) {
          if (res.success) {
            commit(_nameSpace2.SET_TOKEN, res['data'].token);
            commit(_nameSpace2.SET_USER_INFO, res['data']);
            resolve(res);
          } else {
            resolve(res);
            // reject(new Error(res.message))
          }
        }).catch(function (err) {
          return reject(err);
        });
      });
    },
    logout: function logout(_ref7) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState;

      return new _promise2.default(function (resolve, reject) {
        (0, _user.logout)({}).then(function (res) {
          if (res.success) {
            commit(_nameSpace2.SET_TOKEN, '');
            commit(_nameSpace2.SET_USER_INFO, {});
            // 清除相关缓存内容
            if (rootState.app.hideBalance) {
              commit(_nameSpace2.SET_HIDE_BALANCE, false);
            }
            commit(_nameSpace2.SET_FAVORITE_CURRENCIES, []);
            resolve(res);
          } else {
            reject(new Error(res.message));
          }
        }).catch(reject);
      });
    },
    updateUserInfo: function updateUserInfo(_ref8) {
      var commit = _ref8.commit,
          state = _ref8.state;

      if (loadingUserInfo) return;
      return new _promise2.default(function (resolve, reject) {
        loadingUserInfo = true;
        (0, _user.userGetLoginInfo)({}).then(function (res) {
          loadingUserInfo = false;
          if (res.success) {
            commit(_nameSpace2.SET_USER_INFO, (0, _extends3.default)({}, state.userInfo, res.data));
            resolve(res);
          } else {
            reject(new Error(res.message));
          }
        }).catch(function (err) {
          loadingUserInfo = false;
          return reject(err);
        });
      });
    }
  }
};

/***/ }),

/***/ "bwrR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__("Bfwr");

var _index2 = _interopRequireDefault(_index);

var _CustomerService = __webpack_require__("iYDO");

var _CustomerService2 = _interopRequireDefault(_CustomerService);

var _Locales = __webpack_require__("4xPj");

var _Locales2 = _interopRequireDefault(_Locales);

var _vuex = __webpack_require__("NYxO");

var _dom = __webpack_require__("vNF5");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Loading: _index2.default, CustomerService: _CustomerService2.default, Locales: _Locales2.default },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    loadingTxt: function loadingTxt(state) {
      return state.vux.loading.loadingTxt;
    },
    isLoading: function isLoading(state) {
      return state.vux.loading.visible;
    },
    route: function route(state) {
      return state.route;
    },
    localePopVisible: function localePopVisible(state) {
      return state.app.localePopVisible;
    },
    locale: function locale(state) {
      return state.i18n.locale;
    },
    theme: function theme(state) {
      return state.app.theme;
    }
  })),
  watch: {
    locale: function locale() {
      this.$store.dispatch('getSysConfigDict');
    },
    theme: function theme(val, oldVal) {
      var htmlNode = document.documentElement;
      (0, _dom.removeClass)(htmlNode, oldVal);
      (0, _dom.addClass)(htmlNode, val);
    }
  },
  methods: {},
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('initThemeMode');
  },
  beforeDestroy: function beforeDestroy() {}
};

/***/ }),

/***/ "c0or":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'QuickMenus',
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['tradeConfig', 'vcId'])),
  methods: {
    quickTrade: function quickTrade() {
      if (!this.vcId) {
        this.$store.dispatch('setVcId', this.tradeConfig[0].vcId);
      }
      this.$router.push('/trade');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "cFY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__ = __webpack_require__("fGQL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__ = __webpack_require__("HJi0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e05922c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Tab_vue__ = __webpack_require__("+ji0");
function injectStyle (ssrContext) {
  __webpack_require__("M1Iu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e05922c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cUGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-container"},[_vm._m(0),_vm._v(" "),_c('swiper',{staticClass:"notice-swiper",attrs:{"auto":"","height":"40px","direction":"vertical","interval":2000,"show-dots":false,"loop":""}},_vm._l((_vm.items),function(noticeItem,noticeIndex){return _c('swiper-item',{key:noticeItem.id},[_c('p',{staticClass:"txt-color",on:{"click":function($event){return _vm.clickNoticeItem(noticeIndex)}}},[_vm._v(_vm._s(noticeItem.title))])])}),1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('i',{staticClass:"iconfont icon-notice home-icon-color"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cWLO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encryptionPassword = encryptionPassword;
exports.encryptPasswordWithToken = encryptPasswordWithToken;
exports.generatePassword = generatePassword;
/* eslint-disable */
var hexcase = 0;var b64pad = "";var chrsz = 8;function hex_md5(a) {
  return binl2hex(core_md5(str2binl(a), a.length * chrsz));
}function b64_md5(a) {
  return binl2b64(core_md5(str2binl(a), a.length * chrsz));
}function str_md5(a) {
  return binl2str(core_md5(str2binl(a), a.length * chrsz));
}function hex_hmac_md5(b, a) {
  return binl2hex(core_hmac_md5(b, a));
}function b64_hmac_md5(b, a) {
  return binl2b64(core_hmac_md5(b, a));
}function str_hmac_md5(b, a) {
  return binl2str(core_hmac_md5(b, a));
}function md5_vm_test() {
  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}function core_md5(p, k) {
  p[k >> 5] |= 128 << k % 32;p[(k + 64 >>> 9 << 4) + 14] = k;var e = 1732584193;var f = -271733879;var g = -1732584194;var h = 271733878;for (var j = 0; j < p.length; j += 16) {
    var l = e;var m = f;var n = g;var o = h;e = md5_ff(e, f, g, h, p[j + 0], 7, -680876936);h = md5_ff(h, e, f, g, p[j + 1], 12, -389564586);g = md5_ff(g, h, e, f, p[j + 2], 17, 606105819);f = md5_ff(f, g, h, e, p[j + 3], 22, -1044525330);e = md5_ff(e, f, g, h, p[j + 4], 7, -176418897);h = md5_ff(h, e, f, g, p[j + 5], 12, 1200080426);g = md5_ff(g, h, e, f, p[j + 6], 17, -1473231341);f = md5_ff(f, g, h, e, p[j + 7], 22, -45705983);e = md5_ff(e, f, g, h, p[j + 8], 7, 1770035416);h = md5_ff(h, e, f, g, p[j + 9], 12, -1958414417);g = md5_ff(g, h, e, f, p[j + 10], 17, -42063);f = md5_ff(f, g, h, e, p[j + 11], 22, -1990404162);e = md5_ff(e, f, g, h, p[j + 12], 7, 1804603682);h = md5_ff(h, e, f, g, p[j + 13], 12, -40341101);g = md5_ff(g, h, e, f, p[j + 14], 17, -1502002290);f = md5_ff(f, g, h, e, p[j + 15], 22, 1236535329);e = md5_gg(e, f, g, h, p[j + 1], 5, -165796510);h = md5_gg(h, e, f, g, p[j + 6], 9, -1069501632);g = md5_gg(g, h, e, f, p[j + 11], 14, 643717713);f = md5_gg(f, g, h, e, p[j + 0], 20, -373897302);e = md5_gg(e, f, g, h, p[j + 5], 5, -701558691);h = md5_gg(h, e, f, g, p[j + 10], 9, 38016083);g = md5_gg(g, h, e, f, p[j + 15], 14, -660478335);f = md5_gg(f, g, h, e, p[j + 4], 20, -405537848);e = md5_gg(e, f, g, h, p[j + 9], 5, 568446438);h = md5_gg(h, e, f, g, p[j + 14], 9, -1019803690);g = md5_gg(g, h, e, f, p[j + 3], 14, -187363961);f = md5_gg(f, g, h, e, p[j + 8], 20, 1163531501);e = md5_gg(e, f, g, h, p[j + 13], 5, -1444681467);h = md5_gg(h, e, f, g, p[j + 2], 9, -51403784);g = md5_gg(g, h, e, f, p[j + 7], 14, 1735328473);f = md5_gg(f, g, h, e, p[j + 12], 20, -1926607734);e = md5_hh(e, f, g, h, p[j + 5], 4, -378558);h = md5_hh(h, e, f, g, p[j + 8], 11, -2022574463);g = md5_hh(g, h, e, f, p[j + 11], 16, 1839030562);f = md5_hh(f, g, h, e, p[j + 14], 23, -35309556);e = md5_hh(e, f, g, h, p[j + 1], 4, -1530992060);h = md5_hh(h, e, f, g, p[j + 4], 11, 1272893353);g = md5_hh(g, h, e, f, p[j + 7], 16, -155497632);f = md5_hh(f, g, h, e, p[j + 10], 23, -1094730640);e = md5_hh(e, f, g, h, p[j + 13], 4, 681279174);h = md5_hh(h, e, f, g, p[j + 0], 11, -358537222);g = md5_hh(g, h, e, f, p[j + 3], 16, -722521979);f = md5_hh(f, g, h, e, p[j + 6], 23, 76029189);e = md5_hh(e, f, g, h, p[j + 9], 4, -640364487);h = md5_hh(h, e, f, g, p[j + 12], 11, -421815835);g = md5_hh(g, h, e, f, p[j + 15], 16, 530742520);f = md5_hh(f, g, h, e, p[j + 2], 23, -995338651);e = md5_ii(e, f, g, h, p[j + 0], 6, -198630844);h = md5_ii(h, e, f, g, p[j + 7], 10, 1126891415);g = md5_ii(g, h, e, f, p[j + 14], 15, -1416354905);f = md5_ii(f, g, h, e, p[j + 5], 21, -57434055);e = md5_ii(e, f, g, h, p[j + 12], 6, 1700485571);h = md5_ii(h, e, f, g, p[j + 3], 10, -1894986606);g = md5_ii(g, h, e, f, p[j + 10], 15, -1051523);f = md5_ii(f, g, h, e, p[j + 1], 21, -2054922799);e = md5_ii(e, f, g, h, p[j + 8], 6, 1873313359);h = md5_ii(h, e, f, g, p[j + 15], 10, -30611744);g = md5_ii(g, h, e, f, p[j + 6], 15, -1560198380);f = md5_ii(f, g, h, e, p[j + 13], 21, 1309151649);e = md5_ii(e, f, g, h, p[j + 4], 6, -145523070);h = md5_ii(h, e, f, g, p[j + 11], 10, -1120210379);g = md5_ii(g, h, e, f, p[j + 2], 15, 718787259);f = md5_ii(f, g, h, e, p[j + 9], 21, -343485551);e = safe_add(e, l);f = safe_add(f, m);g = safe_add(g, n);h = safe_add(h, o);
  }return Array(e, f, g, h);
}function md5_cmn(e, c, d, h, f, g) {
  return safe_add(bit_rol(safe_add(safe_add(c, e), safe_add(h, g)), f), d);
}function md5_ff(e, f, g, h, k, i, j) {
  return md5_cmn(f & g | ~f & h, e, f, k, i, j);
}function md5_gg(e, f, g, h, k, i, j) {
  return md5_cmn(f & h | g & ~h, e, f, k, i, j);
}function md5_hh(e, f, g, h, k, i, j) {
  return md5_cmn(f ^ g ^ h, e, f, k, i, j);
}function md5_ii(e, f, g, h, k, i, j) {
  return md5_cmn(g ^ (f | ~h), e, f, k, i, j);
}function core_hmac_md5(f, b) {
  var a = str2binl(f);if (a.length > 16) {
    a = core_md5(a, f.length * chrsz);
  }var e = Array(16),
      g = Array(16);for (var d = 0; d < 16; d++) {
    e[d] = a[d] ^ 909522486;g[d] = a[d] ^ 1549556828;
  }var c = core_md5(e.concat(str2binl(b)), 512 + b.length * chrsz);return core_md5(g.concat(c), 512 + 128);
}function safe_add(c, d) {
  var a = (c & 65535) + (d & 65535);var b = (c >> 16) + (d >> 16) + (a >> 16);return b << 16 | a & 65535;
}function bit_rol(b, a) {
  return b << a | b >>> 32 - a;
}function str2binl(d) {
  var a = Array();var c = (1 << chrsz) - 1;for (var b = 0; b < d.length * chrsz; b += chrsz) {
    a[b >> 5] |= (d.charCodeAt(b / chrsz) & c) << b % 32;
  }return a;
}function binl2str(a) {
  var d = "";var c = (1 << chrsz) - 1;for (var b = 0; b < a.length * 32; b += chrsz) {
    d += String.fromCharCode(a[b >> 5] >>> b % 32 & c);
  }return d;
}function binl2hex(a) {
  var b = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";var d = "";for (var c = 0; c < a.length * 4; c++) {
    d += b.charAt(a[c >> 2] >> c % 4 * 8 + 4 & 15) + b.charAt(a[c >> 2] >> c % 4 * 8 & 15);
  }return d;
}function binl2b64(a) {
  var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var d = "";for (var b = 0; b < a.length * 4; b += 3) {
    var f = (a[b >> 2] >> 8 * (b % 4) & 255) << 16 | (a[b + 1 >> 2] >> 8 * ((b + 1) % 4) & 255) << 8 | a[b + 2 >> 2] >> 8 * ((b + 2) % 4) & 255;for (var c = 0; c < 4; c++) {
      if (b * 8 + c * 6 > a.length * 32) {
        d += b64pad;
      } else {
        d += e.charAt(f >> 6 * (3 - c) & 63);
      }
    }
  }return d;
};

function encryptionPassword(password) {
  if (!password) return '';
  return hex_md5(hex_md5(password).toUpperCase()).toUpperCase();
}

function encryptPasswordWithToken(plainStr, token) {
  var password = hex_md5(plainStr);
  if (token) {
    // 密保验证相关逻辑
    password = hex_md5(plainStr).toUpperCase();
    password = hex_md5(password).toUpperCase();
    password = hex_md5(password).toUpperCase();
    password = hex_md5(password + token).toUpperCase();
  }
  return password;
}
function generatePassword(plainStr) {
  var password = hex_md5(plainStr).toUpperCase();
  password = hex_md5(password).toUpperCase();
  return password;
}

/***/ }),

/***/ "cWad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cdCv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.default = function () {
  clearTimeout(updateCacheInfoTimer);
};

var _utils = __webpack_require__("oAV5");

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { CACHE_INFO_KEYS } from './utils/cache'

var updateCacheInfoTimer = void 0;

function initCacheInfoUpdateSysDictConfig(isInit) {
  return new _promise2.default(function (resolve, reject) {
    _store2.default.dispatch('initCacheInfo').then(function () {
      if (isInit) {
        _store2.default.dispatch('getSysConfigDict');
      }
      updateCacheInfoTimer = setTimeout(function () {
        initCacheInfoUpdateSysDictConfig();
      }, (0, _utils.randomTimerUpdateCache)());
      resolve();
    }).catch(function (err) {
      reject(err);
      return _utils.emptyFn;
    });
  });
}

initCacheInfoUpdateSysDictConfig(true);

/***/ }),

/***/ "ctzu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cvA0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preventBodyScroll = __webpack_require__("JkZY");

var _preventBodyScroll2 = _interopRequireDefault(_preventBodyScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_preventBodyScroll2.default],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "d6cP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _icon = __webpack_require__("oWtu");

var _icon2 = _interopRequireDefault(_icon);

var _datetimepicker = __webpack_require__("zV4+");

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _group = __webpack_require__("rHil");

var _group2 = _interopRequireDefault(_group);

var _inlineDesc = __webpack_require__("kbG3");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _uuid = __webpack_require__("KRg4");

var _uuid2 = _interopRequireDefault(_uuid);

var _format2 = __webpack_require__("ODCk");

var _format3 = _interopRequireDefault(_format2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'datetime',
  mixins: [_uuid2.default],
  components: {
    Group: _group2.default,
    InlineDesc: _inlineDesc2.default,
    Icon: _icon2.default
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = (0, _keys2.default)(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new _datetimepicker2.default(_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = (0, _format3.default)(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
};

/***/ }),

/***/ "dyf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('HomeHeader'),_vm._v(" "),_c('div',{staticClass:"top"},[_c('Carousel'),_vm._v(" "),_c('Notice',{attrs:{"items":_vm.dialogNotices.items},on:{"update:items":function($event){return _vm.$set(_vm.dialogNotices, "items", $event)},"clickNoticeItem":_vm.clickNoticeItem,"clickMore":function($event){_vm.noticesPop.visible = true}}}),_vm._v(" "),_c('HotCoins')],1),_vm._v(" "),_c('Poster'),_vm._v(" "),_c('QuickMenus'),_vm._v(" "),_c('Ranking',{ref:"ranking"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e25r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'CButton',
  props: {
    type: {
      required: false,
      default: 'primary',
      type: String
    }
  }
};

/***/ }),

/***/ "ecdD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var langMapping = {
  'zh-TW': 'fxmt1588.com fxmt5566.com fxmt6600.com fxmt8800.com www.fxmt6600.com www.fxmt8800.com www.fxmt1588.com www.fxmt5566.com',
  en: 'fxmt534.com fxmt024.com',
  ar: 'fxmt336.com fxmt588.com',
  pt: 'fxmt6650.com fxmt6660.com'
};

var getDefaultLang = exports.getDefaultLang = function getDefaultLang() {
  var lang = "kr";
  try {
    var domain = window.location.hostname.split('.').splice(1).join('.').split(':')[0];
    for (var locale in langMapping) {
      var domainList = langMapping[locale].split(' ');
      if (domainList.includes(domain)) {
        lang = locale;
      }
    }
    console.log('默认语言', lang, domain);
  } catch (e) {
    console.error(e, '设置默认语言时出错');
  }
  return lang;
};

/***/ }),

/***/ "efBg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__("HD9R");

var _index2 = _interopRequireDefault(_index);

var _vuex = __webpack_require__("NYxO");

var _nameSpace = __webpack_require__("Ypiv");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CustomerService',
  components: { Popup: _index2.default },
  data: function data() {
    return {
      customer: {

        show: false
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    customerVisible: function customerVisible(state) {
      return state.app.customerVisible;
    }
  }), (0, _vuex.mapGetters)(['PORTAL_systemConfig']), {
    currentVisibleVModel: {
      get: function get() {
        return this.customerVisible;
      },
      set: function set(val) {
        this.$store.commit(_nameSpace.SET_CUSTOMER_VISIBLE, val);
      }
    },
    closeVisible: function closeVisible() {
      return this.$config.platform !== 'Darwinex FT';
    }
  }),
  watch: {
    currentVisibleVModel: function currentVisibleVModel() {
      this.customer.show = true;
    }
  }
};

/***/ }),

/***/ "ekbS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "elEQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiper = __webpack_require__("fBcm");

var _swiper2 = _interopRequireDefault(_swiper);

var _swiperItem = __webpack_require__("b+jt");

var _swiperItem2 = _interopRequireDefault(_swiperItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Notice',
  props: ['items'],
  components: { Swiper: _swiper2.default, SwiperItem: _swiperItem2.default },
  data: function data() {
    return {};
  },

  methods: {
    clickNoticeItem: function clickNoticeItem(noticeIndex) {
      this.$emit('clickNoticeItem', noticeIndex);
    }
  }
};

/***/ }),

/***/ "f6mN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick-menus txt-color"},[_c('div',{staticClass:"quick-menu-item content-bg",on:{"click":_vm.quickTrade}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('home.quickMenus.futuresTrading')))])]),_vm._v(" "),_c('div',{staticClass:"quick-menu-item content-bg",on:{"click":function($event){return _vm.$router.push('/help')}}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('home.quickMenus.helpCenter')))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon second-content-bg"},[_c('span',{staticClass:"trade"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon second-content-bg"},[_c('i',{staticClass:"iconfont icon-help value-color"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fBcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("gHEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("24fE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_5d7406b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("cWad");
function injectStyle (ssrContext) {
  __webpack_require__("AwbH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_swiper_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_5d7406b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fGQL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("piuB");

exports.default = {
  name: 'Tab',
  mixins: [_multiItems.parentMixin],
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent';
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;

      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
};

/***/ }),

/***/ "fNWv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gHEp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _swiper = __webpack_require__("NjrX");

var _swiper2 = _interopRequireDefault(_swiper);

var _router = __webpack_require__("0FxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      (0, _router.go)(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse((0, _stringify2.default)(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new _swiper2.default({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
};

/***/ }),

/***/ "h/zc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

var _Carousel = __webpack_require__("We2T");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _Notice = __webpack_require__("jdYA");

var _Notice2 = _interopRequireDefault(_Notice);

var _HotCoins = __webpack_require__("myym");

var _HotCoins2 = _interopRequireDefault(_HotCoins);

var _Poster = __webpack_require__("rMGM");

var _Poster2 = _interopRequireDefault(_Poster);

var _Menus = __webpack_require__("Pm4T");

var _Menus2 = _interopRequireDefault(_Menus);

var _Ranking = __webpack_require__("1Mrm");

var _Ranking2 = _interopRequireDefault(_Ranking);

var _HomeHeader = __webpack_require__("QzIo");

var _HomeHeader2 = _interopRequireDefault(_HomeHeader);

var _QuickMenus = __webpack_require__("52YF");

var _QuickMenus2 = _interopRequireDefault(_QuickMenus);

var _cache = __webpack_require__("TuU3");

var _nameSpace = __webpack_require__("Eeb1");

var _system = __webpack_require__("Zplo");

var _vuex = __webpack_require__("NYxO");

var _isActive = __webpack_require__("FQHV");

var _isActive2 = _interopRequireDefault(_isActive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCoinListWithPriceTimer = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Home',
  components: { Carousel: _Carousel2.default, Notice: _Notice2.default, HotCoins: _HotCoins2.default, Poster: _Poster2.default, Menus: _Menus2.default, Ranking: _Ranking2.default, HomeHeader: _HomeHeader2.default, QuickMenus: _QuickMenus2.default },
  mixins: [_isActive2.default],
  data: function data() {
    return {
      dialogNotices: {
        visible: false,
        finishUpdateTime: '',
        cacheInfoKey: _cache.CACHE_INFO_KEYS.SYS_NOTICE,
        onlyShowOnce: false,
        items: [],
        currentIndex: 0
      },
      noticesPop: {
        visible: false
      },
      noticeDetail: {
        visible: false,
        info: {}
      }
    };
  },

  computed: (0, _extends4.default)({}, (0, _vuex.mapState)({
    locale: function locale(state) {
      return state.i18n.locale;
    },
    vcListState: function vcListState(state) {
      return state.vc.vcList;
    },
    tradeConfigState: function tradeConfigState(state) {
      return state.vc.tradeConfig;
    }
  }), (0, _vuex.mapGetters)(['cacheInfo', 'vcListNoSettleEnabled'])),
  watch: {
    cacheInfo: function cacheInfo() {
      if (this.isActive && !(0, _cache.checkCacheVersionIsRight)((0, _extends4.default)({}, this.dialogNotices, (0, _defineProperty3.default)({}, 'value_' + this.locale, !0)))) {
        this.initSystemNotices();
      }
      if (this.isActive && !(0, _cache.checkCacheVersionIsRight)((0, _extends4.default)({}, this.vcListState))) {
        this.$store.dispatch('getVcList');
      }
      if (this.isActive && !(0, _cache.checkCacheVersionIsRight)((0, _extends4.default)({}, this.tradeConfigState))) {
        this.$store.dispatch('getTradeConfig');
      }
    },
    locale: function locale() {
      var _this = this;

      if (this.isActive) {
        this.initSystemNotices();
        this.$store.dispatch('getVcList').then(function () {
          _this.getCoinListWithPriceInterval().then(function () {
            setTimeout(function () {
              _this.$refs['ranking'].$refs['coins-slide'].refresh();
            }, 60);
          });
        });
        this.$store.dispatch('getTradeConfig');
      }
    }
  },
  methods: {
    initSystemNotices: function initSystemNotices() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        var cacheNoticeInfo = (0, _cache.initStateInCacheHas)(_nameSpace.__SYSTEM_NOTICE__) || {};
        if ((0, _cache.checkCacheVersionIsRight)(cacheNoticeInfo)) {
          _this2.dialogNotices.items = cacheNoticeInfo['value_' + _this2.locale].data;
          _this2.dialogNotices.finishUpdateTime = cacheNoticeInfo['value_' + _this2.locale].finishUpdateTime;
        } else {
          (0, _system.sysNoticeList)({ languageCode: _this2.locale }).then(function (res) {
            if (res.success) {
              var notices = res.data;

              if (notices) {
                _this2.dialogNotices.finishUpdateTime = (0, _cache.cacheObjByKey)(_nameSpace.__SYSTEM_NOTICE__, notices)['value_' + _this2.locale].finishUpdateTime;
                _this2.dialogNotices.items = notices;
              }
            } else {
              _this2.$message.error(res.message);
              return reject(new Error(res.message));
            }
          }).catch(function (err) {
            _this2.$message.error(err.message);
            return reject(err);
          });
        }
      });
    },
    clickNoticeItem: function clickNoticeItem(index) {
      if (!this.dialogNotices.items[index]) return;
      this.noticeDetail.info = this.dialogNotices.items[index];
      this.noticeDetail.visible = true;
    },
    visibilityChange: function visibilityChange() {
      if (document.visibilityState === 'hidden') {
        clearTimeout(getCoinListWithPriceTimer);
      } else {
        this.getCoinListWithPriceInterval();
      }
    },
    getCoinListWithPriceInterval: function getCoinListWithPriceInterval() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        clearTimeout(getCoinListWithPriceTimer);
        if (!_this3.isActive) {
          return;
        }
        _this3.$store.dispatch('getCoinListWithPrice').then(function () {
          getCoinListWithPriceTimer = setTimeout(function () {
            _this3.getCoinListWithPriceInterval();
          }, 3000);
          return resolve();
        }).catch(function () {
          getCoinListWithPriceTimer = setTimeout(function () {
            _this3.getCoinListWithPriceInterval();
          }, 3000);
          return resolve();
        });
      });
    }
  },
  activated: function activated() {
    var _this4 = this;

    document.addEventListener('visibilitychange', this.visibilityChange);
    this.initSystemNotices();
    this.$store.dispatch('getTradeConfig');
    // 获取系统币种列表信息
    this.$store.dispatch('getVcList').then(function () {
      _this4.getCoinListWithPriceInterval();
    }).catch(function (err) {
      console.log(err);
    });
  },
  deactivated: function deactivated() {
    clearTimeout(getCoinListWithPriceTimer);
    document.removeEventListener('visibilitychange', this.visibilityChange);
  }
};

/***/ }),

/***/ "hAqM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

var _swiper = __webpack_require__("fBcm");

var _swiper2 = _interopRequireDefault(_swiper);

var _swiperItem = __webpack_require__("b+jt");

var _swiperItem2 = _interopRequireDefault(_swiperItem);

var _vuex = __webpack_require__("NYxO");

var _nameSpace = __webpack_require__("Eeb1");

var _cache = __webpack_require__("TuU3");

var _sysBanner = __webpack_require__("JNpj");

var _device = __webpack_require__("43sz");

var _isActive = __webpack_require__("FQHV");

var _isActive2 = _interopRequireDefault(_isActive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Carousel',
  components: { Swiper: _swiper2.default, SwiperItem: _swiperItem2.default },
  mixins: [_isActive2.default],
  data: function data() {
    return {
      carousel: {
        finishUpdateTime: '',
        cacheInfoKey: _cache.CACHE_INFO_KEYS.SYS_BANNER,
        currentIndex: 0,
        items: []
      }
    };
  },

  computed: (0, _extends4.default)({}, (0, _vuex.mapState)({
    locale: function locale(state) {
      return state.i18n.locale;
    }
  }), (0, _vuex.mapGetters)(['cacheInfo'])),
  watch: {
    cacheInfo: function cacheInfo() {
      if (this.isActive && !(0, _cache.checkCacheVersionIsRight)((0, _extends4.default)({}, this.carousel, (0, _defineProperty3.default)({}, 'value_' + this.locale, !0)))) {
        this.initSystemBanners();
      }
    },
    locale: function locale() {
      if (this.isActive) {
        this.initSystemBanners();
      }
    }
  },
  methods: {
    initSystemBanners: function initSystemBanners() {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        var cacheCarouselCacheInfo = (0, _cache.initStateInCacheHas)(_nameSpace.__BANNER__) || {};
        if ((0, _cache.checkCacheVersionIsRight)(cacheCarouselCacheInfo)) {
          _this.carousel.items = cacheCarouselCacheInfo['value_' + _this.locale].data;
          _this.carousel.finishUpdateTime = cacheCarouselCacheInfo['value_' + _this.locale].finishUpdateTime;
        } else {
          _this.$loading.show();
          (0, _sysBanner.sysBannerList)({
            deviceType: _device.deviceType,
            languageCode: _this.locale
          }).then(function (res) {
            _this.$loading.hide();
            if (res.success) {
              var carousels = res.data;

              if (carousels) {
                _this.carousel.finishUpdateTime = (0, _cache.cacheObjByKey)(_nameSpace.__BANNER__, carousels)['value_' + _this.locale].finishUpdateTime;
                _this.carousel.items = carousels;
              }
            } else {
              _this.$message.error(res.message);
              return reject(new Error(res.message));
            }
          }).catch(function (err) {
            _this.$loading.hide();
            _this.$message.error(err.message);
            return reject(err);
          });
        }
      });
    }
  },
  activated: function activated() {
    this.initSystemBanners();
  }
};

/***/ }),

/***/ "hEUs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hd3i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

var _swiper = __webpack_require__("fBcm");

var _swiper2 = _interopRequireDefault(_swiper);

var _swiperItem = __webpack_require__("b+jt");

var _swiperItem2 = _interopRequireDefault(_swiperItem);

var _vuex = __webpack_require__("NYxO");

var _nameSpace = __webpack_require__("Eeb1");

var _cache = __webpack_require__("TuU3");

var _sysBanner = __webpack_require__("JNpj");

var _device = __webpack_require__("43sz");

var _isActive = __webpack_require__("FQHV");

var _isActive2 = _interopRequireDefault(_isActive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Carousel',
  components: { Swiper: _swiper2.default, SwiperItem: _swiperItem2.default },
  mixins: [_isActive2.default],
  data: function data() {
    return {
      carousel: {
        finishUpdateTime: '',
        cacheInfoKey: _cache.CACHE_INFO_KEYS.SYS_BANNER,
        currentIndex: 0,
        items: []
      }
    };
  },

  computed: (0, _extends4.default)({}, (0, _vuex.mapState)({
    locale: function locale(state) {
      return state.i18n.locale;
    }
  }), (0, _vuex.mapGetters)(['cacheInfo'])),
  watch: {
    cacheInfo: function cacheInfo() {
      if (this.isActive && !(0, _cache.checkCacheVersionIsRight)((0, _extends4.default)({}, this.carousel, (0, _defineProperty3.default)({}, 'value_' + this.locale, !0)))) {
        this.initSystemBanners();
      }
    },
    locale: function locale() {
      if (this.isActive) {
        this.initSystemBanners();
      }
    }
  },
  methods: {
    initSystemBanners: function initSystemBanners() {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        var cacheCarouselCacheInfo = (0, _cache.initStateInCacheHas)(_nameSpace.__BANNER__) || {};
        if ((0, _cache.checkCacheVersionIsRight)(cacheCarouselCacheInfo)) {
          _this.carousel.items = cacheCarouselCacheInfo['value_' + _this.locale].data;
          _this.carousel.finishUpdateTime = cacheCarouselCacheInfo['value_' + _this.locale].finishUpdateTime;
        } else {
          _this.$loading.show();
          (0, _sysBanner.sysBannerList)({
            deviceType: _device.deviceType,
            languageCode: _this.locale
          }).then(function (res) {
            _this.$loading.hide();
            if (res.success) {
              var carousels = res.data;

              if (carousels) {
                _this.carousel.finishUpdateTime = (0, _cache.cacheObjByKey)(_nameSpace.__BANNER__, carousels)['value_' + _this.locale].finishUpdateTime;
                _this.carousel.items = carousels;
              }
            } else {
              _this.$message.error(res.message);
              return reject(new Error(res.message));
            }
          }).catch(function (err) {
            _this.$loading.hide();
            _this.$message.error(err.message);
            return reject(err);
          });
        }
      });
    }
  },
  activated: function activated() {
    this.initSystemBanners();
  }
};

/***/ }),

/***/ "iEY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iPEl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Cell',
  props: {
    title: {
      required: true,
      type: String
    },
    value: {
      required: false,
      type: [String, Number]
    },
    isLink: {
      required: false,
      type: Boolean,
      default: false
    }
  }
};

/***/ }),

/***/ "iYDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue__ = __webpack_require__("efBg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue__ = __webpack_require__("yekX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528b1a68_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerService_vue__ = __webpack_require__("DS/O");
function injectStyle (ssrContext) {
  __webpack_require__("VY92")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-528b1a68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerService_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528b1a68_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerService_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ivHe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
};

/***/ }),

/***/ "j8CV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: 'Iniciar sesión',
    usernameLabel: 'Nombre de usuario',
    usernamePlaceholder: '2-10 dígitos en inglés',
    loginPasswordLabel: 'Contraseña de inicio de sesión',
    loginPasswordPlaceholder: 'Ingrese su contraseña de inicio de sesión',
    googleCodeLabel: 'código de verificación de Google',
    googleCodePlaceholder: 'Ingrese un código de verificación de Google de 6 dígitos',
    hasNoAccount: 'Sin cuenta todavía,',
    goRegister: 'Ir a registrarse',
    onlineCustom: 'Servicio al cliente en línea',
    loginArgument: 'Continuar iniciando sesión significa estar de acuerdo',
    userArgument: '《Acuerdo de usuario》',
    registerNotEnabled: 'La función de registro no está abierta, comuníquese con el administrador',
    usernameRequired: 'Ingrese un nombre de usuario correcto',
    loginPasswordRequired: 'Ingrese la contraseña de inicio de sesión correcta',
    googleCodeRequired: 'Ingrese el código de verificación de Google correcto',
    loginButton: 'iniciar sesión'
  },
  register: {
    title: 'Registrar',
    usernameLabel: 'Nombre de usuario',
    usernamePlaceholder: 'Ingrese el nombre de usuario registrado',
    loginPasswordLabel: 'Contraseña de inicio de sesión',
    loginPasswordPlaceholder: 'Ingrese la contraseña de inicio de sesión del usuario registrado',
    loginPasswordPreLabel: 'Confirmar contraseña de inicio de sesión',
    loginPasswordPrePlaceholder: 'Ingrese la contraseña de inicio de sesión nuevamente',
    fudPasswordLabel: 'Contraseña del fondo',
    fudPasswordPlaceholder: 'Ingrese la contraseña del fondo',
    inviteCodeLabel: 'Código de invitación',
    inviteCodePlaceholder: 'Ingrese un código de invitación de 6 dígitos',
    registerNeed: 'Continuar para registrarse significa estar de acuerdo',
    registerArgument: '《Acuerdo de registro》',
    usernameRequired: 'Ingrese un nombre de usuario correcto',
    loginPasswordRequired: 'Ingrese la contraseña de inicio de sesión correcta',
    loginPasswordPreRequired: 'Ingrese la contraseña de inicio de sesión de confirmación correcta',
    fundPasswordRequired: 'Ingrese la contraseña correcta del fondo',
    inviteCodeRequired: 'Ingrese el código de invitación correcto',
    diffLoginPasswordError: 'Las dos contraseñas de inicio de sesión son inconsistentes',
    registerSuccess: 'Registro exitoso',
    registerButton: 'Registrarse',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'Ingrese su dirección de correo electrónico',
    emailCodeLabel: 'Código de verificación',
    emailCodePlaceholder: 'Ingrese su código de verificación de correo electrónico',
    second: 'segundo',
    getEmailCodeButton: 'Obtener código',
    emailRequired: 'Ingrese una dirección de correo electrónico correcta y vuelva a intentarlo',
    emailCodeRequired: 'Ingrese el código de verificación de correo electrónico correcto y vuelva a intentarlo'
  },
  home: {
    hotCoin: {
      title: 'Las mejores ofertas',
      more: 'mas'
    },
    poster: {
      title: 'Depósito rápido',
      enter: 'Ingrese ahora>',
      subTitle: 'Soporte BTC, USDT, ETH, etc.'
    },
    quickMenus: {
      futuresTrading: 'Negociación de futuros',
      helpCenter: 'Centro de ayuda'
    },
    ranking: {
      increase: {
        title: 'Lista en ascenso'
      },
      clinch: {
        title: 'Lista de facturación'
      }
    }
  },
  tabBar: {
    home: 'Hogar',
    price: 'Mercado',
    trade: 'Comercio',
    fund: 'Activo',
    user: 'Perfil'
  },
  currency: {
    favorite: 'Opcional',
    allCurrency: 'al contado',
    dayVol: '24H',
    addFavor: '+ Agregar favor'
  },
  trade: {
    bills: 'Facturas',
    todayOpen: 'Abierto',
    star: 'Estrella',
    vol: 'Volumen',
    low: 'Más bajo',
    high: 'Más alto',
    timing: 'rápido',
    spot: 'futuros',
    buyMore: 'Comprar más',
    buyEmpty: 'Comprar vacío',
    indicator: 'Indicador',
    indicatorSettings: 'Configuración del indicador',
    balance: 'Mi saldo',
    fee: 'Tarifa de servicio',
    ruleIdError: 'Seleccione un tiempo de caducidad',
    deleteFavoriteSuccess: 'Eliminar moneda favorita exitosamente',
    addFavoriteSuccess: 'Agregar moneda favorita exitosamente',
    buyIn: 'comprar',
    sellOut: 'Vender',
    holding: 'posición de espera',
    history: 'Historia',
    spotOrderConfirm: {
      title: 'Confirmar compra',
      amountPlaceholder: 'Por favor ingrese la cantidad de compra'
    },
    spotTradeOrder: {
      holding: {
        coin: 'moneda',
        buyInAmountPrice: 'Cantidad/Precio de compra',
        buyInCount: 'Cantidad',
        actions: 'Operación',
        sellOut: 'Vender',
        profit: 'Ganancia'
      }
    },
    orderConfirm: {
      title: 'Confirmación de pedido',
      coinName: 'Moneda',
      direction: 'Dirección',
      price: 'Precio',
      balance: 'Saldo',
      fee: 'Tarifa de servicio',
      buyMoreLabel: 'Comprar más',
      buyEmptyLabel: 'Comprar vacío',
      buyQuantity: 'Comprar cantidad',
      buyAmount: 'Importe de la compra',
      submit: 'Confirmar pedido'
    },
    kline: {
      open: 'abierto:',
      close: 'cerca:',
      change: 'scambia:'
    }
  },
  finance: {
    title: 'Finanzas'
  },
  allFinance: {
    title: 'Gestión financiera',
    all: 'todo'
  },
  financeOrders: {
    title: 'Orden de compromiso',
    holdingLabel: 'sosteniendo',
    historyLabel: 'Historia',
    holding: {
      amount: 'Cantidad de compromiso',
      rateStr: 'cantidad de ingresos/rendimiento',
      vcCount: 'Número de monedas comprometidas',
      cycle: 'Ciclo de posición',
      day: 'día',
      calcStartDate: 'Fecha de valor de inicio',
      serviceAmount: 'Tarifa de servicio',
      redeemOrder: 'Canjear'
    },
    history: {
      incomeAmount: 'cantidad de ingresos',
      rateStr: 'rendimiento',
      amount: 'Cantidad de compromiso',
      vcCount: 'Número de monedas comprometidas',
      calcStartDate: 'Fecha de valor de inicio',
      calcEndDate: 'Fecha de finalización',
      cycle: 'días de ciclo',
      serviceAmount: 'Tarifa de servicio',
      day: 'día'
    }
  },
  financeOrderBills: {
    title: 'Ley de ingresos de promesa',
    amount: 'cantidad',
    balance: 'saldo'
  },
  financeItem: {
    rateStr: 'rendimiento',
    buyType: 'Tipo de compra',
    cycle: 'días de ciclo',
    exchangeRate: 'Tipo de cambio (saldo de cambio de moneda virtual)',
    day: 'día',
    cycleType: 'tipo de ciclo',
    serviceRateStr: 'Tarifa de servicio'
  },
  buyFinance: {
    title: 'Comprar',
    rateStr: 'rendimiento',
    name: 'nombre',
    buyType: 'Tipo de compra',
    cycle: 'días de ciclo',
    cycleType: 'tipo de ciclo',
    exchangeRate: 'Tipo de cambio (saldo de cambio de moneda virtual)',
    serviceRateStr: 'Tarifa de servicio',
    remark: 'observación',
    buyAmountLabel: 'Cantidad de compra ({moneda})',
    descriptionTitle: 'Descripción del producto',
    descriptionPart1: '1. Este producto es un producto de gestión patrimonial sin garantía de principal. Las fluctuaciones del mercado pueden generar pérdidas de principal. Invierta con cuidado.',
    descriptionPart2: '2. Reglas de liquidación de pagos:',
    descriptionPart3: 'Si el precio de liquidación < precio vinculado, BTC se liquidará después del vencimiento; monto de liquidación = monto de inversión * (1+ días * tasa de rendimiento anualizada / 365).',
    descriptionPart4: 'Si el precio de liquidación ≥ precio vinculado, USDT se liquidará después del vencimiento; monto de liquidación = monto de inversión * precio vinculado * (1+ días * tasa de rendimiento anualizada / 365).',
    descriptionPart5: '3. La tasa de rendimiento anualizada real cambia con el mercado en tiempo real, consulte la transacción de compra real.',
    descriptionPart6: '4. El monto de la inversión se convierte de acuerdo con el mercado en tiempo real, consulte la transacción de compra real.',
    descriptionPart7: '5. Después de comprar el producto, se puede ver en mi página de retención de moneda y el reembolso se emitirá automáticamente a la cuenta al contado después de la fecha de vencimiento.',
    buyButton: 'Comprar [{coin}]'
  },
  fund: {
    description: 'Activos',
    recharge: 'Recargar',
    withdraw: 'Retirar',
    exchange: 'Transferir',
    empty: 'La billetera está vacía, ve'
  },
  userCenter: {
    lastLogin: 'Último inicio de sesión',
    myTeam: 'Mi Equipo',
    identity: 'Autenticación',
    walletAddress: 'Dirección de la billetera',
    zskAccount: 'Cuenta ZSK',
    bankCard: 'Cuenta bancaria',
    userBills: 'Facturas de usuario',
    timingTradeOrder: 'Tiempo de orden comercial',
    spotTradeOrder: 'Posisi berjangka',
    contactTradeOrder: 'Posición del contrato',
    userReport: 'Informe de usuario',
    teamReport: 'Informe del equipo',
    share: 'Comparte',
    customer: 'Servicio al cliente',
    helpCenter: 'Centro de ayuda',
    platform: 'Introducción a la plataforma',
    profit: 'Beneficio',
    balance: 'Saldo',
    withdraw: 'Retirar',
    recharge: 'Recargar',
    creditStoreLabel: 'Tienda de crédito'
  },
  settings: {
    title: 'Configuración',
    fundPassword: 'Contraseña del fondo',
    googleValidator: 'Google Validador',
    editLoginPassword: 'Editar contraseña de inicio de sesión',
    switchLocale: 'Cambiar idioma'
  },
  editFundPassword: {
    title: 'Cambiar contraseña del fondo',
    currentPasswordLabel: 'contraseña actual',
    currentPasswordPlaceholder: 'Ingrese la contraseña actual del fondo',
    newPasswordLabel: 'Nueva contraseña',
    newPasswordPlaceholder: 'Ingrese la contraseña del fondo modificada',
    prePasswordLabel: 'Confirmar contraseña',
    prePasswordPlaceholder: 'Borrar y volver a ingresar la contraseña del fondo modificada',
    tips: 'La contraseña del fondo es un certificado importante para las transacciones, configúrela con cuidado y téngala en cuenta',
    currentPasswordRequired: 'Ingrese la contraseña actual del fondo',
    newPasswordRequired: 'Ingrese la contraseña del fondo a modificar',
    prePasswordRequired: 'Ingrese la contraseña del fondo para modificarla nuevamente',
    prePasswordDiff: 'Dos entradas de contraseña son inconsistentes'
  },
  bindFundPassword: {
    title: 'Contraseña de enlace de fondo',
    fundPasswordLabel: 'Contraseña del fondo',
    fundPasswordPlaceholder: 'Ingrese la contraseña del fondo',
    fundPasswordPreLabel: 'Confirmar contraseña',
    fundPasswordPrePlaceholder: 'Ingrese la contraseña del fondo nuevamente',
    fundPasswordRequired: 'Se requiere la contraseña del fondo',
    fundPasswordPreRequired: 'Se requiere confirmar contraseña',
    fundPasswordDiff: 'Dos entradas de contraseña son inconsistentes',
    bindSuccess: 'Enlace exitoso',
    tips: 'La contraseña del fondo es un certificado importante para las transacciones, configúrela con cuidado y téngala en cuenta'
  },
  editLoginPassword: {
    title: 'Cambiar contraseña de inicio de sesión',
    currentPasswordLabel: 'Contraseña actual',
    currentPasswordPlaceholder: 'Ingrese la contraseña de inicio de sesión actual',
    newPasswordLabel: 'Nueva contraseña',
    newPasswordPlaceholder: 'Ingrese la contraseña de inicio de sesión modificada',
    prePasswordLabel: 'Confirmar contraseña',
    prePasswordPlaceholder: 'Borrar y volver a ingresar la contraseña de inicio de sesión modificada',
    tips: 'La contraseña de inicio de sesión es una credencial importante para la autenticación de inicio de sesión, etc., configúrela con cuidado y téngala en cuenta',
    currentPasswordRequired: 'Ingrese la contraseña de inicio de sesión actual',
    newPasswordRequired: 'Ingrese la contraseña de inicio de sesión para modificarla',
    prePasswordRequired: 'Por favor, vuelva a introducir la contraseña de inicio de sesión para modificarla',
    prePasswordDiff: 'Dos entradas de contraseña son inconsistentes'
  },
  bindGoogleValidator: {
    title: 'Vincular Google Authenticator',
    qrCodeLabel: 'código QR',
    keyLabel: 'Clave',
    loginPasswordLabel: 'Contraseña de inicio de sesión',
    loginPasswordPlaceholder: 'Ingrese su contraseña de inicio de sesión',
    googleCodeLabel: 'código de verificación de Google',
    googleCodePlaceholder: 'Ingrese un código de verificación de Google de 6 dígitos',
    tipsPart1: 'Buscar Google Authenticator en la tienda de aplicaciones',
    tipsPart2: 'Use Google Authenticator para escanear el código QR anterior, o ingrese manualmente la clave para enlazar',
    tipsPart3: 'Ingrese el código de verificación de Google de 6 dígitos anterior, haga clic en Confirmar para enviar',
    loginPasswordRequired: 'Ingrese la contraseña de inicio de sesión',
    googleCodeRequired: 'Ingrese un código de verificación de Google de 6 dígitos'
  },
  walletAddress: {
    title: 'Dirección de billetera',
    add: '+ Agregar dirección',
    remark: 'Observación',
    addButton: 'Agregar dirección de billetera',
    tips: 'Si desea modificar o eliminar la información de la dirección, comuníquese con el servicio al cliente'
  },
  addWalletAddress: {
    title: 'Agregar dirección de billetera',
    vcChainNameIdLabel: 'Tipo de cadena',
    vcAccountLabel: 'Dirección de billetera',
    vcAccountPlaceholder: 'Ingrese la dirección de la billetera',
    remarkLabel: 'Observaciones',
    remarkPlaceholder: 'Ingrese el contenido del comentario',
    fundPasswordLabel: 'Contraseña del fondo',
    fundPasswordPlaceholder: 'Ingrese la contraseña de su fondo',
    tips: 'La dirección de la billetera agregada no se puede modificar, verifique que la información sea correcta',
    vcIdRequired: 'Seleccione la moneda correcta',
    vcChainNameIdRequired: 'Seleccione el tipo de cadena correcto',
    vcAccountRequired: 'Ingrese la dirección de billetera correcta',
    fundPwdRequired: 'Ingrese la contraseña correcta del fondo',
    addSuccess: 'Dirección de billetera agregada con éxito'
  },
  receiveWays: {
    title: 'Mi tarjeta bancaria',
    add: '+ Agregar tarjeta bancaria',
    tips: 'Si desea modificar o eliminar la información de la tarjeta bancaria, comuníquese con el servicio al cliente',
    addCardButton: 'Añadir tarjeta bancaria'
  },
  zskAccount: {
    title: 'Cuenta rápida',
    add: '+ Agregar cuenta rápida',
    tips: 'Para modificar o eliminar la información de la cuenta, comuníquese con el servicio al cliente',
    addCardButton: 'Agregar cuenta'
  },
  addZskAccount: {
    title: 'Agregar una cuenta rápida',
    withdrawNameLabel: 'Nombre',
    withdrawNamePlaceholder: 'Ingrese el nombre',
    withdrawNameRequired: 'El nombre es obligatorio',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Ingrese la identificación de velocidad rápida',
    fundPasswordLabel: 'Contraseña del fondo',
    fundPasswordPlaceholder: 'Ingrese la contraseña de su fondo',
    tips: 'Complete cuidadosamente la información de la cuenta agregada, la empresa no será responsable del problema de que el retiro no llegue debido a información incorrecta'
  },
  addBankCard: {
    title: 'Agregar una nueva tarjeta bancaria',
    withdrawNameLabel: 'Nombre',
    withdrawNamePlaceholder: 'Ingrese el nombre',
    withdrawNameRequired: 'El nombre es obligatorio',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Ingrese el de ZSK',
    zskRequired: 'Se requiere ID de ZSK',
    cardNumLabel: 'Número de cuenta bancaria',
    cardNumPlaceholder: 'Ingrese el número de tarjeta bancaria',
    branchLabel: 'Dirección de la sucursal',
    branchPlaceholder: 'Ingrese la dirección de la sucursal de la tarjeta bancaria',
    fundPasswordLabel: 'Contraseña del fondo',
    fundPasswordPlaceholder: 'Ingrese la contraseña del fondo',
    tips: 'La tarjeta bancaria es un dato importante para el retiro de efectivo de la transacción, complete con cuidado, la empresa no será responsable de ningún problema, como la falta de recepción de efectivo debido al llenado incorrecto de la información de la tarjeta. ',
    backIdRequired: 'Por favor seleccione el banco de la cuenta',
    cardNumRequired: 'Ingrese el número de tarjeta bancaria correcto',
    fundPwdRequired: 'Ingrese la contraseña correcta del fondo',
    idCardPlaceholder: 'Ingrese su número de identificación',
    idCardLabel: 'Número de tarjeta de identificación',
    idCardRequired: 'Ingrese el número de identificación correcto',
    cciPlaceholder: 'Por favor, introduzca la tarjeta bancaria CCI',
    branchCodePlaceholder: 'Por favor ingrese el código de sucursal',
    branchCodeLabel: 'código de sucursal',
    katakanaPlaceholder: 'Por favor introduce katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Registro de cambio de cuenta',
    vcName: 'Moneda',
    amount: 'Cantidad',
    balance: 'Saldo'
  },
  timingTradeOrder: {
    title: 'Tiempo de orden comercial',
    waiting: {
      title: 'Pedidos en curso',
      amount: 'Cantidad',
      period: 'período',
      receivePrice: 'Precio de compra',
      settlement: 'liquidación en curso'
    },
    history: {
      title: 'Órdenes históricas',
      buyInClose: 'Precio de compra',
      saleOutClose: 'precio de venta'
    }
  },
  spotTradeOrder: {
    title: '期货交易订单',
    waiting: {
      title: '在持订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      buyInTime: '买入时间'
    },
    history: {
      title: '历史订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      sellOutAmount: '卖出总价',
      sellOutPrice: '卖出单价',
      sellOutTime: '卖出时间'
    }
  },
  userReport: {
    title: 'Informe de usuario',
    profit: 'Beneficio',
    timingTradeAmountFee: 'Orden comercial extremadamente rápida/tarifa de manejo',
    timingTradePrizePoint: 'Bono/reembolso de negociación extremadamente rápido',
    rechargeInfo: 'Tarifa de recarga/manejo',
    withdrawInfo: 'Tarifa de retiro/manejo',
    exchangeInfo: 'Tarifa de cambio/manejo'
  },
  userReportDay: {
    title: 'Informe diario del usuario',
    profit: 'Beneficio',
    timingTradeAmountFee: 'Orden comercial extremadamente rápida/tarifa de manejo',
    timingTradePrizePoint: 'Bono/reembolso de negociación extremadamente rápido',
    rechargeInfo: 'Tarifa de recarga/manejo',
    withdrawInfo: 'Tarifa de retiro/manejo',
    exchangeInfo: 'Tarifa de cambio/manejo'
  },
  teamReport: {
    goToReportDay: 'Día del informe',
    timingTradeBetAmountServiceCharge: 'Tiempo de cantidad/servicios comerciales',
    timingTradeBetPrizePoint: 'Punto/Premio comercial de sincronización',
    timingTradeUserAndCount: 'Cronometraje de usuarios comerciales/recuentos',
    rechargeAmountFee: 'Cantidad de recarga/Servicios',
    rechargePersonCount: 'Recargar Usuarios/Cuentas',
    withdrawAmountFee: 'Retirar Monto/Servicios',
    withdrawPersonCount: 'Retirar Usuarios/Cuentas',
    firstRechargeUserAndCount: 'Cantidad/recuentos de la primera recarga',
    title: 'Informe del equipo',
    usernamePlaceholder: 'Ingrese el nombre de usuario de nivel inferior',
    previewAllTradeInfo: 'Ver toda la información comercial rápida',
    coin: 'moneda',
    timingTradeBetAmount: 'Cantidad de apuestas comerciales extremadamente rápida',
    profit: 'Beneficio',
    action: 'operación',
    previewReportDay: 'Ver el informe diario'
  },
  teamTimingTradeInfo: {
    title: 'Trading de velocidad de equipo',
    profit: 'Beneficio',
    subTitle: 'Información de transacción de velocidad del equipo',
    timingTradeAmountFee: 'Orden comercial/tarifa de servicio extremadamente rápida',
    timingTradePrizePoint: 'Bono/reembolso de negociación extremadamente rápido',
    rechargeInfo: 'Recarga/Tarifa de servicio',
    withdrawInfo: 'Tarifa de retiro/servicio',
    exchangeInfo: 'Tarifa de cambio/servicio'
  },
  teamReportDay: {
    title: 'Informe diario del equipo',
    subTitle: 'Informe diario del equipo [ {username} ]',
    timingTradeBetAmountFee: 'Tarifa de servicio/orden comercial extremadamente rápida',
    timingTradeUserAndCount: 'Cronometraje de usuarios comerciales/recuentos',
    timingTradeBetPrizePoint: 'Bono/reembolso rápido',
    rechargeAmountFee: 'Cantidad de recarga/tarifa de servicio',
    rechargePersonCount: 'Persona de recarga/número de transacciones',
    firstRechargePersonCount: 'Cantidad/recuentos de la primera recarga',
    withdrawAmountFee: 'Cantidad de retiro/tarifa de servicio',
    withdrawPersonCount: 'El número de personas que retiran dinero/transacciones',
    exchangeAmountFee: 'Cantidad de intercambio/Tarifa de servicio'
  },
  share: {
    title: 'Compartir',
    qrCodeLabel: 'código QR',
    registerUrlLabel: 'Dirección de registro',
    inviteCodeLabel: 'Código de invitación',
    hasNoInviteCode: 'La cuenta actual no tiene código de invitación',
    generateInvitationCode: 'Intentar generar con un clic',
    tipsPart1: 'Escanee el código QR anterior para completar la información de registro para registrarse',
    tipsPart2: 'Copie la dirección de registro y complete la información de registro para registrarse',
    tipsPart3: 'Abra manualmente la interfaz de registro de este sitio y complete el código de invitación para registrarse',
    saveImageError: 'No se pudo guardar la imagen, intente mantener presionada la imagen y guardar'
  },
  myTeam: {
    title: 'Mi equipo',
    usernamePlaceholder: 'Ingrese el nombre de usuario de nivel inferior',
    point: 'bonificación (velocidad/contrato)',
    totalBalance: 'Saldo',
    lastLoginTime: 'Hora del último inicio de sesión',
    noLoginTime: 'ninguno'
  },
  userDetail: {
    title: 'Detalle del usuario',
    username: 'Nombre de usuario',
    userType: 'Tipo de usuario',
    pointPercentTiming: 'Punto de tiempo',
    pointPercentContract: 'Punto de contrato',
    registerWay: 'Método de registro',
    teamCounts: 'Número de equipo',
    teamOnline: 'equipo en línea',
    balance: 'saldo',
    registerTime: 'Hora de registro',
    onlineStatus: 'estado de inicio de sesión'
  },
  addUser: {
    title: 'Agregar usuario',
    addUserDirect: {
      userTypeLabel: 'Tipo de usuario',
      usernameLabel: 'Nombre de usuario',
      usernamePlaceholder: 'Ingrese el nombre de usuario de la cuenta',
      pointTimingLabel: 'Reembolso de transacción extremadamente rápido',
      pointContractLabel: 'Reembolso de transacción de contrato',
      tips: 'La contraseña inicial es: "{contraseña}"; recuerde al usuario que cambie la contraseña a tiempo después de abrir la cuenta',
      userTypeRequired: 'Seleccione el tipo de cuenta',
      usernameRequired: 'Ingrese el nombre de usuario de la cuenta',
      pointTimingRequired: 'Seleccione el reembolso de transacción rápida',
      pointContractRequired: 'Por favor, seleccione reembolso de transacción de contrato',
      copyTemplate: '\n          Nombre de usuario: {nombre de usuario};\n          Contrase\xF1a de inicio de sesi\xF3n: {contrase\xF1a de inicio de sesi\xF3n};\n          URL de inicio de sesi\xF3n: {direcci\xF3n de inicio de sesi\xF3n};\n          Reembolso de comercio r\xE1pido: {timingTradePoint};\n          Reembolso de negociaci\xF3n de contratos: {contactTradePoint};\n          '
    }
  },
  recharge: {
    title: 'Recargar',
    configIdLabel: 'Canal de recarga',
    chainNameLabel: 'Nombre de la cadena',
    amountLabel: 'Cantidad del depósito',
    userCardNameLabel: 'Pagador',
    userCardNamePlaceholder: 'Ingrese el nombre del pagador',
    fee: 'tarifa de servicio',
    receiveAmountTipsPart1: 'Recargar',
    receiveAmountTipsPart2: ', Necesita pago',
    tipsPart1: 'Debido a que la interfaz de pago en línea es inestable, ¡actualmente solo se admiten transferencias y recargas fuera de línea! ',
    tipsPart2: 'Ingrese el monto real de la transferencia con veracidad, de lo contrario, puede hacer que el sistema falle en la revisión y afecte el progreso de la recarga. ',
    emptyPart1: 'Sin canal de recarga, ',
    emptyPart2: 'Toque para volver a intentar',
    amountRequired: 'El monto de la recarga no puede estar vacío',
    maxPrecisionError: 'El monto de la recarga puede tener hasta {amountMaxPrecision} decimales',
    payUserNameError: 'Ingrese un pagador correcto y vuelva a intentarlo',
    userMobileLabel: 'Móvil',
    userMobilePlaceholder: 'Ingrese su móvil',
    needPayLabel: 'Necesita pago',
    needPayPlaceholder: 'Ingrese Cantidad'
  },
  payDetail: {
    title: 'Transferir información',
    addressLabel: 'Dirección de depósito',
    rechargeAmount: 'Cantidad',
    bankNameLabel: 'Banco',
    branchLabel: 'Dirección de la sucursal',
    cardName: 'Nombre',
    cardNum: 'número de tarjeta',
    uploadImgLabel: 'Credenciales de pago',
    uploadImgPlaceholder: 'Haga clic para cargar la imagen del comprobante de pago',
    uploadImgRequired: 'Cargue la imagen del comprobante de pago',
    vcTransferTipsPart1: '1. Copie la dirección de depósito o escanee el código QR para depositar',
    vcTransferTipsPart2: '2. Cargue la imagen del comprobante de pago después de completar el depósito',
    vcTransferTipsPart3: 'Para mejorar la eficiencia del depósito, asegúrese de cargar una imagen clara y de alta definición del certificado, si la imagen de la información relevante no es clara, puede hacer que el sistema falle en la revisión y afecte el progreso del depósito. ',
    bankCardTips: 'Para mejorar la eficiencia del depósito de dinero, asegúrese de que el nombre del remitente y el del remitente sean los mismos; si la información relevante no coincide, puede causar que el sistema falle la revisión y afecte el progreso del depósito. ',
    bankCardTransferSuccess: 'He transferido con éxito'
  },
  rechargeOrder: {
    title: 'Orden de depósito',
    payAmount: 'Cantidad',
    receiveAmount: 'Recibir cantidad'
  },
  identity: {
    title: 'Información del nombre real',
    subTitle: 'La autenticación de nombre real incluye autenticación de información, autenticación de identidad',
    name: 'nombre',
    idType: 'Tipo de documento',
    idNum: 'número de identificación',
    demand: 'Requerir',
    informationVer: 'Verificación de información',
    idAuthentication: 'Autenticación',
    material: 'Material'
  },
  verified: {
    title: 'Verificado',
    idCardTypeLabel: 'Tipo de certificado',
    idCardFrontSideImgLabel: 'Card Front SideImgLabel',
    idCardBackSideImgLabel: 'La parte posterior de la foto de identificación',
    idCardHandSideImgLabel: 'Foto de identificación de mano',
    nameLabel: 'Nombre del documento',
    namePlaceholder: 'Ingrese su nombre de ID',
    idCardNumLabel: 'Número de tarjeta de identificación',
    idCardNumPlaceholder: 'Ingrese el número de identificación',
    fundPwdLabel: 'Contraseña del fondo',
    fundPwdPlaceholder: 'Ingrese la contraseña de su fondo',
    tips: 'Una vez que se envía la autenticación de la información, no se puede modificar, verifíquela cuidadosamente y complétela correctamente',
    idCardTypeRequired: 'Seleccione el tipo de tarjeta',
    idCardFrontSideImgRequired: 'Cargue una foto frontal de la tarjeta de identificación',
    idCardBackSideImgRequired: 'Cargue una foto del reverso de la tarjeta de identificación',
    idCardHandSideImgRequired: 'Cargue una foto de identificación de mano',
    nameRequired: 'Ingrese el nombre del documento',
    idCardNumRequired: 'Ingrese el número de identificación',
    fundPwdRequired: 'Ingrese la contraseña de su fondo',
    submitSuccess: 'Solicitud de autenticación enviada con éxito'
  },
  help: {
    title: 'Centro de ayuda'
  },
  helpDetail: {
    title: 'Detalles de ayuda'
  },
  myMessage: {
    title: 'Mi mensaje'
  },
  messageDetail: {
    title: 'Detalles del mensaje'
  },
  withdraw: {
    title: 'Retirar monedas',
    tips: 'Con el fin de garantizar la seguridad de los fondos y la eficiencia de la retirada; compruebe cuidadosamente que la información completada sea correcta, la tarifa de servicios generada durante el proceso de retiro se deducirá del saldo',
    receiveAmountTipsPart1: 'Retirar',
    receiveAmountTipsPart2: ', se espera que llegue',
    fee: 'Tarifa de servicio',
    myBalance: 'Mi [{vcName}] saldo:',
    configIdLabel: 'Canal de retiro',
    amountLabel: 'Cantidad de retiro',
    fundLabel: 'Contraseña del fondo',
    fundPlaceholder: 'Ingrese la contraseña de su fondo',
    googleCodeLabel: 'código de verificación de Google',
    googleCodePlaceholder: 'Ingrese un código de verificación de Google de 6 dígitos',
    maxPrecisionError: 'El monto del retiro puede tener hasta {amountMaxPrecision} decimales',
    amountRequired: 'Ingrese o seleccione la cantidad de retiro correcta',
    bankCardError: 'Seleccione la tarjeta bancaria correcta',
    fundPwdError: 'Ingrese la contraseña correcta del fondo',
    walletAddressError: 'Seleccione la dirección de billetera correcta',
    success: 'La solicitud de retiro se envió con éxito, espere a que se procese',
    emptyPart1: 'No hay canal de retiro disponible, ',
    emptyPart2: 'Toque para reintentar'
  },
  withdrawOrder: {
    title: 'Orden de retiro',
    requestAmount: 'Cantidad',
    receiveAmount: 'Recibir cantidad'
  },
  locales: {
    title: 'Cambiar idioma'
  },
  lines: {
    title: 'Líneas',
    switchLine: 'Cambiar Línea'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Eliminar moneda favorita exitosamente',
    addFavoriteSuccess: 'Agregar moneda favorita exitosamente'
  },
  currencySelect: {
    currencyName: 'moneda',
    currencyPlaceholder: 'Haga clic para seleccionar la moneda'
  },
  walletItem: {
    available: 'disponible',
    convert: 'convertir (USDT)'
  },
  banks: {
    bankIdLabel: 'Banco',
    bankIdPlaceholder: 'Haga clic para seleccionar un banco'
  },
  banksPop: {
    title: 'Seleccionar banco',
    search: 'Palabras clave del banco de entrada'
  },
  historyOrderDetail: {
    title: 'Detalles del pedido',
    coin: 'Moneda de transacción',
    amount: 'monto del pedido',
    buyInClose: 'Precio de compra',
    sellOutClose: 'Precio de venta',
    isQuest: '¿Tiene alguna pregunta sobre este pedido?',
    connectCustomer: '¿Contactar con el servicio de atención al cliente?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Haga clic para seleccionar el reembolso del usuario'
  },
  walletAddressSelect: {
    title: 'Seleccione la dirección de la billetera',
    label: 'Dirección de billetera',
    placeholder: 'Haga clic para seleccionar la dirección de la billetera'
  },
  myCardSelect: {
    title: 'Seleccionar cuenta',
    label: 'cuenta receptora',
    placeholder: 'Haga clic para seleccionar una cuenta'
  },
  amountInput: {
    amountRange: 'Min {minAmount}, Max {maxAmount}',
    amountMin: 'Min {minAmount}, Sin tope',
    amountErrorEmpty: 'Se requiere {etiqueta}',
    amountErrorOutRange: '{label} está fuera de rango'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Min {minAmount}, Uncapped',
    placeholderHasMax: 'Min {minAmount}, Max {maxAmount}',
    amountErrorEmpty: 'La cantidad es incorrecta',
    amountErrorOutRange: 'La cantidad está fuera de rango'
  },
  common: {
    remark: 'Observación',
    saveImage: 'Guardar imagen',
    online: 'En línea',
    offline: 'Fuera de línea',
    profit: 'Beneficio',
    date: 'Fecha',
    period: 'Período',
    pointAmount: 'Cantidad de Puntos',
    point: 'Reembolso de usuario',
    direction: 'Dirección',
    winLoss: 'Ingreso',
    lose: 'Perder',
    add: 'Agregar',
    win: 'ganar',
    edit: 'Modificar',
    notBind: 'Sin consolidar',
    alreadyBind: 'Ya encuadernado',
    enabled: 'Habilitado',
    notEnabled: 'No Habilitado',
    queryRange: 'Rango de consulta',
    copy: 'Copiar',
    orderNum: 'Pedido',
    null: 'Nulo',
    noData: 'Sin datos',
    refreshSuccess: 'Actualización exitosa',
    loadMoreData: 'Cargar más datos',
    noMoreData: 'No más datos',
    lookMore: 'Más',
    more: 'Más'
  },
  date: {
    today: 'Hoy',
    yesterday: 'Ayer',
    last7Days: 'Cerca de 7 días',
    last14Days: 'Cerca de 14 días',
    split: 'A'
  },
  button: {
    save: 'Guardar',
    logout: 'Cerrar sesión',
    confirm: 'OK',
    cancel: 'Cancelar',
    submit: 'enviar',
    addNow: 'Agregar ahora',
    reset: 'restablecer',
    nextStep: 'Siguiente',
    goCertification: 'Ir a la certificación'
  },
  confirm: {
    title: {
      logout: 'Cerrar sesión',
      unBindFundPassword: 'Contraseña de fondo sin vincular',
      addUserDirect: 'Agregar Usuario',
      addUserInfo: 'Agregar usuario con éxito',
      jumpToRechargePage: 'Confirmar salto',
      unAuthentication: 'Unauthentication',
      noBindBankCard: 'Sin tarjeta bancaria',
      noBindCoinAddress: 'Sin dirección de billetera',
      tradeConfirm: 'Confirmar transacción',
      sellOutSpotOrder: 'Posición para vender',
      buyFinance: 'Confirmar compra',
      redeemOrder: 'Redención de órdenes de prenda'
    },
    content: {
      logout: '¿Estás seguro de cerrar sesión en la cuenta actual?',
      unBindFundPassword: 'Se ha detectado una contraseña de fondo no vinculada, para garantizar la seguridad de la cuenta, vincule primero la contraseña de su fondo',
      addUserDirect: 'Pronto se agregará un nuevo usuario, verifique que la información sea correcta y haga clic en Aceptar para continuar, nombre de usuario [ {username} ], tipo de usuario [ {userType} ], contraseña de inicio de sesión [ {password} ] y diferencia entre mi reembolso de velocidad comercial [ {diffPointTiming} ] y mi diferencia de reembolso de transacción de contrato [ {diffPointContract} ]',
      addUserInfo: 'Nombre de usuario [{nombre de usuario}]; <br /> Contraseña de inicio de sesión [ {password} ];<br /> URL de inicio de sesión [ {loginAddress} ];<br /> Reembolso de transacción extrema [ {pointPercentTiming} ];<br /> /> Reembolso de transacción de contrato [{pointPercentContract} ];',
      jumpToRechargePage: 'A punto de saltar a la interfaz de recarga de tres partes, haga clic en confirmar para continuar',
      unAuthentication: 'Se detecta que la cuenta no se ha autenticado con el nombre real. Para garantizar la circulación normal de los fondos, realice primero la autenticación con el nombre real',
      noBindBankCard: 'Se detecta que la cuenta no está vinculada o activada con tarjeta bancaria. Para garantizar la circulación normal de los fondos, vincule primero la tarjeta bancaria',
      noBindCoinAddress: 'Se detecta que la cuenta no tiene una cuenta de moneda virtual vinculada o habilitada. Para garantizar la circulación normal de los fondos, agregue primero la dirección de la cuenta de moneda virtual',
      tradeConfirm: 'El pedido está a punto de enviarse, verifique que la información del pedido sea correcta y haga clic en Confirmar pedido para enviarlo',
      sellOutSpotOrder: 'La orden de posición está a punto de venderse, confirme que la operación es correcta y haga clic en Aceptar para continuar',
      buyFinance: 'A punto de comprar [{coin}], compre acción: {cantidad}, confirme que la operación es correcta y haga clic en Aceptar para continuar',
      redeemOrder: 'El pedido de compromiso ({orderNum}) está a punto de ser canjeado, confirme que la operación es correcta y haga clic en Confirmar para continuar'
    }
  },
  message: {
    bindSuccess: 'Enlazar con éxito',
    successOperation: 'Operación exitosa',
    logoutSuccess: 'Salir con éxito',
    editSuccess: 'Modificado con éxito',
    addSuccess: 'Agregar exitosamente',
    copySuccess: 'Copia exitosa',
    copyFailed: 'Copia fallida'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Día',
      week_dia_1: 'Uno',
      week_dia_2: 'dos',
      week_day_3: 'tres',
      week_day_4: 'cuatro',
      week_day_5: 'cinco',
      week_day_6: 'Seis'
    },
    loading: {
      loading: 'cargando'
    }
  },
  helpItems: {
    title: {
      part1: '¿Por qué cambia la cantidad convertida en activos? ',
      part2: 'Olvidar el método de manejo de la contraseña del fondo para transacciones OTC',
      parte3: '¿Hacia dónde fluirán los fondos después de que se complete la compra de la transacción OTC? ',
      part4: '¿Por qué quieres limitar el número de veces que puedes modificar tu apodo?',
      part5: '¿Cuál es el significado de la transferencia, por qué es necesario transferir',
      part6: '¿Cómo calcular el patrimonio de la cuenta del contrato de usuario? ',
      part7: '¿Cuál es el valor del stop loss y take profit establecido en la posición de apertura? ¿Cómo debe configurarse? ',
      parte8: '¿Cómo reducir el riesgo del contrato? ',
      part9: '¿Qué indica la cantidad en la posición abierta del contrato? ',
      part10: 'Instrucciones sobre liquidación forzosa',
      part11: '¿Cuáles son las reglas de negociación de contratos? ',
      part12: '¿Cuál es el margen en el comercio de contratos? ',
      part13: '¿Qué es la orden limitada y la orden de mercado? ',
      part14: '¿Qué representa el riesgo de las transacciones de contrato?',
      part15: '¿Por qué necesita la conversión de divisas? ',
      part16: '¿Por qué la otra parte no recibió la transferencia a tiempo después de la transferencia de la transacción OTC? ',
      part17: '¿Cómo comprar Tether (USDT) a través de OTC? '
    },
    content: {
      parte1: 'El valor de la moneda digital actualmente en renminbi cuando se convierte en activos cambiará debido a las fluctuaciones de precios de los activos digitales. El número de sus activos digitales no ha cambiado. ',
      parte2: 'Si olvida la contraseña del fondo de transacciones OTC, vaya a "Mi-Configuración-Haga clic para establecer la contraseña del fondo" o comuníquese con el servicio al cliente para restablecer',
      part3: 'Después de que se complete la orden de compra OTC, los fondos ingresarán a la cuenta en moneda legal en el activo. Si necesita utilizar activos adquiridos OTC para la negociación de contratos o la negociación de futuros, vaya al módulo de transferencia de fondos para realizar la transferencia. ',
      part4: 'Por razones de seguridad de su transacción, actualmente limitamos el apodo para que se modifique solo una vez. ',
      part5: 'Con el fin de garantizar la independencia de los fondos entre sus diversas cuentas y facilitar su control razonable de riesgos, las cuentas de los principales módulos comerciales se dividen por la presente. La transferencia se refiere al proceso de conversión mutua de activos entre varias cuentas comerciales. ',
      part6: '<p>Patrimonio de la cuenta del contrato, el método de cálculo es el siguiente:</p> <p>Patrimonio de la cuenta del contrato = margen de la posición + pérdidas y ganancias flotantes de la posición + cantidad disponible en la cuenta corriente</p>',
      part7: 'Take Profit y Stop Loss son el límite de ganancias y el límite de pérdidas establecidos por usted. Cuando se alcanza la cantidad establecida de stop loss y stop profit, el sistema cerrará automáticamente la posición. Se puede utilizar para su control de riesgos al comprar contratos. La mitad de la cantidad de toma de ganancias establecida es: aumentar la cantidad x la cantidad x el múltiplo de apalancamiento y establecer el stop loss. Le recomendamos que lo configure de acuerdo con su situación real de activos para controlar razonablemente los riesgos. ',
      part8: 'Puede transferir los activos disponibles de las cuentas restantes a la cuenta del contrato mediante la transferencia de fondos, o reducir el riesgo mediante la reducción de la posición. ',
      part9: 'La cantidad en la posición abierta indica la cantidad de moneda que espera comprar. Por ejemplo: en la página de apertura del par comercial BTC/USDT, elija comprar en largo, ingrese el precio como 1000USDT e ingrese la cantidad como 10BTC, lo que significa que espera comprar 10 BTC con un precio unitario de 1000USDT. ',
      part10: '<p>El grado de riesgo es un indicador para medir el riesgo de sus activos. Cuando el grado de riesgo es igual al 100%, su posición se considera liquidada. El grado de riesgo=(margen de la posición/patrimonio de la cuenta del contrato)*100%, para evitar que los usuarios sobrepasen sus posiciones, el sistema establece la relación de ajuste del grado de riesgo. Cuando el grado de riesgo alcance el valor de riesgo establecido por el sistema, el sistema forzará la liquidación. Por ejemplo: si el índice de ajuste establecido por el sistema es del 10%, entonces cuando su grado de riesgo sea mayor o igual al 90%, todas sus posiciones serán cerradas a la fuerza por el sistema. </p> <p>Nota: si el sistema fuerza la liquidación causada por un riesgo excesivo, todas sus posiciones se cerrarán, por lo que espero que pueda controlar razonablemente su riesgo para evitar pérdidas innecesarias</p>',
      part11: '<p>Tipo de operación</p> <p>El tipo de operación se divide en dos direcciones: posición larga abierta (compra) y posición corta abierta (venta):</p> <p>Comprar en largo (llamar) significa que cree que el índice actual puede subir y espera comprar una cierta cantidad de ciertos contratos al precio que usted establece o al precio de mercado actual. </p> <p>Venta corta (bajista) significa que usted cree que el índice actual puede caer y espera vender una cierta cantidad de ciertos contratos al precio que estableció o al precio de mercado actual. </p> <p>Cómo realizar un pedido</p> <p>Pedido límite: debe especificar el precio y la cantidad del pedido</p> <p>Pedido de mercado: solo debe establecer la cantidad de la orden, el precio es el precio de mercado actual</p> <p>Posición</p> <p>Cuando se completa la orden de apertura que envía, se llama posición</p> <p>Problemas de entrega del contrato </p> < p>El contrato de plataforma es un contrato perpetuo sin tiempo de entrega establecido. Mientras no se cumplan las condiciones de liquidación del sistema o no cierre la posición manualmente, puede mantener la posición de forma permanente. </p> <p>El sistema cierra la posición</p> <p>1: El sistema cierra automáticamente la posición cuando se alcanza el valor establecido de stop loss y stop profit</p> <p>2: El riesgo es demasiado alto, el sistema fuerza el cierre de la posición< /p>',
      parte12: '<p>En la transacción del contrato, el usuario puede participar en la transacción del contrato mediante el pago de fondos como garantía financiera para la ejecución del contrato de acuerdo con el precio y la cantidad del contrato, de acuerdo con el múltiplo de apalancamiento correspondiente, y este fondo es el margen del contrato. El usuario ocupará el margen al abrir una posición, y cuanto más se ocupe el margen para abrir una posición, mayor será el riesgo de la cuenta. </p> <p>Margen = (precio de apertura * cantidad) / ratio de apalancamiento</p>',
      part13: 'La orden limitada se refiere al precio que espera confiar a la plataforma para realizar transacciones, y la orden de mercado se refiere a confiar directamente a la plataforma para realizar transacciones al precio actual. En las reglas de apertura de posiciones, las órdenes de mercado tienen prioridad sobre las órdenes limitadas. Si elige una orden de límite, abra una posición razonablemente de acuerdo con el precio de mercado de la moneda actual para evitar pérdidas causadas por precios de apertura irrazonables. ',
      part14: 'El nivel de riesgo es el indicador de riesgo en su cuenta de contrato, y el nivel de riesgo igual al 100% se considera liquidación. Le sugerimos que, cuando su riesgo supere el 50%, debe abrir posiciones con cuidado para evitar pérdidas por liquidación. Puede reducir su riesgo reponiendo los fondos disponibles de los activos del contrato o reduciendo posiciones. ',
      part15: 'La función del intercambio es permitir la circulación fluida de fondos en diferentes monedas en sus activos, y el QCC obtenido en la cuenta de futuros se puede convertir libremente en USDT para negociar. USDT en otras cuentas también se puede convertir libremente en QCC para transacciones. ',
      part16: 'En primer lugar, asegúrese de que el método de pago que complete al transferir dinero sea exactamente el mismo que se muestra en la página de detalles del pedido. Luego, confirme si su método de pago es instantáneo o diferido. Finalmente, comuníquese con su banco e institución de pago para el mantenimiento del sistema u otras razones. ',
      part17: '<p>Método 1: seleccione el pedido que desea comprar a través de la lista de compra y venta OTC para comprar o vender. </p> <p>Método 2: haga clic en el botón publicar para publicar órdenes de compra o venta de acuerdo con sus necesidades de transacciones rápidas. El sistema lo conectará rápidamente con compradores y vendedores. </p> <p>Nota: Si la orden de compra no se paga después de 15 minutos, el sistema cancelará automáticamente la orden, pague a tiempo. Si la orden se cancela más de 3 veces el mismo día, la transacción no se puede realizar nuevamente el mismo día y la autoridad comercial se restablecerá al día siguiente. </p>'
    }
  }
};

/***/ }),

/***/ "j969":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ThemeSwitch',
  methods: {
    switchTheme: function switchTheme() {
      this.$store.dispatch('switchThemeMode');
    }
  }
};

/***/ }),

/***/ "jRHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Hypd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("h/zc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff75b7ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("dyf5");
function injectStyle (ssrContext) {
  __webpack_require__("nrPR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff75b7ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff75b7ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jaVk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jbSg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("piuB");

exports.default = {
  name: 'TabItem',
  mixins: [_multiItems.childMixin],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
};

/***/ }),

/***/ "jdYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue__ = __webpack_require__("nXKg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue__ = __webpack_require__("elEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358ac9fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Notice_vue__ = __webpack_require__("cUGw");
function injectStyle (ssrContext) {
  __webpack_require__("NQ/5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-358ac9fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Notice_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358ac9fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Notice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jiRX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jnOm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '/portal';

/***/ }),

/***/ "kK/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{attrs:{"position":"right","width":"100%","popup-style":{ zIndex: 1000 }},model:{value:(_vm.currentVisibleVModel),callback:function ($$v) {_vm.currentVisibleVModel=$$v},expression:"currentVisibleVModel"}},[_c('div',{staticClass:"locales-container base-bg"},[_c('HeaderCommon',{attrs:{"page-title":_vm.$t('locales.title'),"z-index":"499"},on:{"backClick":_vm.closePop}},[_c('div',{attrs:{"slot":"right"},on:{"click":_vm.saveLocale},slot:"right"},[_vm._v(_vm._s(_vm.$t('button.save')))])]),_vm._v(" "),_c('div',{staticClass:"locales-content"},_vm._l((_vm.sysLocaleConfigList),function(localeItem){return _c('Cell',{key:localeItem.key,attrs:{"title":localeItem.localeName},on:{"click":function($event){_vm.nextLocale = localeItem.code}}},[_c('img',{staticClass:"flag-icon",attrs:{"slot":"icon","src":localeItem.icon,"alt":((localeItem.code) + "-flag")},slot:"icon"}),_vm._v(" "),(localeItem.code === _vm.nextLocale)?_c('i',{staticClass:"iconfont icon-success selected value-color",attrs:{"slot":"value"},slot:"value"}):_vm._e()])}),1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kV4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("zaRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("zprm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_4d40071a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("373V");
function injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_4d40071a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lDWx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Clinch',
  filters: {},
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['locale', 'vcListNoSettleEnabled']), (0, _vuex.mapState)({
    coinListWithPrice: function coinListWithPrice(state) {
      return state.vc.coinListWithPrice;
    }
  }), {
    clinchCoinList: function clinchCoinList() {
      var _this = this;

      if (!this.coinListWithPrice.length || !this.vcListNoSettleEnabled.length) return [];
      return this.vcListNoSettleEnabled.map(function (settleItem) {
        return _this.coinListWithPrice.find(function (coinWithPriceItem) {
          return settleItem.id === coinWithPriceItem.a;
        });
      }).filter(function (item) {
        return !!item;
      }).sort(function (pre, next) {
        return next.j - pre.j;
      });
    }
  }),
  methods: {
    clickVcItem: function clickVcItem(currency) {
      var _this2 = this;

      this.$store.dispatch('setVcId', currency.a).then(function () {
        _this2.$router.push('/trade');
      }).catch(function (err) {
        _this2.$message.error(err.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "lixA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'CButton',
  props: {
    type: {
      required: false,
      default: 'primary',
      type: String
    }
  }
};

/***/ }),

/***/ "mWYR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nLocales = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuexI18n = __webpack_require__("kmDT");

var _vuexI18n2 = _interopRequireDefault(_vuexI18n);

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _index = __webpack_require__("R3Rq");

var _index2 = _interopRequireDefault(_index);

var _lang = __webpack_require__("ecdD");

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _zhCN = __webpack_require__("JAV0");

var _zhCN2 = _interopRequireDefault(_zhCN);

var _zhTW = __webpack_require__("HwW6");

var _zhTW2 = _interopRequireDefault(_zhTW);

var _en = __webpack_require__("LVcC");

var _en2 = _interopRequireDefault(_en);

var _id = __webpack_require__("EN2Q");

var _id2 = _interopRequireDefault(_id);

var _ms = __webpack_require__("aqGt");

var _ms2 = _interopRequireDefault(_ms);

var _es = __webpack_require__("j8CV");

var _es2 = _interopRequireDefault(_es);

var _tr = __webpack_require__("Vp4h");

var _tr2 = _interopRequireDefault(_tr);

var _ja = __webpack_require__("HAiq");

var _ja2 = _interopRequireDefault(_ja);

var _kr = __webpack_require__("HMfG");

var _kr2 = _interopRequireDefault(_kr);

var _ar = __webpack_require__("LTeK");

var _ar2 = _interopRequireDefault(_ar);

var _pt = __webpack_require__("p2M4");

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuexI18n2.default.plugin, _store2.default);

_vue2.default.use(_index2.default);

/***
* 系统的语言列表
* @type {{en: {icon: string, locale: (*)}, 'zh-CN': {icon: string, locale: (*)}}}
*/
var i18nLocales = exports.i18nLocales = {
  'zh-CN': {
    localeName: '简体中文',
    key: 1,
    locale: (0, _objectAssign2.default)(_zhCN2.default),
    icon: __webpack_require__("3ECv")
  },
  en: {
    localeName: 'English',
    key: 2,
    locale: (0, _objectAssign2.default)(_en2.default),
    icon: __webpack_require__("1qIR")
  },
  'zh-TW': {
    localeName: '繁體中文',
    key: 3,
    locale: (0, _objectAssign2.default)(_zhTW2.default),
    icon: __webpack_require__("4VBY")
  },
  id: {
    localeName: 'Bahasa Indonesia',
    key: 4,
    locale: (0, _objectAssign2.default)(_id2.default),
    icon: __webpack_require__("W5Ro")
  },
  ms: {
    localeName: 'Melayu',
    key: 5,
    locale: (0, _objectAssign2.default)(_ms2.default),
    icon: __webpack_require__("Ky9I")
  },
  es: {

    localeName: 'Español',
    key: 6,
    locale: (0, _objectAssign2.default)(_es2.default),
    icon: __webpack_require__("5vzO")
  },
  tr: {

    localeName: 'Türkiye',
    key: 7,
    locale: (0, _objectAssign2.default)(_tr2.default),
    icon: __webpack_require__("GYmr")
  },
  ja: {

    localeName: '日本語',
    key: 8,
    locale: (0, _objectAssign2.default)(_ja2.default),
    icon: __webpack_require__("V+au")
  },
  kr: {

    localeName: '한국인',
    key: 9,
    locale: (0, _objectAssign2.default)(_kr2.default),
    icon: __webpack_require__("P/YF")
  },
  ar: {

    localeName: 'العربية',
    key: 10,
    locale: (0, _objectAssign2.default)(_ar2.default),
    icon: __webpack_require__("MuQJ")
  },
  pt: {

    localeName: 'Português',
    key: 11,
    locale: (0, _objectAssign2.default)(_pt2.default),
    icon: __webpack_require__("PyGi")
  }
};

var currentLocale = _store2.default.getters.currentLocale || (0, _lang.getDefaultLang)() || "kr";

for (var i in i18nLocales) {
  _vue2.default.i18n.add(i, i18nLocales[i].locale);
}

_vue2.default.i18n.set(currentLocale);

/*
const nowLocale = Vue.locale.get()
if (/zh/.test(nowLocale)) {
Vue.i18n.set('zh-CN')
} else {
Vue.i18n.set('en')
}
*/

exports.default = _vue2.default.i18n;

/***/ }),

/***/ "mgPS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue__ = __webpack_require__("lDWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue__ = __webpack_require__("I3vB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb6a82f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Clinch_vue__ = __webpack_require__("R0Cy");
function injectStyle (ssrContext) {
  __webpack_require__("aGcY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bb6a82f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Clinch_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb6a82f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Clinch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "myym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue__ = __webpack_require__("V2D1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue__ = __webpack_require__("uSnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7233fd6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_HotCoins_vue__ = __webpack_require__("P0Uk");
function injectStyle (ssrContext) {
  __webpack_require__("tZdH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7233fd6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_HotCoins_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7233fd6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_HotCoins_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "n5H/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _SlideItem = __webpack_require__("L4cg");

var _SlideItem2 = _interopRequireDefault(_SlideItem);

var _betterScroll = __webpack_require__("GQaK");

var _betterScroll2 = _interopRequireDefault(_betterScroll);

var _scroll = __webpack_require__("QMhb");

var _scroll2 = _interopRequireDefault(_scroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_CHANGE = 'change'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var EVENT_SELECT = 'click';
var EVENT_SCROLL_END = 'scroll-end';
var EVENT_SCROLL = 'scroll';

var DIRECTION_H = 'horizontal';
var DIRECTION_V = 'vertical';

var DEFAULT_OPTIONS = {
  momentum: false,
  click: true,
  observeDOM: false,
  bounce: false
};

exports.default = {
  name: 'Slide',
  mixins: [_scroll2.default],
  props: {
    data: {
      type: Array,
      default: function _default() {
        /* istanbul ignore next */
        return [];
      }
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    loop: {
      type: Boolean,
      default: true
    },
    threshold: {
      type: Number,
      default: 0.3
    },
    speed: {
      type: Number,
      default: 400
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 4000
    },
    showDots: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: DIRECTION_H
    },
    // The props allowVertical, stopPropagation could be removed in next minor version.
    allowVertical: {
      type: Boolean,
      default: undefined,
      deprecated: {
        replacedBy: 'options'
      }
    },
    stopPropagation: {
      type: Boolean,
      default: undefined,
      deprecated: {
        replacedBy: 'options'
      }
    },
    refreshResetCurrent: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      dots: 0,
      currentPageIndex: this.initialIndex || 0
    };
  },
  created: function created() {
    var _this = this;

    this._dataWatchers = [];
    var needRefreshProps = ['data', 'loop', 'autoPlay', 'options.eventPassthrough', 'threshold', 'speed', 'allowVertical'];
    needRefreshProps.forEach(function (key) {
      _this._dataWatchers.push(_this.$watch(key, function () {
        // To fix the render bug when add items since loop.
        if (key === 'data') {
          _this._destroy();
        }

        /* istanbul ignore next */
        _this.$nextTick(function () {
          _this.refresh();
        });
      }));
    });
  },

  watch: {
    initialIndex: function initialIndex(newIndex) {
      if (newIndex !== this.currentPageIndex) {
        this.slide && this.slide.goToPage(newIndex);
      }
    }
  },
  methods: {
    clickItem: function clickItem(item, index) {
      /* istanbul ignore next */
      this.$emit(EVENT_SELECT, item, index);
    },
    refresh: function refresh() {
      /* istanbul ignore if */
      if (this.slide === null) {
        return;
      }
      this._destroy();
      clearTimeout(this._timer);

      if (this.slide && this.refreshResetCurrent) {
        this.currentPageIndex = 0;
      }
      this._updateSlideDom();
      if (this.showDots) {
        this._initDots();
      }
      if (this.currentPageIndex >= this.dots.length) {
        this.currentPageIndex = this.dots.length - 1;
      }
      this._initSlide();

      if (this.autoPlay) {
        this._play();
      }
    },
    _destroy: function _destroy() {
      this.slide && this.slide.destroy();
    },
    _refresh: function _refresh() {
      this._updateSlideDom(true);
      this.slide.refresh();
    },
    _updateSlideDom: function _updateSlideDom(isResize) {
      this._setSlideStyle(isResize);
    },
    _setSlideStyle: function _setSlideStyle(isResize) {
      this.children = this.$refs.slideGroup.children;

      var target = this.direction === DIRECTION_H ? 'width' : 'height';
      var allSize = 0;
      var slideSize = this.$refs.slide['client' + (target[0].toUpperCase() + target.slice(1))];
      var len = this.children.length;
      for (var i = 0; i < len; i++) {
        var child = this.children[i];
        child.style[target] = slideSize + 'px';
        allSize += slideSize;
      }
      if (this.loop && !isResize && len > 1) {
        allSize += 2 * slideSize;
      }
      this.$refs.slideGroup.style[target] = allSize + 'px';
    },
    _initSlide: function _initSlide() {
      var _this2 = this;

      var eventPassthrough = this.direction === DIRECTION_H && this.allowVertical ? DIRECTION_V : '';

      var options = (0, _assign2.default)({}, DEFAULT_OPTIONS, {
        scrollX: this.direction === DIRECTION_H,
        scrollY: this.direction === DIRECTION_V,
        eventPassthrough: eventPassthrough,
        snap: {
          loop: this.loop,
          threshold: this.threshold,
          speed: this.speed
        },
        stopPropagation: this.stopPropagation
      }, this.options);

      this.slide = new _betterScroll2.default(this.$refs.slide, options);

      this.slide.on('scrollEnd', this._onScrollEnd);

      this.slide.goToPage(this.currentPageIndex, 0, 0);

      /* dispatch scroll position constantly */
      if (this.options.listenScroll && this.options.probeType === 3) {
        this.slide.on('scroll', this._onScroll);
      }
      var slideEl = this.$refs.slide;
      slideEl.removeEventListener('touchend', this._touchEndEvent, false);
      this._touchEndEvent = function () {
        if (_this2.autoPlay) {
          _this2._play();
        }
      };
      slideEl.addEventListener('touchend', this._touchEndEvent, false);

      this.slide.on('beforeScrollStart', function () {
        if (_this2.autoPlay) {
          clearTimeout(_this2._timer);
        }
      });
    },
    _onScrollEnd: function _onScrollEnd() {
      var _slide$getCurrentPage = this.slide.getCurrentPage(),
          pageX = _slide$getCurrentPage.pageX,
          pageY = _slide$getCurrentPage.pageY;

      var pageIndex = this.direction === DIRECTION_H ? pageX : pageY;
      if (this.currentPageIndex !== pageIndex) {
        this.currentPageIndex = pageIndex;
        this.$emit(EVENT_CHANGE, pageIndex);
      }

      this.$emit(EVENT_SCROLL_END, pageIndex);

      if (this.autoPlay) {
        this._play();
      }
    },
    _onScroll: function _onScroll(pos) {
      this.$emit(EVENT_SCROLL, pos);
    },
    _initDots: function _initDots() {
      this.dots = new Array(this.children.length);
    },
    _play: function _play() {
      var _this3 = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        _this3.slide.next();
      }, this.interval);
    },
    _deactivated: function _deactivated() {
      clearTimeout(this._timer);
      clearTimeout(this._resizeTimer);
      window.removeEventListener('resize', this._resizeHandler);
      var slideEl = this.$refs.slide;
      if (slideEl) {
        slideEl.removeEventListener('touchend', this._touchEndEvent, false);
      }
    },
    _resizeHandler: function _resizeHandler() {
      var _this4 = this;

      /* istanbul ignore if */
      if (!this.slide) {
        return;
      }
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(function () {
        /* istanbul ignore if */
        if (_this4.slide.isInTransition) {
          _this4._onScrollEnd();
        } else {
          if (_this4.autoPlay) {
            _this4._play();
          }
        }
        _this4._refresh();
      }, 60);
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$nextTick(function () {
      _this5.refresh();
    });

    window.addEventListener('resize', this._resizeHandler);
  },
  activated: function activated() {
    /* istanbul ignore next */
    if (this.autoPlay) {
      this._play();
    }
    window.addEventListener('resize', this._resizeHandler);
  },
  deactivated: function deactivated() {
    /* istanbul ignore next */
    this._deactivated();
  },
  destroyed: function destroyed() {
    this._deactivated();
    this._destroy();
    this.slide = null;

    this._dataWatchers.forEach(function (cancalWatcher) {
      cancalWatcher();
    });
    this._dataWatchers = null;
  },

  components: {
    SlideItem: _SlideItem2.default
  }
};

/***/ }),

/***/ "nXKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiper = __webpack_require__("fBcm");

var _swiper2 = _interopRequireDefault(_swiper);

var _swiperItem = __webpack_require__("b+jt");

var _swiperItem2 = _interopRequireDefault(_swiperItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Notice',
  props: ['items'],
  components: { Swiper: _swiper2.default, SwiperItem: _swiperItem2.default },
  data: function data() {
    return {};
  },

  methods: {
    clickNoticeItem: function clickNoticeItem(noticeIndex) {
      this.$emit('clickNoticeItem', noticeIndex);
    }
  }
};

/***/ }),

/***/ "nrPR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oAV5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rsaPrivateDecryptApiData = exports.formatPlaceholderByNoName = exports.forEachValue = exports.isString = exports.setMaxScale = exports.isNumber = exports.randomTimerUpdateCache = exports.emptyFn = exports.patchZeroFront = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getOwnPropertySymbols = __webpack_require__("8hRR");

var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);

var _getOwnPropertyNames = __webpack_require__("aFK5");

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

exports.isEmptyObject = isEmptyObject;
exports.getMaxNumberInObj = getMaxNumberInObj;
exports.deepClone = deepClone;
exports.formatNumberToPercent = formatNumberToPercent;
exports.saveImage = saveImage;
exports.runPromiseActions = runPromiseActions;

var _jsencrypt = __webpack_require__("NMjF");

var _jsencrypt2 = _interopRequireDefault(_jsencrypt);

var _settings = __webpack_require__("TxuI");

var _numberPrecision = __webpack_require__("qy1k");

var _numberPrecision2 = _interopRequireDefault(_numberPrecision);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 当字符数量不及时，给字符前面补0
 * @param value 字符串
 * @param count 期望有多少个字符
 */
var patchZeroFront = exports.patchZeroFront = function patchZeroFront(value, count) {
  var strValue = value + '';
  var lessCount = count - strValue.length;
  if (lessCount <= 0) {
    return value;
  }

  var patchValue = strValue;
  for (var i = 0; i < lessCount; i++) {
    patchValue = '0' + patchValue;
  }
  return patchValue;
};

/**
 * 定义一个空的function
 * @returns {Function}
 */
var emptyFn = exports.emptyFn = function emptyFn() {
  return function () {};
};

/***
 * 刷新缓存时间间隔
 * @returns {number}
 */
var randomTimerUpdateCache = exports.randomTimerUpdateCache = function randomTimerUpdateCache() {
  // return 3000
  return Math.round(Math.random() * 15 + 15) * 1000;
};
/**
 * 查看是否为空对象
 * {  }
 */
function isEmptyObject(obj) {
  return !(0, _getOwnPropertyNames2.default)(obj).length && !(0, _getOwnPropertySymbols2.default)(obj).length;
}

/**
 * 判断是否是数值
 * @param value 数值
 * @returns {boolean}
 */
var isNumber = exports.isNumber = function isNumber(value) {
  return !isNaN(value);
};

/**
 * 将数值格式化成最大不超过多少位小数的数值，非四舍五入，而是用substring来做的
 * 如setMaxScale(1.289, 2)结果是1.28，而不是1.29
 * @param value 要转换的数值
 * @param maxScale 最大保留几位小数
 * @param isAutoComplete 是否自动补齐2, 2 -> 2.00
 * @returns {*}
 */
var setMaxScale = exports.setMaxScale = function setMaxScale(value, maxScale) {
  var isAutoComplete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!maxScale) {
    maxScale = 4;
  }
  var valStr = value.toString();
  if (value === 0) {
    if (isAutoComplete) {
      var scaleCount = maxScale;
      valStr += '.';
      while (scaleCount--) {
        valStr += '0';
      }
      return valStr;
    }
    return 0;
  }
  var nums = valStr.split('.');
  if (nums.length === 1) {
    if (isAutoComplete) {
      var _scaleCount = maxScale;
      valStr += '.';
      while (_scaleCount--) {
        valStr += '0';
      }
      return valStr;
    }
    return value;
  }
  if (nums.length > 1) {
    if (nums[1].length > maxScale) {
      var end = nums[0].length + 1 + maxScale;
      return isAutoComplete ? valStr.substring(0, end) : parseFloat(valStr.substring(0, end));
    }
    if (isAutoComplete) {
      var _scaleCount2 = maxScale - nums[1].length;
      while (_scaleCount2--) {
        valStr += '0';
      }
      return valStr;
    }
    return value;
  }
  return isAutoComplete ? valStr : value;
};

/***
 * 取对象中数值最大的value值
 * @param obj
 * @returns {number|*}
 */
function getMaxNumberInObj(obj) {
  if (!obj) return 0;
  if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') return obj;
  return Math.max.apply(Math, (0, _toConsumableArray3.default)((0, _keys2.default)(obj).map(function (objKey) {
    return obj[objKey];
  })));
}

/***
 * 复制参数对象并返回一个新的对象
 * @param source
 * @returns {*[]}
 */
function deepClone(source) {
  if (!source && (typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  (0, _keys2.default)(source).forEach(function (keys) {
    if (source[keys] && (0, _typeof3.default)(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/***
 * 判定是否为字符串
 * @param value
 * @returns {boolean}
 */
var isString = exports.isString = function isString(value) {
  return typeof value === 'string';
};

/**
 * forEach for object
 */
var forEachValue = exports.forEachValue = function forEachValue(obj, fn) {
  (0, _keys2.default)(obj).forEach(function (key) {
    return fn(key, obj[key]);
  });
};

/***
 * 格式化模板字符
 * @param template
 * @param argArr
 * @returns {*}
 */
var formatPlaceholderByNoName = exports.formatPlaceholderByNoName = function formatPlaceholderByNoName(template) {
  for (var _len = arguments.length, argArr = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    argArr[_key - 1] = arguments[_key];
  }

  if (!argArr) {
    return template;
  }
  var argIndex = 0;
  return template.replace(/\{\}/g, function (temp, tempIndex) {
    if (argArr[argIndex]) {
      return argArr[argIndex++];
    }
    argIndex++;
    return '';
  });
};

/**
 * 解密服务器传过来的RSA公钥加密的数据
 * @param str
 * @return {PromiseLike<ArrayBuffer>}
 */
var rsaPrivateDecryptApiData = exports.rsaPrivateDecryptApiData = function rsaPrivateDecryptApiData(str) {
  var jse = new _jsencrypt2.default();
  jse.setPrivateKey(_settings.serverRSAPrivateKey);
  return jse.decrypt(str);
};

/***
 * 将小数转换成带百分比模式
 * @param number
 */
function formatNumberToPercent(number) {
  if (!number || !+number) return '';
  return _numberPrecision2.default.times(number, 100) + '%';
}

/** *
 * 保存图片(Base64)到本地
 */
function saveImage(base64Img) {
  var image = new Image();
  // 解决跨域 canvas污染问题
  image.setAttribute('crossOrigin', 'anonymous');
  image.onload = function () {
    var canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext('2d');
    context.drawImage(image, 0, 0, image.width, image.height);
    var url = canvas.toDataURL('image/png'); // 图片转为base64格式
    var a = document.createElement('a');
    var e = new MouseEvent('click');
    a.download = 'download-image';
    a.href = url;
    a.dispatchEvent(e);
  };
  // imgUrl即为要下载图片的路径
  image.src = base64Img;
}

/***
 * 同步执行队列事件
 * @param actions
 * @returns {Promise<unknown>}
 */
function runPromiseActions(actions) {
  return new _promise2.default(function (resolve, reject) {
    if (actions.length) {
      var sliceActions = actions.slice();
      sliceActions.shift()().then(function () {
        return runPromiseActions(sliceActions).then(resolve).catch(reject);
      }).catch(function () {
        return new _promise2.default(function () {});
      });
    } else {
      resolve();
    }
  });
}

/***/ }),

/***/ "oOSo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oUHF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Increase',
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['vcListNoSettleEnabled']), (0, _vuex.mapState)({
    coinListWithPrice: function coinListWithPrice(state) {
      return state.vc.coinListWithPrice;
    }
  }), {
    increaseCoinList: function increaseCoinList() {
      var _this = this;

      if (!this.coinListWithPrice.length) return [];
      return this.vcListNoSettleEnabled.map(function (settleItem) {
        return _this.coinListWithPrice.find(function (coinWithPriceItem) {
          return settleItem.id === coinWithPriceItem.a;
        });
      }).filter(function (item) {
        return !!item;
      }).sort(function (pre, next) {
        return next.k - pre.k;
      });
    }
  }),
  methods: {
    clickVcItem: function clickVcItem(currency) {
      var _this2 = this;

      this.$store.dispatch('setVcId', currency.a).then(function () {
        _this2.$router.push('/trade');
      }).catch(function (err) {
        _this2.$message.error(err.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0pea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("vAbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_1ed96448_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ctzu");
function injectStyle (ssrContext) {
  __webpack_require__("tt0L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_1ed96448_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "p2M4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  login: {
    title: 'Entrar',
    usernameLabel: 'Nome de usuário',
    usernamePlaceholder: '2-10 dígitos em inglês',
    loginPasswordLabel: 'Senha de login',
    loginPasswordPlaceholder: 'Por favor, insira sua senha de login',
    googleCodeLabel: 'Código de verificação do Google',
    googleCodePlaceholder: 'Por favor, insira um código de verificação do Google de 6 dígitos',
    hasNoAccount: 'Ainda não tem conta,',
    goRegister: 'Ir para registrar',
    onlineCustom: 'Atendimento online',
    loginArgument: 'Continuar a entrar significa concordar com',
    userArgument: '《Acordo de Usuário》',
    registerNotEnabled: 'A função de registro não está aberta, entre em contato com o administrador',
    usernameRequired: 'Por favor, insira um nome de usuário correto',
    loginPasswordRequired: 'Por favor, insira a senha de login correta',
    googleCodeRequired: 'Por favor, insira o código de verificação do Google correto',
    loginButton: 'Entrar'
  },
  register: {
    title: 'Registrar',
    usernameLabel: 'Nome de usuário',
    usernamePlaceholder: 'Por favor, insira o nome de usuário registrado',
    loginPasswordLabel: 'Senha de login',
    loginPasswordPlaceholder: 'Por favor, insira a senha de login do usuário registrado',
    loginPasswordPreLabel: 'Confirmar senha de login',
    loginPasswordPrePlaceholder: 'Por favor, insira a senha de login novamente',
    fudPasswordLabel: 'Senha de fundos',
    fudPasswordPlaceholder: 'Por favor, insira a senha de fundos',
    inviteCodeLabel: 'Código de convite',
    inviteCodePlaceholder: 'Por favor, insira um código de convite de 6 dígitos',
    registerNeed: 'Continuar a registrar significa concordar com',
    registerArgument: '《Acordo de Registro》',
    usernameRequired: 'Por favor, insira um nome de usuário correto',
    loginPasswordRequired: 'Por favor, insira a senha de login correta',
    loginPasswordPreRequired: 'Por favor, insira a confirmação correta da senha de login',
    fundPasswordRequired: 'Por favor, insira a senha de fundos correta',
    inviteCodeRequired: 'Por favor, insira o código de convite correto',
    diffLoginPasswordError: 'As duas senhas de login não coincidem',
    registerSuccess: 'Registro bem-sucedido',
    registerButton: 'Registrar',
    emailLabel: 'E-mail',
    emailPlaceholder: 'Por favor, insira seu endereço de e-mail',
    emailCodeLabel: 'Código de verificação',
    emailCodePlaceholder: 'Por favor, insira o código de verificação enviado por e-mail',
    second: 'segundo',
    getEmailCodeButton: 'Obter código',
    emailRequired: 'Por favor, insira um endereço de e-mail correto e tente novamente',
    emailCodeRequired: 'Por favor, insira o código de verificação correto enviado por e-mail e tente novamente'
  },
  home: {
    hotCoin: {
      title: 'Ofertas Populares',
      more: 'Mais'
    },
    poster: {
      title: 'Depósito rápido',
      enter: 'Entrar agora >',
      subTitle: 'Suporte para BTC, USDT, ETH, etc.'
    },
    quickMenus: {
      futuresTrading: 'Negociação de Futuros',
      helpCenter: 'Central de Ajuda'
    },
    ranking: {
      increase: {
        title: 'Lista de Altas'
      },
      clinch: {
        title: 'Lista de Volume'
      }
    }
  },
  tabBar: {
    home: 'Início',
    price: 'Mercado',
    trade: 'Negociar',
    fund: 'Ativo',
    user: 'Perfil'
  },
  currency: {
    favorite: 'Favorito',
    allCurrency: 'Spot',
    dayVol: '24H',
    addFavor: '+ Adicionar Favorito'
  },
  trade: {
    bills: 'Faturas',
    todayOpen: 'Abrir',
    star: 'Favorito',
    vol: 'Volume',
    low: 'Mais Baixo',
    high: 'Mais Alto',
    timing: 'Tempo',
    spot: 'Futuros',
    buyMore: 'Comprar Mais',
    buyEmpty: 'Vender',
    indicator: 'Indicador',
    indicatorSettings: 'Configurações do Indicador',
    balance: 'Meu saldo',
    fee: 'Taxa de Serviço',
    ruleIdError: 'Por favor, selecione um prazo de expiração',
    deleteFavoriteSuccess: 'Favorito removido com sucesso',
    addFavoriteSuccess: 'Favorito adicionado com sucesso',
    buyIn: 'Comprar',
    sellOut: 'Vender',
    holding: 'Mantendo',
    history: 'Histórico',
    spotOrderConfirm: {
      title: 'Confirmar Compra',
      amountPlaceholder: 'Por favor, insira a quantidade para comprar'
    },
    spotTradeOrder: {
      holding: {
        coin: 'moeda',
        buyInAmountPrice: 'Quantidade/Preço de Compra',
        buyInCount: 'Quantidade',
        actions: 'Ação',
        sellOut: 'Vender',
        profit: 'Lucro'
      }
    },
    orderConfirm: {
      title: 'Confirmar Pedido',
      coinName: 'Moeda',
      direction: 'Direção',
      price: 'Preço',
      balance: 'Saldo',
      fee: 'Taxa de Serviço',
      buyMoreLabel: 'Comprar Mais',
      buyEmptyLabel: 'Vender',
      buyQuantity: 'Quantidade de Compra',
      buyAmount: 'Valor da Compra',
      submit: 'Confirmar Pedido'
    },
    kline: {
      open: 'Abrir:',
      close: 'Fechar:',
      change: 'Alteração:'
    }
  },
  finance: {
    title: 'Finanças'
  },
  allFinance: {
    title: 'Gestão Financeira',
    all: 'Tudo'
  },
  financeOrders: {
    title: 'Pedido de Penhor',
    holdingLabel: 'Mantendo',
    historyLabel: 'Histórico',
    holding: {
      amount: 'Quantia empenhada',
      rateStr: 'Valor do rendimento/rendimento',
      vcCount: 'Número de moedas empenhadas',
      cycle: 'Ciclo da posição',
      day: 'Dia',
      calcStartDate: 'Data de início do valor',
      serviceAmount: 'Taxa de Serviço',
      redeemOrder: 'Resgatar'
    },
    history: {
      incomeAmount: 'Valor do rendimento',
      rateStr: 'Rendimento',
      amount: 'Quantia empenhada',
      vcCount: 'Número de moedas empenhadas',
      calcStartDate: 'Data de início do valor',
      calcEndDate: 'Data de término',
      cycle: 'Dias do ciclo',
      serviceAmount: 'Taxa de Serviço',
      day: 'dia'
    }
  },
  financeOrderBills: {
    title: 'Fatura de Rendimento do Penhor',
    amount: 'Quantia',
    balance: 'Saldo'
  },
  financeItem: {
    rateStr: 'Rendimento',
    buyType: 'Tipo de Compra',
    cycle: 'Dias do ciclo',
    exchangeRate: 'Taxa de câmbio (troca de moeda virtual por saldo)',
    day: 'dia',
    cycleType: 'Tipo de ciclo',
    serviceRateStr: 'Taxa de Serviço'
  },
  buyFinance: {
    title: 'Comprar',
    rateStr: 'Rendimento',
    name: 'Nome',
    buyType: 'Tipo de Compra',
    cycle: 'Dias do ciclo',
    cycleType: 'Tipo de ciclo',
    exchangeRate: 'Taxa de câmbio (troca de moeda virtual por saldo)',
    serviceRateStr: 'Taxa de Serviço',
    remark: 'Observação',
    buyAmountLabel: 'Quantia de Compra ({coin})',
    descriptionTitle: 'Descrição do Produto',
    descriptionPart1: '1. Este produto é um produto de gestão de riqueza sem garantia de capital. Flutuações de mercado podem levar a perdas de capital. Invista com cuidado.',
    descriptionPart2: '2. Regras de liquidação de pagamento:',
    descriptionPart3: 'Se o preço de liquidação < preço vinculado, o BTC será liquidado após o vencimento; quantia de liquidação = quantia investida * (1+ dias * taxa de retorno anualizada / 365).',
    descriptionPart4: 'Se o preço de liquidação ≥ preço vinculado, o USDT será liquidado após o vencimento; quantia de liquidação = quantia investida * preço vinculado * (1+ dias * taxa de retorno anualizada / 365).',
    descriptionPart5: '3. A taxa de retorno anualizada real muda em tempo real com o mercado, consulte a transação de compra real.',
    descriptionPart6: '4. A quantia investida é convertida de acordo com o mercado em tempo real, consulte a transação de compra real.',
    descriptionPart7: '5. Após a compra do produto, ele pode ser visualizado na página de detenção de moeda e o reembolso será automaticamente emitido para a conta spot após a data de vencimento.',
    buyButton: 'Comprar [{coin}]'
  },
  fund: {
    description: 'Ativos',
    recharge: 'Recarregar',
    withdraw: 'Retirar',
    exchange: 'Transferir',
    empty: 'Carteira vazia, vá'
  },
  userCenter: {
    lastLogin: 'Último login',
    myTeam: 'Minha Equipe',
    identity: 'Autenticação',
    walletAddress: 'Endereço da Carteira',
    zskAccount: 'Conta ZSK',
    bankCard: 'Conta Bancária',
    userBills: 'Faturas do Usuário',
    timingTradeOrder: 'Pedido de Negociação Temporizada',
    spotTradeOrder: 'Pedido de Negociação Futura',
    contactTradeOrder: 'Posição do Contrato',
    userReport: 'Relatório do Usuário',
    teamReport: 'Relatório da Equipe',
    share: 'Compartilhar',
    customer: 'Atendimento ao Cliente',
    helpCenter: 'Central de Ajuda',
    platform: 'Introdução à Plataforma',
    profit: 'Lucro',
    balance: 'Saldo',
    withdraw: 'Retirar',
    recharge: 'Recarregar',
    creditStoreLabel: 'Loja de Crédito'
  },
  settings: {
    title: 'Configurações',
    fundPassword: 'Senha de Fundos',
    googleValidator: 'Validador do Google',
    editLoginPassword: 'Alterar Senha de Login',
    switchLocale: 'Alterar Idioma'
  },
  editFundPassword: {
    title: 'Alterar Senha de Fundos',
    currentPasswordLabel: 'Senha Atual',
    currentPasswordPlaceholder: 'Por favor, insira a senha de fundos atual',
    newPasswordLabel: 'Nova Senha',
    newPasswordPlaceholder: 'Por favor, insira a nova senha de fundos',
    prePasswordLabel: 'Confirmar Senha',
    prePasswordPlaceholder: 'Digite novamente a nova senha de fundos',
    tips: 'A senha de fundos é uma credencial importante para transações. Por favor, configure-a cuidadosamente e memorize-a.',
    currentPasswordRequired: 'Por favor, insira a senha de fundos atual',
    newPasswordRequired: 'Por favor, insira a senha de fundos a ser alterada',
    prePasswordRequired: 'Por favor, insira novamente a senha de fundos a ser alterada',
    prePasswordDiff: 'As duas entradas de senha não coincidem'
  },
  bindFundPassword: {
    title: 'Vincular Senha de Fundos',
    fundPasswordLabel: 'Senha de Fundos',
    fundPasswordPlaceholder: 'Por favor, insira a senha de fundos',
    fundPasswordPreLabel: 'Confirmar Senha',
    fundPasswordPrePlaceholder: 'Por favor, insira novamente a senha de fundos',
    fundPasswordRequired: 'A senha de fundos é obrigatória',
    fundPasswordPreRequired: 'Confirmar senha é obrigatório',
    fundPasswordDiff: 'As duas entradas de senha não coincidem',
    bindSuccess: 'Vinculação Bem-Sucedida',
    tips: 'A senha de fundos é uma credencial importante para transações. Por favor, configure-a cuidadosamente e memorize-a.'
  },
  editLoginPassword: {
    title: 'Alterar Senha de Login',
    currentPasswordLabel: 'Senha Atual',
    currentPasswordPlaceholder: 'Por favor, insira a senha de login atual',
    newPasswordLabel: 'Nova Senha',
    newPasswordPlaceholder: 'Por favor, insira a nova senha de login',
    prePasswordLabel: 'Confirmar Senha',
    prePasswordPlaceholder: 'Digite novamente a nova senha de login',
    tips: 'A senha de login é uma credencial importante para autenticação. Configure-a com cuidado e memorize-a.',
    currentPasswordRequired: 'Por favor, insira a senha de login atual',
    newPasswordRequired: 'Por favor, insira a senha de login a ser alterada',
    prePasswordRequired: 'Por favor, insira novamente a senha de login a ser alterada',
    prePasswordDiff: 'As duas entradas de senha não coincidem'
  },
  bindGoogleValidator: {
    title: 'Vincular Autenticador do Google',
    qrCodeLabel: 'QR Code',
    keyLabel: 'Chave',
    loginPasswordLabel: 'Senha de Login',
    loginPasswordPlaceholder: 'Por favor, insira sua senha de login',
    googleCodeLabel: 'Código de Verificação do Google',
    googleCodePlaceholder: 'Por favor, insira um código de 6 dígitos do Google',
    tipsPart1: 'Pesquise por Google Authenticator na loja de aplicativos',
    tipsPart2: 'Use o Google Authenticator para escanear o QR Code acima ou insira manualmente a chave para vinculação',
    tipsPart3: 'Insira o código de verificação de 6 dígitos do Google acima e clique em Confirmar para enviar',
    loginPasswordRequired: 'Por favor, insira a senha de login',
    googleCodeRequired: 'Por favor, insira um código de verificação de 6 dígitos do Google'
  },
  walletAddress: {
    title: 'Endereço da Carteira',
    add: '+ Adicionar Endereço',
    remark: 'Observação',
    addButton: 'Adicionar endereço da carteira',
    tips: 'Se você deseja modificar ou excluir informações de endereço, entre em contato com o atendimento ao cliente'
  },
  addWalletAddress: {
    title: 'Adicionar endereço da carteira',
    vcChainNameIdLabel: 'Tipo de cadeia',
    vcAccountLabel: 'Endereço da carteira',
    vcAccountPlaceholder: 'Por favor, insira o endereço da carteira',
    remarkLabel: 'Observações',
    remarkPlaceholder: 'Por favor, insira o conteúdo da observação',
    fundPasswordLabel: 'Senha de fundos',
    fundPasswordPlaceholder: 'Por favor, insira sua senha de fundos',
    tips: 'O endereço da carteira adicionado não pode ser modificado, por favor, verifique se as informações estão corretas',
    vcIdRequired: 'Por favor, selecione a moeda correta',
    vcChainNameIdRequired: 'Por favor, selecione o tipo de cadeia correto',
    vcAccountRequired: 'Por favor, insira o endereço da carteira correto',
    fundPwdRequired: 'Por favor, insira a senha de fundos correta',
    addSuccess: 'Endereço da carteira adicionado com sucesso'
  },
  receiveWays: {
    title: 'Meu cartão bancário',
    add: '+ Adicionar cartão bancário',
    tips: 'Se você deseja modificar ou excluir as informações do cartão bancário, entre em contato com o atendimento ao cliente',
    addCardButton: 'Adicionar cartão bancário'
  },
  zskAccount: {
    title: 'Conta rápida',
    add: '+ Adicionar conta rápida',
    tips: 'Para modificar ou excluir informações da conta, entre em contato com o atendimento ao cliente',
    addCardButton: 'Adicionar conta'
  },
  addZskAccount: {
    title: 'Adicionar uma conta rápida',
    withdrawNameLabel: 'Nome',
    withdrawNamePlaceholder: 'Por favor, insira o nome',
    withdrawNameRequired: 'O nome é obrigatório',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Por favor, insira a velocidade rápida',
    fundPasswordLabel: 'Senha de fundos',
    fundPasswordPlaceholder: 'Por favor, insira sua senha de fundos',
    tips: 'Por favor, preencha cuidadosamente as informações da conta adicionada. A empresa não se responsabiliza por problemas devido a informações incorretas'
  },
  addBankCard: {
    title: 'Adicionar um novo cartão bancário',
    withdrawNameLabel: 'Nome',
    withdrawNamePlaceholder: 'Por favor, insira o nome',
    withdrawNameRequired: 'O nome é obrigatório',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Por favor, insira o ZSK',
    zskRequired: 'ZSK é obrigatório',
    cardNumLabel: 'Número da conta bancária',
    cardNumPlaceholder: 'Por favor, insira o número do cartão bancário',
    branchLabel: 'Endereço da agência',
    branchPlaceholder: 'Por favor, insira o endereço da agência bancária',
    fundPasswordLabel: 'Senha de fundos',
    fundPasswordPlaceholder: 'Por favor, insira a senha de fundos',
    tips: 'O cartão bancário é um dado importante para retirada de dinheiro, preencha com cuidado. A empresa não se responsabiliza por problemas devido a informações incorretas.',
    backIdRequired: 'Por favor, selecione o banco da conta',
    cardNumRequired: 'Por favor, insira o número correto do cartão bancário',
    fundPwdRequired: 'Por favor, insira a senha de fundos correta',
    idCardPlaceholder: 'Por favor, insira seu número de identificação',
    idCardLabel: 'Número de identidade',
    idCardRequired: 'Por favor, insira o número de identificação correto',
    cciPlaceholder: 'Por favor, insira o CCI',
    branchCodePlaceholder: 'Por favor, insira o código da agência',
    branchCodeLabel: 'Código da agência',
    katakanaPlaceholder: 'Por favor, insira o katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Registro de Alteração de Conta',
    vcName: 'Moeda',
    amount: 'Quantidade',
    balance: 'Saldo'
  },
  timingTradeOrder: {
    title: 'Pedido de negociação temporizada',
    waiting: {
      title: 'Pedidos em andamento',
      amount: 'Quantidade',
      period: 'Período',
      receivePrice: 'Preço de compra',
      settlement: 'Liquidação em andamento'
    },
    history: {
      title: 'Pedidos históricos',
      buyInClose: 'Preço de compra',
      saleOutClose: 'Preço de venda'
    }
  },
  spotTradeOrder: {
    title: 'Pedidos de negociação à vista',
    waiting: {
      title: 'Pedidos pendentes',
      buyInAmount: 'Preço total de compra',
      buyInPrice: 'Preço unitário de compra',
      buyInCount: 'Quantidade comprada',
      buyInTime: 'Hora da compra'
    },
    history: {
      title: 'Pedidos históricos',
      buyInAmount: 'Preço total de compra',
      buyInPrice: 'Preço unitário de compra',
      buyInCount: 'Quantidade comprada',
      sellOutAmount: 'Preço total de venda',
      sellOutPrice: 'Preço unitário de venda',
      sellOutTime: 'Hora da venda'
    }
  },
  userReport: {
    title: 'Relatório do Usuário',
    profit: 'Lucro',
    timingTradeAmountFee: 'Pedido de negociação rápida/Taxa de manuseio',
    timingTradePrizePoint: 'Bônus de negociação rápida/Rebate',
    rechargeInfo: 'Recarga/Taxa de manuseio',
    withdrawInfo: 'Retirada/Taxa de manuseio',
    exchangeInfo: 'Troca/Taxa de manuseio'
  },
  userReportDay: {
    title: 'Relatório diário do usuário',
    profit: 'Lucro',
    timingTradeAmountFee: 'Pedido de negociação rápida/Taxa de manuseio',
    timingTradePrizePoint: 'Bônus de negociação rápida/Rebate',
    rechargeInfo: 'Recarga/Taxa de manuseio',
    withdrawInfo: 'Retirada/Taxa de manuseio',
    exchangeInfo: 'Troca/Taxa de manuseio'
  },
  teamReport: {
    goToReportDay: 'Relatório diário',
    timingTradeBetAmountServiceCharge: 'Quantidade/Serviços de negociação rápida',
    timingTradeBetPrizePoint: 'Prêmio/Pontos de negociação rápida',
    timingTradeUserAndCount: 'Usuários/Contagens de negociação rápida',
    rechargeAmountFee: 'Quantidade/Serviços de recarga',
    rechargePersonCount: 'Usuários/Contagens de recarga',
    withdrawAmountFee: 'Quantidade/Serviços de retirada',
    withdrawPersonCount: 'Usuários/Contagens de retirada',
    firstRechargeUserAndCount: 'Primeira recarga/Contagens',
    title: 'Relatório da equipe',
    usernamePlaceholder: 'Digite o nome de usuário do nível inferior',
    previewAllTradeInfo: 'Visualizar todas as informações de negociação rápida',
    coin: 'Moeda',
    timingTradeBetAmount: 'Quantidade de apostas em negociação rápida',
    profit: 'Lucro',
    action: 'Operação',
    previewReportDay: 'Visualizar relatório diário'
  },
  teamTimingTradeInfo: {
    title: 'Negociação rápida da equipe',
    profit: 'Lucro',
    subTitle: 'Informações de negociação rápida da equipe',
    timingTradeAmountFee: 'Pedido de negociação rápida/Taxa de serviço',
    timingTradePrizePoint: 'Bônus de negociação rápida/Rebate',
    rechargeInfo: 'Recarga/Taxa de serviço',
    withdrawInfo: 'Retirada/Taxa de serviço',
    exchangeInfo: 'Troca/Taxa de serviço'
  },
  teamReportDay: {
    title: 'Relatório diário da equipe',
    subTitle: 'Relatório diário da equipe [ {username} ]',
    timingTradeBetAmountFee: 'Pedido de negociação rápida/Taxa de serviço',
    timingTradeUserAndCount: 'Usuários/Contagens de negociação rápida',
    timingTradeBetPrizePoint: 'Bônus/Rebate de negociação rápida',
    rechargeAmountFee: 'Quantidade de recarga/Taxa de serviço',
    rechargePersonCount: 'Usuários de recarga/Transações',
    firstRechargePersonCount: 'Primeira recarga/Contagens',
    withdrawAmountFee: 'Quantidade de retirada/Taxa de serviço',
    withdrawPersonCount: 'Usuários de retirada/Transações',
    exchangeAmountFee: 'Quantidade de troca/Taxa de serviço'
  },
  share: {
    title: 'Compartilhar',
    qrCodeLabel: 'Código QR',
    registerUrlLabel: 'Endereço de registro',
    inviteCodeLabel: 'Código de convite',
    hasNoInviteCode: 'A conta atual não possui código de convite,',
    generateInvitationCode: 'Tente gerar com um clique',
    tipsPart1: 'Escaneie o código QR acima para preencher as informações de registro e registrar-se',
    tipsPart2: 'Copie o endereço de registro e preencha as informações para registrar-se',
    tipsPart3: 'Abra manualmente a interface de registro deste site e preencha o código de convite para registrar-se',
    saveImageError: 'Falha ao salvar a imagem, tente pressionar longamente a imagem e salvar'
  },
  myTeam: {
    title: 'Minha equipe',
    usernamePlaceholder: 'Digite o nome de usuário do nível inferior',
    point: 'Rebate (rápido/contrato)',
    totalBalance: 'Saldo',
    lastLoginTime: 'Último horário de login',
    noLoginTime: 'Nenhum'
  },
  userDetail: {
    title: 'Detalhes do Usuário',
    username: 'Nome de Usuário',
    userType: 'Tipo de Usuário',
    pointPercentTiming: 'Rebate de Transação Rápida',
    pointPercentContract: 'Rebate de Transação de Contrato',
    registerWay: 'Método de Registro',
    teamCounts: 'Número da Equipe',
    teamOnline: 'Equipe Online',
    balance: 'Saldo',
    registerTime: 'Data de Registro',
    onlineStatus: 'Status de Login'
  },
  addUser: {
    title: 'Adicionar Usuário',
    addUserDirect: {
      userTypeLabel: 'Tipo de Usuário',
      usernameLabel: 'Nome de Usuário',
      usernamePlaceholder: 'Por favor, insira o nome de usuário da conta',
      pointTimingLabel: 'Rebate de Transação Rápida',
      pointContractLabel: 'Rebate de Transação de Contrato',
      tips: 'A senha inicial é: "{password}"; por favor, lembre o usuário de alterar a senha após ativar a conta.',
      userTypeRequired: 'Por favor, selecione o tipo de conta',
      usernameRequired: 'Por favor, insira o nome de usuário da conta',
      pointTimingRequired: 'Por favor, selecione o rebate de transação rápida',
      pointContractRequired: 'Por favor, selecione o rebate de transação de contrato',
      copyTemplate: 'Nome de usuário: {username};\nSenha de login: {loginPassword};\nURL de Login: {loginAddress};\nRebate de transação rápida: {timingTradePoint};\nRebate de transação de contrato: {contactTradePoint};'
    }
  },
  recharge: {
    title: 'Recarga',
    configIdLabel: 'Canal de Recarga',
    chainNameLabel: 'Nome da Cadeia',
    amountLabel: 'Quantidade de Depósito',
    userCardNameLabel: 'Pagador',
    userCardNamePlaceholder: 'Por favor, insira o nome do pagador',
    fee: 'Taxa de Serviço',
    receiveAmountTipsPart1: 'Recarga',
    receiveAmountTipsPart2: ', Precisa pagar',
    tipsPart1: 'Devido à instabilidade da interface de pagamento online, apenas transferência offline é suportada atualmente.',
    tipsPart2: 'Preencha o valor real da transferência corretamente, caso contrário, pode haver falhas no processo de aprovação.',
    emptyPart1: 'Nenhum canal de recarga disponível,',
    emptyPart2: 'toque para tentar novamente',
    amountRequired: 'O valor da recarga não pode estar vazio',
    maxPrecisionError: 'O valor da recarga pode ter no máximo {amountMaxPrecision} casas decimais',
    payUserNameError: 'Por favor, insira corretamente o nome do pagador e tente novamente',
    userMobileLabel: 'Celular',
    userMobilePlaceholder: 'Por favor, insira seu número de celular',
    needPayLabel: 'Quantia a Pagar',
    needPayPlaceholder: 'Por favor, insira a quantia'
  },
  payDetail: {
    title: 'Informações de Transferência',
    addressLabel: 'Endereço de Depósito',
    rechargeAmount: 'Quantia',
    bankNameLabel: 'Banco',
    branchLabel: 'Endereço da Agência',
    cardName: 'Nome',
    cardNum: 'Número do Cartão',
    uploadImgLabel: 'Comprovante de Pagamento',
    uploadImgPlaceholder: 'Clique para enviar o comprovante de pagamento',
    uploadImgRequired: 'Por favor, envie o comprovante de pagamento',
    vcTransferTipsPart1: '1. Copie o endereço de depósito ou escaneie o código QR para depositar.',
    vcTransferTipsPart2: '2. Envie o comprovante de pagamento após concluir o depósito.',
    vcTransferTipsPart3: 'Envie uma imagem nítida e de alta resolução do comprovante para evitar atrasos na aprovação.',
    bankCardTips: 'Certifique-se de que o nome do remetente corresponda ao do titular da conta para evitar problemas de aprovação.',
    bankCardTransferSuccess: 'Transferência concluída com sucesso'
  },
  rechargeOrder: {
    title: 'Pedido de Depósito',
    payAmount: 'Valor Pago',
    receiveAmount: 'Valor Recebido'
  },
  identity: {
    title: 'Informações de Identidade',
    subTitle: 'A autenticação de identidade inclui verificação de informações e identificação.',
    name: 'Nome',
    idType: 'Tipo de Documento',
    idNum: 'Número de Identificação',
    demand: 'Requisitos',
    informationVer: 'Verificação de Informações',
    idAuthentication: 'Autenticação',
    material: 'Materiais'
  },
  verified: {
    title: 'Autenticado',
    idCardTypeLabel: 'Tipo de Documento',
    idCardFrontSideImgLabel: 'Imagem da Frente do Documento',
    idCardBackSideImgLabel: 'Imagem do Verso do Documento',
    idCardHandSideImgLabel: 'Foto com o Documento em Mãos',
    nameLabel: 'Nome no Documento',
    namePlaceholder: 'Por favor, insira o nome do documento',
    idCardNumLabel: 'Número do Documento',
    idCardNumPlaceholder: 'Por favor, insira o número do documento',
    fundPwdLabel: 'Senha de Fundos',
    fundPwdPlaceholder: 'Por favor, insira sua senha de fundos',
    tips: 'Uma vez enviada, a informação não pode ser alterada. Por favor, verifique antes de enviar.',
    idCardTypeRequired: 'Por favor, selecione o tipo de documento',
    idCardFrontSideImgRequired: 'Por favor, envie a imagem da frente do documento',
    idCardBackSideImgRequired: 'Por favor, envie a imagem do verso do documento',
    idCardHandSideImgRequired: 'Por favor, envie uma foto segurando o documento',
    nameRequired: 'Por favor, insira o nome no documento',
    idCardNumRequired: 'Por favor, insira o número do documento',
    fundPwdRequired: 'Por favor, insira sua senha de fundos',
    submitSuccess: 'Solicitação de autenticação enviada com sucesso'
  },
  help: {
    title: 'Central de Ajuda'
  },
  helpDetail: {
    title: 'Detalhes da Ajuda'
  },
  myMessage: {
    title: 'Minhas Mensagens'
  },
  messageDetail: {
    title: 'Detalhes da Mensagem'
  },
  withdraw: {
    title: 'Retirar moedas',
    tips: 'Para garantir a segurança dos fundos e a eficiência da retirada, por favor, verifique cuidadosamente se as informações preenchidas estão corretas. As taxas de serviço geradas durante o processo de retirada serão deduzidas do saldo.',
    receiveAmountTipsPart1: 'Retirar',
    receiveAmountTipsPart2: ', previsto para chegar',
    fee: 'Taxa de serviço',
    myBalance: 'Meu saldo de [{vcName}]:',
    configIdLabel: 'Canal de retirada',
    amountLabel: 'Valor da retirada',
    fundLabel: 'Senha de fundos',
    fundPlaceholder: 'Por favor, insira sua senha de fundos',
    googleCodeLabel: 'Código de verificação do Google',
    googleCodePlaceholder: 'Por favor, insira o código de verificação de 6 dígitos do Google',
    maxPrecisionError: 'O valor da retirada pode ter no máximo {amountMaxPrecision} casas decimais',
    amountRequired: 'Por favor, insira ou selecione o valor correto para a retirada',
    bankCardError: 'Por favor, selecione o cartão bancário correto',
    fundPwdError: 'Por favor, insira a senha de fundos correta',
    walletAddressError: 'Por favor, selecione o endereço da carteira correto',
    success: 'A solicitação de retirada foi enviada com sucesso. Aguarde o processamento.',
    emptyPart1: 'Não há canal de retirada disponível,',
    emptyPart2: 'toque para tentar novamente'
  },
  withdrawOrder: {
    title: 'Pedido de retirada',
    requestAmount: 'Valor solicitado',
    receiveAmount: 'Valor recebido'
  },
  locales: {
    title: 'Mudar idioma'
  },
  lines: {
    title: 'Linhas',
    switchLine: 'Trocar linha'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Moeda favorita removida com sucesso',
    addFavoriteSuccess: 'Moeda favorita adicionada com sucesso'
  },
  currencySelect: {
    currencyName: 'Moeda',
    currencyPlaceholder: 'Clique para selecionar a moeda'
  },
  walletItem: {
    available: 'disponível',
    convert: 'converter (USDT)'
  },
  banks: {
    bankIdLabel: 'Banco',
    bankIdPlaceholder: 'Clique para selecionar um banco'
  },
  banksPop: {
    title: 'Selecionar banco',
    search: 'Digite as palavras-chave do banco'
  },
  historyOrderDetail: {
    title: 'Detalhes do pedido',
    coin: 'Moeda da transação',
    amount: 'Valor do pedido',
    buyInClose: 'Preço de compra',
    sellOutClose: 'Preço de venda',
    isQuest: 'Tem alguma dúvida sobre este pedido?',
    connectCustomer: 'Entrar em contato com o atendimento ao cliente?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Clique para selecionar o rebate do usuário'
  },
  walletAddressSelect: {
    title: 'Selecionar endereço da carteira',
    label: 'Endereço da carteira',
    placeholder: 'Clique para selecionar o endereço da carteira'
  },
  myCardSelect: {
    title: 'Selecionar conta',
    label: 'Conta de recebimento',
    placeholder: 'Clique para selecionar uma conta'
  },
  amountInput: {
    amountRange: 'Mín {minAmount}, Máx {maxAmount}',
    amountMin: 'Mín {minAmount}, Sem limite superior',
    amountErrorEmpty: '{label} é obrigatório',
    amountErrorOutRange: '{label} está fora do intervalo'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Mín {minAmount}, Sem limite superior',
    placeholderHasMax: 'Mín {minAmount}, Máx {maxAmount}',
    amountErrorEmpty: 'O valor está incorreto',
    amountErrorOutRange: 'O valor está fora do intervalo'
  },
  common: {
    remark: 'Observação',
    saveImage: 'Salvar imagem',
    online: 'Online',
    offline: 'Offline',
    profit: 'Lucro',
    date: 'Data',
    period: 'Período',
    pointAmount: 'Quantidade de pontos',
    point: 'Rebate do usuário',
    direction: 'Direção',
    winLoss: 'Rendimento',
    lose: 'Perda',
    add: 'Adicionar',
    win: 'Ganho',
    edit: 'Modificar',
    notBind: 'Não vinculado',
    alreadyBind: 'Já vinculado',
    enabled: 'Habilitado',
    notEnabled: 'Não habilitado',
    queryRange: 'Intervalo de consulta',
    copy: 'Copiar',
    orderNum: 'Pedido',
    null: 'Nulo',
    noData: 'Sem dados',
    refreshSuccess: 'Atualização bem-sucedida',
    loadMoreData: 'Carregar mais dados',
    noMoreData: 'Não há mais dados',
    lookMore: 'Mais',
    more: 'Mais'
  },
  date: {
    today: 'Hoje',
    yesterday: 'Ontem',
    last7Days: 'Últimos 7 dias',
    last14Days: 'Últimos 14 dias',
    split: 'Até'
  },
  button: {
    save: 'Salvar',
    logout: 'Sair',
    confirm: 'OK',
    cancel: 'Cancelar',
    submit: 'Enviar',
    addNow: 'Adicionar agora',
    reset: 'Redefinir',
    nextStep: 'Próximo',
    goCertification: 'Ir para certificação'
  },
  confirm: {
    title: {
      logout: 'Sair',
      unBindFundPassword: 'Senha de fundos não vinculada',
      addUserDirect: 'Adicionar usuário',
      addUserInfo: 'Usuário adicionado com sucesso',
      jumpToRechargePage: 'Confirmar redirecionamento',
      unAuthentication: 'Não autenticado',
      noBindBankCard: 'Sem cartão bancário',
      noBindCoinAddress: 'Sem endereço de carteira',
      tradeConfirm: 'Confirmar transação',
      sellOutSpotOrder: 'Vender posição',
      buyFinance: 'Confirmar compra',
      redeemOrder: 'Resgatar pedido'
    },
    content: {
      logout: 'Tem certeza de que deseja sair da conta atual?',
      unBindFundPassword: 'Foi detectada uma senha de fundos não vinculada. Para garantir a segurança da conta, vincule sua senha de fundos primeiro.',
      addUserDirect: 'Um novo usuário será adicionado em breve. Verifique se as informações estão corretas e clique em OK para continuar. Nome do usuário [{username}], tipo de usuário [{userType}], senha de login [{password}], diferença do meu rebate de transação rápida [{diffPointTiming}], diferença do meu rebate de transação de contrato [{diffPointContract}].',
      addUserInfo: 'Nome de usuário [{username}]; <br /> Senha de login [{password}];<br /> URL de login [{loginAddress}];<br /> Rebate de transação extrema [{pointPercentTiming}];<br /> Rebate de transação de contrato [{pointPercentContract}];',
      jumpToRechargePage: 'Você será redirecionado para a interface de recarga terceirizada. Clique em confirmar para continuar.',
      unAuthentication: 'Detectamos que a conta não possui autenticação com nome real. Para garantir a circulação normal dos fundos, realize a autenticação primeiro.',
      noBindBankCard: 'Detectamos que a conta não possui cartão bancário vinculado. Para garantir a circulação normal dos fundos, vincule o cartão bancário primeiro.',
      noBindCoinAddress: 'Detectamos que a conta não possui endereço de moeda virtual vinculado. Para garantir a circulação normal dos fundos, adicione o endereço da moeda virtual primeiro.',
      tradeConfirm: 'O pedido será enviado. Verifique se as informações do pedido estão corretas e clique em Confirmar Pedido para enviar.',
      sellOutSpotOrder: 'A ordem de posição será vendida. Verifique se a operação está correta e clique em OK para continuar.',
      buyFinance: 'Você está prestes a comprar [{coin}], quantidade: {amount}. Verifique se a operação está correta e clique em OK para continuar.',
      redeemOrder: 'O pedido de penhor ({orderNum}) será resgatado. Verifique se a operação está correta e clique em Confirmar para continuar.'
    }
  },
  message: {
    bindSuccess: 'Vinculado com sucesso',
    successOperation: 'Operação bem-sucedida',
    logoutSuccess: 'Saída bem-sucedida',
    editSuccess: 'Modificado com sucesso',
    addSuccess: 'Adicionado com sucesso',
    copySuccess: 'Cópia bem-sucedida',
    copyFailed: 'Falha na cópia'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Domingo',
      week_day_1: 'Segunda',
      week_day_2: 'Terça',
      week_day_3: 'Quarta',
      week_day_4: 'Quinta',
      week_day_5: 'Sexta',
      week_day_6: 'Sábado'
    },
    loading: {
      loading: 'Carregando'
    }
  },
  helpItems: {
    title: {
      part1: 'Por que o valor convertido em ativos muda?',
      part2: 'Esqueceu a senha de fundos para transações OTC? Como resolver?',
      part3: 'Para onde os fundos vão após a conclusão da compra em transações OTC?',
      part4: 'Por que é necessário limitar o número de alterações de apelido?',
      part5: 'O que significa transferência e por que é necessária?',
      part6: 'Como calcular o patrimônio da conta do usuário em contratos?',
      part7: 'O que significam os valores de stop loss e take profit definidos na abertura de posição? Como configurá-los?',
      part8: 'Como reduzir o risco de contrato?',
      part9: 'O que significa a quantidade na posição aberta do contrato?',
      part10: 'Instruções sobre liquidação forçada',
      part11: 'Quais são as regras de negociação de contratos?',
      part12: 'O que é margem em negociações de contrato?',
      part13: 'O que é ordem limitada e ordem de mercado?',
      part14: 'O que representa o risco em transações de contrato?',
      part15: 'Por que é necessária a conversão de moeda?',
      part16: 'Por que a outra parte não recebeu a transferência em tempo hábil após a transação OTC?',
      part17: 'Como comprar Tether (USDT) via OTC?'
    },
    content: {
      part1: 'O valor da moeda digital atualmente mantido em Renminbi ao ser convertido em ativos mudará devido às flutuações de preço dos ativos digitais. A quantidade de seus ativos digitais não mudou.',
      part2: "Se você esquecer a senha de fundos de transação OTC, acesse 'Minha conta - Configurações - Clique para definir a senha de fundos' ou entre em contato com o atendimento ao cliente para redefini-la.",
      part3: 'Após a conclusão da ordem de compra OTC, os fundos serão transferidos para a conta de moeda fiduciária no ativo. Caso precise usar os ativos comprados via OTC para negociações de contrato ou futuros, acesse o módulo de transferência de fundos para transferir.',
      part4: 'Por razões de segurança em suas transações, atualmente limitamos a alteração do apelido a apenas uma vez.',
      part5: 'Para garantir a independência dos fundos entre suas várias contas e facilitar seu controle de risco, as contas dos principais módulos de negociação foram divididas. Transferência refere-se ao processo de conversão mútua de ativos entre diferentes contas de negociação.',
      part6: '<p>O patrimônio da conta do contrato é calculado da seguinte forma:</p> <p>Patrimônio da conta do contrato = margem da posição + lucro e prejuízo flutuante da posição + valor disponível da conta atual</p>',
      part7: 'Take profit (realização de lucro) e stop loss (limitação de perda) são limites definidos por você. Quando o valor definido é atingido, o sistema fechará automaticamente a posição. Isso pode ser usado para controlar riscos ao negociar contratos. Recomendamos que você configure isso com base na sua situação financeira para gerenciar os riscos de forma razoável.',
      part8: 'Você pode transferir os ativos disponíveis de outras contas para a conta de contrato, ou reduzir o risco diminuindo a posição.',
      part9: 'A quantidade na posição aberta indica a quantidade de moeda que você espera comprar. Por exemplo: na página de abertura da negociação BTC/USDT, escolha comprar, insira o preço de 1000USDT e a quantidade de 10BTC. Isso significa que você espera comprar 10 BTC a um preço unitário de 1000USDT.',
      part10: '<p>O grau de risco é um indicador que mede o risco dos seus ativos. Quando o grau de risco for igual a 100%, sua posição será liquidada. Para evitar que os usuários excedam suas posições, o sistema define um índice de ajuste de risco. Quando o grau de risco atingir o valor definido pelo sistema, o sistema forçará a liquidação.</p> <p>Nota: Se a liquidação for forçada devido a risco excessivo, todas as suas posições serão encerradas. Portanto, controle seus riscos de forma razoável para evitar perdas desnecessárias.</p>',
      part11: '<p>Tipo de negociação</p> <p>O tipo de negociação é dividido em dois: abrir posição longa (compra) e abrir posição curta (venda):</p> <p>Comprar longo significa que você acredita que o índice atual pode subir e deseja comprar uma certa quantidade de contratos a um preço definido ou ao preço de mercado.</p> <p>Vender curto significa que você acredita que o índice atual pode cair e deseja vender uma certa quantidade de contratos a um preço definido ou ao preço de mercado.</p>',
      part12: '<p>Em negociações de contrato, o usuário participa das negociações pagando uma garantia (margem) com base no preço e na quantidade do contrato. Este valor é a margem do contrato. Quanto maior a margem utilizada, maior o risco.</p>',
      part13: 'Ordem limitada refere-se ao preço que você espera para executar a transação. Ordem de mercado refere-se à execução da transação ao preço atual. Ordens de mercado têm prioridade sobre ordens limitadas.',
      part14: 'O nível de risco é um indicador do seu risco em negociações de contrato. Sugerimos cautela ao abrir posições com risco superior a 50%.',
      part15: 'A conversão de moeda permite a circulação fluida de fundos entre diferentes contas e moedas.',
      part16: 'Certifique-se de que o método de pagamento usado é exatamente igual ao mostrado na página de detalhes do pedido. Se necessário, entre em contato com seu banco para mais informações.',
      part17: '<p>Método 1: Escolha um pedido na lista de compra/venda OTC para realizar a transação.</p> <p>Método 2: Publique seu próprio pedido e aguarde o sistema encontrar um comprador ou vendedor correspondente.</p>'
    }
  }
};

/***/ }),

/***/ "pM0a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  state: {
    loading: {
      visible: false,
      loadingTxt: ''
    }
  },
  mutations: {
    updateLoadingStatus: function updateLoadingStatus(state, payload) {
      state.loading = {
        visible: payload.isLoading,
        loadingTxt: payload.loadingTxt || ''
      };
    }
  },
  actions: {}
};

/***/ }),

/***/ "qlyH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'SlideItem',
  props: {
    item: {
      type: Object,
      default: function _default() {
        /* istanbul ignore next */
        return {};
      }
    }
  }
};

/***/ }),

/***/ "qorP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _clipboard = __webpack_require__("TQvf");

var _clipboard2 = _interopRequireDefault(_clipboard);

var _i18n = __webpack_require__("mWYR");

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clipboardSuccess() {
  _vue2.default.prototype.$message.success(_i18n2.default.translate('message.copySuccess'));
}

function clipboardError() {
  _vue2.default.prototype.$message.error(_i18n2.default.translate('message.copyFailed'));
}

function handleClipboard(_text, event) {
  var clipboard = new _clipboard2.default(event.target, {
    text: function text() {
      return _text;
    }
  });
  clipboard.on('success', function () {
    clipboardSuccess();
    clipboard.destroy();
  });
  clipboard.on('error', function () {
    clipboardError();
    clipboard.destroy();
  });
  clipboard.onClick(event);
}
exports.default = handleClipboard;

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2A0z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bCvt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_347cf7be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("kV4u");
function injectStyle (ssrContext) {
  __webpack_require__("HQNd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_347cf7be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rMGM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue__ = __webpack_require__("+dCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue__ = __webpack_require__("W478");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564e822a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Poster_vue__ = __webpack_require__("Zts+");
function injectStyle (ssrContext) {
  __webpack_require__("hEUs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-564e822a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Poster_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564e822a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Poster_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sF3y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userRegisterEmailCode = exports.privateLetterRead = exports.privateLetterList = exports.userReloadInviteCode = exports.userRegister = exports.userTeamPage = exports.userAdd = exports.userPortalUserAddPointPercentList = exports.userFavorVcDelete = exports.userFavorVcAdd = exports.userFavorVcList = exports.userBindFundPwd = exports.userEditLoginPwd = exports.userEditFundPwd = exports.userGetLoginInfo = exports.userBindGoogleGet = exports.userHasBoundGoogle = exports.userBindGoogle = exports.logout = exports.login = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _request = __webpack_require__("vLgD");

var _request2 = _interopRequireDefault(_request);

var _prefix = __webpack_require__("jnOm");

var _prefix2 = _interopRequireDefault(_prefix);

var _encryption = __webpack_require__("cWLO");

var _auth = __webpack_require__("Pfph");

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***
 * 用户登录
 * @param data
 * @returns {AxiosPromise}
 */
var login = exports.login = function login(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/user/login',
    method: 'post',
    data: (0, _extends3.default)({}, data, {
      password: (0, _encryption.encryptionPassword)(data.password)
    })
  });
};

/***
 * 登出
 * @param data
 * @returns {AxiosPromise}
 */
var logout = exports.logout = function logout(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/user/logout',
    method: 'post',
    data: data
  });
};

/***
 * 用户绑定谷歌验证器
 * @param data
 * @returns {AxiosPromise}
 */
var userBindGoogle = exports.userBindGoogle = function userBindGoogle(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/user/bind-google',
    method: 'post',
    data: (0, _extends3.default)({}, data, {
      password: (0, _encryption.encryptionPassword)(data.password)
    })
  });
};

/***
 * 获取用户是否绑定谷歌验证
 * @param data
 * @returns {AxiosPromise}
 */
var userHasBoundGoogle = exports.userHasBoundGoogle = function userHasBoundGoogle(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/user/has-bound-google',
    method: 'post',
    data: data
  });
};

/***
 * 获取用户是否绑定谷歌验证
 * @param data
 * @returns {AxiosPromise}
 */
var userBindGoogleGet = exports.userBindGoogleGet = function userBindGoogleGet(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/bind-google-get',
    method: 'post',
    data: data
  });
};

/***
 * 获取用户信息
 * @param data
 * @returns {AxiosPromise}
 */
var userGetLoginInfo = exports.userGetLoginInfo = function userGetLoginInfo(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/user/get-login-info',
    method: 'post',
    data: data
  });
};

/***
 * 修改当前用户的资金密码
 * @param data
 * @returns {AxiosPromise}
 */
var userEditFundPwd = exports.userEditFundPwd = function userEditFundPwd(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/edit-fund-pwd',
    method: 'post',
    data: (0, _extends3.default)({}, data, {
      newPwd: (0, _encryption.encryptionPassword)(data.newPwd),
      oldPwd: (0, _encryption.encryptionPassword)(data.oldPwd),
      prePwd: (0, _encryption.encryptionPassword)(data.oldPwd)
    })
  });
};

/***
 * 修改当前用户的登录密码
 * @param data
 * @returns {AxiosPromise}
 */
var userEditLoginPwd = exports.userEditLoginPwd = function userEditLoginPwd(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/edit-login-pwd',
    method: 'post',
    data: (0, _extends3.default)({}, data, {
      newPwd: (0, _encryption.encryptionPassword)(data.newPwd),
      oldPwd: (0, _encryption.encryptionPassword)(data.oldPwd),
      prePwd: (0, _encryption.encryptionPassword)(data.oldPwd)
    })
  });
};

/***
 * 绑定当前用户的资金密码
 * @param data
 * @returns {AxiosPromise}
 */
var userBindFundPwd = exports.userBindFundPwd = function userBindFundPwd(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/bind-fund-pwd',
    method: 'post',
    data: (0, _extends3.default)({}, data, {
      password: (0, _encryption.encryptionPassword)(data.password),
      passwordPre: (0, _encryption.encryptionPassword)(data.passwordPre)
    })
  });
};

/***
 * 获取用户自选币列表
 * @param data
 * @returns {AxiosPromise}
 */
var userFavorVcList = exports.userFavorVcList = function userFavorVcList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/favor-vc/list',
    method: 'post',
    data: data
  });
};

/***
 * 添加用户自选币
 * @param data
 * @returns {AxiosPromise}
 */
var userFavorVcAdd = exports.userFavorVcAdd = function userFavorVcAdd(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/favor-vc/add',
    method: 'post',
    data: data
  });
};

/***
 * 删除用户自选币
 * @param data
 * @returns {AxiosPromise}
 */
var userFavorVcDelete = exports.userFavorVcDelete = function userFavorVcDelete(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/favor-vc/delete',
    method: 'post',
    data: data
  });
};

/***
 * 获取新增用户的返点范围
 * @param data
 * @returns {AxiosPromise}
 */
var userPortalUserAddPointPercentList = exports.userPortalUserAddPointPercentList = function userPortalUserAddPointPercentList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/portal-user-add-point-percent-list',
    method: 'post',
    data: data
  });
};

/***
 * 新增用户
 * @param data
 * @returns {AxiosPromise}
 */
var userAdd = exports.userAdd = function userAdd(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/add',
    method: 'post',
    data: data
  });
};

/***
 * 我的团队列表
 * @param data
 * @returns {AxiosPromise}
 */
var userTeamPage = exports.userTeamPage = function userTeamPage(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/team-page',
    method: 'post',
    data: data
  });
};

/***
 * 新用户注册
 * @param data
 * @returns {AxiosPromise}
 */
var userRegister = exports.userRegister = function userRegister(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/user/register',
    method: 'post',
    withNoToken: true,
    data: (0, _extends3.default)({}, data, {
      loginPwd: (0, _encryption.encryptionPassword)(data.loginPwd),
      preLoginPwd: (0, _encryption.encryptionPassword)(data.preLoginPwd)
    })
  });
};

/***
 * 重新加载当前登录用户邀请码
 * @param data
 * @returns {AxiosPromise}
 */
var userReloadInviteCode = exports.userReloadInviteCode = function userReloadInviteCode(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/user/reload-invite-code',
    method: 'post',
    data: data
  });
};

/***
 * 获取当前用户的私信列表
 * @param data
 * @returns {AxiosPromise}
 */
var privateLetterList = exports.privateLetterList = function privateLetterList(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/private_letter/list',
    method: 'post',
    data: data
  });
};

/***
 * 读取私信
 * @param data
 * @returns {AxiosPromise}
 */
var privateLetterRead = exports.privateLetterRead = function privateLetterRead(data) {
  return (0, _request2.default)({
    url: _prefix2.default + _auth2.default + '/private_letter/read',
    method: 'post',
    data: data
  });
};

/***
 * 注册-邮箱获取验证码
 * @param data
 * @returns {AxiosPromise}
 */
var userRegisterEmailCode = exports.userRegisterEmailCode = function userRegisterEmailCode(data) {
  return (0, _request2.default)({
    url: _prefix2.default + '/user/register/email/code',
    method: 'post',
    data: data
  });
};

/***/ }),

/***/ "stEx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "szdm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tZdH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tt0L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tw8n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u9hx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _index = __webpack_require__("HD9R");

var _index2 = _interopRequireDefault(_index);

var _Header = __webpack_require__("3mzj");

var _Header2 = _interopRequireDefault(_Header);

var _Cell = __webpack_require__("C5nv");

var _Cell2 = _interopRequireDefault(_Cell);

var _nameSpace = __webpack_require__("Ypiv");

var _i18n = __webpack_require__("mWYR");

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Locales',
  components: { Popup: _index2.default, HeaderCommon: _Header2.default, Cell: _Cell2.default },
  data: function data() {
    return {
      nextLocale: _i18n2.default.locale()
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['localeList']), (0, _vuex.mapState)({
    localePopVisible: function localePopVisible(state) {
      return state.app.localePopVisible;
    }
  }), {
    currentVisibleVModel: {
      get: function get() {
        return this.localePopVisible;
      },
      set: function set(val) {
        this.$store.commit(_nameSpace.SET_LOCALE_POP_VISIBLE, val);
      }
    },
    sysLocaleConfigList: function sysLocaleConfigList() {
      if (!this.localeList) return [];
      return this.localeList.filter(function (item) {
        return item.enabled;
      }).map(function (item) {
        return (0, _extends3.default)({}, _i18n.i18nLocales[item.code], item);
      });
    }
  }),
  watch: {
    cacheInfo: function cacheInfo() {
      if (this.currentVisibleVModel) {
        this.$store.dispatch('getSysLocaleList');
      }
    },
    currentVisibleVModel: function currentVisibleVModel(val) {
      var _this = this;

      if (val) {
        this.$store.dispatch('getSysLocaleList');
      } else {
        setTimeout(function () {
          _this.nextLocale = _i18n2.default.locale();
        }, 400);
      }
    }
  },
  methods: {
    saveLocale: function saveLocale() {
      if (this.nextLocale === this.locale) {
        this.currentVisibleVModel = false;
      } else {
        this.$i18n.set(this.nextLocale);
        this.$locale.set(this.nextLocale);
        this.$store.commit(_nameSpace.SET_CURRENT_LOCALE, this.nextLocale);
        this.currentVisibleVModel = false;
      }
    },
    closePop: function closePop() {
      this.currentVisibleVModel = false;
    }
  }
};

/***/ }),

/***/ "uCgK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
};

/***/ }),

/***/ "uSnP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Currencies',
  props: {},
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['vcListNoSettleEnabled']), (0, _vuex.mapState)({
    coinListWithPrice: function coinListWithPrice(state) {
      return state.vc.coinListWithPrice;
    }
  }), {
    hotCoinList: function hotCoinList() {
      var _this = this;

      if (!this.coinListWithPrice.length) return [];
      return this.vcListNoSettleEnabled.map(function (settleItem) {
        return _this.coinListWithPrice.find(function (coinWithPriceItem) {
          return settleItem.id === coinWithPriceItem.a;
        });
      }).filter(function (item) {
        return !!item;
      });
    }
  }),
  methods: {
    clickVcItem: function clickVcItem(currency) {
      var _this2 = this;

      this.$store.dispatch('setVcId', currency.a).then(function () {
        _this2.$router.push('/trade');
      }).catch(function (err) {
        _this2.$message.error(err.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "urgZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__("/kga");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("2sLL");

var _index4 = _interopRequireDefault(_index3);

var _flexbox = __webpack_require__("YxJB");

var _flexbox2 = _interopRequireDefault(_flexbox);

var _flexboxItem = __webpack_require__("3Lt7");

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

var _CButton = __webpack_require__("CBEr");

var _CButton2 = _interopRequireDefault(_CButton);

var _numberPrecision = __webpack_require__("qy1k");

var _numberPrecision2 = _interopRequireDefault(_numberPrecision);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var winPrizeTipTime = 3 * 1000;
exports.default = {
  name: 'confirm',
  components: {
    XDialog: _index2.default, XButton: _index4.default, Flexbox: _flexbox2.default, FlexboxItem: _flexboxItem2.default, CButton: _CButton2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'top'
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  filters: {
    formatMsToS: function formatMsToS(time) {
      return _numberPrecision2.default.divide(time, 1000) + 's';
    }
  },
  watch: {
    value: function value(val) {
      console.log(val);
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
      if (val) {
        this.$emit('on-show');
      }
    }
  },
  data: function data() {
    return {
      showValue: false,
      interval: {
        enabled: false,
        mode: 'cancel',
        timer: '',
        intervalTime: winPrizeTipTime
      }
    };
  },

  methods: {
    intervalCloseConfirm: function intervalCloseConfirm() {
      var _this = this;

      this.interval.intervalTime = winPrizeTipTime;
      clearInterval(this.interval.timer);
      this.interval.timer = setInterval(function () {
        _this.interval.intervalTime -= 1000;
        if (_this.interval.intervalTime <= 0) {
          clearInterval(_this.interval.timer);
          _this.interval.enabled = false;
          if (_this.interval.mode === 'cancel') {
            _this._onCancel();
          } else {
            _this._onConfirm();
          }
        }
      }, 1000);
    },
    _onConfirm: function _onConfirm(ev) {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', ev);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
};

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v42V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__("/kga");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("2sLL");

var _index4 = _interopRequireDefault(_index3);

var _flexbox = __webpack_require__("YxJB");

var _flexbox2 = _interopRequireDefault(_flexbox);

var _flexboxItem = __webpack_require__("3Lt7");

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

var _CButton = __webpack_require__("CBEr");

var _CButton2 = _interopRequireDefault(_CButton);

var _numberPrecision = __webpack_require__("qy1k");

var _numberPrecision2 = _interopRequireDefault(_numberPrecision);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var winPrizeTipTime = 3 * 1000;
exports.default = {
  name: 'confirm',
  components: {
    XDialog: _index2.default, XButton: _index4.default, Flexbox: _flexbox2.default, FlexboxItem: _flexboxItem2.default, CButton: _CButton2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'top'
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  filters: {
    formatMsToS: function formatMsToS(time) {
      return _numberPrecision2.default.divide(time, 1000) + 's';
    }
  },
  watch: {
    value: function value(val) {
      console.log(val);
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
      if (val) {
        this.$emit('on-show');
      }
    }
  },
  data: function data() {
    return {
      showValue: false,
      interval: {
        enabled: false,
        mode: 'cancel',
        timer: '',
        intervalTime: winPrizeTipTime
      }
    };
  },

  methods: {
    intervalCloseConfirm: function intervalCloseConfirm() {
      var _this = this;

      this.interval.intervalTime = winPrizeTipTime;
      clearInterval(this.interval.timer);
      this.interval.timer = setInterval(function () {
        _this.interval.intervalTime -= 1000;
        if (_this.interval.intervalTime <= 0) {
          clearInterval(_this.interval.timer);
          _this.interval.enabled = false;
          if (_this.interval.mode === 'cancel') {
            _this._onCancel();
          } else {
            _this._onConfirm();
          }
        }
      }, 1000);
    },
    _onConfirm: function _onConfirm(ev) {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', ev);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
};

/***/ }),

/***/ "vAbW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
};

/***/ }),

/***/ "vJdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__ = __webpack_require__("MJT1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__ = __webpack_require__("n5H/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4269c4c9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Slide_vue__ = __webpack_require__("Ee28");
function injectStyle (ssrContext) {
  __webpack_require__("3kuK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4269c4c9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vLgD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.getJsonp = getJsonp;

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var request = _axios2.default.create({
  baseURL: '/api', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 40000, // request timeout,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

request.interceptors.request.use(function (config) {
  // do something before request is sent
  if (_store2.default.getters.token && !config['withNoToken']) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config.headers['Authorization'] = _store2.default.getters.token;
  }
  config.headers['language'] = _store2.default.getters.locale;
  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug
  return _promise2.default.reject(error);
});

// response interceptor
request.interceptors.response.use(function (response) {
  if (response.status === 200) {
    if (!response.data.success) {
      var code = response.data.code;
      // 未绑定谷歌验证码
      if (code && code === 'GOOGLE_NOT_YET_BIND') {}
      // 未绑定资金密码
      if (code && code === 'USER_FUND_PASSWORD_NOT_YET_BIND') {}
    }
    // response.data['forceLogout'] = true
    // response.data['message'] = '登录状态一变化, 请重新登录'
    // 强制登出
    if (response.data['forceLogout']) {
      _store2.default.dispatch('logout').then(function () {
        _router2.default.replace('/login');
      });
    }
    try {
      return JSON.parse(response.data);
    } catch (e) {
      return response.data;
    }
  }
}, function (error) {
  console.log('request error = ' + error); // for debug
  return _promise2.default.reject(error);
});

function getJsonp(url, data) {
  if (!url) {
    throw new Error('url is necessary');
  }
  var callback = 'CALLBACK' + Math.random().toString().substr(9, 18);
  var JSONP = document.createElement('script');
  JSONP.setAttribute('type', 'text/javascript');

  var headEle = document.getElementsByTagName('head')[0];

  var ret = '';
  if (data) {
    if (typeof data === 'string') {
      ret = '&' + data;
    } else if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
      for (var key in data) {
        ret += '&' + key + '=' + encodeURIComponent(data[key]);
      }
    }
    ret += '&_time=' + Date.now();
  }
  JSONP.src = url + '?callback=' + callback + ret;
  return new _promise2.default(function (resolve, reject) {
    window[callback] = function (r) {
      resolve(r);
      headEle.removeChild(JSONP);
      delete window[callback];
    };
    headEle.appendChild(JSONP);
  });
}

exports.default = request;

/***/ }),

/***/ "vNF5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.getRect = getRect;
/* istanbul ignore next */

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};

function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName;
      }
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ');
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

/***
 * 获取节点尺寸信息
 * @param el
 * @returns {{top: *, left: *, width: *, height: *}}
 */
function getRect(el) {
  if (el instanceof window.SVGElement) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  } else {
    return {
      top: el.offsetTop,
      left: el.offsetLeft,
      width: el.offsetWidth,
      height: el.offsetHeight
    };
  }
}

/***/ }),

/***/ "vjYW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__("0FxO");

exports.default = {
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && (0, _router.go)(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "vkUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('loading',{staticClass:"global-loading",staticStyle:{"z-index":"999999"},attrs:{"text":_vm.loadingTxt},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}})],1),_vm._v(" "),_c('RouterView'),_vm._v(" "),_c('CustomerService'),_vm._v(" "),_c('Locales')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vtIf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wHkY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
};

/***/ }),

/***/ "wNAT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wP7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-header"},[_c('div',{staticClass:"language",on:{"click":function($event){return _vm.$store.dispatch('showLocalePop')}}},[_c('img',{attrs:{"src":_vm.currentLocaleIcon,"alt":"locale-icon"},on:{"click":function($event){return _vm.$store.dispatch('showLocalePop')}}})]),_vm._v(" "),(false)?_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../../../statics/images/logo-dark.png"),"alt":"logo"}})]):_vm._e(),_vm._v(" "),_c('ThemeSwitch')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wVfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-container content-bg"},[_c('div',{staticClass:"tabs"},_vm._l((_vm.vcTypeOptions),function(tabItem){return _c('div',{key:tabItem.key,staticClass:"tab-item"},[_c('div',{staticClass:"tab-item-content",class:{ active: _vm.currentTab === tabItem.value },on:{"click":function($event){return _vm.clickTabItem(tabItem)}}},[_vm._v("\n          "+_vm._s(_vm.$t(tabItem.label))+"\n        ")])])}),0),_vm._v(" "),_c('div',{staticClass:"swipe-container"},[_c('slide',{ref:"coins-slide",attrs:{"loop":false,"auto-play":false,"show-dots":false,"initial-index":_vm.currentTabIndex,"options":_vm.slideOptions},on:{"change":_vm.slideOnChange}},_vm._l((_vm.vcTypeOptions),function(item,index){return _c('slide-item',{key:item.key},[_c(item.component,{tag:"component",attrs:{"type":item.value,"is-active":_vm.currentTab === item.value}})],1)}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wjhB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'QuickMenus',
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['tradeConfig', 'vcId'])),
  methods: {
    quickTrade: function quickTrade() {
      if (!this.vcId) {
        this.$store.dispatch('setVcId', this.tradeConfig[0].vcId);
      }
      this.$router.push('/trade');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "xjY1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Menus'
};

/***/ }),

/***/ "xkKr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xzd6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__("Bfwr");

var _index2 = _interopRequireDefault(_index);

var _CustomerService = __webpack_require__("iYDO");

var _CustomerService2 = _interopRequireDefault(_CustomerService);

var _Locales = __webpack_require__("4xPj");

var _Locales2 = _interopRequireDefault(_Locales);

var _vuex = __webpack_require__("NYxO");

var _dom = __webpack_require__("vNF5");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Loading: _index2.default, CustomerService: _CustomerService2.default, Locales: _Locales2.default },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    loadingTxt: function loadingTxt(state) {
      return state.vux.loading.loadingTxt;
    },
    isLoading: function isLoading(state) {
      return state.vux.loading.visible;
    },
    route: function route(state) {
      return state.route;
    },
    localePopVisible: function localePopVisible(state) {
      return state.app.localePopVisible;
    },
    locale: function locale(state) {
      return state.i18n.locale;
    },
    theme: function theme(state) {
      return state.app.theme;
    }
  })),
  watch: {
    locale: function locale() {
      this.$store.dispatch('getSysConfigDict');
    },
    theme: function theme(val, oldVal) {
      var htmlNode = document.documentElement;
      (0, _dom.removeClass)(htmlNode, oldVal);
      (0, _dom.addClass)(htmlNode, val);
    }
  },
  methods: {},
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('initThemeMode');
  },
  beforeDestroy: function beforeDestroy() {}
};

/***/ }),

/***/ "yB64":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _ThemeSwitch = __webpack_require__("1KuB");

var _ThemeSwitch2 = _interopRequireDefault(_ThemeSwitch);

var _i18n = __webpack_require__("mWYR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'HomeHeader',
  components: { ThemeSwitch: _ThemeSwitch2.default },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    locale: function locale(state) {
      return state.i18n.locale;
    }
  }), {
    currentLocaleIcon: function currentLocaleIcon() {
      return (_i18n.i18nLocales[this.locale] || { icon: '' }).icon;
    },
    localeName: function localeName() {
      return _i18n.i18nLocales[this.locale].localeName;
    }
  }),
  methods: {
    clickCustomService: function clickCustomService() {
      this.$store.dispatch('showCustomerService');
      // this.$store.dispatch('disConnectSocket')
      // console.log(this.$store.state.app)
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "yekX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__("HD9R");

var _index2 = _interopRequireDefault(_index);

var _vuex = __webpack_require__("NYxO");

var _nameSpace = __webpack_require__("Ypiv");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CustomerService',
  components: { Popup: _index2.default },
  data: function data() {
    return {
      customer: {

        show: false
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    customerVisible: function customerVisible(state) {
      return state.app.customerVisible;
    }
  }), (0, _vuex.mapGetters)(['PORTAL_systemConfig']), {
    currentVisibleVModel: {
      get: function get() {
        return this.customerVisible;
      },
      set: function set(val) {
        this.$store.commit(_nameSpace.SET_CUSTOMER_VISIBLE, val);
      }
    },
    closeVisible: function closeVisible() {
      return this.$config.platform !== 'Darwinex FT';
    }
  }),
  watch: {
    currentVisibleVModel: function currentVisibleVModel() {
      this.customer.show = true;
    }
  }
};

/***/ }),

/***/ "ykmb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

exports.default = {
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
};

/***/ }),

/***/ "yqQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zaRr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'inline-desc'
};

/***/ }),

/***/ "zprm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'inline-desc'
};

/***/ }),

/***/ "zzui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.059dee6335d7187810f3.js